//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase, HttpContext } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IVersionInfoClient {
    get(): Observable<VersionInfoDtoBase>;
}

@Injectable()
export class VersionInfoClient implements IVersionInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(httpContext?: HttpContext): Observable<VersionInfoDtoBase> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VersionInfoDtoBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VersionInfoDtoBase>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VersionInfoDtoBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VersionInfoDtoBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISignalTelemetryClient {
    create(signalTelemetry: SignalTelemetryDto): Observable<boolean>;
    update(signalId: number, signalTelemetry: SignalTelemetryDto): Observable<boolean>;
    replacePoint(pointReplacement: PointReplacementDto): Observable<PointReplacementResponseDto>;
}

@Injectable()
export class SignalTelemetryClient implements ISignalTelemetryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(signalTelemetry: SignalTelemetryDto, httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/api/telemetry/signal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signalTelemetry);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(signalId: number, signalTelemetry: SignalTelemetryDto, httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/api/telemetry/signal/{signalId}";
        if (signalId === undefined || signalId === null)
            throw new Error("The parameter 'signalId' must be defined.");
        url_ = url_.replace("{signalId}", encodeURIComponent("" + signalId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signalTelemetry);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    replacePoint(pointReplacement: PointReplacementDto, httpContext?: HttpContext): Observable<PointReplacementResponseDto> {
        let url_ = this.baseUrl + "/api/telemetry/signal/replace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pointReplacement);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplacePoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplacePoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PointReplacementResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PointReplacementResponseDto>;
        }));
    }

    protected processReplacePoint(response: HttpResponseBase): Observable<PointReplacementResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PointReplacementResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISourceSystemClient {
    get(): Observable<SourceSystemDto[]>;
}

@Injectable()
export class SourceSystemClient implements ISourceSystemClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(httpContext?: HttpContext): Observable<SourceSystemDto[]> {
        let url_ = this.baseUrl + "/api/telemetry/source-system/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceSystemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceSystemDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SourceSystemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SourceSystemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISummaryClient {
    get(summaryName: string, isHistorical?: boolean | undefined, baseDate?: Date | null | undefined, comparisonDate?: Date | null | undefined, options?: ODataQueryOptionsOfSummaryDynamicResponse | null | undefined): Observable<PagedResultDtoOfSummaryDynamicResponse>;
    getNetworkElementsSummary(summaryName: string, hierarchyFamilyId?: string | undefined, hierarchyElementId?: string[] | null | undefined, isHistorical?: boolean | undefined, baseDate?: Date | null | undefined, comparisonDate?: Date | null | undefined, options?: ODataQueryOptionsOfSummaryDynamicResponse | null | undefined): Observable<PagedResultDtoOfSummaryDynamicResponse>;
    get2(summaryName: string): Observable<GetSummaryLatestCalculationDayCmdResponse>;
}

@Injectable()
export class SummaryClient implements ISummaryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(summaryName: string, isHistorical?: boolean | undefined, baseDate?: Date | null | undefined, comparisonDate?: Date | null | undefined, options?: ODataQueryOptionsOfSummaryDynamicResponse | null | undefined, httpContext?: HttpContext): Observable<PagedResultDtoOfSummaryDynamicResponse> {
        let url_ = this.baseUrl + "/api/summary/dynamic/{summaryName}?";
        if (summaryName === undefined || summaryName === null)
            throw new Error("The parameter 'summaryName' must be defined.");
        url_ = url_.replace("{summaryName}", encodeURIComponent("" + summaryName));
        if (isHistorical === null)
            throw new Error("The parameter 'isHistorical' cannot be null.");
        else if (isHistorical !== undefined)
            url_ += "isHistorical=" + encodeURIComponent("" + isHistorical) + "&";
        if (baseDate !== undefined && baseDate !== null)
            url_ += "baseDate=" + encodeURIComponent(baseDate ? "" + baseDate.toISOString() : "") + "&";
        if (comparisonDate !== undefined && comparisonDate !== null)
            url_ += "comparisonDate=" + encodeURIComponent(comparisonDate ? "" + comparisonDate.toISOString() : "") + "&";
        if (options !== undefined && options !== null)
            url_ += "options=" + encodeURIComponent("" + options) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSummaryDynamicResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSummaryDynamicResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PagedResultDtoOfSummaryDynamicResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSummaryDynamicResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNetworkElementsSummary(summaryName: string, hierarchyFamilyId?: string | undefined, hierarchyElementId?: string[] | null | undefined, isHistorical?: boolean | undefined, baseDate?: Date | null | undefined, comparisonDate?: Date | null | undefined, options?: ODataQueryOptionsOfSummaryDynamicResponse | null | undefined, httpContext?: HttpContext): Observable<PagedResultDtoOfSummaryDynamicResponse> {
        let url_ = this.baseUrl + "/api/summary/dynamic/networkelements/{summaryName}?";
        if (summaryName === undefined || summaryName === null)
            throw new Error("The parameter 'summaryName' must be defined.");
        url_ = url_.replace("{summaryName}", encodeURIComponent("" + summaryName));
        if (hierarchyFamilyId === null)
            throw new Error("The parameter 'hierarchyFamilyId' cannot be null.");
        else if (hierarchyFamilyId !== undefined)
            url_ += "hierarchyFamilyId=" + encodeURIComponent("" + hierarchyFamilyId) + "&";
        if (hierarchyElementId !== undefined && hierarchyElementId !== null)
            hierarchyElementId && hierarchyElementId.forEach(item => { url_ += "hierarchyElementId=" + encodeURIComponent("" + item) + "&"; });
        if (isHistorical === null)
            throw new Error("The parameter 'isHistorical' cannot be null.");
        else if (isHistorical !== undefined)
            url_ += "isHistorical=" + encodeURIComponent("" + isHistorical) + "&";
        if (baseDate !== undefined && baseDate !== null)
            url_ += "baseDate=" + encodeURIComponent(baseDate ? "" + baseDate.toISOString() : "") + "&";
        if (comparisonDate !== undefined && comparisonDate !== null)
            url_ += "comparisonDate=" + encodeURIComponent(comparisonDate ? "" + comparisonDate.toISOString() : "") + "&";
        if (options !== undefined && options !== null)
            url_ += "options=" + encodeURIComponent("" + options) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNetworkElementsSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNetworkElementsSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSummaryDynamicResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSummaryDynamicResponse>;
        }));
    }

    protected processGetNetworkElementsSummary(response: HttpResponseBase): Observable<PagedResultDtoOfSummaryDynamicResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSummaryDynamicResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(summaryName: string, httpContext?: HttpContext): Observable<GetSummaryLatestCalculationDayCmdResponse> {
        let url_ = this.baseUrl + "/api/summary/dynamic/{summaryName}/latestcalculationday";
        if (summaryName === undefined || summaryName === null)
            throw new Error("The parameter 'summaryName' must be defined.");
        url_ = url_.replace("{summaryName}", encodeURIComponent("" + summaryName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSummaryLatestCalculationDayCmdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSummaryLatestCalculationDayCmdResponse>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<GetSummaryLatestCalculationDayCmdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSummaryLatestCalculationDayCmdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISignalsConfigurationClient {
    getSignalsConfiguration(query: SignalsConfiguredQueryDto): Observable<SignalConfigurationDto[]>;
}

@Injectable()
export class SignalsConfigurationClient implements ISignalsConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSignalsConfiguration(query: SignalsConfiguredQueryDto, httpContext?: HttpContext): Observable<SignalConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/telemetry/signal/configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSignalsConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSignalsConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SignalConfigurationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SignalConfigurationDto[]>;
        }));
    }

    protected processGetSignalsConfiguration(response: HttpResponseBase): Observable<SignalConfigurationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SignalConfigurationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IGridSettingsClient {
    getGridSettingsUser(gridName: string): Observable<any>;
    getGridSettingsTemplate(gridName: string): Observable<any>;
    add(requestDto: UpsertGridSettingsDto): Observable<UpsertGridSettingsResponseDto>;
    getGridSettingSaveState(gridName: string): Observable<GridSettingSaveStateResponseDto>;
}

@Injectable()
export class GridSettingsClient implements IGridSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getGridSettingsUser(gridName: string, httpContext?: HttpContext): Observable<any> {
        let url_ = this.baseUrl + "/api/settings/grid/{gridName}/user";
        if (gridName === undefined || gridName === null)
            throw new Error("The parameter 'gridName' must be defined.");
        url_ = url_.replace("{gridName}", encodeURIComponent("" + gridName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGridSettingsUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGridSettingsUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetGridSettingsUser(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGridSettingsTemplate(gridName: string, httpContext?: HttpContext): Observable<any> {
        let url_ = this.baseUrl + "/api/settings/grid/{gridName}/template";
        if (gridName === undefined || gridName === null)
            throw new Error("The parameter 'gridName' must be defined.");
        url_ = url_.replace("{gridName}", encodeURIComponent("" + gridName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGridSettingsTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGridSettingsTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetGridSettingsTemplate(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    add(requestDto: UpsertGridSettingsDto, httpContext?: HttpContext): Observable<UpsertGridSettingsResponseDto> {
        let url_ = this.baseUrl + "/api/settings/grid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertGridSettingsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertGridSettingsResponseDto>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<UpsertGridSettingsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertGridSettingsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGridSettingSaveState(gridName: string, httpContext?: HttpContext): Observable<GridSettingSaveStateResponseDto> {
        let url_ = this.baseUrl + "/api/settings/grid/{gridName}/save-state";
        if (gridName === undefined || gridName === null)
            throw new Error("The parameter 'gridName' must be defined.");
        url_ = url_.replace("{gridName}", encodeURIComponent("" + gridName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGridSettingSaveState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGridSettingSaveState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridSettingSaveStateResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridSettingSaveStateResponseDto>;
        }));
    }

    protected processGetGridSettingSaveState(response: HttpResponseBase): Observable<GridSettingSaveStateResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GridSettingSaveStateResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISettingComponentClient {
    getSettingComponent(componentArea: string, componentKey: string): Observable<string>;
    upsert(requestDto: UpsertSettingComponentDto): Observable<UpsertSettingComponentResponseDto>;
    deleteSettingComponent(requestDto: DeleteSettingComponentDto): Observable<void>;
    bulkUpsert(requestsDto: UpsertSettingComponentDto[]): Observable<boolean>;
    getSettingComponentLevel(componentArea: string, componentKey: string): Observable<number>;
}

@Injectable()
export class SettingComponentClient implements ISettingComponentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSettingComponent(componentArea: string, componentKey: string, httpContext?: HttpContext): Observable<string> {
        let url_ = this.baseUrl + "/api/settings/{componentArea}/{componentKey}";
        if (componentArea === undefined || componentArea === null)
            throw new Error("The parameter 'componentArea' must be defined.");
        url_ = url_.replace("{componentArea}", encodeURIComponent("" + componentArea));
        if (componentKey === undefined || componentKey === null)
            throw new Error("The parameter 'componentKey' must be defined.");
        url_ = url_.replace("{componentKey}", encodeURIComponent("" + componentKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSettingComponent(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsert(requestDto: UpsertSettingComponentDto, httpContext?: HttpContext): Observable<UpsertSettingComponentResponseDto> {
        let url_ = this.baseUrl + "/api/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpsertSettingComponentResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpsertSettingComponentResponseDto>;
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<UpsertSettingComponentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertSettingComponentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSettingComponent(requestDto: DeleteSettingComponentDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSettingComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSettingComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSettingComponent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkUpsert(requestsDto: UpsertSettingComponentDto[], httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/api/settings/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestsDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processBulkUpsert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSettingComponentLevel(componentArea: string, componentKey: string, httpContext?: HttpContext): Observable<number> {
        let url_ = this.baseUrl + "/api/settings/{componentArea}/{componentKey}/level";
        if (componentArea === undefined || componentArea === null)
            throw new Error("The parameter 'componentArea' must be defined.");
        url_ = url_.replace("{componentArea}", encodeURIComponent("" + componentArea));
        if (componentKey === undefined || componentKey === null)
            throw new Error("The parameter 'componentKey' must be defined.");
        url_ = url_.replace("{componentKey}", encodeURIComponent("" + componentKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingComponentLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingComponentLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetSettingComponentLevel(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IGroupClient {
    getGroups(options?: ODataQueryOptionsOfGroupsDto | null | undefined, userCode?: string | null | undefined, exclude?: boolean | undefined): Observable<GroupsDto>;
    getProfileDialogsByCurrentUser(): Observable<UserPermissionsDto>;
    getProfileDialogsByGroupId(groupId: number): Observable<ProfileDialogsPathsDto[]>;
    getProfileDialogsByUserCode(userCode: string): Observable<UserPermissionsDto>;
    postProfileCrud(profileCruds: ProfileCrudCmd): Observable<ProfileCrudsResponse>;
    updateGroup(groupCmd: RolesGroupAddOrUpdateCmd): Observable<GroupResponse>;
    deleteGroup(groupCmd: RolesGroupDeleteCmd): Observable<GroupResponse>;
}

@Injectable()
export class GroupClient implements IGroupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getGroups(options?: ODataQueryOptionsOfGroupsDto | null | undefined, userCode?: string | null | undefined, exclude?: boolean | undefined, httpContext?: HttpContext): Observable<GroupsDto> {
        let url_ = this.baseUrl + "/api/roles/groups?";
        if (options !== undefined && options !== null)
            url_ += "options=" + encodeURIComponent("" + options) + "&";
        if (userCode !== undefined && userCode !== null)
            url_ += "userCode=" + encodeURIComponent("" + userCode) + "&";
        if (exclude === null)
            throw new Error("The parameter 'exclude' cannot be null.");
        else if (exclude !== undefined)
            url_ += "exclude=" + encodeURIComponent("" + exclude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupsDto>;
        }));
    }

    protected processGetGroups(response: HttpResponseBase): Observable<GroupsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfileDialogsByCurrentUser(httpContext?: HttpContext): Observable<UserPermissionsDto> {
        let url_ = this.baseUrl + "/api/roles/groups/current-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileDialogsByCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileDialogsByCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPermissionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPermissionsDto>;
        }));
    }

    protected processGetProfileDialogsByCurrentUser(response: HttpResponseBase): Observable<UserPermissionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPermissionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfileDialogsByGroupId(groupId: number, httpContext?: HttpContext): Observable<ProfileDialogsPathsDto[]> {
        let url_ = this.baseUrl + "/api/roles/groups/{groupId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileDialogsByGroupId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileDialogsByGroupId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileDialogsPathsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileDialogsPathsDto[]>;
        }));
    }

    protected processGetProfileDialogsByGroupId(response: HttpResponseBase): Observable<ProfileDialogsPathsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfileDialogsPathsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfileDialogsByUserCode(userCode: string, httpContext?: HttpContext): Observable<UserPermissionsDto> {
        let url_ = this.baseUrl + "/api/roles/groups/usercode/{userCode}";
        if (userCode === undefined || userCode === null)
            throw new Error("The parameter 'userCode' must be defined.");
        url_ = url_.replace("{userCode}", encodeURIComponent("" + userCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileDialogsByUserCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileDialogsByUserCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPermissionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPermissionsDto>;
        }));
    }

    protected processGetProfileDialogsByUserCode(response: HttpResponseBase): Observable<UserPermissionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPermissionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postProfileCrud(profileCruds: ProfileCrudCmd, httpContext?: HttpContext): Observable<ProfileCrudsResponse> {
        let url_ = this.baseUrl + "/api/roles/groups/profile-crud";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileCruds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostProfileCrud(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostProfileCrud(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileCrudsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileCrudsResponse>;
        }));
    }

    protected processPostProfileCrud(response: HttpResponseBase): Observable<ProfileCrudsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileCrudsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateGroup(groupCmd: RolesGroupAddOrUpdateCmd, httpContext?: HttpContext): Observable<GroupResponse> {
        let url_ = this.baseUrl + "/api/roles/groups/group-update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupCmd);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupResponse>;
        }));
    }

    protected processUpdateGroup(response: HttpResponseBase): Observable<GroupResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteGroup(groupCmd: RolesGroupDeleteCmd, httpContext?: HttpContext): Observable<GroupResponse> {
        let url_ = this.baseUrl + "/api/roles/groups/group-delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupCmd);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupResponse>;
        }));
    }

    protected processDeleteGroup(response: HttpResponseBase): Observable<GroupResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUsersClient {
    get(userCode: string): Observable<UsersDto>;
    getAll(startDate?: Date | undefined, endDate?: Date | undefined, elementIds?: string[] | null | undefined, algorithms?: UserActivitityTrendEnum[] | null | undefined, attribute?: UserActivitityTrendEnum | undefined): Observable<UserActivitityTrendDto[]>;
    create(newUser: UsersDto): Observable<UsersDto>;
    delete(newUser: UsersDto): Observable<UsersDto>;
    insertGroupUsers(groupUsersCmd: GroupUsersInsertCmd): Observable<GroupUsersResponse>;
    deleteGroupUsers(groupUsersCmd: GroupUsersDeleteCmd): Observable<GroupUsersResponse>;
    reactivateUser(newUser: UsersDto): Observable<UsersDto>;
}

@Injectable()
export class UsersClient implements IUsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(userCode: string, httpContext?: HttpContext): Observable<UsersDto> {
        let url_ = this.baseUrl + "/api/roles/users/{userCode}";
        if (userCode === undefined || userCode === null)
            throw new Error("The parameter 'userCode' must be defined.");
        url_ = url_.replace("{userCode}", encodeURIComponent("" + userCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsersDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UsersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(startDate?: Date | undefined, endDate?: Date | undefined, elementIds?: string[] | null | undefined, algorithms?: UserActivitityTrendEnum[] | null | undefined, attribute?: UserActivitityTrendEnum | undefined, httpContext?: HttpContext): Observable<UserActivitityTrendDto[]> {
        let url_ = this.baseUrl + "/api/roles/users/users-activity-chart?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (elementIds !== undefined && elementIds !== null)
            elementIds && elementIds.forEach(item => { url_ += "elementIds=" + encodeURIComponent("" + item) + "&"; });
        if (algorithms !== undefined && algorithms !== null)
            algorithms && algorithms.forEach(item => { url_ += "algorithms=" + encodeURIComponent("" + item) + "&"; });
        if (attribute === null)
            throw new Error("The parameter 'attribute' cannot be null.");
        else if (attribute !== undefined)
            url_ += "attribute=" + encodeURIComponent("" + attribute) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserActivitityTrendDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserActivitityTrendDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserActivitityTrendDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserActivitityTrendDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(newUser: UsersDto, httpContext?: HttpContext): Observable<UsersDto> {
        let url_ = this.baseUrl + "/api/roles/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newUser);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsersDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UsersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = UsersDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(newUser: UsersDto, httpContext?: HttpContext): Observable<UsersDto> {
        let url_ = this.baseUrl + "/api/roles/users/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newUser);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsersDto>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<UsersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insertGroupUsers(groupUsersCmd: GroupUsersInsertCmd, httpContext?: HttpContext): Observable<GroupUsersResponse> {
        let url_ = this.baseUrl + "/api/roles/users/group-user/insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupUsersCmd);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertGroupUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertGroupUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupUsersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupUsersResponse>;
        }));
    }

    protected processInsertGroupUsers(response: HttpResponseBase): Observable<GroupUsersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupUsersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteGroupUsers(groupUsersCmd: GroupUsersDeleteCmd, httpContext?: HttpContext): Observable<GroupUsersResponse> {
        let url_ = this.baseUrl + "/api/roles/users/group-user/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupUsersCmd);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteGroupUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGroupUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupUsersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupUsersResponse>;
        }));
    }

    protected processDeleteGroupUsers(response: HttpResponseBase): Observable<GroupUsersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupUsersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reactivateUser(newUser: UsersDto, httpContext?: HttpContext): Observable<UsersDto> {
        let url_ = this.baseUrl + "/api/roles/users/reactivate-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newUser);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsersDto>;
        }));
    }

    protected processReactivateUser(response: HttpResponseBase): Observable<UsersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUsersIdentityClient {
    get(): Observable<UsersIdentityMappingDto[]>;
    insertUsersIdentityMapping(userIdentityInsertCmd: UserIdentityInsertCmd): Observable<UsersIdentityResponse>;
    deleteUsersIdentityMapping(userIdentityDeleteCmd: UserIdentityDeleteCmd): Observable<UsersIdentityResponse>;
}

@Injectable()
export class UsersIdentityClient implements IUsersIdentityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(httpContext?: HttpContext): Observable<UsersIdentityMappingDto[]> {
        let url_ = this.baseUrl + "/api/roles/users-identity/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsersIdentityMappingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsersIdentityMappingDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UsersIdentityMappingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UsersIdentityMappingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insertUsersIdentityMapping(userIdentityInsertCmd: UserIdentityInsertCmd, httpContext?: HttpContext): Observable<UsersIdentityResponse> {
        let url_ = this.baseUrl + "/api/roles/users-identity/insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userIdentityInsertCmd);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertUsersIdentityMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertUsersIdentityMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsersIdentityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsersIdentityResponse>;
        }));
    }

    protected processInsertUsersIdentityMapping(response: HttpResponseBase): Observable<UsersIdentityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersIdentityResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteUsersIdentityMapping(userIdentityDeleteCmd: UserIdentityDeleteCmd, httpContext?: HttpContext): Observable<UsersIdentityResponse> {
        let url_ = this.baseUrl + "/api/roles/users-identity/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userIdentityDeleteCmd);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUsersIdentityMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUsersIdentityMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UsersIdentityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UsersIdentityResponse>;
        }));
    }

    protected processDeleteUsersIdentityMapping(response: HttpResponseBase): Observable<UsersIdentityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersIdentityResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMeasuredValuesClient {
    getShort(query: MeasuredValuesQueryDto): Observable<MeasuredValueDto[]>;
    getChartByAlarms(query: ChartAlarmsQueryDto): Observable<MVChartSerieDto[]>;
    getChart(query: MeasuredValuesQueryDto): Observable<MVChartSerieDto[]>;
    getMVhresholds(query: ThresholdQueryDto): Observable<MVThresholdDto[][]>;
}

@Injectable()
export class MeasuredValuesClient implements IMeasuredValuesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getShort(query: MeasuredValuesQueryDto, httpContext?: HttpContext): Observable<MeasuredValueDto[]> {
        let url_ = this.baseUrl + "/api/mv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasuredValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasuredValueDto[]>;
        }));
    }

    protected processGetShort(response: HttpResponseBase): Observable<MeasuredValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasuredValueDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChartByAlarms(query: ChartAlarmsQueryDto, httpContext?: HttpContext): Observable<MVChartSerieDto[]> {
        let url_ = this.baseUrl + "/api/mv/chart/alarms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChartByAlarms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChartByAlarms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MVChartSerieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MVChartSerieDto[]>;
        }));
    }

    protected processGetChartByAlarms(response: HttpResponseBase): Observable<MVChartSerieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MVChartSerieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChart(query: MeasuredValuesQueryDto, httpContext?: HttpContext): Observable<MVChartSerieDto[]> {
        let url_ = this.baseUrl + "/api/mv/chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MVChartSerieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MVChartSerieDto[]>;
        }));
    }

    protected processGetChart(response: HttpResponseBase): Observable<MVChartSerieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MVChartSerieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMVhresholds(query: ThresholdQueryDto, httpContext?: HttpContext): Observable<MVThresholdDto[][]> {
        let url_ = this.baseUrl + "/api/mv/threshold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMVhresholds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMVhresholds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MVThresholdDto[][]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MVThresholdDto[][]>;
        }));
    }

    protected processGetMVhresholds(response: HttpResponseBase): Observable<MVThresholdDto[][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserClient {
    createFirstUser(): Observable<boolean>;
    getExistIntegratorUser(): Observable<boolean>;
}

@Injectable()
export class UserClient implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createFirstUser(httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/api/integration/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFirstUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFirstUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateFirstUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExistIntegratorUser(httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/api/integration/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistIntegratorUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistIntegratorUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetExistIntegratorUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICalculatedValuesClient {
    getShort(query: CalculatedValuesShortQueryDto): Observable<CalculatedValuesShortDto[]>;
    getChart(query: CalculatedValuesShortQueryDto): Observable<CVChartSerieDto[]>;
    getMVhresholds(query: ThresholdQueryDto): Observable<CVThresholdDto[][]>;
}

@Injectable()
export class CalculatedValuesClient implements ICalculatedValuesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getShort(query: CalculatedValuesShortQueryDto, httpContext?: HttpContext): Observable<CalculatedValuesShortDto[]> {
        let url_ = this.baseUrl + "/api/cv/short";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculatedValuesShortDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculatedValuesShortDto[]>;
        }));
    }

    protected processGetShort(response: HttpResponseBase): Observable<CalculatedValuesShortDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculatedValuesShortDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChart(query: CalculatedValuesShortQueryDto, httpContext?: HttpContext): Observable<CVChartSerieDto[]> {
        let url_ = this.baseUrl + "/api/cv/chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CVChartSerieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CVChartSerieDto[]>;
        }));
    }

    protected processGetChart(response: HttpResponseBase): Observable<CVChartSerieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CVChartSerieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMVhresholds(query: ThresholdQueryDto, httpContext?: HttpContext): Observable<CVThresholdDto[][]> {
        let url_ = this.baseUrl + "/api/cv/threshold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMVhresholds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMVhresholds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CVThresholdDto[][]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CVThresholdDto[][]>;
        }));
    }

    protected processGetMVhresholds(response: HttpResponseBase): Observable<CVThresholdDto[][]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPointClient {
    getPointConfiguration(options?: ODataQueryOptionsOfPointConfigurationDto | null | undefined, modelId?: string | undefined, modelVersionId?: string | undefined, pointId?: string | null | undefined): Observable<PointConfigurationDto[]>;
    getDimensions(scenarioIds?: string[] | null | undefined): Observable<DimensionInfoDto[]>;
    getNetworkElementTypes(dimensionId: string, scenarioIds?: string[] | null | undefined): Observable<string[]>;
}

@Injectable()
export class PointClient implements IPointClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getPointConfiguration(options?: ODataQueryOptionsOfPointConfigurationDto | null | undefined, modelId?: string | undefined, modelVersionId?: string | undefined, pointId?: string | null | undefined, httpContext?: HttpContext): Observable<PointConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/telemetry/point?";
        if (options !== undefined && options !== null)
            url_ += "options=" + encodeURIComponent("" + options) + "&";
        if (modelId === null)
            throw new Error("The parameter 'modelId' cannot be null.");
        else if (modelId !== undefined)
            url_ += "modelId=" + encodeURIComponent("" + modelId) + "&";
        if (modelVersionId === null)
            throw new Error("The parameter 'modelVersionId' cannot be null.");
        else if (modelVersionId !== undefined)
            url_ += "modelVersionId=" + encodeURIComponent("" + modelVersionId) + "&";
        if (pointId !== undefined && pointId !== null)
            url_ += "pointId=" + encodeURIComponent("" + pointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPointConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPointConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PointConfigurationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PointConfigurationDto[]>;
        }));
    }

    protected processGetPointConfiguration(response: HttpResponseBase): Observable<PointConfigurationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PointConfigurationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDimensions(scenarioIds?: string[] | null | undefined, httpContext?: HttpContext): Observable<DimensionInfoDto[]> {
        let url_ = this.baseUrl + "/api/telemetry/dimension?";
        if (scenarioIds !== undefined && scenarioIds !== null)
            scenarioIds && scenarioIds.forEach(item => { url_ += "scenarioIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDimensions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDimensions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DimensionInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DimensionInfoDto[]>;
        }));
    }

    protected processGetDimensions(response: HttpResponseBase): Observable<DimensionInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DimensionInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNetworkElementTypes(dimensionId: string, scenarioIds?: string[] | null | undefined, httpContext?: HttpContext): Observable<string[]> {
        let url_ = this.baseUrl + "/api/telemetry/dimension/{dimensionId}/network-element?";
        if (dimensionId === undefined || dimensionId === null)
            throw new Error("The parameter 'dimensionId' must be defined.");
        url_ = url_.replace("{dimensionId}", encodeURIComponent("" + dimensionId));
        if (scenarioIds !== undefined && scenarioIds !== null)
            scenarioIds && scenarioIds.forEach(item => { url_ += "scenarioIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNetworkElementTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNetworkElementTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetNetworkElementTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMeasurementClient {
    getMeasurements(options?: ODataQueryOptionsOfMeasurementDto | null | undefined, modelId?: string | null | undefined, modelVersionId?: string | null | undefined, dimensionId?: string | null | undefined, networkElementTypeId?: string | null | undefined): Observable<MeasurementDto[]>;
    save(data: TagSaveDto): Observable<void>;
    getMeasurementsByScenarios(scenarioIds?: string[] | null | undefined): Observable<MeasurementDto[]>;
    getMeasurementSerie(measurementQuery: MeasurementQueryDto[]): Observable<MeasurementSerieDto>;
}

@Injectable()
export class MeasurementClient implements IMeasurementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getMeasurements(options?: ODataQueryOptionsOfMeasurementDto | null | undefined, modelId?: string | null | undefined, modelVersionId?: string | null | undefined, dimensionId?: string | null | undefined, networkElementTypeId?: string | null | undefined, httpContext?: HttpContext): Observable<MeasurementDto[]> {
        let url_ = this.baseUrl + "/api/telemetry/measurement?";
        if (options !== undefined && options !== null)
            url_ += "options=" + encodeURIComponent("" + options) + "&";
        if (modelId !== undefined && modelId !== null)
            url_ += "modelId=" + encodeURIComponent("" + modelId) + "&";
        if (modelVersionId !== undefined && modelVersionId !== null)
            url_ += "modelVersionId=" + encodeURIComponent("" + modelVersionId) + "&";
        if (dimensionId !== undefined && dimensionId !== null)
            url_ += "dimensionId=" + encodeURIComponent("" + dimensionId) + "&";
        if (networkElementTypeId !== undefined && networkElementTypeId !== null)
            url_ += "networkElementTypeId=" + encodeURIComponent("" + networkElementTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasurementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasurementDto[]>;
        }));
    }

    protected processGetMeasurements(response: HttpResponseBase): Observable<MeasurementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasurementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(data: TagSaveDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/telemetry/measurement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMeasurementsByScenarios(scenarioIds?: string[] | null | undefined, httpContext?: HttpContext): Observable<MeasurementDto[]> {
        let url_ = this.baseUrl + "/api/telemetry/measurement/scenarios?";
        if (scenarioIds !== undefined && scenarioIds !== null)
            scenarioIds && scenarioIds.forEach(item => { url_ += "scenarioIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementsByScenarios(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementsByScenarios(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasurementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasurementDto[]>;
        }));
    }

    protected processGetMeasurementsByScenarios(response: HttpResponseBase): Observable<MeasurementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasurementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMeasurementSerie(measurementQuery: MeasurementQueryDto[], httpContext?: HttpContext): Observable<MeasurementSerieDto> {
        let url_ = this.baseUrl + "/api/telemetry/measurement/serie";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(measurementQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasurementSerie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasurementSerie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasurementSerieDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasurementSerieDto>;
        }));
    }

    protected processGetMeasurementSerie(response: HttpResponseBase): Observable<MeasurementSerieDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasurementSerieDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IWorkOrderClient {
    getWorkOrdersByExecution(executionId: string): Observable<WorkOrderElementResponseDto[]>;
    getWorkOrdersByElement(networkElementId: string): Observable<WorkOrderElementResponseDto[]>;
}

@Injectable()
export class WorkOrderClient implements IWorkOrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getWorkOrdersByExecution(executionId: string, httpContext?: HttpContext): Observable<WorkOrderElementResponseDto[]> {
        let url_ = this.baseUrl + "/api/work-order/execution/{executionId}";
        if (executionId === undefined || executionId === null)
            throw new Error("The parameter 'executionId' must be defined.");
        url_ = url_.replace("{executionId}", encodeURIComponent("" + executionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkOrdersByExecution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkOrdersByExecution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkOrderElementResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkOrderElementResponseDto[]>;
        }));
    }

    protected processGetWorkOrdersByExecution(response: HttpResponseBase): Observable<WorkOrderElementResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkOrderElementResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWorkOrdersByElement(networkElementId: string, httpContext?: HttpContext): Observable<WorkOrderElementResponseDto[]> {
        let url_ = this.baseUrl + "/api/work-order/element/{networkElementId}";
        if (networkElementId === undefined || networkElementId === null)
            throw new Error("The parameter 'networkElementId' must be defined.");
        url_ = url_.replace("{networkElementId}", encodeURIComponent("" + networkElementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkOrdersByElement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkOrdersByElement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkOrderElementResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkOrderElementResponseDto[]>;
        }));
    }

    protected processGetWorkOrdersByElement(response: HttpResponseBase): Observable<WorkOrderElementResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkOrderElementResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITopologyClient {
    checkTopology(instanceId: string, simulationScenarioId: string): Observable<CheckTopologyResponseDto>;
    getNetWorkElements(instanceId: string, scenarioId: string): Observable<NetworkElementResponseDto[]>;
    sendTopology(instanceId: string, topologyDto: TopologyDto): Observable<SendTopologyResponseDto>;
    sendTopologyStream(instanceId: string, totalChunks: number, chunkIndex: number, chunkData: string): Observable<boolean>;
    processTopologyStream(instanceId: string): Observable<boolean>;
}

@Injectable()
export class TopologyClient implements ITopologyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    checkTopology(instanceId: string, simulationScenarioId: string, httpContext?: HttpContext): Observable<CheckTopologyResponseDto> {
        let url_ = this.baseUrl + "/api/topology/{instanceId}/{simulationScenarioId}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        if (simulationScenarioId === undefined || simulationScenarioId === null)
            throw new Error("The parameter 'simulationScenarioId' must be defined.");
        url_ = url_.replace("{simulationScenarioId}", encodeURIComponent("" + simulationScenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckTopology(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTopology(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckTopologyResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckTopologyResponseDto>;
        }));
    }

    protected processCheckTopology(response: HttpResponseBase): Observable<CheckTopologyResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckTopologyResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNetWorkElements(instanceId: string, scenarioId: string, httpContext?: HttpContext): Observable<NetworkElementResponseDto[]> {
        let url_ = this.baseUrl + "/api/topology/{instanceId}/{scenarioId}/networkelements";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNetWorkElements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNetWorkElements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NetworkElementResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NetworkElementResponseDto[]>;
        }));
    }

    protected processGetNetWorkElements(response: HttpResponseBase): Observable<NetworkElementResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NetworkElementResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendTopology(instanceId: string, topologyDto: TopologyDto, httpContext?: HttpContext): Observable<SendTopologyResponseDto> {
        let url_ = this.baseUrl + "/api/topology/{instanceId}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topologyDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTopology(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTopology(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendTopologyResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendTopologyResponseDto>;
        }));
    }

    protected processSendTopology(response: HttpResponseBase): Observable<SendTopologyResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendTopologyResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendTopologyStream(instanceId: string, totalChunks: number, chunkIndex: number, chunkData: string, httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/api/topology/send-topology-chunked/{instanceId}/{totalChunks}/{chunkIndex}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        if (totalChunks === undefined || totalChunks === null)
            throw new Error("The parameter 'totalChunks' must be defined.");
        url_ = url_.replace("{totalChunks}", encodeURIComponent("" + totalChunks));
        if (chunkIndex === undefined || chunkIndex === null)
            throw new Error("The parameter 'chunkIndex' must be defined.");
        url_ = url_.replace("{chunkIndex}", encodeURIComponent("" + chunkIndex));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chunkData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTopologyStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTopologyStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendTopologyStream(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    processTopologyStream(instanceId: string, httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/api/topology/process-topology-chunked/{instanceId}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessTopologyStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessTopologyStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processProcessTopologyStream(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISimulationClient {
    startSimulation(instanceId: string, simulationSettings: SimulationParametersDto): Observable<SimulationActionResponseDto>;
    startCyclicSimulation(instanceId: string, simulationSettings: CyclicSimulationParametersDto): Observable<SimulationActionResponseDto>;
    stoptSimulation(instanceId: string): Observable<SimulationActionResponseDto>;
}

@Injectable()
export class SimulationClient implements ISimulationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    startSimulation(instanceId: string, simulationSettings: SimulationParametersDto, httpContext?: HttpContext): Observable<SimulationActionResponseDto> {
        let url_ = this.baseUrl + "/api/simulation/start/{instanceId}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(simulationSettings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartSimulation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartSimulation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimulationActionResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimulationActionResponseDto>;
        }));
    }

    protected processStartSimulation(response: HttpResponseBase): Observable<SimulationActionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimulationActionResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    startCyclicSimulation(instanceId: string, simulationSettings: CyclicSimulationParametersDto, httpContext?: HttpContext): Observable<SimulationActionResponseDto> {
        let url_ = this.baseUrl + "/api/simulation/start-cyclic/{instanceId}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(simulationSettings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartCyclicSimulation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartCyclicSimulation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimulationActionResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimulationActionResponseDto>;
        }));
    }

    protected processStartCyclicSimulation(response: HttpResponseBase): Observable<SimulationActionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimulationActionResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    stoptSimulation(instanceId: string, httpContext?: HttpContext): Observable<SimulationActionResponseDto> {
        let url_ = this.baseUrl + "/api/simulation/stop/{instanceId}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStoptSimulation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStoptSimulation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimulationActionResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimulationActionResponseDto>;
        }));
    }

    protected processStoptSimulation(response: HttpResponseBase): Observable<SimulationActionResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimulationActionResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IResultClient {
    sendResultStream(simulationExecutionId: string, totalChunks: number, chunkIndex: number, chunkData: string): Observable<boolean>;
    processResultStream(simulationExecutionId: string): Observable<boolean>;
    getSnapshotsByInstance(instanceId: string): Observable<SnapshotDto[]>;
    getLayersByScenarioIds(scenarioIds?: string[] | null | undefined): Observable<LayerResponseDto[]>;
    getScenariosResults(scenarioIds?: string[] | null | undefined): Observable<ScenarioAttributeResultDto[]>;
    getMapResults(scenarioIds?: string[] | null | undefined, stepDate?: Date | undefined): Observable<ScenarioAttributeResultDto[]>;
    getChartResults(chartResultsDto: ChartResultDto[]): Observable<ChartResultResponseDto[]>;
    sendScenarioResults(simulationExecutionId: string, resultObjectRequestDto: ResultObjectRequestDto): Observable<ResultObjectRequestCmdResponse>;
    sendSimulationSettings(instanceId: string, simulationSettings: SimulationSettingsDto): Observable<SimulationSettingsResponseDto>;
    sendScenarioSettings(simulationExecutionId: string, scenarioSettings: ScenarioSettingsDto): Observable<ScenarioSettingsResponseDto>;
    publishScenarioResults(simulationExecutionId: string, request: PublishScenarioResultsDto): Observable<PublishScenarioExecutionCmdResponse>;
    setScenarioStatus(scenarioId: string, updateScenarioStatusDto: UpdateScenarioStatusDto): Observable<ScenarioResponseDto>;
    cleanSnapshot(snapshotId: string): Observable<CleanSnapshotResponseDto>;
}

@Injectable()
export class ResultClient implements IResultClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    sendResultStream(simulationExecutionId: string, totalChunks: number, chunkIndex: number, chunkData: string, httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/api/result/send-results-chunked/{simulationExecutionId}/{totalChunks}/{chunkIndex}";
        if (simulationExecutionId === undefined || simulationExecutionId === null)
            throw new Error("The parameter 'simulationExecutionId' must be defined.");
        url_ = url_.replace("{simulationExecutionId}", encodeURIComponent("" + simulationExecutionId));
        if (totalChunks === undefined || totalChunks === null)
            throw new Error("The parameter 'totalChunks' must be defined.");
        url_ = url_.replace("{totalChunks}", encodeURIComponent("" + totalChunks));
        if (chunkIndex === undefined || chunkIndex === null)
            throw new Error("The parameter 'chunkIndex' must be defined.");
        url_ = url_.replace("{chunkIndex}", encodeURIComponent("" + chunkIndex));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chunkData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendResultStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendResultStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendResultStream(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    processResultStream(simulationExecutionId: string, httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/api/result/process-results-chunked/{simulationExecutionId}";
        if (simulationExecutionId === undefined || simulationExecutionId === null)
            throw new Error("The parameter 'simulationExecutionId' must be defined.");
        url_ = url_.replace("{simulationExecutionId}", encodeURIComponent("" + simulationExecutionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessResultStream(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessResultStream(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processProcessResultStream(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSnapshotsByInstance(instanceId: string, httpContext?: HttpContext): Observable<SnapshotDto[]> {
        let url_ = this.baseUrl + "/api/result/{instanceId}/snapshot";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSnapshotsByInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSnapshotsByInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SnapshotDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SnapshotDto[]>;
        }));
    }

    protected processGetSnapshotsByInstance(response: HttpResponseBase): Observable<SnapshotDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SnapshotDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLayersByScenarioIds(scenarioIds?: string[] | null | undefined, httpContext?: HttpContext): Observable<LayerResponseDto[]> {
        let url_ = this.baseUrl + "/api/result/layers?";
        if (scenarioIds !== undefined && scenarioIds !== null)
            scenarioIds && scenarioIds.forEach(item => { url_ += "scenarioIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLayersByScenarioIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLayersByScenarioIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LayerResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LayerResponseDto[]>;
        }));
    }

    protected processGetLayersByScenarioIds(response: HttpResponseBase): Observable<LayerResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LayerResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getScenariosResults(scenarioIds?: string[] | null | undefined, httpContext?: HttpContext): Observable<ScenarioAttributeResultDto[]> {
        let url_ = this.baseUrl + "/api/result?";
        if (scenarioIds !== undefined && scenarioIds !== null)
            scenarioIds && scenarioIds.forEach(item => { url_ += "scenarioIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScenariosResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScenariosResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScenarioAttributeResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScenarioAttributeResultDto[]>;
        }));
    }

    protected processGetScenariosResults(response: HttpResponseBase): Observable<ScenarioAttributeResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScenarioAttributeResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMapResults(scenarioIds?: string[] | null | undefined, stepDate?: Date | undefined, httpContext?: HttpContext): Observable<ScenarioAttributeResultDto[]> {
        let url_ = this.baseUrl + "/api/result/map?";
        if (scenarioIds !== undefined && scenarioIds !== null)
            scenarioIds && scenarioIds.forEach(item => { url_ += "scenarioIds=" + encodeURIComponent("" + item) + "&"; });
        if (stepDate === null)
            throw new Error("The parameter 'stepDate' cannot be null.");
        else if (stepDate !== undefined)
            url_ += "stepDate=" + encodeURIComponent(stepDate ? "" + stepDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMapResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMapResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScenarioAttributeResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScenarioAttributeResultDto[]>;
        }));
    }

    protected processGetMapResults(response: HttpResponseBase): Observable<ScenarioAttributeResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScenarioAttributeResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChartResults(chartResultsDto: ChartResultDto[], httpContext?: HttpContext): Observable<ChartResultResponseDto[]> {
        let url_ = this.baseUrl + "/api/result/chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chartResultsDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChartResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChartResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChartResultResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChartResultResponseDto[]>;
        }));
    }

    protected processGetChartResults(response: HttpResponseBase): Observable<ChartResultResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChartResultResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendScenarioResults(simulationExecutionId: string, resultObjectRequestDto: ResultObjectRequestDto, httpContext?: HttpContext): Observable<ResultObjectRequestCmdResponse> {
        let url_ = this.baseUrl + "/api/result/{simulationExecutionId}";
        if (simulationExecutionId === undefined || simulationExecutionId === null)
            throw new Error("The parameter 'simulationExecutionId' must be defined.");
        url_ = url_.replace("{simulationExecutionId}", encodeURIComponent("" + simulationExecutionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resultObjectRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendScenarioResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendScenarioResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultObjectRequestCmdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultObjectRequestCmdResponse>;
        }));
    }

    protected processSendScenarioResults(response: HttpResponseBase): Observable<ResultObjectRequestCmdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultObjectRequestCmdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendSimulationSettings(instanceId: string, simulationSettings: SimulationSettingsDto, httpContext?: HttpContext): Observable<SimulationSettingsResponseDto> {
        let url_ = this.baseUrl + "/api/result/{instanceId}/scenario";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(simulationSettings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSimulationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSimulationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimulationSettingsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimulationSettingsResponseDto>;
        }));
    }

    protected processSendSimulationSettings(response: HttpResponseBase): Observable<SimulationSettingsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimulationSettingsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendScenarioSettings(simulationExecutionId: string, scenarioSettings: ScenarioSettingsDto, httpContext?: HttpContext): Observable<ScenarioSettingsResponseDto> {
        let url_ = this.baseUrl + "/api/result/{simulationExecutionId}/metadata";
        if (simulationExecutionId === undefined || simulationExecutionId === null)
            throw new Error("The parameter 'simulationExecutionId' must be defined.");
        url_ = url_.replace("{simulationExecutionId}", encodeURIComponent("" + simulationExecutionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scenarioSettings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendScenarioSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendScenarioSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScenarioSettingsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScenarioSettingsResponseDto>;
        }));
    }

    protected processSendScenarioSettings(response: HttpResponseBase): Observable<ScenarioSettingsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScenarioSettingsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    publishScenarioResults(simulationExecutionId: string, request: PublishScenarioResultsDto, httpContext?: HttpContext): Observable<PublishScenarioExecutionCmdResponse> {
        let url_ = this.baseUrl + "/api/result/{simulationExecutionId}/publish";
        if (simulationExecutionId === undefined || simulationExecutionId === null)
            throw new Error("The parameter 'simulationExecutionId' must be defined.");
        url_ = url_.replace("{simulationExecutionId}", encodeURIComponent("" + simulationExecutionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishScenarioResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishScenarioResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublishScenarioExecutionCmdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublishScenarioExecutionCmdResponse>;
        }));
    }

    protected processPublishScenarioResults(response: HttpResponseBase): Observable<PublishScenarioExecutionCmdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublishScenarioExecutionCmdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setScenarioStatus(scenarioId: string, updateScenarioStatusDto: UpdateScenarioStatusDto, httpContext?: HttpContext): Observable<ScenarioResponseDto> {
        let url_ = this.baseUrl + "/api/result/{scenarioId}/scenario";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateScenarioStatusDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetScenarioStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetScenarioStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScenarioResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScenarioResponseDto>;
        }));
    }

    protected processSetScenarioStatus(response: HttpResponseBase): Observable<ScenarioResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScenarioResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cleanSnapshot(snapshotId: string, httpContext?: HttpContext): Observable<CleanSnapshotResponseDto> {
        let url_ = this.baseUrl + "/api/result/{snapshotId}/clean-snapshot";
        if (snapshotId === undefined || snapshotId === null)
            throw new Error("The parameter 'snapshotId' must be defined.");
        url_ = url_.replace("{snapshotId}", encodeURIComponent("" + snapshotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCleanSnapshot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCleanSnapshot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CleanSnapshotResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CleanSnapshotResponseDto>;
        }));
    }

    protected processCleanSnapshot(response: HttpResponseBase): Observable<CleanSnapshotResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CleanSnapshotResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFrontendSettingsClient {
    getFrontendSettings(): Observable<FrontendSettingsDto>;
}

@Injectable()
export class FrontendSettingsClient implements IFrontendSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getFrontendSettings(httpContext?: HttpContext): Observable<FrontendSettingsDto> {
        let url_ = this.baseUrl + "/api/settings/frontend";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFrontendSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFrontendSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FrontendSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FrontendSettingsDto>;
        }));
    }

    protected processGetFrontendSettings(response: HttpResponseBase): Observable<FrontendSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FrontendSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IGroupModelsClient {
    getGroupModelsCrudByGroupId(groupId: number): Observable<GetGroupModelsCrudByGroupIdCmdResponse>;
    saveGroupModelsCrud(dto: SaveGroupModelsCrudDto): Observable<SaveGroupModelsCrudCmdResponse>;
}

@Injectable()
export class GroupModelsClient implements IGroupModelsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getGroupModelsCrudByGroupId(groupId: number, httpContext?: HttpContext): Observable<GetGroupModelsCrudByGroupIdCmdResponse> {
        let url_ = this.baseUrl + "/api/roles/group-models/{groupId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupModelsCrudByGroupId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupModelsCrudByGroupId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGroupModelsCrudByGroupIdCmdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGroupModelsCrudByGroupIdCmdResponse>;
        }));
    }

    protected processGetGroupModelsCrudByGroupId(response: HttpResponseBase): Observable<GetGroupModelsCrudByGroupIdCmdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGroupModelsCrudByGroupIdCmdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveGroupModelsCrud(dto: SaveGroupModelsCrudDto, httpContext?: HttpContext): Observable<SaveGroupModelsCrudCmdResponse> {
        let url_ = this.baseUrl + "/api/roles/group-models";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveGroupModelsCrud(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveGroupModelsCrud(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveGroupModelsCrudCmdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveGroupModelsCrudCmdResponse>;
        }));
    }

    protected processSaveGroupModelsCrud(response: HttpResponseBase): Observable<SaveGroupModelsCrudCmdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveGroupModelsCrudCmdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportClient {
    get(instanceIds?: string[] | null | undefined): Observable<GetReportsResponseDto>;
    getReport(instanceId: string, reportName: string, format: ReportFormat, connectionId?: string | null | undefined): Observable<GetReportResponseDto>;
    getGeneratedReport(instanceId: string, reportName: string): Observable<FileResponse>;
}

@Injectable()
export class ReportClient implements IReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(instanceIds?: string[] | null | undefined, httpContext?: HttpContext): Observable<GetReportsResponseDto> {
        let url_ = this.baseUrl + "/api/report?";
        if (instanceIds !== undefined && instanceIds !== null)
            instanceIds && instanceIds.forEach(item => { url_ += "instanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportsResponseDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetReportsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReport(instanceId: string, reportName: string, format: ReportFormat, connectionId?: string | null | undefined, httpContext?: HttpContext): Observable<GetReportResponseDto> {
        let url_ = this.baseUrl + "/api/report/{instanceId}/{reportName}/{format}?";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        if (reportName === undefined || reportName === null)
            throw new Error("The parameter 'reportName' must be defined.");
        url_ = url_.replace("{reportName}", encodeURIComponent("" + reportName));
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (connectionId !== undefined && connectionId !== null)
            url_ += "connectionId=" + encodeURIComponent("" + connectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReportResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReportResponseDto>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<GetReportResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGeneratedReport(instanceId: string, reportName: string, httpContext?: HttpContext): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/report/{instanceId}/{reportName}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        if (reportName === undefined || reportName === null)
            throw new Error("The parameter 'reportName' must be defined.");
        url_ = url_.replace("{reportName}", encodeURIComponent("" + reportName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneratedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneratedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetGeneratedReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRegisterClient {
    getInstances(): Observable<InstanceResponseDto[]>;
    registerInstance(registerInstanceDto: RegisterInstanceDto): Observable<InstanceResponseDto>;
    updateStatus(updateInstanceDto: UpdateInstanceDto): Observable<InstanceResponseDto>;
    getInstance(instanceId: string): Observable<InstanceResponseDto>;
    unregisterInstance(instanceId: string): Observable<InstanceResponseDto>;
    getInstancesByRealtimeId(realtimeId: string): Observable<InstanceResponseDto[]>;
    deleteInstance(instanceId: string): Observable<InstanceResponseDto>;
    deleteSnapshots(instanceId: string, snapshotIds: string[]): Observable<InstanceResponseDto>;
    deleteScenarios(instanceId: string, snapshotId: string, scenarioIds: string[]): Observable<InstanceResponseDto>;
}

@Injectable()
export class RegisterClient implements IRegisterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getInstances(httpContext?: HttpContext): Observable<InstanceResponseDto[]> {
        let url_ = this.baseUrl + "/api/register";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInstances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInstances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstanceResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstanceResponseDto[]>;
        }));
    }

    protected processGetInstances(response: HttpResponseBase): Observable<InstanceResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstanceResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    registerInstance(registerInstanceDto: RegisterInstanceDto, httpContext?: HttpContext): Observable<InstanceResponseDto> {
        let url_ = this.baseUrl + "/api/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registerInstanceDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstanceResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstanceResponseDto>;
        }));
    }

    protected processRegisterInstance(response: HttpResponseBase): Observable<InstanceResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstanceResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStatus(updateInstanceDto: UpdateInstanceDto, httpContext?: HttpContext): Observable<InstanceResponseDto> {
        let url_ = this.baseUrl + "/api/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateInstanceDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstanceResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstanceResponseDto>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<InstanceResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstanceResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInstance(instanceId: string, httpContext?: HttpContext): Observable<InstanceResponseDto> {
        let url_ = this.baseUrl + "/api/register/{instanceId}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstanceResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstanceResponseDto>;
        }));
    }

    protected processGetInstance(response: HttpResponseBase): Observable<InstanceResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstanceResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unregisterInstance(instanceId: string, httpContext?: HttpContext): Observable<InstanceResponseDto> {
        let url_ = this.baseUrl + "/api/register/{instanceId}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnregisterInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnregisterInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstanceResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstanceResponseDto>;
        }));
    }

    protected processUnregisterInstance(response: HttpResponseBase): Observable<InstanceResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstanceResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInstancesByRealtimeId(realtimeId: string, httpContext?: HttpContext): Observable<InstanceResponseDto[]> {
        let url_ = this.baseUrl + "/api/register/{realtimeId}/operation";
        if (realtimeId === undefined || realtimeId === null)
            throw new Error("The parameter 'realtimeId' must be defined.");
        url_ = url_.replace("{realtimeId}", encodeURIComponent("" + realtimeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInstancesByRealtimeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInstancesByRealtimeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstanceResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstanceResponseDto[]>;
        }));
    }

    protected processGetInstancesByRealtimeId(response: HttpResponseBase): Observable<InstanceResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstanceResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteInstance(instanceId: string, httpContext?: HttpContext): Observable<InstanceResponseDto> {
        let url_ = this.baseUrl + "/api/register/model/{instanceId}";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstanceResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstanceResponseDto>;
        }));
    }

    protected processDeleteInstance(response: HttpResponseBase): Observable<InstanceResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstanceResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSnapshots(instanceId: string, snapshotIds: string[], httpContext?: HttpContext): Observable<InstanceResponseDto> {
        let url_ = this.baseUrl + "/api/register/model/{instanceId}/snapshots";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(snapshotIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSnapshots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSnapshots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstanceResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstanceResponseDto>;
        }));
    }

    protected processDeleteSnapshots(response: HttpResponseBase): Observable<InstanceResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstanceResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteScenarios(instanceId: string, snapshotId: string, scenarioIds: string[], httpContext?: HttpContext): Observable<InstanceResponseDto> {
        let url_ = this.baseUrl + "/api/register/model/{instanceId}/{snapshotId}/scenarios";
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        if (snapshotId === undefined || snapshotId === null)
            throw new Error("The parameter 'snapshotId' must be defined.");
        url_ = url_.replace("{snapshotId}", encodeURIComponent("" + snapshotId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scenarioIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteScenarios(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteScenarios(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstanceResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstanceResponseDto>;
        }));
    }

    protected processDeleteScenarios(response: HttpResponseBase): Observable<InstanceResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstanceResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProfileClient {
    getScenarioProfiles(scenarioIds?: string[] | null | undefined): Observable<GetScenarioProfilesDto>;
    getProfileSerie(profileId: string, date?: Date | undefined): Observable<GetProfileSeriesDto>;
    get(): Observable<ProfileDto>;
    update(input: UpdateProfileDto): Observable<ProfileDto>;
    changePassword(input: ChangePasswordInput): Observable<void>;
}

@Injectable()
export class ProfileClient implements IProfileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getScenarioProfiles(scenarioIds?: string[] | null | undefined, httpContext?: HttpContext): Observable<GetScenarioProfilesDto> {
        let url_ = this.baseUrl + "/api/profile?";
        if (scenarioIds !== undefined && scenarioIds !== null)
            scenarioIds && scenarioIds.forEach(item => { url_ += "scenarioIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScenarioProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScenarioProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetScenarioProfilesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetScenarioProfilesDto>;
        }));
    }

    protected processGetScenarioProfiles(response: HttpResponseBase): Observable<GetScenarioProfilesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetScenarioProfilesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfileSerie(profileId: string, date?: Date | undefined, httpContext?: HttpContext): Observable<GetProfileSeriesDto> {
        let url_ = this.baseUrl + "/api/profile/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileSerie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileSerie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfileSeriesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfileSeriesDto>;
        }));
    }

    protected processGetProfileSerie(response: HttpResponseBase): Observable<GetProfileSeriesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfileSeriesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(httpContext?: HttpContext): Observable<ProfileDto> {
        let url_ = this.baseUrl + "/api/account/my-profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(input: UpdateProfileDto, httpContext?: HttpContext): Observable<ProfileDto> {
        let url_ = this.baseUrl + "/api/account/my-profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePassword(input: ChangePasswordInput, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/account/my-profile/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IWorkspaceMapSettingsClient {
    getByWorkspaceId(workspaceId: string): Observable<WorkspaceMapSettingsDto>;
    upsert(requestDto: WorkspaceMapSettingsDto): Observable<string>;
}

@Injectable()
export class WorkspaceMapSettingsClient implements IWorkspaceMapSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getByWorkspaceId(workspaceId: string, httpContext?: HttpContext): Observable<WorkspaceMapSettingsDto> {
        let url_ = this.baseUrl + "/api/workspace-map-settings/{workspaceId}";
        if (workspaceId === undefined || workspaceId === null)
            throw new Error("The parameter 'workspaceId' must be defined.");
        url_ = url_.replace("{workspaceId}", encodeURIComponent("" + workspaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByWorkspaceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByWorkspaceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkspaceMapSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkspaceMapSettingsDto>;
        }));
    }

    protected processGetByWorkspaceId(response: HttpResponseBase): Observable<WorkspaceMapSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceMapSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = WorkspaceMapSettingsDto.fromJS(resultData204);
            return _observableOf(result204);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsert(requestDto: WorkspaceMapSettingsDto, httpContext?: HttpContext): Observable<string> {
        let url_ = this.baseUrl + "/api/workspace-map-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMultiTenancyClient {
    getMultiTenants(): Observable<MultiTenantDto[]>;
    createTenant(tenantDto: MultiTenantDto): Observable<boolean>;
    getMultiTenant(tenantId: string): Observable<MultiTenantDto>;
    deleteTenant(tenantId: string): Observable<MultiTenantDto>;
}

@Injectable()
export class MultiTenancyClient implements IMultiTenancyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getMultiTenants(httpContext?: HttpContext): Observable<MultiTenantDto[]> {
        let url_ = this.baseUrl + "/api/multitenancy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMultiTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMultiTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MultiTenantDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MultiTenantDto[]>;
        }));
    }

    protected processGetMultiTenants(response: HttpResponseBase): Observable<MultiTenantDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MultiTenantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createTenant(tenantDto: MultiTenantDto, httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/api/multitenancy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenantDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMultiTenant(tenantId: string, httpContext?: HttpContext): Observable<MultiTenantDto> {
        let url_ = this.baseUrl + "/api/multitenancy/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMultiTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMultiTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MultiTenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MultiTenantDto>;
        }));
    }

    protected processGetMultiTenant(response: HttpResponseBase): Observable<MultiTenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MultiTenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteTenant(tenantId: string, httpContext?: HttpContext): Observable<MultiTenantDto> {
        let url_ = this.baseUrl + "/api/multitenancy/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MultiTenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MultiTenantDto>;
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<MultiTenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MultiTenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMapStylesClient {
    getAllStyles(): Observable<MapStyleResponseDto[]>;
    getAllThematics(workspaceId?: string | null | undefined): Observable<LayerThematicStylesDto[]>;
    upsert(id: string | null, requestDto: LayerThematicStylesDto): Observable<boolean>;
    deleteStyle(id: string): Observable<void>;
}

@Injectable()
export class MapStylesClient implements IMapStylesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllStyles(httpContext?: HttpContext): Observable<MapStyleResponseDto[]> {
        let url_ = this.baseUrl + "/api/map/styles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStyles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStyles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapStyleResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapStyleResponseDto[]>;
        }));
    }

    protected processGetAllStyles(response: HttpResponseBase): Observable<MapStyleResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MapStyleResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllThematics(workspaceId?: string | null | undefined, httpContext?: HttpContext): Observable<LayerThematicStylesDto[]> {
        let url_ = this.baseUrl + "/api/map/styles/thematics?";
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllThematics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllThematics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LayerThematicStylesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LayerThematicStylesDto[]>;
        }));
    }

    protected processGetAllThematics(response: HttpResponseBase): Observable<LayerThematicStylesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LayerThematicStylesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsert(id: string | null, requestDto: LayerThematicStylesDto, httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/api/map/styles/thematics/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteStyle(id: string, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/map/styles/thematics/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStyle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStyle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteStyle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IWorkspaceDashboardClient {
    getWorkspacesByUserCode(workspaceId?: string | undefined): Observable<WorkspaceDashboardsSettingDto>;
    createWorkspaceDashboard(workspaceDashboard: WorkspaceDashboardsSettingDto): Observable<WorkspaceDashboardsSettingDto>;
    updateWorkspaceDashboard(workspaceDashboard: WorkspaceDashboardsSettingDto): Observable<WorkspaceDashboardsSettingDto>;
    getDashboardById(dashboardId?: string | undefined): Observable<DashboardDefinitionDto>;
    createDashboard(dashboardDefinition: DashboardDefinitionDto): Observable<DashboardDefinitionDto>;
    updateDashboardDefinition(dashboard: DashboardDefinitionDto): Observable<DashboardDefinitionDto>;
}

@Injectable()
export class WorkspaceDashboardClient implements IWorkspaceDashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getWorkspacesByUserCode(workspaceId?: string | undefined, httpContext?: HttpContext): Observable<WorkspaceDashboardsSettingDto> {
        let url_ = this.baseUrl + "/api/workspace/dashboard?";
        if (workspaceId === null)
            throw new Error("The parameter 'workspaceId' cannot be null.");
        else if (workspaceId !== undefined)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkspacesByUserCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkspacesByUserCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkspaceDashboardsSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkspaceDashboardsSettingDto>;
        }));
    }

    protected processGetWorkspacesByUserCode(response: HttpResponseBase): Observable<WorkspaceDashboardsSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceDashboardsSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createWorkspaceDashboard(workspaceDashboard: WorkspaceDashboardsSettingDto, httpContext?: HttpContext): Observable<WorkspaceDashboardsSettingDto> {
        let url_ = this.baseUrl + "/api/workspace/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workspaceDashboard);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkspaceDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkspaceDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkspaceDashboardsSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkspaceDashboardsSettingDto>;
        }));
    }

    protected processCreateWorkspaceDashboard(response: HttpResponseBase): Observable<WorkspaceDashboardsSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceDashboardsSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateWorkspaceDashboard(workspaceDashboard: WorkspaceDashboardsSettingDto, httpContext?: HttpContext): Observable<WorkspaceDashboardsSettingDto> {
        let url_ = this.baseUrl + "/api/workspace/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workspaceDashboard);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkspaceDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkspaceDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkspaceDashboardsSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkspaceDashboardsSettingDto>;
        }));
    }

    protected processUpdateWorkspaceDashboard(response: HttpResponseBase): Observable<WorkspaceDashboardsSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkspaceDashboardsSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDashboardById(dashboardId?: string | undefined, httpContext?: HttpContext): Observable<DashboardDefinitionDto> {
        let url_ = this.baseUrl + "/api/workspace/dashboard/definition?";
        if (dashboardId === null)
            throw new Error("The parameter 'dashboardId' cannot be null.");
        else if (dashboardId !== undefined)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardDefinitionDto>;
        }));
    }

    protected processGetDashboardById(response: HttpResponseBase): Observable<DashboardDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardDefinitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDashboard(dashboardDefinition: DashboardDefinitionDto, httpContext?: HttpContext): Observable<DashboardDefinitionDto> {
        let url_ = this.baseUrl + "/api/workspace/dashboard/definition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dashboardDefinition);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardDefinitionDto>;
        }));
    }

    protected processCreateDashboard(response: HttpResponseBase): Observable<DashboardDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardDefinitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDashboardDefinition(dashboard: DashboardDefinitionDto, httpContext?: HttpContext): Observable<DashboardDefinitionDto> {
        let url_ = this.baseUrl + "/api/workspace/dashboard/definition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dashboard);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDashboardDefinition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDashboardDefinition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardDefinitionDto>;
        }));
    }

    protected processUpdateDashboardDefinition(response: HttpResponseBase): Observable<DashboardDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardDefinitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IWorkspaceClient {
    getWorkspacesByUserCode(): Observable<CtWorkspaceDto[]>;
    createWorkspace(workspace: CtWorkspaceDto): Observable<CtWorkspaceDto>;
    deleteWorkspace(workspace: CtWorkspaceDto): Observable<void>;
    updateWorkspace(workspace: CtWorkspaceDto): Observable<CtWorkspaceDto>;
    getWorkspaceById(id: string): Observable<CtWorkspaceDto>;
}

@Injectable()
export class WorkspaceClient implements IWorkspaceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getWorkspacesByUserCode(httpContext?: HttpContext): Observable<CtWorkspaceDto[]> {
        let url_ = this.baseUrl + "/api/workspace";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkspacesByUserCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkspacesByUserCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtWorkspaceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtWorkspaceDto[]>;
        }));
    }

    protected processGetWorkspacesByUserCode(response: HttpResponseBase): Observable<CtWorkspaceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CtWorkspaceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createWorkspace(workspace: CtWorkspaceDto, httpContext?: HttpContext): Observable<CtWorkspaceDto> {
        let url_ = this.baseUrl + "/api/workspace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workspace);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtWorkspaceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtWorkspaceDto>;
        }));
    }

    protected processCreateWorkspace(response: HttpResponseBase): Observable<CtWorkspaceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtWorkspaceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteWorkspace(workspace: CtWorkspaceDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/workspace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workspace);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWorkspace(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateWorkspace(workspace: CtWorkspaceDto, httpContext?: HttpContext): Observable<CtWorkspaceDto> {
        let url_ = this.baseUrl + "/api/workspace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workspace);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtWorkspaceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtWorkspaceDto>;
        }));
    }

    protected processUpdateWorkspace(response: HttpResponseBase): Observable<CtWorkspaceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtWorkspaceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWorkspaceById(id: string, httpContext?: HttpContext): Observable<CtWorkspaceDto> {
        let url_ = this.baseUrl + "/api/workspace/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkspaceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkspaceById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CtWorkspaceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CtWorkspaceDto>;
        }));
    }

    protected processGetWorkspaceById(response: HttpResponseBase): Observable<CtWorkspaceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CtWorkspaceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAttributeClient {
    getAttributeValues(snapshotId: string, scenarioId?: string | undefined, networkElementId?: string | undefined, startDate?: Date | undefined, endDate?: Date | undefined, category?: string | null | undefined, attributeNames?: string[] | null | undefined): Observable<AttributeDto[]>;
    getAttributesMetadata(scenarioIds?: string[] | null | undefined): Observable<{ [key: string]: ElementTypeCategoriesDto[]; }>;
    getAttributeDateRange(scenarioIds?: string[] | null | undefined): Observable<DateRangeDto>;
}

@Injectable()
export class AttributeClient implements IAttributeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAttributeValues(snapshotId: string, scenarioId?: string | undefined, networkElementId?: string | undefined, startDate?: Date | undefined, endDate?: Date | undefined, category?: string | null | undefined, attributeNames?: string[] | null | undefined, httpContext?: HttpContext): Observable<AttributeDto[]> {
        let url_ = this.baseUrl + "/api/attribute/{snapshotId}?";
        if (snapshotId === undefined || snapshotId === null)
            throw new Error("The parameter 'snapshotId' must be defined.");
        url_ = url_.replace("{snapshotId}", encodeURIComponent("" + snapshotId));
        if (scenarioId === null)
            throw new Error("The parameter 'scenarioId' cannot be null.");
        else if (scenarioId !== undefined)
            url_ += "ScenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        if (networkElementId === null)
            throw new Error("The parameter 'networkElementId' cannot be null.");
        else if (networkElementId !== undefined)
            url_ += "NetworkElementId=" + encodeURIComponent("" + networkElementId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (category !== undefined && category !== null)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (attributeNames !== undefined && attributeNames !== null)
            attributeNames && attributeNames.forEach(item => { url_ += "AttributeNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttributeValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttributeValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttributeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttributeDto[]>;
        }));
    }

    protected processGetAttributeValues(response: HttpResponseBase): Observable<AttributeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttributeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttributesMetadata(scenarioIds?: string[] | null | undefined, httpContext?: HttpContext): Observable<{ [key: string]: ElementTypeCategoriesDto[]; }> {
        let url_ = this.baseUrl + "/api/attribute/metadata?";
        if (scenarioIds !== undefined && scenarioIds !== null)
            scenarioIds && scenarioIds.forEach(item => { url_ += "scenarioIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttributesMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttributesMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: ElementTypeCategoriesDto[]; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: ElementTypeCategoriesDto[]; }>;
        }));
    }

    protected processGetAttributesMetadata(response: HttpResponseBase): Observable<{ [key: string]: ElementTypeCategoriesDto[]; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? resultData200[key].map((i: any) => ElementTypeCategoriesDto.fromJS(i)) : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttributeDateRange(scenarioIds?: string[] | null | undefined, httpContext?: HttpContext): Observable<DateRangeDto> {
        let url_ = this.baseUrl + "/api/attribute/date-range?";
        if (scenarioIds !== undefined && scenarioIds !== null)
            scenarioIds && scenarioIds.forEach(item => { url_ += "scenarioIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttributeDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttributeDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateRangeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateRangeDto>;
        }));
    }

    protected processGetAttributeDateRange(response: HttpResponseBase): Observable<DateRangeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateRangeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAccountClient {
    register(input: RegisterDto): Observable<IdentityUserDto>;
    sendPasswordResetCode(input: SendPasswordResetCodeDto): Observable<void>;
    verifyPasswordResetToken(input: VerifyPasswordResetTokenInput): Observable<boolean>;
    resetPassword(input: ResetPasswordDto): Observable<void>;
    login(login: UserLoginInfo): Observable<AbpLoginResult>;
    logout(): Observable<void>;
    checkPassword(login: UserLoginInfo): Observable<AbpLoginResult>;
}

@Injectable()
export class AccountClient implements IAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    register(input: RegisterDto, httpContext?: HttpContext): Observable<IdentityUserDto> {
        let url_ = this.baseUrl + "/api/account/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdentityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdentityUserDto>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<IdentityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendPasswordResetCode(input: SendPasswordResetCodeDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/account/send-password-reset-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyPasswordResetToken(input: VerifyPasswordResetTokenInput, httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/api/account/verify-password-reset-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyPasswordResetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyPasswordResetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerifyPasswordResetToken(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPassword(input: ResetPasswordDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/account/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    login(login: UserLoginInfo, httpContext?: HttpContext): Observable<AbpLoginResult> {
        let url_ = this.baseUrl + "/api/account/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AbpLoginResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AbpLoginResult>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<AbpLoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AbpLoginResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logout(httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/account/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkPassword(login: UserLoginInfo, httpContext?: HttpContext): Observable<AbpLoginResult> {
        let url_ = this.baseUrl + "/api/account/check-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AbpLoginResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AbpLoginResult>;
        }));
    }

    protected processCheckPassword(response: HttpResponseBase): Observable<AbpLoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AbpLoginResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDynamicClaimsClient {
    refresh(): Observable<void>;
}

@Injectable()
export class DynamicClaimsClient implements IDynamicClaimsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    refresh(httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/account/dynamic-claims/refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefresh(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefresh(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRefresh(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAbpTenantClient {
    findTenantByName(name: string): Observable<FindTenantResultDto>;
    findTenantById(id: string): Observable<FindTenantResultDto>;
}

@Injectable()
export class AbpTenantClient implements IAbpTenantClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    findTenantByName(name: string, httpContext?: HttpContext): Observable<FindTenantResultDto> {
        let url_ = this.baseUrl + "/api/abp/multi-tenancy/tenants/by-name/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindTenantByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindTenantByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FindTenantResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FindTenantResultDto>;
        }));
    }

    protected processFindTenantByName(response: HttpResponseBase): Observable<FindTenantResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FindTenantResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    findTenantById(id: string, httpContext?: HttpContext): Observable<FindTenantResultDto> {
        let url_ = this.baseUrl + "/api/abp/multi-tenancy/tenants/by-id/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindTenantById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindTenantById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FindTenantResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FindTenantResultDto>;
        }));
    }

    protected processFindTenantById(response: HttpResponseBase): Observable<FindTenantResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FindTenantResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IIdentityRoleClient {
    getAllList(): Observable<ListResultDtoOfIdentityRoleDto>;
    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) Maximum result count should be returned.
    This is generally used to limit result count on paging.
     */
    getList(filter?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfIdentityRoleDto>;
    create(input: IdentityRoleCreateDto): Observable<IdentityRoleDto>;
    get(id: string): Observable<IdentityRoleDto>;
    update(id: string, input: IdentityRoleUpdateDto): Observable<IdentityRoleDto>;
    delete(id: string): Observable<void>;
}

@Injectable()
export class IdentityRoleClient implements IIdentityRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllList(httpContext?: HttpContext): Observable<ListResultDtoOfIdentityRoleDto> {
        let url_ = this.baseUrl + "/api/identity/roles/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfIdentityRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfIdentityRoleDto>;
        }));
    }

    protected processGetAllList(response: HttpResponseBase): Observable<ListResultDtoOfIdentityRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfIdentityRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) Maximum result count should be returned.
    This is generally used to limit result count on paging.
     */
    getList(filter?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, httpContext?: HttpContext): Observable<PagedResultDtoOfIdentityRoleDto> {
        let url_ = this.baseUrl + "/api/identity/roles?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfIdentityRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfIdentityRoleDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultDtoOfIdentityRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfIdentityRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(input: IdentityRoleCreateDto, httpContext?: HttpContext): Observable<IdentityRoleDto> {
        let url_ = this.baseUrl + "/api/identity/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdentityRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdentityRoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<IdentityRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: string, httpContext?: HttpContext): Observable<IdentityRoleDto> {
        let url_ = this.baseUrl + "/api/identity/roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdentityRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdentityRoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<IdentityRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, input: IdentityRoleUpdateDto, httpContext?: HttpContext): Observable<IdentityRoleDto> {
        let url_ = this.baseUrl + "/api/identity/roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdentityRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdentityRoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<IdentityRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/identity/roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IIdentityUserClient {
    get(id: string): Observable<IdentityUserDto>;
    update(id: string, input: IdentityUserUpdateDto): Observable<IdentityUserDto>;
    delete(id: string): Observable<void>;
    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) Maximum result count should be returned.
    This is generally used to limit result count on paging.
     */
    getList(filter?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfIdentityUserDto>;
    create(input: IdentityUserCreateDto): Observable<IdentityUserDto>;
    getRoles(id: string): Observable<ListResultDtoOfIdentityRoleDto>;
    updateRoles(id: string, input: IdentityUserUpdateRolesDto): Observable<void>;
    getAssignableRoles(): Observable<ListResultDtoOfIdentityRoleDto>;
    findByUsername(userName: string): Observable<IdentityUserDto>;
    findByEmail(email: string): Observable<IdentityUserDto>;
}

@Injectable()
export class IdentityUserClient implements IIdentityUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: string, httpContext?: HttpContext): Observable<IdentityUserDto> {
        let url_ = this.baseUrl + "/api/identity/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdentityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdentityUserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<IdentityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, input: IdentityUserUpdateDto, httpContext?: HttpContext): Observable<IdentityUserDto> {
        let url_ = this.baseUrl + "/api/identity/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdentityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdentityUserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<IdentityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/identity/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) Maximum result count should be returned.
    This is generally used to limit result count on paging.
     */
    getList(filter?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, httpContext?: HttpContext): Observable<PagedResultDtoOfIdentityUserDto> {
        let url_ = this.baseUrl + "/api/identity/users?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfIdentityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfIdentityUserDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultDtoOfIdentityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfIdentityUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(input: IdentityUserCreateDto, httpContext?: HttpContext): Observable<IdentityUserDto> {
        let url_ = this.baseUrl + "/api/identity/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdentityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdentityUserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<IdentityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRoles(id: string, httpContext?: HttpContext): Observable<ListResultDtoOfIdentityRoleDto> {
        let url_ = this.baseUrl + "/api/identity/users/{id}/roles";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfIdentityRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfIdentityRoleDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfIdentityRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfIdentityRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateRoles(id: string, input: IdentityUserUpdateRolesDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/identity/users/{id}/roles";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRoles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssignableRoles(httpContext?: HttpContext): Observable<ListResultDtoOfIdentityRoleDto> {
        let url_ = this.baseUrl + "/api/identity/users/assignable-roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignableRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignableRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfIdentityRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfIdentityRoleDto>;
        }));
    }

    protected processGetAssignableRoles(response: HttpResponseBase): Observable<ListResultDtoOfIdentityRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfIdentityRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    findByUsername(userName: string, httpContext?: HttpContext): Observable<IdentityUserDto> {
        let url_ = this.baseUrl + "/api/identity/users/by-username/{userName}";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindByUsername(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindByUsername(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdentityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdentityUserDto>;
        }));
    }

    protected processFindByUsername(response: HttpResponseBase): Observable<IdentityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    findByEmail(email: string, httpContext?: HttpContext): Observable<IdentityUserDto> {
        let url_ = this.baseUrl + "/api/identity/users/by-email/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdentityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdentityUserDto>;
        }));
    }

    protected processFindByEmail(response: HttpResponseBase): Observable<IdentityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IIdentityUserLookupClient {
    findById(id: string): Observable<UserData>;
    findByUserName(userName: string): Observable<UserData>;
    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) Maximum result count should be returned.
    This is generally used to limit result count on paging.
     */
    search(filter?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<ListResultDtoOfUserData>;
    getCount(filter?: string | null | undefined): Observable<number>;
}

@Injectable()
export class IdentityUserLookupClient implements IIdentityUserLookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    findById(id: string, httpContext?: HttpContext): Observable<UserData> {
        let url_ = this.baseUrl + "/api/identity/users/lookup/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserData>;
        }));
    }

    protected processFindById(response: HttpResponseBase): Observable<UserData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    findByUserName(userName: string, httpContext?: HttpContext): Observable<UserData> {
        let url_ = this.baseUrl + "/api/identity/users/lookup/by-username/{userName}";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindByUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserData>;
        }));
    }

    protected processFindByUserName(response: HttpResponseBase): Observable<UserData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) Maximum result count should be returned.
    This is generally used to limit result count on paging.
     */
    search(filter?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, httpContext?: HttpContext): Observable<ListResultDtoOfUserData> {
        let url_ = this.baseUrl + "/api/identity/users/lookup/search?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserData>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ListResultDtoOfUserData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCount(filter?: string | null | undefined, httpContext?: HttpContext): Observable<number> {
        let url_ = this.baseUrl + "/api/identity/users/lookup/count?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITenantClient {
    get(id: string): Observable<TenantDto>;
    update(id: string, input: TenantUpdateDto): Observable<TenantDto>;
    delete(id: string): Observable<void>;
    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) Maximum result count should be returned.
    This is generally used to limit result count on paging.
     */
    getList(filter?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): Observable<PagedResultDtoOfTenantDto>;
    create(input: TenantCreateDto): Observable<TenantDto>;
    getDefaultConnectionString(id: string): Observable<string>;
    updateDefaultConnectionString(id: string, defaultConnectionString?: string | null | undefined): Observable<void>;
    deleteDefaultConnectionString(id: string): Observable<void>;
}

@Injectable()
export class TenantClient implements ITenantClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: string, httpContext?: HttpContext): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/multi-tenancy/tenants/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, input: TenantUpdateDto, httpContext?: HttpContext): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/multi-tenancy/tenants/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/multi-tenancy/tenants/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) Maximum result count should be returned.
    This is generally used to limit result count on paging.
     */
    getList(filter?: string | null | undefined, sorting?: string | null | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, httpContext?: HttpContext): Observable<PagedResultDtoOfTenantDto> {
        let url_ = this.baseUrl + "/api/multi-tenancy/tenants?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTenantDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultDtoOfTenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(input: TenantCreateDto, httpContext?: HttpContext): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/multi-tenancy/tenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDefaultConnectionString(id: string, httpContext?: HttpContext): Observable<string> {
        let url_ = this.baseUrl + "/api/multi-tenancy/tenants/{id}/default-connection-string";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultConnectionString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultConnectionString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDefaultConnectionString(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDefaultConnectionString(id: string, defaultConnectionString?: string | null | undefined, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/multi-tenancy/tenants/{id}/default-connection-string?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (defaultConnectionString !== undefined && defaultConnectionString !== null)
            url_ += "defaultConnectionString=" + encodeURIComponent("" + defaultConnectionString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDefaultConnectionString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDefaultConnectionString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDefaultConnectionString(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDefaultConnectionString(id: string, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/multi-tenancy/tenants/{id}/default-connection-string";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDefaultConnectionString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDefaultConnectionString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDefaultConnectionString(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFeaturesClient {
    get(providerName?: string | null | undefined, providerKey?: string | null | undefined): Observable<GetFeatureListResultDto>;
    update(input: UpdateFeaturesDto, providerName?: string | null | undefined, providerKey?: string | null | undefined): Observable<void>;
    delete(providerName?: string | null | undefined, providerKey?: string | null | undefined): Observable<void>;
}

@Injectable()
export class FeaturesClient implements IFeaturesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(providerName?: string | null | undefined, providerKey?: string | null | undefined, httpContext?: HttpContext): Observable<GetFeatureListResultDto> {
        let url_ = this.baseUrl + "/api/feature-management/features?";
        if (providerName !== undefined && providerName !== null)
            url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
        if (providerKey !== undefined && providerKey !== null)
            url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFeatureListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFeatureListResultDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetFeatureListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFeatureListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(input: UpdateFeaturesDto, providerName?: string | null | undefined, providerKey?: string | null | undefined, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/feature-management/features?";
        if (providerName !== undefined && providerName !== null)
            url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
        if (providerKey !== undefined && providerKey !== null)
            url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(providerName?: string | null | undefined, providerKey?: string | null | undefined, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/feature-management/features?";
        if (providerName !== undefined && providerName !== null)
            url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
        if (providerKey !== undefined && providerKey !== null)
            url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAbpApplicationConfigurationClient {
    /**
     * @param includeLocalizationResources (optional) Set to true to fill the Values property in Localization.
     */
    get(includeLocalizationResources?: boolean | undefined): Observable<ApplicationConfigurationDto>;
}

@Injectable()
export class AbpApplicationConfigurationClient implements IAbpApplicationConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param includeLocalizationResources (optional) Set to true to fill the Values property in Localization.
     */
    get(includeLocalizationResources?: boolean | undefined, httpContext?: HttpContext): Observable<ApplicationConfigurationDto> {
        let url_ = this.baseUrl + "/api/abp/application-configuration?";
        if (includeLocalizationResources === null)
            throw new Error("The parameter 'includeLocalizationResources' cannot be null.");
        else if (includeLocalizationResources !== undefined)
            url_ += "IncludeLocalizationResources=" + encodeURIComponent("" + includeLocalizationResources) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationConfigurationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApplicationConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAbpApplicationLocalizationClient {
    get(cultureName?: string | undefined, onlyDynamics?: boolean | undefined): Observable<ApplicationLocalizationDto>;
}

@Injectable()
export class AbpApplicationLocalizationClient implements IAbpApplicationLocalizationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(cultureName?: string | undefined, onlyDynamics?: boolean | undefined, httpContext?: HttpContext): Observable<ApplicationLocalizationDto> {
        let url_ = this.baseUrl + "/api/abp/application-localization?";
        if (cultureName === null)
            throw new Error("The parameter 'cultureName' cannot be null.");
        else if (cultureName !== undefined)
            url_ += "CultureName=" + encodeURIComponent("" + cultureName) + "&";
        if (onlyDynamics === null)
            throw new Error("The parameter 'onlyDynamics' cannot be null.");
        else if (onlyDynamics !== undefined)
            url_ += "OnlyDynamics=" + encodeURIComponent("" + onlyDynamics) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationLocalizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationLocalizationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApplicationLocalizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationLocalizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAbpApiDefinitionClient {
    get(includeTypes?: boolean | undefined): Observable<ApplicationApiDescriptionModel>;
}

@Injectable()
export class AbpApiDefinitionClient implements IAbpApiDefinitionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(includeTypes?: boolean | undefined, httpContext?: HttpContext): Observable<ApplicationApiDescriptionModel> {
        let url_ = this.baseUrl + "/api/abp/api-definition?";
        if (includeTypes === null)
            throw new Error("The parameter 'includeTypes' cannot be null.");
        else if (includeTypes !== undefined)
            url_ += "IncludeTypes=" + encodeURIComponent("" + includeTypes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationApiDescriptionModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationApiDescriptionModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApplicationApiDescriptionModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationApiDescriptionModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 501) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class VersionInfoDtoBase implements IVersionInfoDtoBase {
    productsVersion?: { [key: string]: string; } | undefined;
    maxUsers?: number;
    expiration?: string | undefined;
    enabledModules?: string[] | undefined;

    constructor(data?: IVersionInfoDtoBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["productsVersion"]) {
                this.productsVersion = {} as any;
                for (let key in _data["productsVersion"]) {
                    if (_data["productsVersion"].hasOwnProperty(key))
                        (<any>this.productsVersion)![key] = _data["productsVersion"][key];
                }
            }
            this.maxUsers = _data["maxUsers"];
            this.expiration = _data["expiration"];
            if (Array.isArray(_data["enabledModules"])) {
                this.enabledModules = [] as any;
                for (let item of _data["enabledModules"])
                    this.enabledModules!.push(item);
            }
        }
    }

    static fromJS(data: any): VersionInfoDtoBase {
        data = typeof data === 'object' ? data : {};
        let result = new VersionInfoDtoBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.productsVersion) {
            data["productsVersion"] = {};
            for (let key in this.productsVersion) {
                if (this.productsVersion.hasOwnProperty(key))
                    (<any>data["productsVersion"])[key] = (<any>this.productsVersion)[key];
            }
        }
        data["maxUsers"] = this.maxUsers;
        data["expiration"] = this.expiration;
        if (Array.isArray(this.enabledModules)) {
            data["enabledModules"] = [];
            for (let item of this.enabledModules)
                data["enabledModules"].push(item);
        }
        return data;
    }

    clone(): VersionInfoDtoBase {
        const json = this.toJSON();
        let result = new VersionInfoDtoBase();
        result.init(json);
        return result;
    }
}

export interface IVersionInfoDtoBase {
    productsVersion?: { [key: string]: string; } | undefined;
    maxUsers?: number;
    expiration?: string | undefined;
    enabledModules?: string[] | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export class SignalTelemetryDto implements ISignalTelemetryDto {
    signalId?: number | undefined;
    unitTypeId?: number;
    sourceSystemId?: number;
    pointId?: string | undefined;
    pointDescription?: string | undefined;
    isPointOfInterest?: boolean;
    dimensionTypeId?: number | undefined;

    constructor(data?: ISignalTelemetryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signalId = _data["signalId"];
            this.unitTypeId = _data["unitTypeId"];
            this.sourceSystemId = _data["sourceSystemId"];
            this.pointId = _data["pointId"];
            this.pointDescription = _data["pointDescription"];
            this.isPointOfInterest = _data["isPointOfInterest"];
            this.dimensionTypeId = _data["dimensionTypeId"];
        }
    }

    static fromJS(data: any): SignalTelemetryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignalTelemetryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signalId"] = this.signalId;
        data["unitTypeId"] = this.unitTypeId;
        data["sourceSystemId"] = this.sourceSystemId;
        data["pointId"] = this.pointId;
        data["pointDescription"] = this.pointDescription;
        data["isPointOfInterest"] = this.isPointOfInterest;
        data["dimensionTypeId"] = this.dimensionTypeId;
        return data;
    }

    clone(): SignalTelemetryDto {
        const json = this.toJSON();
        let result = new SignalTelemetryDto();
        result.init(json);
        return result;
    }
}

export interface ISignalTelemetryDto {
    signalId?: number | undefined;
    unitTypeId?: number;
    sourceSystemId?: number;
    pointId?: string | undefined;
    pointDescription?: string | undefined;
    isPointOfInterest?: boolean;
    dimensionTypeId?: number | undefined;
}

export class PointReplacementResponseDto implements IPointReplacementResponseDto {
    message?: string | undefined;
    hasErrors?: boolean;

    constructor(data?: IPointReplacementResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.hasErrors = _data["hasErrors"];
        }
    }

    static fromJS(data: any): PointReplacementResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointReplacementResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["hasErrors"] = this.hasErrors;
        return data;
    }

    clone(): PointReplacementResponseDto {
        const json = this.toJSON();
        let result = new PointReplacementResponseDto();
        result.init(json);
        return result;
    }
}

export interface IPointReplacementResponseDto {
    message?: string | undefined;
    hasErrors?: boolean;
}

export class PointReplacementDto implements IPointReplacementDto {
    destinationPointId?: string | undefined;
    sourcePointId?: string | undefined;
    userCode?: string | undefined;

    constructor(data?: IPointReplacementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinationPointId = _data["destinationPointId"];
            this.sourcePointId = _data["sourcePointId"];
            this.userCode = _data["userCode"];
        }
    }

    static fromJS(data: any): PointReplacementDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointReplacementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationPointId"] = this.destinationPointId;
        data["sourcePointId"] = this.sourcePointId;
        data["userCode"] = this.userCode;
        return data;
    }

    clone(): PointReplacementDto {
        const json = this.toJSON();
        let result = new PointReplacementDto();
        result.init(json);
        return result;
    }
}

export interface IPointReplacementDto {
    destinationPointId?: string | undefined;
    sourcePointId?: string | undefined;
    userCode?: string | undefined;
}

export class SourceSystemDto implements ISourceSystemDto {
    sourceSystemId?: number;
    sourceSystemDescription?: string | undefined;

    constructor(data?: ISourceSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceSystemId = _data["sourceSystemId"];
            this.sourceSystemDescription = _data["sourceSystemDescription"];
        }
    }

    static fromJS(data: any): SourceSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourceSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceSystemId"] = this.sourceSystemId;
        data["sourceSystemDescription"] = this.sourceSystemDescription;
        return data;
    }

    clone(): SourceSystemDto {
        const json = this.toJSON();
        let result = new SourceSystemDto();
        result.init(json);
        return result;
    }
}

export interface ISourceSystemDto {
    sourceSystemId?: number;
    sourceSystemDescription?: string | undefined;
}

export class ListResultDtoOfSummaryDynamicResponse implements IListResultDtoOfSummaryDynamicResponse {
    /** List of items. */
    items?: SummaryDynamicResponse[];

    constructor(data?: IListResultDtoOfSummaryDynamicResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SummaryDynamicResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSummaryDynamicResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSummaryDynamicResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfSummaryDynamicResponse {
        const json = this.toJSON();
        let result = new ListResultDtoOfSummaryDynamicResponse();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfSummaryDynamicResponse {
    /** List of items. */
    items?: SummaryDynamicResponse[];
}

/** Implements IPagedResult`1. */
export class PagedResultDtoOfSummaryDynamicResponse extends ListResultDtoOfSummaryDynamicResponse implements IPagedResultDtoOfSummaryDynamicResponse {
    /** Total count of Items. */
    totalCount?: number;

    constructor(data?: IPagedResultDtoOfSummaryDynamicResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfSummaryDynamicResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSummaryDynamicResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultDtoOfSummaryDynamicResponse {
        const json = this.toJSON();
        let result = new PagedResultDtoOfSummaryDynamicResponse();
        result.init(json);
        return result;
    }
}

/** Implements IPagedResult`1. */
export interface IPagedResultDtoOfSummaryDynamicResponse extends IListResultDtoOfSummaryDynamicResponse {
    /** Total count of Items. */
    totalCount?: number;
}

export class SummaryDynamicResponse implements ISummaryDynamicResponse {
    identifier?: string | undefined;
    properties?: { [key: string]: any; } | undefined;

    constructor(data?: ISummaryDynamicResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): SummaryDynamicResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryDynamicResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        return data;
    }

    clone(): SummaryDynamicResponse {
        const json = this.toJSON();
        let result = new SummaryDynamicResponse();
        result.init(json);
        return result;
    }
}

export interface ISummaryDynamicResponse {
    identifier?: string | undefined;
    properties?: { [key: string]: any; } | undefined;
}

/** This defines a composite OData query options that can be used to perform query composition. Currently this only supports $filter, $orderby, $top, $skip, and $count. */
export class ODataQueryOptions implements IODataQueryOptions {
    /** Gets the request message associated with this instance. */
    request?: HttpRequest | undefined;
    /** Gets the given ODataQueryContext
             */
    context?: ODataQueryContext | undefined;
    /** Gets the raw string of all the OData query options */
    rawValues?: ODataRawQueryOptions | undefined;
    /** Gets the SelectExpandQueryOption. */
    selectExpand?: SelectExpandQueryOption | undefined;
    /** Gets the ApplyQueryOption. */
    apply?: ApplyQueryOption | undefined;
    /** Gets the ComputeQueryOption. */
    compute?: ComputeQueryOption | undefined;
    /** Gets the FilterQueryOption. */
    filter?: FilterQueryOption | undefined;
    /** Gets the SearchQueryOption. */
    search?: SearchQueryOption | undefined;
    /** Gets the OrderByQueryOption. */
    orderBy?: OrderByQueryOption | undefined;
    /** Gets the SkipQueryOption. */
    skip?: SkipQueryOption | undefined;
    /** Gets the SkipTokenQueryOption. */
    skipToken?: SkipTokenQueryOption | undefined;
    /** Gets the TopQueryOption. */
    top?: TopQueryOption | undefined;
    /** Gets the CountQueryOption. */
    count?: CountQueryOption | undefined;
    /** Gets or sets the query validator. */
    validator?: ODataQueryValidator | undefined;
    /** Gets the ETag from IfMatch header. */
    ifMatch?: ETag | undefined;
    /** Gets the ETag from IfNoneMatch header. */
    ifNoneMatch?: ETag | undefined;

    constructor(data?: IODataQueryOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? HttpRequest.fromJS(_data["request"]) : <any>undefined;
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : <any>undefined;
            this.rawValues = _data["rawValues"] ? ODataRawQueryOptions.fromJS(_data["rawValues"]) : <any>undefined;
            this.selectExpand = _data["selectExpand"] ? SelectExpandQueryOption.fromJS(_data["selectExpand"]) : <any>undefined;
            this.apply = _data["apply"] ? ApplyQueryOption.fromJS(_data["apply"]) : <any>undefined;
            this.compute = _data["compute"] ? ComputeQueryOption.fromJS(_data["compute"]) : <any>undefined;
            this.filter = _data["filter"] ? FilterQueryOption.fromJS(_data["filter"]) : <any>undefined;
            this.search = _data["search"] ? SearchQueryOption.fromJS(_data["search"]) : <any>undefined;
            this.orderBy = _data["orderBy"] ? OrderByQueryOption.fromJS(_data["orderBy"]) : <any>undefined;
            this.skip = _data["skip"] ? SkipQueryOption.fromJS(_data["skip"]) : <any>undefined;
            this.skipToken = _data["skipToken"] ? SkipTokenQueryOption.fromJS(_data["skipToken"]) : <any>undefined;
            this.top = _data["top"] ? TopQueryOption.fromJS(_data["top"]) : <any>undefined;
            this.count = _data["count"] ? CountQueryOption.fromJS(_data["count"]) : <any>undefined;
            this.validator = _data["validator"] ? ODataQueryValidator.fromJS(_data["validator"]) : <any>undefined;
            this.ifMatch = _data["ifMatch"] ? ETag.fromJS(_data["ifMatch"]) : <any>undefined;
            this.ifNoneMatch = _data["ifNoneMatch"] ? ETag.fromJS(_data["ifNoneMatch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ODataQueryOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ODataQueryOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["rawValues"] = this.rawValues ? this.rawValues.toJSON() : <any>undefined;
        data["selectExpand"] = this.selectExpand ? this.selectExpand.toJSON() : <any>undefined;
        data["apply"] = this.apply ? this.apply.toJSON() : <any>undefined;
        data["compute"] = this.compute ? this.compute.toJSON() : <any>undefined;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["search"] = this.search ? this.search.toJSON() : <any>undefined;
        data["orderBy"] = this.orderBy ? this.orderBy.toJSON() : <any>undefined;
        data["skip"] = this.skip ? this.skip.toJSON() : <any>undefined;
        data["skipToken"] = this.skipToken ? this.skipToken.toJSON() : <any>undefined;
        data["top"] = this.top ? this.top.toJSON() : <any>undefined;
        data["count"] = this.count ? this.count.toJSON() : <any>undefined;
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["ifMatch"] = this.ifMatch ? this.ifMatch.toJSON() : <any>undefined;
        data["ifNoneMatch"] = this.ifNoneMatch ? this.ifNoneMatch.toJSON() : <any>undefined;
        return data;
    }

    clone(): ODataQueryOptions {
        const json = this.toJSON();
        let result = new ODataQueryOptions();
        result.init(json);
        return result;
    }
}

/** This defines a composite OData query options that can be used to perform query composition. Currently this only supports $filter, $orderby, $top, $skip, and $count. */
export interface IODataQueryOptions {
    /** Gets the request message associated with this instance. */
    request?: HttpRequest | undefined;
    /** Gets the given ODataQueryContext
             */
    context?: ODataQueryContext | undefined;
    /** Gets the raw string of all the OData query options */
    rawValues?: ODataRawQueryOptions | undefined;
    /** Gets the SelectExpandQueryOption. */
    selectExpand?: SelectExpandQueryOption | undefined;
    /** Gets the ApplyQueryOption. */
    apply?: ApplyQueryOption | undefined;
    /** Gets the ComputeQueryOption. */
    compute?: ComputeQueryOption | undefined;
    /** Gets the FilterQueryOption. */
    filter?: FilterQueryOption | undefined;
    /** Gets the SearchQueryOption. */
    search?: SearchQueryOption | undefined;
    /** Gets the OrderByQueryOption. */
    orderBy?: OrderByQueryOption | undefined;
    /** Gets the SkipQueryOption. */
    skip?: SkipQueryOption | undefined;
    /** Gets the SkipTokenQueryOption. */
    skipToken?: SkipTokenQueryOption | undefined;
    /** Gets the TopQueryOption. */
    top?: TopQueryOption | undefined;
    /** Gets the CountQueryOption. */
    count?: CountQueryOption | undefined;
    /** Gets or sets the query validator. */
    validator?: ODataQueryValidator | undefined;
    /** Gets the ETag from IfMatch header. */
    ifMatch?: ETag | undefined;
    /** Gets the ETag from IfNoneMatch header. */
    ifNoneMatch?: ETag | undefined;
}

/** This defines a composite OData query options that can be used to perform query composition. Currently this only supports $filter, $orderby, $top, $skip. */
export class ODataQueryOptionsOfSummaryDynamicResponse extends ODataQueryOptions implements IODataQueryOptionsOfSummaryDynamicResponse {
    ifMatch?: ETagOfSummaryDynamicResponse | undefined;
    ifNoneMatch?: ETagOfSummaryDynamicResponse | undefined;

    constructor(data?: IODataQueryOptionsOfSummaryDynamicResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ifMatch = _data["ifMatch"] ? ETagOfSummaryDynamicResponse.fromJS(_data["ifMatch"]) : <any>undefined;
            this.ifNoneMatch = _data["ifNoneMatch"] ? ETagOfSummaryDynamicResponse.fromJS(_data["ifNoneMatch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ODataQueryOptionsOfSummaryDynamicResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ODataQueryOptionsOfSummaryDynamicResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ifMatch"] = this.ifMatch ? this.ifMatch.toJSON() : <any>undefined;
        data["ifNoneMatch"] = this.ifNoneMatch ? this.ifNoneMatch.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): ODataQueryOptionsOfSummaryDynamicResponse {
        const json = this.toJSON();
        let result = new ODataQueryOptionsOfSummaryDynamicResponse();
        result.init(json);
        return result;
    }
}

/** This defines a composite OData query options that can be used to perform query composition. Currently this only supports $filter, $orderby, $top, $skip. */
export interface IODataQueryOptionsOfSummaryDynamicResponse extends IODataQueryOptions {
    ifMatch?: ETagOfSummaryDynamicResponse | undefined;
    ifNoneMatch?: ETagOfSummaryDynamicResponse | undefined;
}

export class DynamicObject implements IDynamicObject {

    constructor(data?: IDynamicObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DynamicObject {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): DynamicObject {
        const json = this.toJSON();
        let result = new DynamicObject();
        result.init(json);
        return result;
    }
}

export interface IDynamicObject {
}

/** The ETag parsed from request. */
export class ETag extends DynamicObject implements IETag {
    item?: any | undefined;
    /** Gets or sets whether the ETag is well-formed. */
    isWellFormed?: boolean;
    /** Gets or sets an entity type of the ETag. */
    entityType?: string | undefined;
    /** Gets or sets whether the ETag is corresponding to "*". */
    isAny?: boolean;
    /** Gets or sets whether If-None-Match set in the request header. */
    isIfNoneMatch?: boolean;
    concurrencyProperties?: { [key: string]: any; } | undefined;

    constructor(data?: IETag) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.item = _data["Item"];
            this.isWellFormed = _data["IsWellFormed"];
            this.entityType = _data["EntityType"];
            this.isAny = _data["IsAny"];
            this.isIfNoneMatch = _data["IsIfNoneMatch"];
            if (_data["ConcurrencyProperties"]) {
                this.concurrencyProperties = {} as any;
                for (let key in _data["ConcurrencyProperties"]) {
                    if (_data["ConcurrencyProperties"].hasOwnProperty(key))
                        (<any>this.concurrencyProperties)![key] = _data["ConcurrencyProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): ETag {
        data = typeof data === 'object' ? data : {};
        let result = new ETag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Item"] = this.item;
        data["IsWellFormed"] = this.isWellFormed;
        data["EntityType"] = this.entityType;
        data["IsAny"] = this.isAny;
        data["IsIfNoneMatch"] = this.isIfNoneMatch;
        if (this.concurrencyProperties) {
            data["ConcurrencyProperties"] = {};
            for (let key in this.concurrencyProperties) {
                if (this.concurrencyProperties.hasOwnProperty(key))
                    (<any>data["ConcurrencyProperties"])[key] = (<any>this.concurrencyProperties)[key];
            }
        }
        super.toJSON(data);
        return data;
    }

    clone(): ETag {
        const json = this.toJSON();
        let result = new ETag();
        result.init(json);
        return result;
    }
}

/** The ETag parsed from request. */
export interface IETag extends IDynamicObject {
    item?: any | undefined;
    /** Gets or sets whether the ETag is well-formed. */
    isWellFormed?: boolean;
    /** Gets or sets an entity type of the ETag. */
    entityType?: string | undefined;
    /** Gets or sets whether the ETag is corresponding to "*". */
    isAny?: boolean;
    /** Gets or sets whether If-None-Match set in the request header. */
    isIfNoneMatch?: boolean;
    concurrencyProperties?: { [key: string]: any; } | undefined;
}

/** OData ETag of an entity type . */
export class ETagOfSummaryDynamicResponse extends ETag implements IETagOfSummaryDynamicResponse {

    constructor(data?: IETagOfSummaryDynamicResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ETagOfSummaryDynamicResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ETagOfSummaryDynamicResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ETagOfSummaryDynamicResponse {
        const json = this.toJSON();
        let result = new ETagOfSummaryDynamicResponse();
        result.init(json);
        return result;
    }
}

/** OData ETag of an entity type . */
export interface IETagOfSummaryDynamicResponse extends IETag {
}

export abstract class HttpRequest implements IHttpRequest {
    bodyReader?: PipeReader;
    routeValues?: any[];

    constructor(data?: IHttpRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bodyReader = _data["bodyReader"] ? PipeReader.fromJS(_data["bodyReader"]) : <any>undefined;
            if (Array.isArray(_data["routeValues"])) {
                this.routeValues = [] as any;
                for (let item of _data["routeValues"])
                    this.routeValues!.push(item);
            }
        }
    }

    static fromJS(data: any): HttpRequest {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'HttpRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bodyReader"] = this.bodyReader ? this.bodyReader.toJSON() : <any>undefined;
        if (Array.isArray(this.routeValues)) {
            data["routeValues"] = [];
            for (let item of this.routeValues)
                data["routeValues"].push(item);
        }
        return data;
    }

    clone(): HttpRequest {
        throw new Error("The abstract class 'HttpRequest' cannot be instantiated.");
    }
}

export interface IHttpRequest {
    bodyReader?: PipeReader;
    routeValues?: any[];
}

/** Defines a class that provides access to a read side of pipe. */
export abstract class PipeReader implements IPipeReader {

    constructor(data?: IPipeReader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PipeReader {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PipeReader' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): PipeReader {
        throw new Error("The abstract class 'PipeReader' cannot be instantiated.");
    }
}

/** Defines a class that provides access to a read side of pipe. */
export interface IPipeReader {
}

/** This defines some context information used to perform query composition. */
export class ODataQueryContext implements IODataQueryContext {
    /** Gets the given DefaultQuerySettings. */
    defaultQuerySettings?: DefaultQuerySettings | undefined;
    /** Gets the given IEdmModel that contains the EntitySet. */
    model?: IEdmModel | undefined;
    /** Gets the IEdmType of the element. */
    elementType?: IEdmType | undefined;
    /** Gets the IEdmNavigationSource that contains the element. */
    navigationSource?: IEdmNavigationSource | undefined;
    /** Gets the CLR type of the element. */
    elementClrType?: string | undefined;
    /** Gets the ODataPath. */
    path?: ODataPathSegment[] | undefined;
    /** Gets the request container. */
    requestContainer?: IServiceProvider | undefined;

    constructor(data?: IODataQueryContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultQuerySettings = _data["defaultQuerySettings"] ? DefaultQuerySettings.fromJS(_data["defaultQuerySettings"]) : <any>undefined;
            this.model = _data["model"] ? IEdmModel.fromJS(_data["model"]) : <any>undefined;
            this.elementType = _data["elementType"] ? IEdmType.fromJS(_data["elementType"]) : <any>undefined;
            this.navigationSource = _data["navigationSource"] ? IEdmNavigationSource.fromJS(_data["navigationSource"]) : <any>undefined;
            this.elementClrType = _data["elementClrType"];
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(ODataPathSegment.fromJS(item));
            }
            this.requestContainer = _data["requestContainer"] ? IServiceProvider.fromJS(_data["requestContainer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ODataQueryContext {
        data = typeof data === 'object' ? data : {};
        let result = new ODataQueryContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultQuerySettings"] = this.defaultQuerySettings ? this.defaultQuerySettings.toJSON() : <any>undefined;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        data["elementType"] = this.elementType ? this.elementType.toJSON() : <any>undefined;
        data["navigationSource"] = this.navigationSource ? this.navigationSource.toJSON() : <any>undefined;
        data["elementClrType"] = this.elementClrType;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item.toJSON());
        }
        data["requestContainer"] = this.requestContainer ? this.requestContainer.toJSON() : <any>undefined;
        return data;
    }

    clone(): ODataQueryContext {
        const json = this.toJSON();
        let result = new ODataQueryContext();
        result.init(json);
        return result;
    }
}

/** This defines some context information used to perform query composition. */
export interface IODataQueryContext {
    /** Gets the given DefaultQuerySettings. */
    defaultQuerySettings?: DefaultQuerySettings | undefined;
    /** Gets the given IEdmModel that contains the EntitySet. */
    model?: IEdmModel | undefined;
    /** Gets the IEdmType of the element. */
    elementType?: IEdmType | undefined;
    /** Gets the IEdmNavigationSource that contains the element. */
    navigationSource?: IEdmNavigationSource | undefined;
    /** Gets the CLR type of the element. */
    elementClrType?: string | undefined;
    /** Gets the ODataPath. */
    path?: ODataPathSegment[] | undefined;
    /** Gets the request container. */
    requestContainer?: IServiceProvider | undefined;
}

/** This class describes the default settings to use during query composition. */
export class DefaultQuerySettings implements IDefaultQuerySettings {
    /** Gets or sets a value indicating whether navigation property can be expanded. */
    enableExpand?: boolean;
    /** Gets or sets a value indicating whether property can be selected. */
    enableSelect?: boolean;
    /** Gets or sets a value indicating whether entity set and property can apply $count. */
    enableCount?: boolean;
    /** Gets or sets a value indicating whether property can apply $orderby. */
    enableOrderBy?: boolean;
    /** Gets or sets a value indicating whether property can apply $filter. */
    enableFilter?: boolean;
    /** Gets or sets the max value of $top that a client can request. */
    maxTop?: number | undefined;
    /** Gets or sets a value indicating whether the service will use skiptoken or not. */
    enableSkipToken?: boolean;

    constructor(data?: IDefaultQuerySettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableExpand = _data["enableExpand"];
            this.enableSelect = _data["enableSelect"];
            this.enableCount = _data["enableCount"];
            this.enableOrderBy = _data["enableOrderBy"];
            this.enableFilter = _data["enableFilter"];
            this.maxTop = _data["maxTop"];
            this.enableSkipToken = _data["enableSkipToken"];
        }
    }

    static fromJS(data: any): DefaultQuerySettings {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultQuerySettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableExpand"] = this.enableExpand;
        data["enableSelect"] = this.enableSelect;
        data["enableCount"] = this.enableCount;
        data["enableOrderBy"] = this.enableOrderBy;
        data["enableFilter"] = this.enableFilter;
        data["maxTop"] = this.maxTop;
        data["enableSkipToken"] = this.enableSkipToken;
        return data;
    }

    clone(): DefaultQuerySettings {
        const json = this.toJSON();
        let result = new DefaultQuerySettings();
        result.init(json);
        return result;
    }
}

/** This class describes the default settings to use during query composition. */
export interface IDefaultQuerySettings {
    /** Gets or sets a value indicating whether navigation property can be expanded. */
    enableExpand?: boolean;
    /** Gets or sets a value indicating whether property can be selected. */
    enableSelect?: boolean;
    /** Gets or sets a value indicating whether entity set and property can apply $count. */
    enableCount?: boolean;
    /** Gets or sets a value indicating whether property can apply $orderby. */
    enableOrderBy?: boolean;
    /** Gets or sets a value indicating whether property can apply $filter. */
    enableFilter?: boolean;
    /** Gets or sets the max value of $top that a client can request. */
    maxTop?: number | undefined;
    /** Gets or sets a value indicating whether the service will use skiptoken or not. */
    enableSkipToken?: boolean;
}

/** Semantic representation of an EDM model. */
export abstract class IEdmModel implements IIEdmModel {
    /** Gets the collection of schema elements that are contained in this model. */
    schemaElements?: IEdmSchemaElement[] | undefined;
    /** Gets the collection of vocabulary annotations that are contained in this model. */
    vocabularyAnnotations?: IEdmVocabularyAnnotation[] | undefined;
    /** Gets the collection of models referred to by this model (mainly by the this.References). */
    referencedModels?: IEdmModel[] | undefined;
    /** Gets the collection of namespaces that schema elements use contained in this model. */
    declaredNamespaces?: string[] | undefined;
    /** Gets the model's annotations manager. */
    directValueAnnotationsManager?: IEdmDirectValueAnnotationsManager | undefined;
    /** Gets the only one entity container of the model. */
    entityContainer?: IEdmEntityContainer | undefined;

    constructor(data?: IIEdmModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["schemaElements"])) {
                this.schemaElements = [] as any;
                for (let item of _data["schemaElements"])
                    this.schemaElements!.push(IEdmSchemaElement.fromJS(item));
            }
            if (Array.isArray(_data["vocabularyAnnotations"])) {
                this.vocabularyAnnotations = [] as any;
                for (let item of _data["vocabularyAnnotations"])
                    this.vocabularyAnnotations!.push(IEdmVocabularyAnnotation.fromJS(item));
            }
            if (Array.isArray(_data["referencedModels"])) {
                this.referencedModels = [] as any;
                for (let item of _data["referencedModels"])
                    this.referencedModels!.push(IEdmModel.fromJS(item));
            }
            if (Array.isArray(_data["declaredNamespaces"])) {
                this.declaredNamespaces = [] as any;
                for (let item of _data["declaredNamespaces"])
                    this.declaredNamespaces!.push(item);
            }
            this.directValueAnnotationsManager = _data["directValueAnnotationsManager"] ? IEdmDirectValueAnnotationsManager.fromJS(_data["directValueAnnotationsManager"]) : <any>undefined;
            this.entityContainer = _data["entityContainer"] ? IEdmEntityContainer.fromJS(_data["entityContainer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IEdmModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.schemaElements)) {
            data["schemaElements"] = [];
            for (let item of this.schemaElements)
                data["schemaElements"].push(item.toJSON());
        }
        if (Array.isArray(this.vocabularyAnnotations)) {
            data["vocabularyAnnotations"] = [];
            for (let item of this.vocabularyAnnotations)
                data["vocabularyAnnotations"].push(item.toJSON());
        }
        if (Array.isArray(this.referencedModels)) {
            data["referencedModels"] = [];
            for (let item of this.referencedModels)
                data["referencedModels"].push(item.toJSON());
        }
        if (Array.isArray(this.declaredNamespaces)) {
            data["declaredNamespaces"] = [];
            for (let item of this.declaredNamespaces)
                data["declaredNamespaces"].push(item);
        }
        data["directValueAnnotationsManager"] = this.directValueAnnotationsManager ? this.directValueAnnotationsManager.toJSON() : <any>undefined;
        data["entityContainer"] = this.entityContainer ? this.entityContainer.toJSON() : <any>undefined;
        return data;
    }

    clone(): IEdmModel {
        throw new Error("The abstract class 'IEdmModel' cannot be instantiated.");
    }
}

/** Semantic representation of an EDM model. */
export interface IIEdmModel {
    /** Gets the collection of schema elements that are contained in this model. */
    schemaElements?: IEdmSchemaElement[] | undefined;
    /** Gets the collection of vocabulary annotations that are contained in this model. */
    vocabularyAnnotations?: IEdmVocabularyAnnotation[] | undefined;
    /** Gets the collection of models referred to by this model (mainly by the this.References). */
    referencedModels?: IEdmModel[] | undefined;
    /** Gets the collection of namespaces that schema elements use contained in this model. */
    declaredNamespaces?: string[] | undefined;
    /** Gets the model's annotations manager. */
    directValueAnnotationsManager?: IEdmDirectValueAnnotationsManager | undefined;
    /** Gets the only one entity container of the model. */
    entityContainer?: IEdmEntityContainer | undefined;
}

/** Common base interface for all named children of EDM schema. */
export abstract class IEdmSchemaElement implements IIEdmSchemaElement {
    /** Gets the kind of this schema element. */
    schemaElementKind?: EdmSchemaElementKind;
    /** Gets the namespace this schema element belongs to. */
    namespace?: string | undefined;

    constructor(data?: IIEdmSchemaElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schemaElementKind = _data["schemaElementKind"];
            this.namespace = _data["namespace"];
        }
    }

    static fromJS(data: any): IEdmSchemaElement {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmSchemaElement' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schemaElementKind"] = this.schemaElementKind;
        data["namespace"] = this.namespace;
        return data;
    }

    clone(): IEdmSchemaElement {
        throw new Error("The abstract class 'IEdmSchemaElement' cannot be instantiated.");
    }
}

/** Common base interface for all named children of EDM schema. */
export interface IIEdmSchemaElement {
    /** Gets the kind of this schema element. */
    schemaElementKind?: EdmSchemaElementKind;
    /** Gets the namespace this schema element belongs to. */
    namespace?: string | undefined;
}

/** Defines EDM schema element types. */
export enum EdmSchemaElementKind {
    None = 0,
    TypeDefinition = 1,
    Term = 2,
    Action = 3,
    EntityContainer = 4,
    Function = 5,
}

/** Represents an EDM vocabulary annotation. */
export abstract class IEdmVocabularyAnnotation implements IIEdmVocabularyAnnotation {
    /** Gets the qualifier used to discriminate between multiple bindings of the same property or type. */
    qualifier?: string | undefined;
    /** Gets the term bound by the annotation. */
    term?: IEdmTerm | undefined;
    /** Gets the element the annotation applies to. */
    target?: IEdmVocabularyAnnotatable | undefined;
    /** Gets the expression producing the value of the annotation. */
    value?: IEdmExpression | undefined;

    constructor(data?: IIEdmVocabularyAnnotation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualifier = _data["qualifier"];
            this.term = _data["term"] ? IEdmTerm.fromJS(_data["term"]) : <any>undefined;
            this.target = _data["target"] ? IEdmVocabularyAnnotatable.fromJS(_data["target"]) : <any>undefined;
            this.value = _data["value"] ? IEdmExpression.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IEdmVocabularyAnnotation {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmVocabularyAnnotation' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualifier"] = this.qualifier;
        data["term"] = this.term ? this.term.toJSON() : <any>undefined;
        data["target"] = this.target ? this.target.toJSON() : <any>undefined;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }

    clone(): IEdmVocabularyAnnotation {
        throw new Error("The abstract class 'IEdmVocabularyAnnotation' cannot be instantiated.");
    }
}

/** Represents an EDM vocabulary annotation. */
export interface IIEdmVocabularyAnnotation {
    /** Gets the qualifier used to discriminate between multiple bindings of the same property or type. */
    qualifier?: string | undefined;
    /** Gets the term bound by the annotation. */
    term?: IEdmTerm | undefined;
    /** Gets the element the annotation applies to. */
    target?: IEdmVocabularyAnnotatable | undefined;
    /** Gets the expression producing the value of the annotation. */
    value?: IEdmExpression | undefined;
}

/** Represents an EDM term. */
export abstract class IEdmTerm implements IIEdmTerm {
    /** Gets the type of this term. */
    type?: IEdmTypeReference | undefined;
    /** Gets the AppliesTo of this term. */
    appliesTo?: string | undefined;
    /** Gets the DefaultValue of this term. */
    defaultValue?: string | undefined;

    constructor(data?: IIEdmTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] ? IEdmTypeReference.fromJS(_data["type"]) : <any>undefined;
            this.appliesTo = _data["appliesTo"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): IEdmTerm {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmTerm' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["appliesTo"] = this.appliesTo;
        data["defaultValue"] = this.defaultValue;
        return data;
    }

    clone(): IEdmTerm {
        throw new Error("The abstract class 'IEdmTerm' cannot be instantiated.");
    }
}

/** Represents an EDM term. */
export interface IIEdmTerm {
    /** Gets the type of this term. */
    type?: IEdmTypeReference | undefined;
    /** Gets the AppliesTo of this term. */
    appliesTo?: string | undefined;
    /** Gets the DefaultValue of this term. */
    defaultValue?: string | undefined;
}

/** Represents a references to a type. */
export abstract class IEdmTypeReference implements IIEdmTypeReference {
    /** Gets a value indicating whether this type is nullable. */
    isNullable?: boolean;
    /** Gets the definition to which this type refers. */
    definition?: IEdmType | undefined;

    constructor(data?: IIEdmTypeReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isNullable = _data["isNullable"];
            this.definition = _data["definition"] ? IEdmType.fromJS(_data["definition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IEdmTypeReference {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmTypeReference' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isNullable"] = this.isNullable;
        data["definition"] = this.definition ? this.definition.toJSON() : <any>undefined;
        return data;
    }

    clone(): IEdmTypeReference {
        throw new Error("The abstract class 'IEdmTypeReference' cannot be instantiated.");
    }
}

/** Represents a references to a type. */
export interface IIEdmTypeReference {
    /** Gets a value indicating whether this type is nullable. */
    isNullable?: boolean;
    /** Gets the definition to which this type refers. */
    definition?: IEdmType | undefined;
}

/** Represents the definition of an EDM type. */
export abstract class IEdmType implements IIEdmType {
    /** Gets the kind of this type. */
    typeKind?: EdmTypeKind;

    constructor(data?: IIEdmType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeKind = _data["typeKind"];
        }
    }

    static fromJS(data: any): IEdmType {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmType' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeKind"] = this.typeKind;
        return data;
    }

    clone(): IEdmType {
        throw new Error("The abstract class 'IEdmType' cannot be instantiated.");
    }
}

/** Represents the definition of an EDM type. */
export interface IIEdmType {
    /** Gets the kind of this type. */
    typeKind?: EdmTypeKind;
}

/** Defines EDM metatypes. */
export enum EdmTypeKind {
    None = 0,
    Primitive = 1,
    Entity = 2,
    Complex = 3,
    Collection = 4,
    EntityReference = 5,
    Enum = 6,
    TypeDefinition = 7,
    Untyped = 8,
    Path = 9,
}

/** Represents an element that can be targeted by Vocabulary Annotations */
export abstract class IEdmVocabularyAnnotatable implements IIEdmVocabularyAnnotatable {

    constructor(data?: IIEdmVocabularyAnnotatable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IEdmVocabularyAnnotatable {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmVocabularyAnnotatable' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): IEdmVocabularyAnnotatable {
        throw new Error("The abstract class 'IEdmVocabularyAnnotatable' cannot be instantiated.");
    }
}

/** Represents an element that can be targeted by Vocabulary Annotations */
export interface IIEdmVocabularyAnnotatable {
}

/** Represents an EDM expression. */
export abstract class IEdmExpression implements IIEdmExpression {
    /** Gets the kind of this expression. */
    expressionKind?: EdmExpressionKind;

    constructor(data?: IIEdmExpression) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressionKind = _data["expressionKind"];
        }
    }

    static fromJS(data: any): IEdmExpression {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmExpression' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressionKind"] = this.expressionKind;
        return data;
    }

    clone(): IEdmExpression {
        throw new Error("The abstract class 'IEdmExpression' cannot be instantiated.");
    }
}

/** Represents an EDM expression. */
export interface IIEdmExpression {
    /** Gets the kind of this expression. */
    expressionKind?: EdmExpressionKind;
}

/** Defines EDM expression kinds. */
export enum EdmExpressionKind {
    None = 0,
    BinaryConstant = 1,
    BooleanConstant = 2,
    DateTimeOffsetConstant = 3,
    DecimalConstant = 4,
    FloatingConstant = 5,
    GuidConstant = 6,
    IntegerConstant = 7,
    StringConstant = 8,
    DurationConstant = 9,
    Null = 10,
    Record = 11,
    Collection = 12,
    Path = 13,
    If = 14,
    Cast = 15,
    IsType = 16,
    FunctionApplication = 17,
    LabeledExpressionReference = 18,
    Labeled = 19,
    PropertyPath = 20,
    NavigationPropertyPath = 21,
    DateConstant = 22,
    TimeOfDayConstant = 23,
    EnumMember = 24,
    AnnotationPath = 25,
}

/** Manages getting and setting direct annotations on EDM elements. */
export abstract class IEdmDirectValueAnnotationsManager implements IIEdmDirectValueAnnotationsManager {

    constructor(data?: IIEdmDirectValueAnnotationsManager) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IEdmDirectValueAnnotationsManager {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmDirectValueAnnotationsManager' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): IEdmDirectValueAnnotationsManager {
        throw new Error("The abstract class 'IEdmDirectValueAnnotationsManager' cannot be instantiated.");
    }
}

/** Manages getting and setting direct annotations on EDM elements. */
export interface IIEdmDirectValueAnnotationsManager {
}

/** Represents an EDM entity container. */
export abstract class IEdmEntityContainer implements IIEdmEntityContainer {
    /** Gets a collection of the elements of this entity container. */
    elements?: IEdmEntityContainerElement[] | undefined;

    constructor(data?: IIEdmEntityContainer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(IEdmEntityContainerElement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IEdmEntityContainer {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmEntityContainer' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        return data;
    }

    clone(): IEdmEntityContainer {
        throw new Error("The abstract class 'IEdmEntityContainer' cannot be instantiated.");
    }
}

/** Represents an EDM entity container. */
export interface IIEdmEntityContainer {
    /** Gets a collection of the elements of this entity container. */
    elements?: IEdmEntityContainerElement[] | undefined;
}

/** Represents the common elements of all EDM entity container elements. */
export abstract class IEdmEntityContainerElement implements IIEdmEntityContainerElement {
    /** Gets the kind of element of this container element. */
    containerElementKind?: EdmContainerElementKind;
    /** Gets the container that contains this element. */
    container?: IEdmEntityContainer | undefined;

    constructor(data?: IIEdmEntityContainerElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.containerElementKind = _data["containerElementKind"];
            this.container = _data["container"] ? IEdmEntityContainer.fromJS(_data["container"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IEdmEntityContainerElement {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmEntityContainerElement' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["containerElementKind"] = this.containerElementKind;
        data["container"] = this.container ? this.container.toJSON() : <any>undefined;
        return data;
    }

    clone(): IEdmEntityContainerElement {
        throw new Error("The abstract class 'IEdmEntityContainerElement' cannot be instantiated.");
    }
}

/** Represents the common elements of all EDM entity container elements. */
export interface IIEdmEntityContainerElement {
    /** Gets the kind of element of this container element. */
    containerElementKind?: EdmContainerElementKind;
    /** Gets the container that contains this element. */
    container?: IEdmEntityContainer | undefined;
}

/** Defines EDM container element types. */
export enum EdmContainerElementKind {
    None = 0,
    EntitySet = 1,
    ActionImport = 2,
    FunctionImport = 3,
    Singleton = 4,
}

/** Represents an EDM navigation source. */
export abstract class IEdmNavigationSource implements IIEdmNavigationSource {
    /** Gets the navigation property bindings of this navigation source. */
    navigationPropertyBindings?: IEdmNavigationPropertyBinding[] | undefined;
    /** Gets the path of this navigation source. */
    path?: IEdmPathExpression | undefined;
    /** Gets the type of this navigation source. */
    type?: IEdmType | undefined;

    constructor(data?: IIEdmNavigationSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["navigationPropertyBindings"])) {
                this.navigationPropertyBindings = [] as any;
                for (let item of _data["navigationPropertyBindings"])
                    this.navigationPropertyBindings!.push(IEdmNavigationPropertyBinding.fromJS(item));
            }
            this.path = _data["path"] ? IEdmPathExpression.fromJS(_data["path"]) : <any>undefined;
            this.type = _data["type"] ? IEdmType.fromJS(_data["type"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IEdmNavigationSource {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmNavigationSource' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.navigationPropertyBindings)) {
            data["navigationPropertyBindings"] = [];
            for (let item of this.navigationPropertyBindings)
                data["navigationPropertyBindings"].push(item.toJSON());
        }
        data["path"] = this.path ? this.path.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        return data;
    }

    clone(): IEdmNavigationSource {
        throw new Error("The abstract class 'IEdmNavigationSource' cannot be instantiated.");
    }
}

/** Represents an EDM navigation source. */
export interface IIEdmNavigationSource {
    /** Gets the navigation property bindings of this navigation source. */
    navigationPropertyBindings?: IEdmNavigationPropertyBinding[] | undefined;
    /** Gets the path of this navigation source. */
    path?: IEdmPathExpression | undefined;
    /** Gets the type of this navigation source. */
    type?: IEdmType | undefined;
}

/** Represents a binding from an EDM navigation property to a navigation source. */
export abstract class IEdmNavigationPropertyBinding implements IIEdmNavigationPropertyBinding {
    /** Gets the navigation property. */
    navigationProperty?: IEdmNavigationProperty | undefined;
    /** Gets the target navigation source. */
    target?: IEdmNavigationSource | undefined;
    /** Get the path that a navigation property targets. */
    path?: IEdmPathExpression | undefined;

    constructor(data?: IIEdmNavigationPropertyBinding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.navigationProperty = _data["navigationProperty"] ? IEdmNavigationProperty.fromJS(_data["navigationProperty"]) : <any>undefined;
            this.target = _data["target"] ? IEdmNavigationSource.fromJS(_data["target"]) : <any>undefined;
            this.path = _data["path"] ? IEdmPathExpression.fromJS(_data["path"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IEdmNavigationPropertyBinding {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmNavigationPropertyBinding' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["navigationProperty"] = this.navigationProperty ? this.navigationProperty.toJSON() : <any>undefined;
        data["target"] = this.target ? this.target.toJSON() : <any>undefined;
        data["path"] = this.path ? this.path.toJSON() : <any>undefined;
        return data;
    }

    clone(): IEdmNavigationPropertyBinding {
        throw new Error("The abstract class 'IEdmNavigationPropertyBinding' cannot be instantiated.");
    }
}

/** Represents a binding from an EDM navigation property to a navigation source. */
export interface IIEdmNavigationPropertyBinding {
    /** Gets the navigation property. */
    navigationProperty?: IEdmNavigationProperty | undefined;
    /** Gets the target navigation source. */
    target?: IEdmNavigationSource | undefined;
    /** Get the path that a navigation property targets. */
    path?: IEdmPathExpression | undefined;
}

/** Represents an EDM navigation property. */
export abstract class IEdmNavigationProperty implements IIEdmNavigationProperty {
    /** Gets the partner of this navigation property. */
    partner?: IEdmNavigationProperty | undefined;
    /** Gets the action to execute on the deletion of this end of a bidirectional association. */
    onDelete?: EdmOnDeleteAction;
    /** Gets a value indicating whether the navigation target is contained inside the navigation source. */
    containsTarget?: boolean;
    /** Gets the referential constraint for this navigation, returning null if this is the principal end or if there is no referential constraint. */
    referentialConstraint?: IEdmReferentialConstraint | undefined;

    constructor(data?: IIEdmNavigationProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data["partner"] ? IEdmNavigationProperty.fromJS(_data["partner"]) : <any>undefined;
            this.onDelete = _data["onDelete"];
            this.containsTarget = _data["containsTarget"];
            this.referentialConstraint = _data["referentialConstraint"] ? IEdmReferentialConstraint.fromJS(_data["referentialConstraint"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IEdmNavigationProperty {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmNavigationProperty' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
        data["onDelete"] = this.onDelete;
        data["containsTarget"] = this.containsTarget;
        data["referentialConstraint"] = this.referentialConstraint ? this.referentialConstraint.toJSON() : <any>undefined;
        return data;
    }

    clone(): IEdmNavigationProperty {
        throw new Error("The abstract class 'IEdmNavigationProperty' cannot be instantiated.");
    }
}

/** Represents an EDM navigation property. */
export interface IIEdmNavigationProperty {
    /** Gets the partner of this navigation property. */
    partner?: IEdmNavigationProperty | undefined;
    /** Gets the action to execute on the deletion of this end of a bidirectional association. */
    onDelete?: EdmOnDeleteAction;
    /** Gets a value indicating whether the navigation target is contained inside the navigation source. */
    containsTarget?: boolean;
    /** Gets the referential constraint for this navigation, returning null if this is the principal end or if there is no referential constraint. */
    referentialConstraint?: IEdmReferentialConstraint | undefined;
}

/** Enumerates the actions EDM can apply on deletes. */
export enum EdmOnDeleteAction {
    None = 0,
    Cascade = 1,
}

/** Represents an EDM referential constraint on a navigation property. */
export abstract class IEdmReferentialConstraint implements IIEdmReferentialConstraint {
    /** Gets the set of property pairs from the referential constraint. No particular ordering should be assumed. */
    propertyPairs?: EdmReferentialConstraintPropertyPair[] | undefined;

    constructor(data?: IIEdmReferentialConstraint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["propertyPairs"])) {
                this.propertyPairs = [] as any;
                for (let item of _data["propertyPairs"])
                    this.propertyPairs!.push(EdmReferentialConstraintPropertyPair.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IEdmReferentialConstraint {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmReferentialConstraint' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.propertyPairs)) {
            data["propertyPairs"] = [];
            for (let item of this.propertyPairs)
                data["propertyPairs"].push(item.toJSON());
        }
        return data;
    }

    clone(): IEdmReferentialConstraint {
        throw new Error("The abstract class 'IEdmReferentialConstraint' cannot be instantiated.");
    }
}

/** Represents an EDM referential constraint on a navigation property. */
export interface IIEdmReferentialConstraint {
    /** Gets the set of property pairs from the referential constraint. No particular ordering should be assumed. */
    propertyPairs?: EdmReferentialConstraintPropertyPair[] | undefined;
}

/** Represents a pair of properties as part of a referential constraint. */
export class EdmReferentialConstraintPropertyPair implements IEdmReferentialConstraintPropertyPair {
    /** The local or dependent property in the referential constraint property pair. Will never be null. */
    dependentProperty?: IEdmStructuralProperty | undefined;
    /** The foreign or principal property in the referential constraint property pair. Will never be null. */
    principalProperty?: IEdmStructuralProperty | undefined;

    constructor(data?: IEdmReferentialConstraintPropertyPair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dependentProperty = _data["dependentProperty"] ? IEdmStructuralProperty.fromJS(_data["dependentProperty"]) : <any>undefined;
            this.principalProperty = _data["principalProperty"] ? IEdmStructuralProperty.fromJS(_data["principalProperty"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EdmReferentialConstraintPropertyPair {
        data = typeof data === 'object' ? data : {};
        let result = new EdmReferentialConstraintPropertyPair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dependentProperty"] = this.dependentProperty ? this.dependentProperty.toJSON() : <any>undefined;
        data["principalProperty"] = this.principalProperty ? this.principalProperty.toJSON() : <any>undefined;
        return data;
    }

    clone(): EdmReferentialConstraintPropertyPair {
        const json = this.toJSON();
        let result = new EdmReferentialConstraintPropertyPair();
        result.init(json);
        return result;
    }
}

/** Represents a pair of properties as part of a referential constraint. */
export interface IEdmReferentialConstraintPropertyPair {
    /** The local or dependent property in the referential constraint property pair. Will never be null. */
    dependentProperty?: IEdmStructuralProperty | undefined;
    /** The foreign or principal property in the referential constraint property pair. Will never be null. */
    principalProperty?: IEdmStructuralProperty | undefined;
}

/** Represents an EDM structural (i.e. non-navigation) property. */
export abstract class IEdmStructuralProperty implements IIEdmStructuralProperty {
    /** Gets the default value of this property. */
    defaultValueString?: string | undefined;

    constructor(data?: IIEdmStructuralProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultValueString = _data["defaultValueString"];
        }
    }

    static fromJS(data: any): IEdmStructuralProperty {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmStructuralProperty' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultValueString"] = this.defaultValueString;
        return data;
    }

    clone(): IEdmStructuralProperty {
        throw new Error("The abstract class 'IEdmStructuralProperty' cannot be instantiated.");
    }
}

/** Represents an EDM structural (i.e. non-navigation) property. */
export interface IIEdmStructuralProperty {
    /** Gets the default value of this property. */
    defaultValueString?: string | undefined;
}

/** Represents an EDM path expression. */
export abstract class IEdmPathExpression implements IIEdmPathExpression {
    /** Gets the path segments as a decomposed qualified name. "A.B/C/D.E" is { "A.B", "C", "D.E" }. */
    pathSegments?: string[] | undefined;
    /** Gets the path string, like "A.B/C/D.E". */
    path?: string | undefined;

    constructor(data?: IIEdmPathExpression) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pathSegments"])) {
                this.pathSegments = [] as any;
                for (let item of _data["pathSegments"])
                    this.pathSegments!.push(item);
            }
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): IEdmPathExpression {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IEdmPathExpression' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pathSegments)) {
            data["pathSegments"] = [];
            for (let item of this.pathSegments)
                data["pathSegments"].push(item);
        }
        data["path"] = this.path;
        return data;
    }

    clone(): IEdmPathExpression {
        throw new Error("The abstract class 'IEdmPathExpression' cannot be instantiated.");
    }
}

/** Represents an EDM path expression. */
export interface IIEdmPathExpression {
    /** Gets the path segments as a decomposed qualified name. "A.B/C/D.E" is { "A.B", "C", "D.E" }. */
    pathSegments?: string[] | undefined;
    /** Gets the path string, like "A.B/C/D.E". */
    path?: string | undefined;
}

/** The semantic representation of a segment in a path. */
export abstract class ODataPathSegment implements IODataPathSegment {
    /** Returns the identifier for this segment i.e. string part without the keys. */
    identifier?: string | undefined;

    constructor(data?: IODataPathSegment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): ODataPathSegment {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ODataPathSegment' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        return data;
    }

    clone(): ODataPathSegment {
        throw new Error("The abstract class 'ODataPathSegment' cannot be instantiated.");
    }
}

/** The semantic representation of a segment in a path. */
export interface IODataPathSegment {
    /** Returns the identifier for this segment i.e. string part without the keys. */
    identifier?: string | undefined;
}

export abstract class IServiceProvider implements IIServiceProvider {

    constructor(data?: IIServiceProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IServiceProvider {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IServiceProvider' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): IServiceProvider {
        throw new Error("The abstract class 'IServiceProvider' cannot be instantiated.");
    }
}

export interface IIServiceProvider {
}

/** Represents the raw query values in the string format from the incoming request. */
export class ODataRawQueryOptions implements IODataRawQueryOptions {
    /** Gets the raw $filter query value from the incoming request Uri if exists.
             */
    filter?: string | undefined;
    /** Gets the raw $apply query value from the incoming request Uri if exists.
             */
    apply?: string | undefined;
    /** Gets the raw $compute query value from the incoming request Uri if exists.
             */
    compute?: string | undefined;
    /** Gets the raw $search query value from the incoming request Uri if exists.
             */
    search?: string | undefined;
    /** Gets the raw $orderby query value from the incoming request Uri if exists.
             */
    orderBy?: string | undefined;
    /** Gets the raw $top query value from the incoming request Uri if exists.
             */
    top?: string | undefined;
    /** Gets the raw $skip query value from the incoming request Uri if exists.
             */
    skip?: string | undefined;
    /** Gets the raw $select query value from the incoming request Uri if exists.
             */
    select?: string | undefined;
    /** Gets the raw $expand query value from the incoming request Uri if exists.
             */
    expand?: string | undefined;
    /** Gets the raw $count query value from the incoming request Uri if exists.
             */
    count?: string | undefined;
    /** Gets the raw $format query value from the incoming request Uri if exists.
             */
    format?: string | undefined;
    /** Gets the raw $skiptoken query value from the incoming request Uri if exists.
             */
    skipToken?: string | undefined;
    /** Gets the raw $deltatoken query value from the incoming request Uri if exists.
             */
    deltaToken?: string | undefined;

    constructor(data?: IODataRawQueryOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.apply = _data["apply"];
            this.compute = _data["compute"];
            this.search = _data["search"];
            this.orderBy = _data["orderBy"];
            this.top = _data["top"];
            this.skip = _data["skip"];
            this.select = _data["select"];
            this.expand = _data["expand"];
            this.count = _data["count"];
            this.format = _data["format"];
            this.skipToken = _data["skipToken"];
            this.deltaToken = _data["deltaToken"];
        }
    }

    static fromJS(data: any): ODataRawQueryOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ODataRawQueryOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["apply"] = this.apply;
        data["compute"] = this.compute;
        data["search"] = this.search;
        data["orderBy"] = this.orderBy;
        data["top"] = this.top;
        data["skip"] = this.skip;
        data["select"] = this.select;
        data["expand"] = this.expand;
        data["count"] = this.count;
        data["format"] = this.format;
        data["skipToken"] = this.skipToken;
        data["deltaToken"] = this.deltaToken;
        return data;
    }

    clone(): ODataRawQueryOptions {
        const json = this.toJSON();
        let result = new ODataRawQueryOptions();
        result.init(json);
        return result;
    }
}

/** Represents the raw query values in the string format from the incoming request. */
export interface IODataRawQueryOptions {
    /** Gets the raw $filter query value from the incoming request Uri if exists.
             */
    filter?: string | undefined;
    /** Gets the raw $apply query value from the incoming request Uri if exists.
             */
    apply?: string | undefined;
    /** Gets the raw $compute query value from the incoming request Uri if exists.
             */
    compute?: string | undefined;
    /** Gets the raw $search query value from the incoming request Uri if exists.
             */
    search?: string | undefined;
    /** Gets the raw $orderby query value from the incoming request Uri if exists.
             */
    orderBy?: string | undefined;
    /** Gets the raw $top query value from the incoming request Uri if exists.
             */
    top?: string | undefined;
    /** Gets the raw $skip query value from the incoming request Uri if exists.
             */
    skip?: string | undefined;
    /** Gets the raw $select query value from the incoming request Uri if exists.
             */
    select?: string | undefined;
    /** Gets the raw $expand query value from the incoming request Uri if exists.
             */
    expand?: string | undefined;
    /** Gets the raw $count query value from the incoming request Uri if exists.
             */
    count?: string | undefined;
    /** Gets the raw $format query value from the incoming request Uri if exists.
             */
    format?: string | undefined;
    /** Gets the raw $skiptoken query value from the incoming request Uri if exists.
             */
    skipToken?: string | undefined;
    /** Gets the raw $deltatoken query value from the incoming request Uri if exists.
             */
    deltaToken?: string | undefined;
}

/** Represents the OData $select and $expand query options. */
export class SelectExpandQueryOption implements ISelectExpandQueryOption {
    /** Gets the given ODataQueryContext.
             */
    context?: ODataQueryContext | undefined;
    /** Gets the raw $select value. */
    rawSelect?: string | undefined;
    /** Gets the raw $expand value. */
    rawExpand?: string | undefined;
    /** Gets or sets the ComputeQueryOption. */
    compute?: ComputeQueryOption | undefined;
    /** Gets or sets the $select and $expand query validator. */
    validator?: SelectExpandQueryValidator | undefined;
    /** Gets the parsed SelectExpandClause for this query option. */
    selectExpandClause?: SelectExpandClause | undefined;
    /** Gets or sets the number of levels that a top level $expand=NavigationProperty($levels=max)
will be expanded.
This value will decrease by one with each nesting level in the $expand clause.
For example, with a property value 5, the following query $expand=A($expand=B($expand=C($levels=max)))
will be interpreted as $expand=A($expand=B($expand=C($levels=3))).
If the query gets validated, the MaxExpansionDepth value
must be greater than or equal to this value. */
    levelsMaxLiteralExpansionDepth?: number;

    constructor(data?: ISelectExpandQueryOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : <any>undefined;
            this.rawSelect = _data["rawSelect"];
            this.rawExpand = _data["rawExpand"];
            this.compute = _data["compute"] ? ComputeQueryOption.fromJS(_data["compute"]) : <any>undefined;
            this.validator = _data["validator"] ? SelectExpandQueryValidator.fromJS(_data["validator"]) : <any>undefined;
            this.selectExpandClause = _data["selectExpandClause"] ? SelectExpandClause.fromJS(_data["selectExpandClause"]) : <any>undefined;
            this.levelsMaxLiteralExpansionDepth = _data["levelsMaxLiteralExpansionDepth"];
        }
    }

    static fromJS(data: any): SelectExpandQueryOption {
        data = typeof data === 'object' ? data : {};
        let result = new SelectExpandQueryOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["rawSelect"] = this.rawSelect;
        data["rawExpand"] = this.rawExpand;
        data["compute"] = this.compute ? this.compute.toJSON() : <any>undefined;
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["selectExpandClause"] = this.selectExpandClause ? this.selectExpandClause.toJSON() : <any>undefined;
        data["levelsMaxLiteralExpansionDepth"] = this.levelsMaxLiteralExpansionDepth;
        return data;
    }

    clone(): SelectExpandQueryOption {
        const json = this.toJSON();
        let result = new SelectExpandQueryOption();
        result.init(json);
        return result;
    }
}

/** Represents the OData $select and $expand query options. */
export interface ISelectExpandQueryOption {
    /** Gets the given ODataQueryContext.
             */
    context?: ODataQueryContext | undefined;
    /** Gets the raw $select value. */
    rawSelect?: string | undefined;
    /** Gets the raw $expand value. */
    rawExpand?: string | undefined;
    /** Gets or sets the ComputeQueryOption. */
    compute?: ComputeQueryOption | undefined;
    /** Gets or sets the $select and $expand query validator. */
    validator?: SelectExpandQueryValidator | undefined;
    /** Gets the parsed SelectExpandClause for this query option. */
    selectExpandClause?: SelectExpandClause | undefined;
    /** Gets or sets the number of levels that a top level $expand=NavigationProperty($levels=max)
will be expanded.
This value will decrease by one with each nesting level in the $expand clause.
For example, with a property value 5, the following query $expand=A($expand=B($expand=C($levels=max)))
will be interpreted as $expand=A($expand=B($expand=C($levels=3))).
If the query gets validated, the MaxExpansionDepth value
must be greater than or equal to this value. */
    levelsMaxLiteralExpansionDepth?: number;
}

/** This defines a $compute OData query option for querying. The $compute system query option allows clients to define computed properties that can be used in a $select or within a $filter or $orderby expression. Computed properties SHOULD be included as dynamic properties in the result and MUST be included if $select is specified with the computed property name, or star (*). */
export class ComputeQueryOption implements IComputeQueryOption {
    /** Gets the given ODataQueryContext. */
    context?: ODataQueryContext | undefined;
    /** ClrType for result of transformations */
    resultClrType?: string | undefined;
    /** Gets the parsed ComputeClause for this query option. */
    computeClause?: ComputeClause | undefined;
    /** Gets the raw $compute value.
             */
    rawValue?: string | undefined;

    constructor(data?: IComputeQueryOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : <any>undefined;
            this.resultClrType = _data["resultClrType"];
            this.computeClause = _data["computeClause"] ? ComputeClause.fromJS(_data["computeClause"]) : <any>undefined;
            this.rawValue = _data["rawValue"];
        }
    }

    static fromJS(data: any): ComputeQueryOption {
        data = typeof data === 'object' ? data : {};
        let result = new ComputeQueryOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["resultClrType"] = this.resultClrType;
        data["computeClause"] = this.computeClause ? this.computeClause.toJSON() : <any>undefined;
        data["rawValue"] = this.rawValue;
        return data;
    }

    clone(): ComputeQueryOption {
        const json = this.toJSON();
        let result = new ComputeQueryOption();
        result.init(json);
        return result;
    }
}

/** This defines a $compute OData query option for querying. The $compute system query option allows clients to define computed properties that can be used in a $select or within a $filter or $orderby expression. Computed properties SHOULD be included as dynamic properties in the result and MUST be included if $select is specified with the computed property name, or star (*). */
export interface IComputeQueryOption {
    /** Gets the given ODataQueryContext. */
    context?: ODataQueryContext | undefined;
    /** ClrType for result of transformations */
    resultClrType?: string | undefined;
    /** Gets the parsed ComputeClause for this query option. */
    computeClause?: ComputeClause | undefined;
    /** Gets the raw $compute value.
             */
    rawValue?: string | undefined;
}

/** The result of parsing a $compute query option. */
export class ComputeClause implements IComputeClause {
    /** Gets the computed properties and operations. */
    computedItems?: ComputeExpression[] | undefined;

    constructor(data?: IComputeClause) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["computedItems"])) {
                this.computedItems = [] as any;
                for (let item of _data["computedItems"])
                    this.computedItems!.push(ComputeExpression.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComputeClause {
        data = typeof data === 'object' ? data : {};
        let result = new ComputeClause();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.computedItems)) {
            data["computedItems"] = [];
            for (let item of this.computedItems)
                data["computedItems"].push(item.toJSON());
        }
        return data;
    }

    clone(): ComputeClause {
        const json = this.toJSON();
        let result = new ComputeClause();
        result.init(json);
        return result;
    }
}

/** The result of parsing a $compute query option. */
export interface IComputeClause {
    /** Gets the computed properties and operations. */
    computedItems?: ComputeExpression[] | undefined;
}

/** An item that has been computed by the query at the current level of the tree. */
export class ComputeExpression implements IComputeExpression {
    /** Gets the aggregation expression. */
    expression?: SingleValueNode | undefined;
    /** Gets the aggregation alias. */
    alias?: string | undefined;
    /** Gets the IEdmTypeReference of this aggregate expression. */
    typeReference?: IEdmTypeReference | undefined;

    constructor(data?: IComputeExpression) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? SingleValueNode.fromJS(_data["expression"]) : <any>undefined;
            this.alias = _data["alias"];
            this.typeReference = _data["typeReference"] ? IEdmTypeReference.fromJS(_data["typeReference"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ComputeExpression {
        data = typeof data === 'object' ? data : {};
        let result = new ComputeExpression();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["alias"] = this.alias;
        data["typeReference"] = this.typeReference ? this.typeReference.toJSON() : <any>undefined;
        return data;
    }

    clone(): ComputeExpression {
        const json = this.toJSON();
        let result = new ComputeExpression();
        result.init(json);
        return result;
    }
}

/** An item that has been computed by the query at the current level of the tree. */
export interface IComputeExpression {
    /** Gets the aggregation expression. */
    expression?: SingleValueNode | undefined;
    /** Gets the aggregation alias. */
    alias?: string | undefined;
    /** Gets the IEdmTypeReference of this aggregate expression. */
    typeReference?: IEdmTypeReference | undefined;
}

/** Base class for all semantic metadata bound nodes. */
export abstract class QueryNode implements IQueryNode {

    constructor(data?: IQueryNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): QueryNode {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QueryNode' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): QueryNode {
        throw new Error("The abstract class 'QueryNode' cannot be instantiated.");
    }
}

/** Base class for all semantic metadata bound nodes. */
export interface IQueryNode {
}

/** Base class for all semantic metadata bound nodes which represent a single composable value. */
export abstract class SingleValueNode extends QueryNode implements ISingleValueNode {
    /** Gets the kind of this node. */
    kind?: QueryNodeKind;

    constructor(data?: ISingleValueNode) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.kind = _data["kind"];
        }
    }

    static fromJS(data: any): SingleValueNode {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SingleValueNode' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        super.toJSON(data);
        return data;
    }

    clone(): SingleValueNode {
        throw new Error("The abstract class 'SingleValueNode' cannot be instantiated.");
    }
}

/** Base class for all semantic metadata bound nodes which represent a single composable value. */
export interface ISingleValueNode extends IQueryNode {
    /** Gets the kind of this node. */
    kind?: QueryNodeKind;
}

/** Public enumeration of kinds of query nodes. A subset of InternalQueryNodeKind */
export enum QueryNodeKind {
    None = 0,
    Constant = 1,
    Convert = 2,
    NonResourceRangeVariableReference = 3,
    BinaryOperator = 4,
    UnaryOperator = 5,
    SingleValuePropertyAccess = 6,
    CollectionPropertyAccess = 7,
    SingleValueFunctionCall = 8,
    Any = 9,
    CollectionNavigationNode = 10,
    SingleNavigationNode = 11,
    SingleValueOpenPropertyAccess = 12,
    SingleResourceCast = 13,
    All = 14,
    CollectionResourceCast = 15,
    ResourceRangeVariableReference = 16,
    SingleResourceFunctionCall = 17,
    CollectionFunctionCall = 18,
    CollectionResourceFunctionCall = 19,
    NamedFunctionParameter = 20,
    ParameterAlias = 21,
    EntitySet = 22,
    KeyLookup = 23,
    SearchTerm = 24,
    CollectionOpenPropertyAccess = 25,
    CollectionComplexNode = 26,
    SingleComplexNode = 27,
    Count = 28,
    SingleValueCast = 29,
    CollectionPropertyNode = 30,
    AggregatedCollectionPropertyNode = 31,
    In = 32,
    CollectionConstant = 33,
}

/** Represents a validator used to validate a SelectExpandQueryOption based on the ODataValidationSettings. */
export class SelectExpandQueryValidator implements ISelectExpandQueryValidator {

    constructor(data?: ISelectExpandQueryValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SelectExpandQueryValidator {
        data = typeof data === 'object' ? data : {};
        let result = new SelectExpandQueryValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): SelectExpandQueryValidator {
        const json = this.toJSON();
        let result = new SelectExpandQueryValidator();
        result.init(json);
        return result;
    }
}

/** Represents a validator used to validate a SelectExpandQueryOption based on the ODataValidationSettings. */
export interface ISelectExpandQueryValidator {
}

/** Class representing the combined semantic meaning of any select or expand clauses in the uri. */
export class SelectExpandClause implements ISelectExpandClause {
    /** Gets the selected properties and operations. */
    selectedItems?: SelectItem[] | undefined;
    /** Gets a flag indicating that everything at this level has been selected. */
    allSelected?: boolean;

    constructor(data?: ISelectExpandClause) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectedItems"])) {
                this.selectedItems = [] as any;
                for (let item of _data["selectedItems"])
                    this.selectedItems!.push(SelectItem.fromJS(item));
            }
            this.allSelected = _data["allSelected"];
        }
    }

    static fromJS(data: any): SelectExpandClause {
        data = typeof data === 'object' ? data : {};
        let result = new SelectExpandClause();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedItems)) {
            data["selectedItems"] = [];
            for (let item of this.selectedItems)
                data["selectedItems"].push(item.toJSON());
        }
        data["allSelected"] = this.allSelected;
        return data;
    }

    clone(): SelectExpandClause {
        const json = this.toJSON();
        let result = new SelectExpandClause();
        result.init(json);
        return result;
    }
}

/** Class representing the combined semantic meaning of any select or expand clauses in the uri. */
export interface ISelectExpandClause {
    /** Gets the selected properties and operations. */
    selectedItems?: SelectItem[] | undefined;
    /** Gets a flag indicating that everything at this level has been selected. */
    allSelected?: boolean;
}

/** An item that has been selected by the query at the current level of the tree. */
export abstract class SelectItem implements ISelectItem {

    constructor(data?: ISelectItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SelectItem {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SelectItem' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): SelectItem {
        throw new Error("The abstract class 'SelectItem' cannot be instantiated.");
    }
}

/** An item that has been selected by the query at the current level of the tree. */
export interface ISelectItem {
}

/** This defines a $apply OData query option for querying. */
export class ApplyQueryOption implements IApplyQueryOption {
    /** Gets the given ODataQueryContext.
             */
    context?: ODataQueryContext | undefined;
    /** ClrType for result of transformations */
    resultClrType?: string | undefined;
    /** Gets the parsed ApplyClause for this query option. */
    applyClause?: ApplyClause | undefined;
    /** Gets the raw $apply value.
             */
    rawValue?: string | undefined;

    constructor(data?: IApplyQueryOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : <any>undefined;
            this.resultClrType = _data["resultClrType"];
            this.applyClause = _data["applyClause"] ? ApplyClause.fromJS(_data["applyClause"]) : <any>undefined;
            this.rawValue = _data["rawValue"];
        }
    }

    static fromJS(data: any): ApplyQueryOption {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyQueryOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["resultClrType"] = this.resultClrType;
        data["applyClause"] = this.applyClause ? this.applyClause.toJSON() : <any>undefined;
        data["rawValue"] = this.rawValue;
        return data;
    }

    clone(): ApplyQueryOption {
        const json = this.toJSON();
        let result = new ApplyQueryOption();
        result.init(json);
        return result;
    }
}

/** This defines a $apply OData query option for querying. */
export interface IApplyQueryOption {
    /** Gets the given ODataQueryContext.
             */
    context?: ODataQueryContext | undefined;
    /** ClrType for result of transformations */
    resultClrType?: string | undefined;
    /** Gets the parsed ApplyClause for this query option. */
    applyClause?: ApplyClause | undefined;
    /** Gets the raw $apply value.
             */
    rawValue?: string | undefined;
}

/** Represents the set of transformations to perform as part of $apply. */
export class ApplyClause implements IApplyClause {
    /** The collection of transformations to perform. */
    transformations?: TransformationNode[] | undefined;

    constructor(data?: IApplyClause) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transformations"])) {
                this.transformations = [] as any;
                for (let item of _data["transformations"])
                    this.transformations!.push(TransformationNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplyClause {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyClause();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transformations)) {
            data["transformations"] = [];
            for (let item of this.transformations)
                data["transformations"].push(item.toJSON());
        }
        return data;
    }

    clone(): ApplyClause {
        const json = this.toJSON();
        let result = new ApplyClause();
        result.init(json);
        return result;
    }
}

/** Represents the set of transformations to perform as part of $apply. */
export interface IApplyClause {
    /** The collection of transformations to perform. */
    transformations?: TransformationNode[] | undefined;
}

/** Base class for all transformation nodes. */
export abstract class TransformationNode implements ITransformationNode {

    constructor(data?: ITransformationNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TransformationNode {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TransformationNode' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): TransformationNode {
        throw new Error("The abstract class 'TransformationNode' cannot be instantiated.");
    }
}

/** Base class for all transformation nodes. */
export interface ITransformationNode {
}

/** This defines a $filter OData query option for querying. */
export class FilterQueryOption implements IFilterQueryOption {
    /** Gets the given ODataQueryContext.
             */
    context?: ODataQueryContext | undefined;
    /** Gets or sets the Filter Query Validator */
    validator?: FilterQueryValidator | undefined;
    /** Gets or sets the ComputeQueryOption. */
    compute?: ComputeQueryOption | undefined;
    /** Gets the parsed FilterClause for this query option. */
    filterClause?: FilterClause | undefined;
    /** Gets the raw $filter value.
             */
    rawValue?: string | undefined;

    constructor(data?: IFilterQueryOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : <any>undefined;
            this.validator = _data["validator"] ? FilterQueryValidator.fromJS(_data["validator"]) : <any>undefined;
            this.compute = _data["compute"] ? ComputeQueryOption.fromJS(_data["compute"]) : <any>undefined;
            this.filterClause = _data["filterClause"] ? FilterClause.fromJS(_data["filterClause"]) : <any>undefined;
            this.rawValue = _data["rawValue"];
        }
    }

    static fromJS(data: any): FilterQueryOption {
        data = typeof data === 'object' ? data : {};
        let result = new FilterQueryOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["compute"] = this.compute ? this.compute.toJSON() : <any>undefined;
        data["filterClause"] = this.filterClause ? this.filterClause.toJSON() : <any>undefined;
        data["rawValue"] = this.rawValue;
        return data;
    }

    clone(): FilterQueryOption {
        const json = this.toJSON();
        let result = new FilterQueryOption();
        result.init(json);
        return result;
    }
}

/** This defines a $filter OData query option for querying. */
export interface IFilterQueryOption {
    /** Gets the given ODataQueryContext.
             */
    context?: ODataQueryContext | undefined;
    /** Gets or sets the Filter Query Validator */
    validator?: FilterQueryValidator | undefined;
    /** Gets or sets the ComputeQueryOption. */
    compute?: ComputeQueryOption | undefined;
    /** Gets the parsed FilterClause for this query option. */
    filterClause?: FilterClause | undefined;
    /** Gets the raw $filter value.
             */
    rawValue?: string | undefined;
}

/** Represents a validator used to validate a FilterQueryOption based on the ODataValidationSettings. */
export class FilterQueryValidator implements IFilterQueryValidator {

    constructor(data?: IFilterQueryValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FilterQueryValidator {
        data = typeof data === 'object' ? data : {};
        let result = new FilterQueryValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): FilterQueryValidator {
        const json = this.toJSON();
        let result = new FilterQueryValidator();
        result.init(json);
        return result;
    }
}

/** Represents a validator used to validate a FilterQueryOption based on the ODataValidationSettings. */
export interface IFilterQueryValidator {
}

/** The result of parsing a $filter query option. */
export class FilterClause implements IFilterClause {
    /** Gets the filter expression - this should evaluate to a single boolean value. */
    expression?: SingleValueNode | undefined;
    /** Gets the parameter for the expression which represents a single value from the collection. */
    rangeVariable?: RangeVariable | undefined;
    /** Gets the type of item returned by this clause. */
    itemType?: IEdmTypeReference | undefined;

    constructor(data?: IFilterClause) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? SingleValueNode.fromJS(_data["expression"]) : <any>undefined;
            this.rangeVariable = _data["rangeVariable"] ? RangeVariable.fromJS(_data["rangeVariable"]) : <any>undefined;
            this.itemType = _data["itemType"] ? IEdmTypeReference.fromJS(_data["itemType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FilterClause {
        data = typeof data === 'object' ? data : {};
        let result = new FilterClause();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["rangeVariable"] = this.rangeVariable ? this.rangeVariable.toJSON() : <any>undefined;
        data["itemType"] = this.itemType ? this.itemType.toJSON() : <any>undefined;
        return data;
    }

    clone(): FilterClause {
        const json = this.toJSON();
        let result = new FilterClause();
        result.init(json);
        return result;
    }
}

/** The result of parsing a $filter query option. */
export interface IFilterClause {
    /** Gets the filter expression - this should evaluate to a single boolean value. */
    expression?: SingleValueNode | undefined;
    /** Gets the parameter for the expression which represents a single value from the collection. */
    rangeVariable?: RangeVariable | undefined;
    /** Gets the type of item returned by this clause. */
    itemType?: IEdmTypeReference | undefined;
}

/** A RangeVariable, which represents an iterator variable either over a collection, either of entities or not. Exists outside of the main SemanticAST, but hooked in via a RangeVariableReferenceNode (either Non-Entity or Entity). */
export abstract class RangeVariable implements IRangeVariable {

    constructor(data?: IRangeVariable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RangeVariable {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RangeVariable' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): RangeVariable {
        throw new Error("The abstract class 'RangeVariable' cannot be instantiated.");
    }
}

/** A RangeVariable, which represents an iterator variable either over a collection, either of entities or not. Exists outside of the main SemanticAST, but hooked in via a RangeVariableReferenceNode (either Non-Entity or Entity). */
export interface IRangeVariable {
}

/** This defines a $search OData query option for querying. The $search system query option restricts the result to include only those items matching the specified search expression. The definition of what it means to match is dependent upon the implementation. */
export class SearchQueryOption implements ISearchQueryOption {
    /** Gets the given ODataQueryContext. */
    context?: ODataQueryContext | undefined;
    /** ClrType for result of transformations */
    resultClrType?: string | undefined;
    /** Gets the parsed SearchClause for this query option. */
    searchClause?: SearchClause | undefined;
    /** Gets the raw $search value.
             */
    rawValue?: string | undefined;

    constructor(data?: ISearchQueryOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : <any>undefined;
            this.resultClrType = _data["resultClrType"];
            this.searchClause = _data["searchClause"] ? SearchClause.fromJS(_data["searchClause"]) : <any>undefined;
            this.rawValue = _data["rawValue"];
        }
    }

    static fromJS(data: any): SearchQueryOption {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQueryOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["resultClrType"] = this.resultClrType;
        data["searchClause"] = this.searchClause ? this.searchClause.toJSON() : <any>undefined;
        data["rawValue"] = this.rawValue;
        return data;
    }

    clone(): SearchQueryOption {
        const json = this.toJSON();
        let result = new SearchQueryOption();
        result.init(json);
        return result;
    }
}

/** This defines a $search OData query option for querying. The $search system query option restricts the result to include only those items matching the specified search expression. The definition of what it means to match is dependent upon the implementation. */
export interface ISearchQueryOption {
    /** Gets the given ODataQueryContext. */
    context?: ODataQueryContext | undefined;
    /** ClrType for result of transformations */
    resultClrType?: string | undefined;
    /** Gets the parsed SearchClause for this query option. */
    searchClause?: SearchClause | undefined;
    /** Gets the raw $search value.
             */
    rawValue?: string | undefined;
}

/** The result of parsing a $search query option. */
export class SearchClause implements ISearchClause {
    /** Gets the filter expression - this should evaluate to a single boolean value. */
    expression?: SingleValueNode | undefined;

    constructor(data?: ISearchClause) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"] ? SingleValueNode.fromJS(_data["expression"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchClause {
        data = typeof data === 'object' ? data : {};
        let result = new SearchClause();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        return data;
    }

    clone(): SearchClause {
        const json = this.toJSON();
        let result = new SearchClause();
        result.init(json);
        return result;
    }
}

/** The result of parsing a $search query option. */
export interface ISearchClause {
    /** Gets the filter expression - this should evaluate to a single boolean value. */
    expression?: SingleValueNode | undefined;
}

/** This defines a $orderby OData query option for querying. */
export class OrderByQueryOption implements IOrderByQueryOption {
    /** Gets the given ODataQueryContext.
             */
    context?: ODataQueryContext | undefined;
    /** Gets the mutable list of OrderByPropertyNode instances for this query option. */
    orderByNodes?: OrderByNode[] | undefined;
    /** Gets the raw $orderby value.
             */
    rawValue?: string | undefined;
    /** Gets or sets the OrderBy Query Validator. */
    validator?: OrderByQueryValidator | undefined;
    /** Gets or sets the ComputeQueryOption. */
    compute?: ComputeQueryOption | undefined;
    /** Gets the parsed OrderByClause for this query option. */
    orderByClause?: OrderByClause | undefined;

    constructor(data?: IOrderByQueryOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : <any>undefined;
            if (Array.isArray(_data["orderByNodes"])) {
                this.orderByNodes = [] as any;
                for (let item of _data["orderByNodes"])
                    this.orderByNodes!.push(OrderByNode.fromJS(item));
            }
            this.rawValue = _data["rawValue"];
            this.validator = _data["validator"] ? OrderByQueryValidator.fromJS(_data["validator"]) : <any>undefined;
            this.compute = _data["compute"] ? ComputeQueryOption.fromJS(_data["compute"]) : <any>undefined;
            this.orderByClause = _data["orderByClause"] ? OrderByClause.fromJS(_data["orderByClause"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderByQueryOption {
        data = typeof data === 'object' ? data : {};
        let result = new OrderByQueryOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        if (Array.isArray(this.orderByNodes)) {
            data["orderByNodes"] = [];
            for (let item of this.orderByNodes)
                data["orderByNodes"].push(item.toJSON());
        }
        data["rawValue"] = this.rawValue;
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["compute"] = this.compute ? this.compute.toJSON() : <any>undefined;
        data["orderByClause"] = this.orderByClause ? this.orderByClause.toJSON() : <any>undefined;
        return data;
    }

    clone(): OrderByQueryOption {
        const json = this.toJSON();
        let result = new OrderByQueryOption();
        result.init(json);
        return result;
    }
}

/** This defines a $orderby OData query option for querying. */
export interface IOrderByQueryOption {
    /** Gets the given ODataQueryContext.
             */
    context?: ODataQueryContext | undefined;
    /** Gets the mutable list of OrderByPropertyNode instances for this query option. */
    orderByNodes?: OrderByNode[] | undefined;
    /** Gets the raw $orderby value.
             */
    rawValue?: string | undefined;
    /** Gets or sets the OrderBy Query Validator. */
    validator?: OrderByQueryValidator | undefined;
    /** Gets or sets the ComputeQueryOption. */
    compute?: ComputeQueryOption | undefined;
    /** Gets the parsed OrderByClause for this query option. */
    orderByClause?: OrderByClause | undefined;
}

/** Represents a single order by expression in the $orderby clause. */
export abstract class OrderByNode implements IOrderByNode {
    /** Gets the OrderByDirection for the current node. */
    direction?: OrderByDirection;

    constructor(data?: IOrderByNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.direction = _data["direction"];
        }
    }

    static fromJS(data: any): OrderByNode {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OrderByNode' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction;
        return data;
    }

    clone(): OrderByNode {
        throw new Error("The abstract class 'OrderByNode' cannot be instantiated.");
    }
}

/** Represents a single order by expression in the $orderby clause. */
export interface IOrderByNode {
    /** Gets the OrderByDirection for the current node. */
    direction?: OrderByDirection;
}

/** Enumeration of order by directions. */
export enum OrderByDirection {
    Ascending = 0,
    Descending = 1,
}

/** Represents a validator used to validate an OrderByQueryOption based on the ODataValidationSettings. */
export class OrderByQueryValidator implements IOrderByQueryValidator {

    constructor(data?: IOrderByQueryValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): OrderByQueryValidator {
        data = typeof data === 'object' ? data : {};
        let result = new OrderByQueryValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): OrderByQueryValidator {
        const json = this.toJSON();
        let result = new OrderByQueryValidator();
        result.init(json);
        return result;
    }
}

/** Represents a validator used to validate an OrderByQueryOption based on the ODataValidationSettings. */
export interface IOrderByQueryValidator {
}

/** Represents the result of parsing the $orderby query option. */
export class OrderByClause implements IOrderByClause {
    /** Gets the next orderby to perform after performing this orderby, can be null in the case of only a single orderby expression. */
    thenBy?: OrderByClause | undefined;
    /** Gets the order-by expression. */
    expression?: SingleValueNode | undefined;
    /** Gets the direction to order. */
    direction?: OrderByDirection;
    /** Gets the rangeVariable for the expression which represents a single value from the collection we iterate over. */
    rangeVariable?: RangeVariable | undefined;
    /** Gets the type of a single item from the collection returned after ordering. */
    itemType?: IEdmTypeReference | undefined;

    constructor(data?: IOrderByClause) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.thenBy = _data["thenBy"] ? OrderByClause.fromJS(_data["thenBy"]) : <any>undefined;
            this.expression = _data["expression"] ? SingleValueNode.fromJS(_data["expression"]) : <any>undefined;
            this.direction = _data["direction"];
            this.rangeVariable = _data["rangeVariable"] ? RangeVariable.fromJS(_data["rangeVariable"]) : <any>undefined;
            this.itemType = _data["itemType"] ? IEdmTypeReference.fromJS(_data["itemType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderByClause {
        data = typeof data === 'object' ? data : {};
        let result = new OrderByClause();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thenBy"] = this.thenBy ? this.thenBy.toJSON() : <any>undefined;
        data["expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        data["direction"] = this.direction;
        data["rangeVariable"] = this.rangeVariable ? this.rangeVariable.toJSON() : <any>undefined;
        data["itemType"] = this.itemType ? this.itemType.toJSON() : <any>undefined;
        return data;
    }

    clone(): OrderByClause {
        const json = this.toJSON();
        let result = new OrderByClause();
        result.init(json);
        return result;
    }
}

/** Represents the result of parsing the $orderby query option. */
export interface IOrderByClause {
    /** Gets the next orderby to perform after performing this orderby, can be null in the case of only a single orderby expression. */
    thenBy?: OrderByClause | undefined;
    /** Gets the order-by expression. */
    expression?: SingleValueNode | undefined;
    /** Gets the direction to order. */
    direction?: OrderByDirection;
    /** Gets the rangeVariable for the expression which represents a single value from the collection we iterate over. */
    rangeVariable?: RangeVariable | undefined;
    /** Gets the type of a single item from the collection returned after ordering. */
    itemType?: IEdmTypeReference | undefined;
}

/** This defines a $skip OData query option for querying. */
export class SkipQueryOption implements ISkipQueryOption {
    /** Gets the given ODataQueryContext. */
    context?: ODataQueryContext | undefined;
    /** Gets the raw $skip value. */
    rawValue?: string | undefined;
    /** Gets the value of the $skip as a parsed integer. */
    value?: number;
    /** Gets or sets the Skip Query Validator. */
    validator?: SkipQueryValidator | undefined;

    constructor(data?: ISkipQueryOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : <any>undefined;
            this.rawValue = _data["rawValue"];
            this.value = _data["value"];
            this.validator = _data["validator"] ? SkipQueryValidator.fromJS(_data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SkipQueryOption {
        data = typeof data === 'object' ? data : {};
        let result = new SkipQueryOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["rawValue"] = this.rawValue;
        data["value"] = this.value;
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data;
    }

    clone(): SkipQueryOption {
        const json = this.toJSON();
        let result = new SkipQueryOption();
        result.init(json);
        return result;
    }
}

/** This defines a $skip OData query option for querying. */
export interface ISkipQueryOption {
    /** Gets the given ODataQueryContext. */
    context?: ODataQueryContext | undefined;
    /** Gets the raw $skip value. */
    rawValue?: string | undefined;
    /** Gets the value of the $skip as a parsed integer. */
    value?: number;
    /** Gets or sets the Skip Query Validator. */
    validator?: SkipQueryValidator | undefined;
}

/** Represents a validator used to validate a SkipQueryOption based on the ODataValidationSettings. */
export class SkipQueryValidator implements ISkipQueryValidator {

    constructor(data?: ISkipQueryValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SkipQueryValidator {
        data = typeof data === 'object' ? data : {};
        let result = new SkipQueryValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): SkipQueryValidator {
        const json = this.toJSON();
        let result = new SkipQueryValidator();
        result.init(json);
        return result;
    }
}

/** Represents a validator used to validate a SkipQueryOption based on the ODataValidationSettings. */
export interface ISkipQueryValidator {
}

/** This defines a $skiptoken OData query option for querying. */
export class SkipTokenQueryOption implements ISkipTokenQueryOption {
    /** Gets the raw $skiptoken value. */
    rawValue?: string | undefined;
    /** Gets the given ODataQueryContext. */
    context?: ODataQueryContext | undefined;
    /** Gets the SkipToken Query Validator. */
    validator?: SkipTokenQueryValidator | undefined;
    /** Gets the skip token handler. */
    handler?: SkipTokenHandler | undefined;

    constructor(data?: ISkipTokenQueryOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rawValue = _data["rawValue"];
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : <any>undefined;
            this.validator = _data["validator"] ? SkipTokenQueryValidator.fromJS(_data["validator"]) : <any>undefined;
            this.handler = _data["handler"] ? SkipTokenHandler.fromJS(_data["handler"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SkipTokenQueryOption {
        data = typeof data === 'object' ? data : {};
        let result = new SkipTokenQueryOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawValue"] = this.rawValue;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["handler"] = this.handler ? this.handler.toJSON() : <any>undefined;
        return data;
    }

    clone(): SkipTokenQueryOption {
        const json = this.toJSON();
        let result = new SkipTokenQueryOption();
        result.init(json);
        return result;
    }
}

/** This defines a $skiptoken OData query option for querying. */
export interface ISkipTokenQueryOption {
    /** Gets the raw $skiptoken value. */
    rawValue?: string | undefined;
    /** Gets the given ODataQueryContext. */
    context?: ODataQueryContext | undefined;
    /** Gets the SkipToken Query Validator. */
    validator?: SkipTokenQueryValidator | undefined;
    /** Gets the skip token handler. */
    handler?: SkipTokenHandler | undefined;
}

/** Represents a validator used to validate a SkipTokenQueryOption based on the ODataValidationSettings. */
export class SkipTokenQueryValidator implements ISkipTokenQueryValidator {

    constructor(data?: ISkipTokenQueryValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SkipTokenQueryValidator {
        data = typeof data === 'object' ? data : {};
        let result = new SkipTokenQueryValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): SkipTokenQueryValidator {
        const json = this.toJSON();
        let result = new SkipTokenQueryValidator();
        result.init(json);
        return result;
    }
}

/** Represents a validator used to validate a SkipTokenQueryOption based on the ODataValidationSettings. */
export interface ISkipTokenQueryValidator {
}

/** Represents how NextLink for paging is generated. */
export abstract class SkipTokenHandler implements ISkipTokenHandler {

    constructor(data?: ISkipTokenHandler) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SkipTokenHandler {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SkipTokenHandler' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): SkipTokenHandler {
        throw new Error("The abstract class 'SkipTokenHandler' cannot be instantiated.");
    }
}

/** Represents how NextLink for paging is generated. */
export interface ISkipTokenHandler {
}

/** This defines a $top OData query option for querying. */
export class TopQueryOption implements ITopQueryOption {
    /** Gets the given ODataQueryContext. */
    context?: ODataQueryContext | undefined;
    /** Gets the raw $top value. */
    rawValue?: string | undefined;
    /** Gets the value of the $top as a parsed integer. */
    value?: number;
    /** Gets or sets the Top Query Validator. */
    validator?: TopQueryValidator | undefined;

    constructor(data?: ITopQueryOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : <any>undefined;
            this.rawValue = _data["rawValue"];
            this.value = _data["value"];
            this.validator = _data["validator"] ? TopQueryValidator.fromJS(_data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TopQueryOption {
        data = typeof data === 'object' ? data : {};
        let result = new TopQueryOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["rawValue"] = this.rawValue;
        data["value"] = this.value;
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data;
    }

    clone(): TopQueryOption {
        const json = this.toJSON();
        let result = new TopQueryOption();
        result.init(json);
        return result;
    }
}

/** This defines a $top OData query option for querying. */
export interface ITopQueryOption {
    /** Gets the given ODataQueryContext. */
    context?: ODataQueryContext | undefined;
    /** Gets the raw $top value. */
    rawValue?: string | undefined;
    /** Gets the value of the $top as a parsed integer. */
    value?: number;
    /** Gets or sets the Top Query Validator. */
    validator?: TopQueryValidator | undefined;
}

/** Represents a validator used to validate a TopQueryOption based on the ODataValidationSettings. */
export class TopQueryValidator implements ITopQueryValidator {

    constructor(data?: ITopQueryValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TopQueryValidator {
        data = typeof data === 'object' ? data : {};
        let result = new TopQueryValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): TopQueryValidator {
        const json = this.toJSON();
        let result = new TopQueryValidator();
        result.init(json);
        return result;
    }
}

/** Represents a validator used to validate a TopQueryOption based on the ODataValidationSettings. */
export interface ITopQueryValidator {
}

/** Represents the value of the $count query option and exposes a way to retrieve the number of entities that satisfy a query. */
export class CountQueryOption implements ICountQueryOption {
    /** Gets the given ODataQueryContext. */
    context?: ODataQueryContext | undefined;
    /** Gets the raw $count value. */
    rawValue?: string | undefined;
    /** Gets the value of the $count in a parsed form. */
    value?: boolean;
    /** Gets or sets the $count query validator. */
    validator?: CountQueryValidator | undefined;

    constructor(data?: ICountQueryOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.context = _data["context"] ? ODataQueryContext.fromJS(_data["context"]) : <any>undefined;
            this.rawValue = _data["rawValue"];
            this.value = _data["value"];
            this.validator = _data["validator"] ? CountQueryValidator.fromJS(_data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CountQueryOption {
        data = typeof data === 'object' ? data : {};
        let result = new CountQueryOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["rawValue"] = this.rawValue;
        data["value"] = this.value;
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data;
    }

    clone(): CountQueryOption {
        const json = this.toJSON();
        let result = new CountQueryOption();
        result.init(json);
        return result;
    }
}

/** Represents the value of the $count query option and exposes a way to retrieve the number of entities that satisfy a query. */
export interface ICountQueryOption {
    /** Gets the given ODataQueryContext. */
    context?: ODataQueryContext | undefined;
    /** Gets the raw $count value. */
    rawValue?: string | undefined;
    /** Gets the value of the $count in a parsed form. */
    value?: boolean;
    /** Gets or sets the $count query validator. */
    validator?: CountQueryValidator | undefined;
}

/** Represents a validator used to validate a CountQueryOption based on the ODataValidationSettings. */
export class CountQueryValidator implements ICountQueryValidator {

    constructor(data?: ICountQueryValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CountQueryValidator {
        data = typeof data === 'object' ? data : {};
        let result = new CountQueryValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CountQueryValidator {
        const json = this.toJSON();
        let result = new CountQueryValidator();
        result.init(json);
        return result;
    }
}

/** Represents a validator used to validate a CountQueryOption based on the ODataValidationSettings. */
export interface ICountQueryValidator {
}

/** Represents a validator used to validate OData queries based on the ODataValidationSettings. */
export class ODataQueryValidator implements IODataQueryValidator {

    constructor(data?: IODataQueryValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ODataQueryValidator {
        data = typeof data === 'object' ? data : {};
        let result = new ODataQueryValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ODataQueryValidator {
        const json = this.toJSON();
        let result = new ODataQueryValidator();
        result.init(json);
        return result;
    }
}

/** Represents a validator used to validate OData queries based on the ODataValidationSettings. */
export interface IODataQueryValidator {
}

export class GetSummaryLatestCalculationDayCmdResponse implements IGetSummaryLatestCalculationDayCmdResponse {
    latestCalculationDay?: Date | undefined;

    constructor(data?: IGetSummaryLatestCalculationDayCmdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latestCalculationDay = _data["latestCalculationDay"] ? new Date(_data["latestCalculationDay"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSummaryLatestCalculationDayCmdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSummaryLatestCalculationDayCmdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latestCalculationDay"] = this.latestCalculationDay ? this.latestCalculationDay.toISOString() : <any>undefined;
        return data;
    }

    clone(): GetSummaryLatestCalculationDayCmdResponse {
        const json = this.toJSON();
        let result = new GetSummaryLatestCalculationDayCmdResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSummaryLatestCalculationDayCmdResponse {
    latestCalculationDay?: Date | undefined;
}

export class SignalConfigurationDto implements ISignalConfigurationDto {
    signalId?: number;
    pointDescription?: string | undefined;
    pointId?: string | undefined;
    dimensionTypeId?: number;
    dimensionTypeDescription?: string | undefined;
    signalDescription?: string | undefined;
    networkElementId?: string;
    hierarchyElementId?: string | undefined;
    category?: string | undefined;
    elementType?: string | undefined;
    elementName?: string | undefined;
    isHierarchy?: boolean;
    unitTypeId?: number;
    unitType?: string | undefined;
    isBoundary?: boolean | undefined;
    isAlarmRelated?: boolean | undefined;
    subcategory?: string | undefined;

    constructor(data?: ISignalConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signalId = _data["signalId"];
            this.pointDescription = _data["pointDescription"];
            this.pointId = _data["pointId"];
            this.dimensionTypeId = _data["dimensionTypeId"];
            this.dimensionTypeDescription = _data["dimensionTypeDescription"];
            this.signalDescription = _data["signalDescription"];
            this.networkElementId = _data["networkElementId"];
            this.hierarchyElementId = _data["hierarchyElementId"];
            this.category = _data["category"];
            this.elementType = _data["elementType"];
            this.elementName = _data["elementName"];
            this.isHierarchy = _data["isHierarchy"];
            this.unitTypeId = _data["unitTypeId"];
            this.unitType = _data["unitType"];
            this.isBoundary = _data["isBoundary"];
            this.isAlarmRelated = _data["isAlarmRelated"];
            this.subcategory = _data["subcategory"];
        }
    }

    static fromJS(data: any): SignalConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignalConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signalId"] = this.signalId;
        data["pointDescription"] = this.pointDescription;
        data["pointId"] = this.pointId;
        data["dimensionTypeId"] = this.dimensionTypeId;
        data["dimensionTypeDescription"] = this.dimensionTypeDescription;
        data["signalDescription"] = this.signalDescription;
        data["networkElementId"] = this.networkElementId;
        data["hierarchyElementId"] = this.hierarchyElementId;
        data["category"] = this.category;
        data["elementType"] = this.elementType;
        data["elementName"] = this.elementName;
        data["isHierarchy"] = this.isHierarchy;
        data["unitTypeId"] = this.unitTypeId;
        data["unitType"] = this.unitType;
        data["isBoundary"] = this.isBoundary;
        data["isAlarmRelated"] = this.isAlarmRelated;
        data["subcategory"] = this.subcategory;
        return data;
    }

    clone(): SignalConfigurationDto {
        const json = this.toJSON();
        let result = new SignalConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface ISignalConfigurationDto {
    signalId?: number;
    pointDescription?: string | undefined;
    pointId?: string | undefined;
    dimensionTypeId?: number;
    dimensionTypeDescription?: string | undefined;
    signalDescription?: string | undefined;
    networkElementId?: string;
    hierarchyElementId?: string | undefined;
    category?: string | undefined;
    elementType?: string | undefined;
    elementName?: string | undefined;
    isHierarchy?: boolean;
    unitTypeId?: number;
    unitType?: string | undefined;
    isBoundary?: boolean | undefined;
    isAlarmRelated?: boolean | undefined;
    subcategory?: string | undefined;
}

export class SignalsConfiguredQueryDto implements ISignalsConfiguredQueryDto {
    includeBoundaries?: boolean;
    includeLargeUsers?: boolean;
    includePressure?: boolean;
    includeInletOutlet?: boolean;
    includeLevel?: boolean;
    includeLarsSworps?: boolean;
    includeSmartMeters?: boolean;
    elementsIds?: string[] | undefined;

    constructor(data?: ISignalsConfiguredQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeBoundaries = _data["includeBoundaries"];
            this.includeLargeUsers = _data["includeLargeUsers"];
            this.includePressure = _data["includePressure"];
            this.includeInletOutlet = _data["includeInletOutlet"];
            this.includeLevel = _data["includeLevel"];
            this.includeLarsSworps = _data["includeLarsSworps"];
            this.includeSmartMeters = _data["includeSmartMeters"];
            if (Array.isArray(_data["elementsIds"])) {
                this.elementsIds = [] as any;
                for (let item of _data["elementsIds"])
                    this.elementsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SignalsConfiguredQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignalsConfiguredQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeBoundaries"] = this.includeBoundaries;
        data["includeLargeUsers"] = this.includeLargeUsers;
        data["includePressure"] = this.includePressure;
        data["includeInletOutlet"] = this.includeInletOutlet;
        data["includeLevel"] = this.includeLevel;
        data["includeLarsSworps"] = this.includeLarsSworps;
        data["includeSmartMeters"] = this.includeSmartMeters;
        if (Array.isArray(this.elementsIds)) {
            data["elementsIds"] = [];
            for (let item of this.elementsIds)
                data["elementsIds"].push(item);
        }
        return data;
    }

    clone(): SignalsConfiguredQueryDto {
        const json = this.toJSON();
        let result = new SignalsConfiguredQueryDto();
        result.init(json);
        return result;
    }
}

export interface ISignalsConfiguredQueryDto {
    includeBoundaries?: boolean;
    includeLargeUsers?: boolean;
    includePressure?: boolean;
    includeInletOutlet?: boolean;
    includeLevel?: boolean;
    includeLarsSworps?: boolean;
    includeSmartMeters?: boolean;
    elementsIds?: string[] | undefined;
}

export class UpsertGridSettingsResponseDto implements IUpsertGridSettingsResponseDto {
    success?: string[] | undefined;
    errors?: string[] | undefined;
    successUsers?: string[] | undefined;
    errorUsers?: string[] | undefined;

    constructor(data?: IUpsertGridSettingsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["success"])) {
                this.success = [] as any;
                for (let item of _data["success"])
                    this.success!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["successUsers"])) {
                this.successUsers = [] as any;
                for (let item of _data["successUsers"])
                    this.successUsers!.push(item);
            }
            if (Array.isArray(_data["errorUsers"])) {
                this.errorUsers = [] as any;
                for (let item of _data["errorUsers"])
                    this.errorUsers!.push(item);
            }
        }
    }

    static fromJS(data: any): UpsertGridSettingsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertGridSettingsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.success)) {
            data["success"] = [];
            for (let item of this.success)
                data["success"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.successUsers)) {
            data["successUsers"] = [];
            for (let item of this.successUsers)
                data["successUsers"].push(item);
        }
        if (Array.isArray(this.errorUsers)) {
            data["errorUsers"] = [];
            for (let item of this.errorUsers)
                data["errorUsers"].push(item);
        }
        return data;
    }

    clone(): UpsertGridSettingsResponseDto {
        const json = this.toJSON();
        let result = new UpsertGridSettingsResponseDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertGridSettingsResponseDto {
    success?: string[] | undefined;
    errors?: string[] | undefined;
    successUsers?: string[] | undefined;
    errorUsers?: string[] | undefined;
}

export class UpsertGridSettingsDto implements IUpsertGridSettingsDto {
    gridSettingsValue!: string;
    gridSettingKey?: string | undefined;
    saveAsDefault?: boolean;

    constructor(data?: IUpsertGridSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gridSettingsValue = _data["gridSettingsValue"];
            this.gridSettingKey = _data["gridSettingKey"];
            this.saveAsDefault = _data["saveAsDefault"];
        }
    }

    static fromJS(data: any): UpsertGridSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertGridSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gridSettingsValue"] = this.gridSettingsValue;
        data["gridSettingKey"] = this.gridSettingKey;
        data["saveAsDefault"] = this.saveAsDefault;
        return data;
    }

    clone(): UpsertGridSettingsDto {
        const json = this.toJSON();
        let result = new UpsertGridSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertGridSettingsDto {
    gridSettingsValue: string;
    gridSettingKey?: string | undefined;
    saveAsDefault?: boolean;
}

export class GridSettingSaveStateResponseDto implements IGridSettingSaveStateResponseDto {
    hasSystemSettings?: boolean;
    hasUserSettings?: boolean;

    constructor(data?: IGridSettingSaveStateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasSystemSettings = _data["hasSystemSettings"];
            this.hasUserSettings = _data["hasUserSettings"];
        }
    }

    static fromJS(data: any): GridSettingSaveStateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GridSettingSaveStateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasSystemSettings"] = this.hasSystemSettings;
        data["hasUserSettings"] = this.hasUserSettings;
        return data;
    }

    clone(): GridSettingSaveStateResponseDto {
        const json = this.toJSON();
        let result = new GridSettingSaveStateResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGridSettingSaveStateResponseDto {
    hasSystemSettings?: boolean;
    hasUserSettings?: boolean;
}

export class UpsertSettingComponentResponseDto implements IUpsertSettingComponentResponseDto {
    success?: string[] | undefined;
    successUsers?: string[] | undefined;

    constructor(data?: IUpsertSettingComponentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["success"])) {
                this.success = [] as any;
                for (let item of _data["success"])
                    this.success!.push(item);
            }
            if (Array.isArray(_data["successUsers"])) {
                this.successUsers = [] as any;
                for (let item of _data["successUsers"])
                    this.successUsers!.push(item);
            }
        }
    }

    static fromJS(data: any): UpsertSettingComponentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertSettingComponentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.success)) {
            data["success"] = [];
            for (let item of this.success)
                data["success"].push(item);
        }
        if (Array.isArray(this.successUsers)) {
            data["successUsers"] = [];
            for (let item of this.successUsers)
                data["successUsers"].push(item);
        }
        return data;
    }

    clone(): UpsertSettingComponentResponseDto {
        const json = this.toJSON();
        let result = new UpsertSettingComponentResponseDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertSettingComponentResponseDto {
    success?: string[] | undefined;
    successUsers?: string[] | undefined;
}

export class UpsertSettingComponentDto implements IUpsertSettingComponentDto {
    settingValue!: string;
    settingArea?: string | undefined;
    settingKey?: string | undefined;
    saveAsDefault?: boolean;
    componentTypeId?: number | undefined;
    createComponentIfNoExists?: boolean | undefined;

    constructor(data?: IUpsertSettingComponentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settingValue = _data["settingValue"];
            this.settingArea = _data["settingArea"];
            this.settingKey = _data["settingKey"];
            this.saveAsDefault = _data["saveAsDefault"];
            this.componentTypeId = _data["componentTypeId"];
            this.createComponentIfNoExists = _data["createComponentIfNoExists"];
        }
    }

    static fromJS(data: any): UpsertSettingComponentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertSettingComponentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingValue"] = this.settingValue;
        data["settingArea"] = this.settingArea;
        data["settingKey"] = this.settingKey;
        data["saveAsDefault"] = this.saveAsDefault;
        data["componentTypeId"] = this.componentTypeId;
        data["createComponentIfNoExists"] = this.createComponentIfNoExists;
        return data;
    }

    clone(): UpsertSettingComponentDto {
        const json = this.toJSON();
        let result = new UpsertSettingComponentDto();
        result.init(json);
        return result;
    }
}

export interface IUpsertSettingComponentDto {
    settingValue: string;
    settingArea?: string | undefined;
    settingKey?: string | undefined;
    saveAsDefault?: boolean;
    componentTypeId?: number | undefined;
    createComponentIfNoExists?: boolean | undefined;
}

export class DeleteSettingComponentDto implements IDeleteSettingComponentDto {
    settingsToDelete!: SettingComponentDto[];

    constructor(data?: IDeleteSettingComponentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.settingsToDelete = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["settingsToDelete"])) {
                this.settingsToDelete = [] as any;
                for (let item of _data["settingsToDelete"])
                    this.settingsToDelete!.push(SettingComponentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeleteSettingComponentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSettingComponentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.settingsToDelete)) {
            data["settingsToDelete"] = [];
            for (let item of this.settingsToDelete)
                data["settingsToDelete"].push(item.toJSON());
        }
        return data;
    }

    clone(): DeleteSettingComponentDto {
        const json = this.toJSON();
        let result = new DeleteSettingComponentDto();
        result.init(json);
        return result;
    }
}

export interface IDeleteSettingComponentDto {
    settingsToDelete: SettingComponentDto[];
}

export class SettingComponentDto implements ISettingComponentDto {
    settingArea?: string | undefined;
    settingKey?: string | undefined;

    constructor(data?: ISettingComponentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settingArea = _data["settingArea"];
            this.settingKey = _data["settingKey"];
        }
    }

    static fromJS(data: any): SettingComponentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingComponentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingArea"] = this.settingArea;
        data["settingKey"] = this.settingKey;
        return data;
    }

    clone(): SettingComponentDto {
        const json = this.toJSON();
        let result = new SettingComponentDto();
        result.init(json);
        return result;
    }
}

export interface ISettingComponentDto {
    settingArea?: string | undefined;
    settingKey?: string | undefined;
}

export class GroupsDto implements IGroupsDto {
    groupId?: number;
    groupName?: string | undefined;
    groupDescription?: string | undefined;

    constructor(data?: IGroupsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.groupDescription = _data["groupDescription"];
        }
    }

    static fromJS(data: any): GroupsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["groupDescription"] = this.groupDescription;
        return data;
    }

    clone(): GroupsDto {
        const json = this.toJSON();
        let result = new GroupsDto();
        result.init(json);
        return result;
    }
}

export interface IGroupsDto {
    groupId?: number;
    groupName?: string | undefined;
    groupDescription?: string | undefined;
}

/** This defines a composite OData query options that can be used to perform query composition. Currently this only supports $filter, $orderby, $top, $skip. */
export class ODataQueryOptionsOfGroupsDto extends ODataQueryOptions implements IODataQueryOptionsOfGroupsDto {
    ifMatch?: ETagOfGroupsDto | undefined;
    ifNoneMatch?: ETagOfGroupsDto | undefined;

    constructor(data?: IODataQueryOptionsOfGroupsDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ifMatch = _data["ifMatch"] ? ETagOfGroupsDto.fromJS(_data["ifMatch"]) : <any>undefined;
            this.ifNoneMatch = _data["ifNoneMatch"] ? ETagOfGroupsDto.fromJS(_data["ifNoneMatch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ODataQueryOptionsOfGroupsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ODataQueryOptionsOfGroupsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ifMatch"] = this.ifMatch ? this.ifMatch.toJSON() : <any>undefined;
        data["ifNoneMatch"] = this.ifNoneMatch ? this.ifNoneMatch.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): ODataQueryOptionsOfGroupsDto {
        const json = this.toJSON();
        let result = new ODataQueryOptionsOfGroupsDto();
        result.init(json);
        return result;
    }
}

/** This defines a composite OData query options that can be used to perform query composition. Currently this only supports $filter, $orderby, $top, $skip. */
export interface IODataQueryOptionsOfGroupsDto extends IODataQueryOptions {
    ifMatch?: ETagOfGroupsDto | undefined;
    ifNoneMatch?: ETagOfGroupsDto | undefined;
}

/** OData ETag of an entity type . */
export class ETagOfGroupsDto extends ETag implements IETagOfGroupsDto {

    constructor(data?: IETagOfGroupsDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ETagOfGroupsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ETagOfGroupsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ETagOfGroupsDto {
        const json = this.toJSON();
        let result = new ETagOfGroupsDto();
        result.init(json);
        return result;
    }
}

/** OData ETag of an entity type . */
export interface IETagOfGroupsDto extends IETag {
}

export class UserPermissionsDto implements IUserPermissionsDto {
    isSuperUser?: boolean;
    userCode?: string | undefined;
    permissions?: ProfileDialogsPathsDto[] | undefined;

    constructor(data?: IUserPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuperUser = _data["isSuperUser"];
            this.userCode = _data["userCode"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(ProfileDialogsPathsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuperUser"] = this.isSuperUser;
        data["userCode"] = this.userCode;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserPermissionsDto {
        const json = this.toJSON();
        let result = new UserPermissionsDto();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionsDto {
    isSuperUser?: boolean;
    userCode?: string | undefined;
    permissions?: ProfileDialogsPathsDto[] | undefined;
}

export class ProfileDialogsPathsDto implements IProfileDialogsPathsDto {
    groupId?: number;
    profileId?: number;
    dialogId?: number;
    canCreate?: boolean;
    canRead?: boolean;
    canUpdate?: boolean;
    canDelete?: boolean;
    dialogName?: string | undefined;
    dialogDescription?: string | undefined;
    ancestorId?: number | undefined;

    constructor(data?: IProfileDialogsPathsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.profileId = _data["profileId"];
            this.dialogId = _data["dialogId"];
            this.canCreate = _data["canCreate"];
            this.canRead = _data["canRead"];
            this.canUpdate = _data["canUpdate"];
            this.canDelete = _data["canDelete"];
            this.dialogName = _data["dialogName"];
            this.dialogDescription = _data["dialogDescription"];
            this.ancestorId = _data["ancestorId"];
        }
    }

    static fromJS(data: any): ProfileDialogsPathsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDialogsPathsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["profileId"] = this.profileId;
        data["dialogId"] = this.dialogId;
        data["canCreate"] = this.canCreate;
        data["canRead"] = this.canRead;
        data["canUpdate"] = this.canUpdate;
        data["canDelete"] = this.canDelete;
        data["dialogName"] = this.dialogName;
        data["dialogDescription"] = this.dialogDescription;
        data["ancestorId"] = this.ancestorId;
        return data;
    }

    clone(): ProfileDialogsPathsDto {
        const json = this.toJSON();
        let result = new ProfileDialogsPathsDto();
        result.init(json);
        return result;
    }
}

export interface IProfileDialogsPathsDto {
    groupId?: number;
    profileId?: number;
    dialogId?: number;
    canCreate?: boolean;
    canRead?: boolean;
    canUpdate?: boolean;
    canDelete?: boolean;
    dialogName?: string | undefined;
    dialogDescription?: string | undefined;
    ancestorId?: number | undefined;
}

export class ProfileCrudsResponse implements IProfileCrudsResponse {
    success?: string[] | undefined;
    errors?: string[] | undefined;
    successProfileCrud?: string[] | undefined;
    errorProfileCrud?: string[] | undefined;

    constructor(data?: IProfileCrudsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["success"])) {
                this.success = [] as any;
                for (let item of _data["success"])
                    this.success!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["successProfileCrud"])) {
                this.successProfileCrud = [] as any;
                for (let item of _data["successProfileCrud"])
                    this.successProfileCrud!.push(item);
            }
            if (Array.isArray(_data["errorProfileCrud"])) {
                this.errorProfileCrud = [] as any;
                for (let item of _data["errorProfileCrud"])
                    this.errorProfileCrud!.push(item);
            }
        }
    }

    static fromJS(data: any): ProfileCrudsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileCrudsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.success)) {
            data["success"] = [];
            for (let item of this.success)
                data["success"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.successProfileCrud)) {
            data["successProfileCrud"] = [];
            for (let item of this.successProfileCrud)
                data["successProfileCrud"].push(item);
        }
        if (Array.isArray(this.errorProfileCrud)) {
            data["errorProfileCrud"] = [];
            for (let item of this.errorProfileCrud)
                data["errorProfileCrud"].push(item);
        }
        return data;
    }

    clone(): ProfileCrudsResponse {
        const json = this.toJSON();
        let result = new ProfileCrudsResponse();
        result.init(json);
        return result;
    }
}

export interface IProfileCrudsResponse {
    success?: string[] | undefined;
    errors?: string[] | undefined;
    successProfileCrud?: string[] | undefined;
    errorProfileCrud?: string[] | undefined;
}

export class ProfileCrudCmd implements IProfileCrudCmd {
    profileId?: number;
    dialogId?: number;
    canCreate?: boolean | undefined;
    canRead?: boolean | undefined;
    canUpdate?: boolean | undefined;
    canDelete?: boolean | undefined;
    userName?: string | undefined;
    dialogName?: string | undefined;
    groupName?: string | undefined;

    constructor(data?: IProfileCrudCmd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            this.dialogId = _data["dialogId"];
            this.canCreate = _data["canCreate"];
            this.canRead = _data["canRead"];
            this.canUpdate = _data["canUpdate"];
            this.canDelete = _data["canDelete"];
            this.userName = _data["userName"];
            this.dialogName = _data["dialogName"];
            this.groupName = _data["groupName"];
        }
    }

    static fromJS(data: any): ProfileCrudCmd {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileCrudCmd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["dialogId"] = this.dialogId;
        data["canCreate"] = this.canCreate;
        data["canRead"] = this.canRead;
        data["canUpdate"] = this.canUpdate;
        data["canDelete"] = this.canDelete;
        data["userName"] = this.userName;
        data["dialogName"] = this.dialogName;
        data["groupName"] = this.groupName;
        return data;
    }

    clone(): ProfileCrudCmd {
        const json = this.toJSON();
        let result = new ProfileCrudCmd();
        result.init(json);
        return result;
    }
}

export interface IProfileCrudCmd {
    profileId?: number;
    dialogId?: number;
    canCreate?: boolean | undefined;
    canRead?: boolean | undefined;
    canUpdate?: boolean | undefined;
    canDelete?: boolean | undefined;
    userName?: string | undefined;
    dialogName?: string | undefined;
    groupName?: string | undefined;
}

export class GroupResponse implements IGroupResponse {
    success?: string[] | undefined;
    errors?: string[] | undefined;
    hasSameNameError?: boolean;

    constructor(data?: IGroupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["success"])) {
                this.success = [] as any;
                for (let item of _data["success"])
                    this.success!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.hasSameNameError = _data["hasSameNameError"];
        }
    }

    static fromJS(data: any): GroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.success)) {
            data["success"] = [];
            for (let item of this.success)
                data["success"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["hasSameNameError"] = this.hasSameNameError;
        return data;
    }

    clone(): GroupResponse {
        const json = this.toJSON();
        let result = new GroupResponse();
        result.init(json);
        return result;
    }
}

export interface IGroupResponse {
    success?: string[] | undefined;
    errors?: string[] | undefined;
    hasSameNameError?: boolean;
}

export abstract class BaseRolesGroupCmd implements IBaseRolesGroupCmd {
    groupId?: number | undefined;
    groupName?: string | undefined;
    groupDescription?: string | undefined;

    constructor(data?: IBaseRolesGroupCmd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.groupDescription = _data["groupDescription"];
        }
    }

    static fromJS(data: any): BaseRolesGroupCmd {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseRolesGroupCmd' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["groupDescription"] = this.groupDescription;
        return data;
    }

    clone(): BaseRolesGroupCmd {
        throw new Error("The abstract class 'BaseRolesGroupCmd' cannot be instantiated.");
    }
}

export interface IBaseRolesGroupCmd {
    groupId?: number | undefined;
    groupName?: string | undefined;
    groupDescription?: string | undefined;
}

export class RolesGroupAddOrUpdateCmd extends BaseRolesGroupCmd implements IRolesGroupAddOrUpdateCmd {

    constructor(data?: IRolesGroupAddOrUpdateCmd) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): RolesGroupAddOrUpdateCmd {
        data = typeof data === 'object' ? data : {};
        let result = new RolesGroupAddOrUpdateCmd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): RolesGroupAddOrUpdateCmd {
        const json = this.toJSON();
        let result = new RolesGroupAddOrUpdateCmd();
        result.init(json);
        return result;
    }
}

export interface IRolesGroupAddOrUpdateCmd extends IBaseRolesGroupCmd {
}

export class RolesGroupDeleteCmd extends BaseRolesGroupCmd implements IRolesGroupDeleteCmd {

    constructor(data?: IRolesGroupDeleteCmd) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): RolesGroupDeleteCmd {
        data = typeof data === 'object' ? data : {};
        let result = new RolesGroupDeleteCmd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): RolesGroupDeleteCmd {
        const json = this.toJSON();
        let result = new RolesGroupDeleteCmd();
        result.init(json);
        return result;
    }
}

export interface IRolesGroupDeleteCmd extends IBaseRolesGroupCmd {
}

export class UsersDto implements IUsersDto {
    userCode?: string | undefined;
    surname?: string | undefined;
    name?: string | undefined;
    isActive?: boolean | undefined;
    isSuperUser?: boolean;
    lastAccess?: Date | undefined;
    groups?: number[] | undefined;

    constructor(data?: IUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCode = _data["userCode"];
            this.surname = _data["surname"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.isSuperUser = _data["isSuperUser"];
            this.lastAccess = _data["lastAccess"] ? new Date(_data["lastAccess"].toString()) : <any>undefined;
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
        }
    }

    static fromJS(data: any): UsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCode"] = this.userCode;
        data["surname"] = this.surname;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["isSuperUser"] = this.isSuperUser;
        data["lastAccess"] = this.lastAccess ? this.lastAccess.toISOString() : <any>undefined;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        return data;
    }

    clone(): UsersDto {
        const json = this.toJSON();
        let result = new UsersDto();
        result.init(json);
        return result;
    }
}

export interface IUsersDto {
    userCode?: string | undefined;
    surname?: string | undefined;
    name?: string | undefined;
    isActive?: boolean | undefined;
    isSuperUser?: boolean;
    lastAccess?: Date | undefined;
    groups?: number[] | undefined;
}

export class UserActivitityTrendDto implements IUserActivitityTrendDto {
    userActivity?: UserActivitityTrendEnum;
    trendValues?: TrendDataPointDto[] | undefined;

    constructor(data?: IUserActivitityTrendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userActivity = _data["userActivity"];
            if (Array.isArray(_data["trendValues"])) {
                this.trendValues = [] as any;
                for (let item of _data["trendValues"])
                    this.trendValues!.push(TrendDataPointDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserActivitityTrendDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivitityTrendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userActivity"] = this.userActivity;
        if (Array.isArray(this.trendValues)) {
            data["trendValues"] = [];
            for (let item of this.trendValues)
                data["trendValues"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserActivitityTrendDto {
        const json = this.toJSON();
        let result = new UserActivitityTrendDto();
        result.init(json);
        return result;
    }
}

export interface IUserActivitityTrendDto {
    userActivity?: UserActivitityTrendEnum;
    trendValues?: TrendDataPointDto[] | undefined;
}

export enum UserActivitityTrendEnum {
    LicensedUsers = 1,
    DAUC = 2,
    DULAC = 3,
}

export class TrendDataPointDto implements ITrendDataPointDto {
    value?: number;
    key?: any | undefined;

    constructor(data?: ITrendDataPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): TrendDataPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrendDataPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["key"] = this.key;
        return data;
    }

    clone(): TrendDataPointDto {
        const json = this.toJSON();
        let result = new TrendDataPointDto();
        result.init(json);
        return result;
    }
}

export interface ITrendDataPointDto {
    value?: number;
    key?: any | undefined;
}

export class GroupUsersResponse implements IGroupUsersResponse {
    success?: string[] | undefined;
    errors?: string[] | undefined;
    successUsers?: string[] | undefined;
    errorUsers?: string[] | undefined;

    constructor(data?: IGroupUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["success"])) {
                this.success = [] as any;
                for (let item of _data["success"])
                    this.success!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["successUsers"])) {
                this.successUsers = [] as any;
                for (let item of _data["successUsers"])
                    this.successUsers!.push(item);
            }
            if (Array.isArray(_data["errorUsers"])) {
                this.errorUsers = [] as any;
                for (let item of _data["errorUsers"])
                    this.errorUsers!.push(item);
            }
        }
    }

    static fromJS(data: any): GroupUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GroupUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.success)) {
            data["success"] = [];
            for (let item of this.success)
                data["success"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.successUsers)) {
            data["successUsers"] = [];
            for (let item of this.successUsers)
                data["successUsers"].push(item);
        }
        if (Array.isArray(this.errorUsers)) {
            data["errorUsers"] = [];
            for (let item of this.errorUsers)
                data["errorUsers"].push(item);
        }
        return data;
    }

    clone(): GroupUsersResponse {
        const json = this.toJSON();
        let result = new GroupUsersResponse();
        result.init(json);
        return result;
    }
}

export interface IGroupUsersResponse {
    success?: string[] | undefined;
    errors?: string[] | undefined;
    successUsers?: string[] | undefined;
    errorUsers?: string[] | undefined;
}

export abstract class BaseGroupUsersCmd implements IBaseGroupUsersCmd {
    groupsIds?: number[] | undefined;
    users?: string[] | undefined;

    constructor(data?: IBaseGroupUsersCmd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groupsIds"])) {
                this.groupsIds = [] as any;
                for (let item of _data["groupsIds"])
                    this.groupsIds!.push(item);
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(item);
            }
        }
    }

    static fromJS(data: any): BaseGroupUsersCmd {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseGroupUsersCmd' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groupsIds)) {
            data["groupsIds"] = [];
            for (let item of this.groupsIds)
                data["groupsIds"].push(item);
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item);
        }
        return data;
    }

    clone(): BaseGroupUsersCmd {
        throw new Error("The abstract class 'BaseGroupUsersCmd' cannot be instantiated.");
    }
}

export interface IBaseGroupUsersCmd {
    groupsIds?: number[] | undefined;
    users?: string[] | undefined;
}

export class GroupUsersInsertCmd extends BaseGroupUsersCmd implements IGroupUsersInsertCmd {

    constructor(data?: IGroupUsersInsertCmd) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GroupUsersInsertCmd {
        data = typeof data === 'object' ? data : {};
        let result = new GroupUsersInsertCmd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): GroupUsersInsertCmd {
        const json = this.toJSON();
        let result = new GroupUsersInsertCmd();
        result.init(json);
        return result;
    }
}

export interface IGroupUsersInsertCmd extends IBaseGroupUsersCmd {
}

export class GroupUsersDeleteCmd extends BaseGroupUsersCmd implements IGroupUsersDeleteCmd {

    constructor(data?: IGroupUsersDeleteCmd) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GroupUsersDeleteCmd {
        data = typeof data === 'object' ? data : {};
        let result = new GroupUsersDeleteCmd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): GroupUsersDeleteCmd {
        const json = this.toJSON();
        let result = new GroupUsersDeleteCmd();
        result.init(json);
        return result;
    }
}

export interface IGroupUsersDeleteCmd extends IBaseGroupUsersCmd {
}

export class UsersIdentityMappingDto implements IUsersIdentityMappingDto {
    userId?: string;
    userCode?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUsersIdentityMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userCode = _data["userCode"];
            this.userName = _data["userName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UsersIdentityMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsersIdentityMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userCode"] = this.userCode;
        data["userName"] = this.userName;
        data["email"] = this.email;
        return data;
    }

    clone(): UsersIdentityMappingDto {
        const json = this.toJSON();
        let result = new UsersIdentityMappingDto();
        result.init(json);
        return result;
    }
}

export interface IUsersIdentityMappingDto {
    userId?: string;
    userCode?: string | undefined;
    userName?: string | undefined;
    email?: string | undefined;
}

export class UsersIdentityResponse implements IUsersIdentityResponse {
    success?: string[] | undefined;
    errors?: string[] | undefined;
    successUsers?: string[] | undefined;
    errorUsers?: string[] | undefined;

    constructor(data?: IUsersIdentityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["success"])) {
                this.success = [] as any;
                for (let item of _data["success"])
                    this.success!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["successUsers"])) {
                this.successUsers = [] as any;
                for (let item of _data["successUsers"])
                    this.successUsers!.push(item);
            }
            if (Array.isArray(_data["errorUsers"])) {
                this.errorUsers = [] as any;
                for (let item of _data["errorUsers"])
                    this.errorUsers!.push(item);
            }
        }
    }

    static fromJS(data: any): UsersIdentityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UsersIdentityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.success)) {
            data["success"] = [];
            for (let item of this.success)
                data["success"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.successUsers)) {
            data["successUsers"] = [];
            for (let item of this.successUsers)
                data["successUsers"].push(item);
        }
        if (Array.isArray(this.errorUsers)) {
            data["errorUsers"] = [];
            for (let item of this.errorUsers)
                data["errorUsers"].push(item);
        }
        return data;
    }

    clone(): UsersIdentityResponse {
        const json = this.toJSON();
        let result = new UsersIdentityResponse();
        result.init(json);
        return result;
    }
}

export interface IUsersIdentityResponse {
    success?: string[] | undefined;
    errors?: string[] | undefined;
    successUsers?: string[] | undefined;
    errorUsers?: string[] | undefined;
}

export abstract class BaseUserIdentityCmd implements IBaseUserIdentityCmd {
    userIds?: string[] | undefined;
    asociatedUserCode?: string | undefined;

    constructor(data?: IBaseUserIdentityCmd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.asociatedUserCode = _data["asociatedUserCode"];
        }
    }

    static fromJS(data: any): BaseUserIdentityCmd {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseUserIdentityCmd' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["asociatedUserCode"] = this.asociatedUserCode;
        return data;
    }

    clone(): BaseUserIdentityCmd {
        throw new Error("The abstract class 'BaseUserIdentityCmd' cannot be instantiated.");
    }
}

export interface IBaseUserIdentityCmd {
    userIds?: string[] | undefined;
    asociatedUserCode?: string | undefined;
}

export class UserIdentityInsertCmd extends BaseUserIdentityCmd implements IUserIdentityInsertCmd {

    constructor(data?: IUserIdentityInsertCmd) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UserIdentityInsertCmd {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdentityInsertCmd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): UserIdentityInsertCmd {
        const json = this.toJSON();
        let result = new UserIdentityInsertCmd();
        result.init(json);
        return result;
    }
}

export interface IUserIdentityInsertCmd extends IBaseUserIdentityCmd {
}

export class UserIdentityDeleteCmd extends BaseUserIdentityCmd implements IUserIdentityDeleteCmd {

    constructor(data?: IUserIdentityDeleteCmd) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UserIdentityDeleteCmd {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdentityDeleteCmd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): UserIdentityDeleteCmd {
        const json = this.toJSON();
        let result = new UserIdentityDeleteCmd();
        result.init(json);
        return result;
    }
}

export interface IUserIdentityDeleteCmd extends IBaseUserIdentityCmd {
}

export class MeasuredValueDto implements IMeasuredValueDto {
    signalId?: number;
    measureTimestamp?: Date;
    value?: number;
    fieldQuality?: number;
    validity?: number;
    estimatedEdited?: number;
    sourceSystemId?: number;
    arrivalDateTime?: Date;
    trendTypeId?: number;
    referenceTime?: Date | undefined;
    validationFunctionId?: number | undefined;
    estimationFunctionId?: number | undefined;
    dimensionTypeId?: number | undefined;
    pointDescription?: string | undefined;
    pointId?: string | undefined;
    id?: string | undefined;

    constructor(data?: IMeasuredValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signalId = _data["signalId"];
            this.measureTimestamp = _data["measureTimestamp"] ? new Date(_data["measureTimestamp"].toString()) : <any>undefined;
            this.value = _data["value"];
            this.fieldQuality = _data["fieldQuality"];
            this.validity = _data["validity"];
            this.estimatedEdited = _data["estimatedEdited"];
            this.sourceSystemId = _data["sourceSystemId"];
            this.arrivalDateTime = _data["arrivalDateTime"] ? new Date(_data["arrivalDateTime"].toString()) : <any>undefined;
            this.trendTypeId = _data["trendTypeId"];
            this.referenceTime = _data["referenceTime"] ? new Date(_data["referenceTime"].toString()) : <any>undefined;
            this.validationFunctionId = _data["validationFunctionId"];
            this.estimationFunctionId = _data["estimationFunctionId"];
            this.dimensionTypeId = _data["dimensionTypeId"];
            this.pointDescription = _data["pointDescription"];
            this.pointId = _data["pointId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MeasuredValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuredValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signalId"] = this.signalId;
        data["measureTimestamp"] = this.measureTimestamp ? this.measureTimestamp.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["fieldQuality"] = this.fieldQuality;
        data["validity"] = this.validity;
        data["estimatedEdited"] = this.estimatedEdited;
        data["sourceSystemId"] = this.sourceSystemId;
        data["arrivalDateTime"] = this.arrivalDateTime ? this.arrivalDateTime.toISOString() : <any>undefined;
        data["trendTypeId"] = this.trendTypeId;
        data["referenceTime"] = this.referenceTime ? this.referenceTime.toISOString() : <any>undefined;
        data["validationFunctionId"] = this.validationFunctionId;
        data["estimationFunctionId"] = this.estimationFunctionId;
        data["dimensionTypeId"] = this.dimensionTypeId;
        data["pointDescription"] = this.pointDescription;
        data["pointId"] = this.pointId;
        data["id"] = this.id;
        return data;
    }

    clone(): MeasuredValueDto {
        const json = this.toJSON();
        let result = new MeasuredValueDto();
        result.init(json);
        return result;
    }
}

export interface IMeasuredValueDto {
    signalId?: number;
    measureTimestamp?: Date;
    value?: number;
    fieldQuality?: number;
    validity?: number;
    estimatedEdited?: number;
    sourceSystemId?: number;
    arrivalDateTime?: Date;
    trendTypeId?: number;
    referenceTime?: Date | undefined;
    validationFunctionId?: number | undefined;
    estimationFunctionId?: number | undefined;
    dimensionTypeId?: number | undefined;
    pointDescription?: string | undefined;
    pointId?: string | undefined;
    id?: string | undefined;
}

export class MeasuredValuesQueryDto implements IMeasuredValuesQueryDto {
    startDate?: Date;
    endDate?: Date | undefined;
    signalIds?: number[] | undefined;

    constructor(data?: IMeasuredValuesQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["signalIds"])) {
                this.signalIds = [] as any;
                for (let item of _data["signalIds"])
                    this.signalIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MeasuredValuesQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuredValuesQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.signalIds)) {
            data["signalIds"] = [];
            for (let item of this.signalIds)
                data["signalIds"].push(item);
        }
        return data;
    }

    clone(): MeasuredValuesQueryDto {
        const json = this.toJSON();
        let result = new MeasuredValuesQueryDto();
        result.init(json);
        return result;
    }
}

export interface IMeasuredValuesQueryDto {
    startDate?: Date;
    endDate?: Date | undefined;
    signalIds?: number[] | undefined;
}

export class SerieDto implements ISerieDto {

    constructor(data?: ISerieDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SerieDto {
        data = typeof data === 'object' ? data : {};
        let result = new SerieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): SerieDto {
        const json = this.toJSON();
        let result = new SerieDto();
        result.init(json);
        return result;
    }
}

export interface ISerieDto {
}

export class MVChartSerieDto extends SerieDto implements IMVChartSerieDto {
    signalId?: number;
    pointDescription?: string | undefined;
    pointId?: string | undefined;
    points?: MVChartPointDto[] | undefined;
    sourceSystemId?: number;
    trendTypeId?: number;
    dimensionTypeId?: number | undefined;
    isFlatten?: boolean;

    constructor(data?: IMVChartSerieDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.signalId = _data["signalId"];
            this.pointDescription = _data["pointDescription"];
            this.pointId = _data["pointId"];
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(MVChartPointDto.fromJS(item));
            }
            this.sourceSystemId = _data["sourceSystemId"];
            this.trendTypeId = _data["trendTypeId"];
            this.dimensionTypeId = _data["dimensionTypeId"];
            this.isFlatten = _data["isFlatten"];
        }
    }

    static fromJS(data: any): MVChartSerieDto {
        data = typeof data === 'object' ? data : {};
        let result = new MVChartSerieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signalId"] = this.signalId;
        data["pointDescription"] = this.pointDescription;
        data["pointId"] = this.pointId;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        data["sourceSystemId"] = this.sourceSystemId;
        data["trendTypeId"] = this.trendTypeId;
        data["dimensionTypeId"] = this.dimensionTypeId;
        data["isFlatten"] = this.isFlatten;
        super.toJSON(data);
        return data;
    }

    clone(): MVChartSerieDto {
        const json = this.toJSON();
        let result = new MVChartSerieDto();
        result.init(json);
        return result;
    }
}

export interface IMVChartSerieDto extends ISerieDto {
    signalId?: number;
    pointDescription?: string | undefined;
    pointId?: string | undefined;
    points?: MVChartPointDto[] | undefined;
    sourceSystemId?: number;
    trendTypeId?: number;
    dimensionTypeId?: number | undefined;
    isFlatten?: boolean;
}

export class MVChartPointDto implements IMVChartPointDto {
    signalId?: number | undefined;
    measureTimestamp?: Date;
    value?: number;
    fieldQuality?: number;
    validity?: number;
    estimatedEdited?: number;
    arrivalDateTime?: Date;
    referenceTime?: Date | undefined;
    validationFunctionId?: number | undefined;
    estimationFunctionId?: number | undefined;
    id?: string | undefined;

    constructor(data?: IMVChartPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signalId = _data["signalId"];
            this.measureTimestamp = _data["measureTimestamp"] ? new Date(_data["measureTimestamp"].toString()) : <any>undefined;
            this.value = _data["value"];
            this.fieldQuality = _data["fieldQuality"];
            this.validity = _data["validity"];
            this.estimatedEdited = _data["estimatedEdited"];
            this.arrivalDateTime = _data["arrivalDateTime"] ? new Date(_data["arrivalDateTime"].toString()) : <any>undefined;
            this.referenceTime = _data["referenceTime"] ? new Date(_data["referenceTime"].toString()) : <any>undefined;
            this.validationFunctionId = _data["validationFunctionId"];
            this.estimationFunctionId = _data["estimationFunctionId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MVChartPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new MVChartPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signalId"] = this.signalId;
        data["measureTimestamp"] = this.measureTimestamp ? this.measureTimestamp.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["fieldQuality"] = this.fieldQuality;
        data["validity"] = this.validity;
        data["estimatedEdited"] = this.estimatedEdited;
        data["arrivalDateTime"] = this.arrivalDateTime ? this.arrivalDateTime.toISOString() : <any>undefined;
        data["referenceTime"] = this.referenceTime ? this.referenceTime.toISOString() : <any>undefined;
        data["validationFunctionId"] = this.validationFunctionId;
        data["estimationFunctionId"] = this.estimationFunctionId;
        data["id"] = this.id;
        return data;
    }

    clone(): MVChartPointDto {
        const json = this.toJSON();
        let result = new MVChartPointDto();
        result.init(json);
        return result;
    }
}

export interface IMVChartPointDto {
    signalId?: number | undefined;
    measureTimestamp?: Date;
    value?: number;
    fieldQuality?: number;
    validity?: number;
    estimatedEdited?: number;
    arrivalDateTime?: Date;
    referenceTime?: Date | undefined;
    validationFunctionId?: number | undefined;
    estimationFunctionId?: number | undefined;
    id?: string | undefined;
}

export class ChartAlarmsQueryDto implements IChartAlarmsQueryDto {
    startDate?: Date;
    endDate?: Date;
    alarmsIds?: string[] | undefined;

    constructor(data?: IChartAlarmsQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["alarmsIds"])) {
                this.alarmsIds = [] as any;
                for (let item of _data["alarmsIds"])
                    this.alarmsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ChartAlarmsQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartAlarmsQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.alarmsIds)) {
            data["alarmsIds"] = [];
            for (let item of this.alarmsIds)
                data["alarmsIds"].push(item);
        }
        return data;
    }

    clone(): ChartAlarmsQueryDto {
        const json = this.toJSON();
        let result = new ChartAlarmsQueryDto();
        result.init(json);
        return result;
    }
}

export interface IChartAlarmsQueryDto {
    startDate?: Date;
    endDate?: Date;
    alarmsIds?: string[] | undefined;
}

export class ThresholdDto implements IThresholdDto {
    envelopeId?: string;
    unitTypeId?: number | undefined;
    envelopeTypeId?: number;
    envelopeDescription?: string | undefined;
    severityId?: number;
    values?: ThresholdValueDto[] | undefined;

    constructor(data?: IThresholdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.envelopeId = _data["envelopeId"];
            this.unitTypeId = _data["unitTypeId"];
            this.envelopeTypeId = _data["envelopeTypeId"];
            this.envelopeDescription = _data["envelopeDescription"];
            this.severityId = _data["severityId"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ThresholdValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ThresholdDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThresholdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["envelopeId"] = this.envelopeId;
        data["unitTypeId"] = this.unitTypeId;
        data["envelopeTypeId"] = this.envelopeTypeId;
        data["envelopeDescription"] = this.envelopeDescription;
        data["severityId"] = this.severityId;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        return data;
    }

    clone(): ThresholdDto {
        const json = this.toJSON();
        let result = new ThresholdDto();
        result.init(json);
        return result;
    }
}

export interface IThresholdDto {
    envelopeId?: string;
    unitTypeId?: number | undefined;
    envelopeTypeId?: number;
    envelopeDescription?: string | undefined;
    severityId?: number;
    values?: ThresholdValueDto[] | undefined;
}

export class MVThresholdDto extends ThresholdDto implements IMVThresholdDto {
    signalId?: number;

    constructor(data?: IMVThresholdDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.signalId = _data["signalId"];
        }
    }

    static fromJS(data: any): MVThresholdDto {
        data = typeof data === 'object' ? data : {};
        let result = new MVThresholdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signalId"] = this.signalId;
        super.toJSON(data);
        return data;
    }

    clone(): MVThresholdDto {
        const json = this.toJSON();
        let result = new MVThresholdDto();
        result.init(json);
        return result;
    }
}

export interface IMVThresholdDto extends IThresholdDto {
    signalId?: number;
}

export class ThresholdValueDto implements IThresholdValueDto {
    date?: Date;
    value?: number;

    constructor(data?: IThresholdValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ThresholdValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThresholdValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data;
    }

    clone(): ThresholdValueDto {
        const json = this.toJSON();
        let result = new ThresholdValueDto();
        result.init(json);
        return result;
    }
}

export interface IThresholdValueDto {
    date?: Date;
    value?: number;
}

export class ThresholdQueryDto implements IThresholdQueryDto {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    alarmTypeId!: string;

    constructor(data?: IThresholdQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.alarmTypeId = _data["alarmTypeId"];
        }
    }

    static fromJS(data: any): ThresholdQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThresholdQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["alarmTypeId"] = this.alarmTypeId;
        return data;
    }

    clone(): ThresholdQueryDto {
        const json = this.toJSON();
        let result = new ThresholdQueryDto();
        result.init(json);
        return result;
    }
}

export interface IThresholdQueryDto {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    alarmTypeId: string;
}

export class CalculatedValuesShortDto implements ICalculatedValuesShortDto {
    algorithmShortName?: string | undefined;
    referenceTimestamp?: Date;
    value?: number;
    elementId?: string | undefined;
    timeAggregationId?: number | undefined;
    elementName?: string | undefined;
    elementDescription?: string | undefined;
    validity?: number;
    dimensionTypeId?: number;
    dimensionTypeDescription?: string | undefined;
    unitTypeId?: number;
    networkElementTypeId?: number;
    algorithmRunShortId?: number;
    quality?: number;
    estimated?: boolean;
    edited?: boolean;
    adjusted?: boolean;
    hierarchyElementTypeId?: string | undefined;
    key?: string | undefined;

    constructor(data?: ICalculatedValuesShortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.algorithmShortName = _data["algorithmShortName"];
            this.referenceTimestamp = _data["referenceTimestamp"] ? new Date(_data["referenceTimestamp"].toString()) : <any>undefined;
            this.value = _data["value"];
            this.elementId = _data["elementId"];
            this.timeAggregationId = _data["timeAggregationId"];
            this.elementName = _data["elementName"];
            this.elementDescription = _data["elementDescription"];
            this.validity = _data["validity"];
            this.dimensionTypeId = _data["dimensionTypeId"];
            this.dimensionTypeDescription = _data["dimensionTypeDescription"];
            this.unitTypeId = _data["unitTypeId"];
            this.networkElementTypeId = _data["networkElementTypeId"];
            this.algorithmRunShortId = _data["algorithmRunShortId"];
            this.quality = _data["quality"];
            this.estimated = _data["estimated"];
            this.edited = _data["edited"];
            this.adjusted = _data["adjusted"];
            this.hierarchyElementTypeId = _data["hierarchyElementTypeId"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): CalculatedValuesShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculatedValuesShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["algorithmShortName"] = this.algorithmShortName;
        data["referenceTimestamp"] = this.referenceTimestamp ? this.referenceTimestamp.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["elementId"] = this.elementId;
        data["timeAggregationId"] = this.timeAggregationId;
        data["elementName"] = this.elementName;
        data["elementDescription"] = this.elementDescription;
        data["validity"] = this.validity;
        data["dimensionTypeId"] = this.dimensionTypeId;
        data["dimensionTypeDescription"] = this.dimensionTypeDescription;
        data["unitTypeId"] = this.unitTypeId;
        data["networkElementTypeId"] = this.networkElementTypeId;
        data["algorithmRunShortId"] = this.algorithmRunShortId;
        data["quality"] = this.quality;
        data["estimated"] = this.estimated;
        data["edited"] = this.edited;
        data["adjusted"] = this.adjusted;
        data["hierarchyElementTypeId"] = this.hierarchyElementTypeId;
        data["key"] = this.key;
        return data;
    }

    clone(): CalculatedValuesShortDto {
        const json = this.toJSON();
        let result = new CalculatedValuesShortDto();
        result.init(json);
        return result;
    }
}

export interface ICalculatedValuesShortDto {
    algorithmShortName?: string | undefined;
    referenceTimestamp?: Date;
    value?: number;
    elementId?: string | undefined;
    timeAggregationId?: number | undefined;
    elementName?: string | undefined;
    elementDescription?: string | undefined;
    validity?: number;
    dimensionTypeId?: number;
    dimensionTypeDescription?: string | undefined;
    unitTypeId?: number;
    networkElementTypeId?: number;
    algorithmRunShortId?: number;
    quality?: number;
    estimated?: boolean;
    edited?: boolean;
    adjusted?: boolean;
    hierarchyElementTypeId?: string | undefined;
    key?: string | undefined;
}

export class CalculatedValuesShortQueryDto implements ICalculatedValuesShortQueryDto {
    startDate?: Date;
    endDate?: Date | undefined;
    elementIds?: string[] | undefined;
    algorithms?: string[] | undefined;

    constructor(data?: ICalculatedValuesShortQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["elementIds"])) {
                this.elementIds = [] as any;
                for (let item of _data["elementIds"])
                    this.elementIds!.push(item);
            }
            if (Array.isArray(_data["algorithms"])) {
                this.algorithms = [] as any;
                for (let item of _data["algorithms"])
                    this.algorithms!.push(item);
            }
        }
    }

    static fromJS(data: any): CalculatedValuesShortQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculatedValuesShortQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.elementIds)) {
            data["elementIds"] = [];
            for (let item of this.elementIds)
                data["elementIds"].push(item);
        }
        if (Array.isArray(this.algorithms)) {
            data["algorithms"] = [];
            for (let item of this.algorithms)
                data["algorithms"].push(item);
        }
        return data;
    }

    clone(): CalculatedValuesShortQueryDto {
        const json = this.toJSON();
        let result = new CalculatedValuesShortQueryDto();
        result.init(json);
        return result;
    }
}

export interface ICalculatedValuesShortQueryDto {
    startDate?: Date;
    endDate?: Date | undefined;
    elementIds?: string[] | undefined;
    algorithms?: string[] | undefined;
}

export class CVChartSerieDto extends SerieDto implements ICVChartSerieDto {
    algorithmShortName?: string | undefined;
    elementId?: string | undefined;
    points?: CVChartPointDto[] | undefined;
    timeAggregationId?: number | undefined;
    elementName?: string | undefined;
    elementDescription?: string | undefined;
    dimensionTypeId?: number;
    dimensionTypeDescription?: string | undefined;
    unitTypeId?: number;
    networkElementTypeId?: number;
    hierarchyElementTypeId?: string | undefined;

    constructor(data?: ICVChartSerieDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.algorithmShortName = _data["algorithmShortName"];
            this.elementId = _data["elementId"];
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(CVChartPointDto.fromJS(item));
            }
            this.timeAggregationId = _data["timeAggregationId"];
            this.elementName = _data["elementName"];
            this.elementDescription = _data["elementDescription"];
            this.dimensionTypeId = _data["dimensionTypeId"];
            this.dimensionTypeDescription = _data["dimensionTypeDescription"];
            this.unitTypeId = _data["unitTypeId"];
            this.networkElementTypeId = _data["networkElementTypeId"];
            this.hierarchyElementTypeId = _data["hierarchyElementTypeId"];
        }
    }

    static fromJS(data: any): CVChartSerieDto {
        data = typeof data === 'object' ? data : {};
        let result = new CVChartSerieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["algorithmShortName"] = this.algorithmShortName;
        data["elementId"] = this.elementId;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        data["timeAggregationId"] = this.timeAggregationId;
        data["elementName"] = this.elementName;
        data["elementDescription"] = this.elementDescription;
        data["dimensionTypeId"] = this.dimensionTypeId;
        data["dimensionTypeDescription"] = this.dimensionTypeDescription;
        data["unitTypeId"] = this.unitTypeId;
        data["networkElementTypeId"] = this.networkElementTypeId;
        data["hierarchyElementTypeId"] = this.hierarchyElementTypeId;
        super.toJSON(data);
        return data;
    }

    clone(): CVChartSerieDto {
        const json = this.toJSON();
        let result = new CVChartSerieDto();
        result.init(json);
        return result;
    }
}

export interface ICVChartSerieDto extends ISerieDto {
    algorithmShortName?: string | undefined;
    elementId?: string | undefined;
    points?: CVChartPointDto[] | undefined;
    timeAggregationId?: number | undefined;
    elementName?: string | undefined;
    elementDescription?: string | undefined;
    dimensionTypeId?: number;
    dimensionTypeDescription?: string | undefined;
    unitTypeId?: number;
    networkElementTypeId?: number;
    hierarchyElementTypeId?: string | undefined;
}

export class CVChartPointDto implements ICVChartPointDto {
    referenceTimestamp?: Date;
    value?: number;
    validity?: number;
    quality?: number;
    estimated?: boolean;
    edited?: boolean;
    adjusted?: boolean;

    constructor(data?: ICVChartPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceTimestamp = _data["referenceTimestamp"] ? new Date(_data["referenceTimestamp"].toString()) : <any>undefined;
            this.value = _data["value"];
            this.validity = _data["validity"];
            this.quality = _data["quality"];
            this.estimated = _data["estimated"];
            this.edited = _data["edited"];
            this.adjusted = _data["adjusted"];
        }
    }

    static fromJS(data: any): CVChartPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new CVChartPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceTimestamp"] = this.referenceTimestamp ? this.referenceTimestamp.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["validity"] = this.validity;
        data["quality"] = this.quality;
        data["estimated"] = this.estimated;
        data["edited"] = this.edited;
        data["adjusted"] = this.adjusted;
        return data;
    }

    clone(): CVChartPointDto {
        const json = this.toJSON();
        let result = new CVChartPointDto();
        result.init(json);
        return result;
    }
}

export interface ICVChartPointDto {
    referenceTimestamp?: Date;
    value?: number;
    validity?: number;
    quality?: number;
    estimated?: boolean;
    edited?: boolean;
    adjusted?: boolean;
}

export class CVThresholdDto extends ThresholdDto implements ICVThresholdDto {
    algorithmShortName?: string | undefined;

    constructor(data?: ICVThresholdDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.algorithmShortName = _data["algorithmShortName"];
        }
    }

    static fromJS(data: any): CVThresholdDto {
        data = typeof data === 'object' ? data : {};
        let result = new CVThresholdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["algorithmShortName"] = this.algorithmShortName;
        super.toJSON(data);
        return data;
    }

    clone(): CVThresholdDto {
        const json = this.toJSON();
        let result = new CVThresholdDto();
        result.init(json);
        return result;
    }
}

export interface ICVThresholdDto extends IThresholdDto {
    algorithmShortName?: string | undefined;
}

export class PointConfigurationDto implements IPointConfigurationDto {
    networkElementKey?: string | undefined;
    networkElementType?: string | undefined;
    scenario?: string | undefined;
    attributeName?: string | undefined;

    constructor(data?: IPointConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.networkElementKey = _data["networkElementKey"];
            this.networkElementType = _data["networkElementType"];
            this.scenario = _data["scenario"];
            this.attributeName = _data["attributeName"];
        }
    }

    static fromJS(data: any): PointConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["networkElementKey"] = this.networkElementKey;
        data["networkElementType"] = this.networkElementType;
        data["scenario"] = this.scenario;
        data["attributeName"] = this.attributeName;
        return data;
    }

    clone(): PointConfigurationDto {
        const json = this.toJSON();
        let result = new PointConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IPointConfigurationDto {
    networkElementKey?: string | undefined;
    networkElementType?: string | undefined;
    scenario?: string | undefined;
    attributeName?: string | undefined;
}

/** This defines a composite OData query options that can be used to perform query composition. Currently this only supports $filter, $orderby, $top, $skip. */
export class ODataQueryOptionsOfPointConfigurationDto extends ODataQueryOptions implements IODataQueryOptionsOfPointConfigurationDto {
    ifMatch?: ETagOfPointConfigurationDto | undefined;
    ifNoneMatch?: ETagOfPointConfigurationDto | undefined;

    constructor(data?: IODataQueryOptionsOfPointConfigurationDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ifMatch = _data["ifMatch"] ? ETagOfPointConfigurationDto.fromJS(_data["ifMatch"]) : <any>undefined;
            this.ifNoneMatch = _data["ifNoneMatch"] ? ETagOfPointConfigurationDto.fromJS(_data["ifNoneMatch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ODataQueryOptionsOfPointConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ODataQueryOptionsOfPointConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ifMatch"] = this.ifMatch ? this.ifMatch.toJSON() : <any>undefined;
        data["ifNoneMatch"] = this.ifNoneMatch ? this.ifNoneMatch.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): ODataQueryOptionsOfPointConfigurationDto {
        const json = this.toJSON();
        let result = new ODataQueryOptionsOfPointConfigurationDto();
        result.init(json);
        return result;
    }
}

/** This defines a composite OData query options that can be used to perform query composition. Currently this only supports $filter, $orderby, $top, $skip. */
export interface IODataQueryOptionsOfPointConfigurationDto extends IODataQueryOptions {
    ifMatch?: ETagOfPointConfigurationDto | undefined;
    ifNoneMatch?: ETagOfPointConfigurationDto | undefined;
}

/** OData ETag of an entity type . */
export class ETagOfPointConfigurationDto extends ETag implements IETagOfPointConfigurationDto {

    constructor(data?: IETagOfPointConfigurationDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ETagOfPointConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ETagOfPointConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ETagOfPointConfigurationDto {
        const json = this.toJSON();
        let result = new ETagOfPointConfigurationDto();
        result.init(json);
        return result;
    }
}

/** OData ETag of an entity type . */
export interface IETagOfPointConfigurationDto extends IETag {
}

export class DimensionInfoDto implements IDimensionInfoDto {
    name?: string | undefined;
    alias?: string | undefined;

    constructor(data?: IDimensionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.alias = _data["alias"];
        }
    }

    static fromJS(data: any): DimensionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DimensionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["alias"] = this.alias;
        return data;
    }

    clone(): DimensionInfoDto {
        const json = this.toJSON();
        let result = new DimensionInfoDto();
        result.init(json);
        return result;
    }
}

export interface IDimensionInfoDto {
    name?: string | undefined;
    alias?: string | undefined;
}

export class MeasurementDto implements IMeasurementDto {
    pointId?: string | undefined;
    pointDescription?: string | undefined;
    unitType?: string | undefined;
    attributeType?: string | undefined;
    sourceSystemDescription?: string | undefined;
    scenarioId?: string;
    pointConfigurations?: PointConfigurationDto[] | undefined;

    constructor(data?: IMeasurementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pointId = _data["pointId"];
            this.pointDescription = _data["pointDescription"];
            this.unitType = _data["unitType"];
            this.attributeType = _data["attributeType"];
            this.sourceSystemDescription = _data["sourceSystemDescription"];
            this.scenarioId = _data["scenarioId"];
            if (Array.isArray(_data["pointConfigurations"])) {
                this.pointConfigurations = [] as any;
                for (let item of _data["pointConfigurations"])
                    this.pointConfigurations!.push(PointConfigurationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeasurementDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pointId"] = this.pointId;
        data["pointDescription"] = this.pointDescription;
        data["unitType"] = this.unitType;
        data["attributeType"] = this.attributeType;
        data["sourceSystemDescription"] = this.sourceSystemDescription;
        data["scenarioId"] = this.scenarioId;
        if (Array.isArray(this.pointConfigurations)) {
            data["pointConfigurations"] = [];
            for (let item of this.pointConfigurations)
                data["pointConfigurations"].push(item.toJSON());
        }
        return data;
    }

    clone(): MeasurementDto {
        const json = this.toJSON();
        let result = new MeasurementDto();
        result.init(json);
        return result;
    }
}

export interface IMeasurementDto {
    pointId?: string | undefined;
    pointDescription?: string | undefined;
    unitType?: string | undefined;
    attributeType?: string | undefined;
    sourceSystemDescription?: string | undefined;
    scenarioId?: string;
    pointConfigurations?: PointConfigurationDto[] | undefined;
}

/** This defines a composite OData query options that can be used to perform query composition. Currently this only supports $filter, $orderby, $top, $skip. */
export class ODataQueryOptionsOfMeasurementDto extends ODataQueryOptions implements IODataQueryOptionsOfMeasurementDto {
    ifMatch?: ETagOfMeasurementDto | undefined;
    ifNoneMatch?: ETagOfMeasurementDto | undefined;

    constructor(data?: IODataQueryOptionsOfMeasurementDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ifMatch = _data["ifMatch"] ? ETagOfMeasurementDto.fromJS(_data["ifMatch"]) : <any>undefined;
            this.ifNoneMatch = _data["ifNoneMatch"] ? ETagOfMeasurementDto.fromJS(_data["ifNoneMatch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ODataQueryOptionsOfMeasurementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ODataQueryOptionsOfMeasurementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ifMatch"] = this.ifMatch ? this.ifMatch.toJSON() : <any>undefined;
        data["ifNoneMatch"] = this.ifNoneMatch ? this.ifNoneMatch.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): ODataQueryOptionsOfMeasurementDto {
        const json = this.toJSON();
        let result = new ODataQueryOptionsOfMeasurementDto();
        result.init(json);
        return result;
    }
}

/** This defines a composite OData query options that can be used to perform query composition. Currently this only supports $filter, $orderby, $top, $skip. */
export interface IODataQueryOptionsOfMeasurementDto extends IODataQueryOptions {
    ifMatch?: ETagOfMeasurementDto | undefined;
    ifNoneMatch?: ETagOfMeasurementDto | undefined;
}

/** OData ETag of an entity type . */
export class ETagOfMeasurementDto extends ETag implements IETagOfMeasurementDto {

    constructor(data?: IETagOfMeasurementDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ETagOfMeasurementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ETagOfMeasurementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ETagOfMeasurementDto {
        const json = this.toJSON();
        let result = new ETagOfMeasurementDto();
        result.init(json);
        return result;
    }
}

/** OData ETag of an entity type . */
export interface IETagOfMeasurementDto extends IETag {
}

export class MeasurementSerieDto implements IMeasurementSerieDto {
    pointId?: string | undefined;
    unitType?: string | undefined;
    values?: { [key: string]: any; } | undefined;

    constructor(data?: IMeasurementSerieDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pointId = _data["pointId"];
            this.unitType = _data["unitType"];
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): MeasurementSerieDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementSerieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pointId"] = this.pointId;
        data["unitType"] = this.unitType;
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = (<any>this.values)[key];
            }
        }
        return data;
    }

    clone(): MeasurementSerieDto {
        const json = this.toJSON();
        let result = new MeasurementSerieDto();
        result.init(json);
        return result;
    }
}

export interface IMeasurementSerieDto {
    pointId?: string | undefined;
    unitType?: string | undefined;
    values?: { [key: string]: any; } | undefined;
}

export class MeasurementQueryDto implements IMeasurementQueryDto {
    scenarioId?: string;
    pointId?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IMeasurementQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.pointId = _data["pointId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MeasurementQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["pointId"] = this.pointId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): MeasurementQueryDto {
        const json = this.toJSON();
        let result = new MeasurementQueryDto();
        result.init(json);
        return result;
    }
}

export interface IMeasurementQueryDto {
    scenarioId?: string;
    pointId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class TagSaveDto implements ITagSaveDto {
    definitions?: TagDefinition[] | undefined;
    values?: TagValue[] | undefined;
    ts?: TagTS[] | undefined;

    constructor(data?: ITagSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definitions"])) {
                this.definitions = [] as any;
                for (let item of _data["definitions"])
                    this.definitions!.push(TagDefinition.fromJS(item));
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(TagValue.fromJS(item));
            }
            if (Array.isArray(_data["ts"])) {
                this.ts = [] as any;
                for (let item of _data["ts"])
                    this.ts!.push(TagTS.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TagSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definitions)) {
            data["definitions"] = [];
            for (let item of this.definitions)
                data["definitions"].push(item.toJSON());
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        if (Array.isArray(this.ts)) {
            data["ts"] = [];
            for (let item of this.ts)
                data["ts"].push(item.toJSON());
        }
        return data;
    }

    clone(): TagSaveDto {
        const json = this.toJSON();
        let result = new TagSaveDto();
        result.init(json);
        return result;
    }
}

export interface ITagSaveDto {
    definitions?: TagDefinition[] | undefined;
    values?: TagValue[] | undefined;
    ts?: TagTS[] | undefined;
}

export class TagDefinition implements ITagDefinition {
    id?: number;
    tagId?: string | undefined;

    constructor(data?: ITagDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tagId = _data["tagId"];
        }
    }

    static fromJS(data: any): TagDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new TagDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagId"] = this.tagId;
        return data;
    }

    clone(): TagDefinition {
        const json = this.toJSON();
        let result = new TagDefinition();
        result.init(json);
        return result;
    }
}

export interface ITagDefinition {
    id?: number;
    tagId?: string | undefined;
}

export class TagValue implements ITagValue {
    id?: number;
    tagDefinitionId?: number;
    timeTag?: Date;
    raw?: number | undefined;
    value?: number | undefined;
    status?: number;

    constructor(data?: ITagValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tagDefinitionId = _data["tagDefinitionId"];
            this.timeTag = _data["timeTag"] ? new Date(_data["timeTag"].toString()) : <any>undefined;
            this.raw = _data["raw"];
            this.value = _data["value"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TagValue {
        data = typeof data === 'object' ? data : {};
        let result = new TagValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagDefinitionId"] = this.tagDefinitionId;
        data["timeTag"] = this.timeTag ? this.timeTag.toISOString() : <any>undefined;
        data["raw"] = this.raw;
        data["value"] = this.value;
        data["status"] = this.status;
        return data;
    }

    clone(): TagValue {
        const json = this.toJSON();
        let result = new TagValue();
        result.init(json);
        return result;
    }
}

export interface ITagValue {
    id?: number;
    tagDefinitionId?: number;
    timeTag?: Date;
    raw?: number | undefined;
    value?: number | undefined;
    status?: number;
}

export class TagTS implements ITagTS {
    id?: number;
    tagValueId?: number;
    time?: Date;
    raw?: number;
    value?: number;

    constructor(data?: ITagTS) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tagValueId = _data["tagValueId"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.raw = _data["raw"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TagTS {
        data = typeof data === 'object' ? data : {};
        let result = new TagTS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagValueId"] = this.tagValueId;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["raw"] = this.raw;
        data["value"] = this.value;
        return data;
    }

    clone(): TagTS {
        const json = this.toJSON();
        let result = new TagTS();
        result.init(json);
        return result;
    }
}

export interface ITagTS {
    id?: number;
    tagValueId?: number;
    time?: Date;
    raw?: number;
    value?: number;
}

export class WorkOrderElementResponseDto implements IWorkOrderElementResponseDto {
    id?: string;
    networkElementId?: string;
    workOrders?: WorkOrderResponseDto[] | undefined;

    constructor(data?: IWorkOrderElementResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.networkElementId = _data["networkElementId"];
            if (Array.isArray(_data["workOrders"])) {
                this.workOrders = [] as any;
                for (let item of _data["workOrders"])
                    this.workOrders!.push(WorkOrderResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkOrderElementResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderElementResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["networkElementId"] = this.networkElementId;
        if (Array.isArray(this.workOrders)) {
            data["workOrders"] = [];
            for (let item of this.workOrders)
                data["workOrders"].push(item.toJSON());
        }
        return data;
    }

    clone(): WorkOrderElementResponseDto {
        const json = this.toJSON();
        let result = new WorkOrderElementResponseDto();
        result.init(json);
        return result;
    }
}

export interface IWorkOrderElementResponseDto {
    id?: string;
    networkElementId?: string;
    workOrders?: WorkOrderResponseDto[] | undefined;
}

export class WorkOrderResponseDto implements IWorkOrderResponseDto {
    timeStamp?: Date;
    action?: number;

    constructor(data?: IWorkOrderResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): WorkOrderResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["action"] = this.action;
        return data;
    }

    clone(): WorkOrderResponseDto {
        const json = this.toJSON();
        let result = new WorkOrderResponseDto();
        result.init(json);
        return result;
    }
}

export interface IWorkOrderResponseDto {
    timeStamp?: Date;
    action?: number;
}

export class CheckTopologyResponseDto implements ICheckTopologyResponseDto {
    isOk?: boolean;

    constructor(data?: ICheckTopologyResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOk = _data["isOk"];
        }
    }

    static fromJS(data: any): CheckTopologyResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckTopologyResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOk"] = this.isOk;
        return data;
    }

    clone(): CheckTopologyResponseDto {
        const json = this.toJSON();
        let result = new CheckTopologyResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICheckTopologyResponseDto {
    isOk?: boolean;
}

export class NetworkElementResponseDto implements INetworkElementResponseDto {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    centroid?: number[] | undefined;

    constructor(data?: INetworkElementResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["centroid"])) {
                this.centroid = [] as any;
                for (let item of _data["centroid"])
                    this.centroid!.push(item);
            }
        }
    }

    static fromJS(data: any): NetworkElementResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new NetworkElementResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.centroid)) {
            data["centroid"] = [];
            for (let item of this.centroid)
                data["centroid"].push(item);
        }
        return data;
    }

    clone(): NetworkElementResponseDto {
        const json = this.toJSON();
        let result = new NetworkElementResponseDto();
        result.init(json);
        return result;
    }
}

export interface INetworkElementResponseDto {
    id?: string;
    name?: string | undefined;
    type?: string | undefined;
    centroid?: number[] | undefined;
}

export class SendTopologyResponseDto implements ISendTopologyResponseDto {
    isOk?: boolean;

    constructor(data?: ISendTopologyResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOk = _data["isOk"];
        }
    }

    static fromJS(data: any): SendTopologyResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendTopologyResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOk"] = this.isOk;
        return data;
    }

    clone(): SendTopologyResponseDto {
        const json = this.toJSON();
        let result = new SendTopologyResponseDto();
        result.init(json);
        return result;
    }
}

export interface ISendTopologyResponseDto {
    isOk?: boolean;
}

export class TopologyDto implements ITopologyDto {
    scenarioId?: string;
    objects?: { [key: string]: ObjectTopologyDto; } | undefined;
    paths?: PathDto[] | undefined;
    profiles?: ProfilePathDto[] | undefined;
    profileSettings?: ProfileSettingsDto[] | undefined;
    layerStyles?: { [key: string]: LayerStylesDto; } | undefined;

    constructor(data?: ITopologyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            if (_data["objects"]) {
                this.objects = {} as any;
                for (let key in _data["objects"]) {
                    if (_data["objects"].hasOwnProperty(key))
                        (<any>this.objects)![key] = _data["objects"][key] ? ObjectTopologyDto.fromJS(_data["objects"][key]) : new ObjectTopologyDto();
                }
            }
            if (Array.isArray(_data["paths"])) {
                this.paths = [] as any;
                for (let item of _data["paths"])
                    this.paths!.push(PathDto.fromJS(item));
            }
            if (Array.isArray(_data["profiles"])) {
                this.profiles = [] as any;
                for (let item of _data["profiles"])
                    this.profiles!.push(ProfilePathDto.fromJS(item));
            }
            if (Array.isArray(_data["profileSettings"])) {
                this.profileSettings = [] as any;
                for (let item of _data["profileSettings"])
                    this.profileSettings!.push(ProfileSettingsDto.fromJS(item));
            }
            if (_data["layerStyles"]) {
                this.layerStyles = {} as any;
                for (let key in _data["layerStyles"]) {
                    if (_data["layerStyles"].hasOwnProperty(key))
                        (<any>this.layerStyles)![key] = _data["layerStyles"][key] ? LayerStylesDto.fromJS(_data["layerStyles"][key]) : new LayerStylesDto();
                }
            }
        }
    }

    static fromJS(data: any): TopologyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopologyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        if (this.objects) {
            data["objects"] = {};
            for (let key in this.objects) {
                if (this.objects.hasOwnProperty(key))
                    (<any>data["objects"])[key] = this.objects[key] ? this.objects[key].toJSON() : <any>undefined;
            }
        }
        if (Array.isArray(this.paths)) {
            data["paths"] = [];
            for (let item of this.paths)
                data["paths"].push(item.toJSON());
        }
        if (Array.isArray(this.profiles)) {
            data["profiles"] = [];
            for (let item of this.profiles)
                data["profiles"].push(item.toJSON());
        }
        if (Array.isArray(this.profileSettings)) {
            data["profileSettings"] = [];
            for (let item of this.profileSettings)
                data["profileSettings"].push(item.toJSON());
        }
        if (this.layerStyles) {
            data["layerStyles"] = {};
            for (let key in this.layerStyles) {
                if (this.layerStyles.hasOwnProperty(key))
                    (<any>data["layerStyles"])[key] = this.layerStyles[key] ? this.layerStyles[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }

    clone(): TopologyDto {
        const json = this.toJSON();
        let result = new TopologyDto();
        result.init(json);
        return result;
    }
}

export interface ITopologyDto {
    scenarioId?: string;
    objects?: { [key: string]: ObjectTopologyDto; } | undefined;
    paths?: PathDto[] | undefined;
    profiles?: ProfilePathDto[] | undefined;
    profileSettings?: ProfileSettingsDto[] | undefined;
    layerStyles?: { [key: string]: LayerStylesDto; } | undefined;
}

export class ObjectTopologyDto implements IObjectTopologyDto {
    geometry?: string | undefined;
    objectType?: string | undefined;
    meaAttributes?: { [key: string]: string; } | undefined;

    constructor(data?: IObjectTopologyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geometry = _data["geometry"];
            this.objectType = _data["objectType"];
            if (_data["meaAttributes"]) {
                this.meaAttributes = {} as any;
                for (let key in _data["meaAttributes"]) {
                    if (_data["meaAttributes"].hasOwnProperty(key))
                        (<any>this.meaAttributes)![key] = _data["meaAttributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): ObjectTopologyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectTopologyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geometry"] = this.geometry;
        data["objectType"] = this.objectType;
        if (this.meaAttributes) {
            data["meaAttributes"] = {};
            for (let key in this.meaAttributes) {
                if (this.meaAttributes.hasOwnProperty(key))
                    (<any>data["meaAttributes"])[key] = (<any>this.meaAttributes)[key];
            }
        }
        return data;
    }

    clone(): ObjectTopologyDto {
        const json = this.toJSON();
        let result = new ObjectTopologyDto();
        result.init(json);
        return result;
    }
}

export interface IObjectTopologyDto {
    geometry?: string | undefined;
    objectType?: string | undefined;
    meaAttributes?: { [key: string]: string; } | undefined;
}

export class PathDto implements IPathDto {
    name?: string | undefined;
    items?: PathItemDto[] | undefined;

    constructor(data?: IPathDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PathItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PathDto {
        data = typeof data === 'object' ? data : {};
        let result = new PathDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PathDto {
        const json = this.toJSON();
        let result = new PathDto();
        result.init(json);
        return result;
    }
}

export interface IPathDto {
    name?: string | undefined;
    items?: PathItemDto[] | undefined;
}

export class PathItemDto implements IPathItemDto {
    name?: string | undefined;
    chainAge?: number;

    constructor(data?: IPathItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.chainAge = _data["chainAge"];
        }
    }

    static fromJS(data: any): PathItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PathItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["chainAge"] = this.chainAge;
        return data;
    }

    clone(): PathItemDto {
        const json = this.toJSON();
        let result = new PathItemDto();
        result.init(json);
        return result;
    }
}

export interface IPathItemDto {
    name?: string | undefined;
    chainAge?: number;
}

export class ProfilePathDto implements IProfilePathDto {
    name?: string | undefined;
    profileSettingId?: string | undefined;
    pathName?: string | undefined;
    lengend?: string | undefined;
    chainageUnits?: string | undefined;
    chainagePhysType?: string | undefined;

    constructor(data?: IProfilePathDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.profileSettingId = _data["profileSettingId"];
            this.pathName = _data["pathName"];
            this.lengend = _data["lengend"];
            this.chainageUnits = _data["chainageUnits"];
            this.chainagePhysType = _data["chainagePhysType"];
        }
    }

    static fromJS(data: any): ProfilePathDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfilePathDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["profileSettingId"] = this.profileSettingId;
        data["pathName"] = this.pathName;
        data["lengend"] = this.lengend;
        data["chainageUnits"] = this.chainageUnits;
        data["chainagePhysType"] = this.chainagePhysType;
        return data;
    }

    clone(): ProfilePathDto {
        const json = this.toJSON();
        let result = new ProfilePathDto();
        result.init(json);
        return result;
    }
}

export interface IProfilePathDto {
    name?: string | undefined;
    profileSettingId?: string | undefined;
    pathName?: string | undefined;
    lengend?: string | undefined;
    chainageUnits?: string | undefined;
    chainagePhysType?: string | undefined;
}

export class ProfileSettingsDto implements IProfileSettingsDto {
    id?: string | undefined;
    attributes?: string[] | undefined;

    constructor(data?: IProfileSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(item);
            }
        }
    }

    static fromJS(data: any): ProfileSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item);
        }
        return data;
    }

    clone(): ProfileSettingsDto {
        const json = this.toJSON();
        let result = new ProfileSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IProfileSettingsDto {
    id?: string | undefined;
    attributes?: string[] | undefined;
}

export class LayerStylesDto implements ILayerStylesDto {
    id?: string;
    layerId?: string | undefined;
    objectType?: string | undefined;
    layerType?: LayerType;
    styleName?: string | undefined;
    styleDefinition?: MapCssStyleDto | undefined;

    constructor(data?: ILayerStylesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.layerId = _data["layerId"];
            this.objectType = _data["objectType"];
            this.layerType = _data["layerType"];
            this.styleName = _data["styleName"];
            this.styleDefinition = _data["styleDefinition"] ? MapCssStyleDto.fromJS(_data["styleDefinition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LayerStylesDto {
        data = typeof data === 'object' ? data : {};
        let result = new LayerStylesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["layerId"] = this.layerId;
        data["objectType"] = this.objectType;
        data["layerType"] = this.layerType;
        data["styleName"] = this.styleName;
        data["styleDefinition"] = this.styleDefinition ? this.styleDefinition.toJSON() : <any>undefined;
        return data;
    }

    clone(): LayerStylesDto {
        const json = this.toJSON();
        let result = new LayerStylesDto();
        result.init(json);
        return result;
    }
}

export interface ILayerStylesDto {
    id?: string;
    layerId?: string | undefined;
    objectType?: string | undefined;
    layerType?: LayerType;
    styleName?: string | undefined;
    styleDefinition?: MapCssStyleDto | undefined;
}

export enum LayerType {
    Point = "Point",
    Line = "Line",
    Polygon = "Polygon",
    MultiLine = "MultiLine",
    MultiPolygon = "MultiPolygon",
}

export class MapCssStyleDto implements IMapCssStyleDto {
    definition?: { [key: string]: string; } | undefined;

    constructor(data?: IMapCssStyleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["definition"]) {
                this.definition = {} as any;
                for (let key in _data["definition"]) {
                    if (_data["definition"].hasOwnProperty(key))
                        (<any>this.definition)![key] = _data["definition"][key];
                }
            }
        }
    }

    static fromJS(data: any): MapCssStyleDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapCssStyleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.definition) {
            data["definition"] = {};
            for (let key in this.definition) {
                if (this.definition.hasOwnProperty(key))
                    (<any>data["definition"])[key] = (<any>this.definition)[key];
            }
        }
        return data;
    }

    clone(): MapCssStyleDto {
        const json = this.toJSON();
        let result = new MapCssStyleDto();
        result.init(json);
        return result;
    }
}

export interface IMapCssStyleDto {
    definition?: { [key: string]: string; } | undefined;
}

export class SimulationActionResponseDto implements ISimulationActionResponseDto {
    message?: string | undefined;

    constructor(data?: ISimulationActionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SimulationActionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationActionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }

    clone(): SimulationActionResponseDto {
        const json = this.toJSON();
        let result = new SimulationActionResponseDto();
        result.init(json);
        return result;
    }
}

export interface ISimulationActionResponseDto {
    message?: string | undefined;
}

export class BaseSimulationParametersDto implements IBaseSimulationParametersDto {
    snapshotId?: string;
    timeStepMax?: number;
    timeStepMin?: number;
    scenarioIds?: string[] | undefined;

    constructor(data?: IBaseSimulationParametersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.snapshotId = _data["snapshotId"];
            this.timeStepMax = _data["timeStepMax"];
            this.timeStepMin = _data["timeStepMin"];
            if (Array.isArray(_data["scenarioIds"])) {
                this.scenarioIds = [] as any;
                for (let item of _data["scenarioIds"])
                    this.scenarioIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BaseSimulationParametersDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseSimulationParametersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["snapshotId"] = this.snapshotId;
        data["timeStepMax"] = this.timeStepMax;
        data["timeStepMin"] = this.timeStepMin;
        if (Array.isArray(this.scenarioIds)) {
            data["scenarioIds"] = [];
            for (let item of this.scenarioIds)
                data["scenarioIds"].push(item);
        }
        return data;
    }

    clone(): BaseSimulationParametersDto {
        const json = this.toJSON();
        let result = new BaseSimulationParametersDto();
        result.init(json);
        return result;
    }
}

export interface IBaseSimulationParametersDto {
    snapshotId?: string;
    timeStepMax?: number;
    timeStepMin?: number;
    scenarioIds?: string[] | undefined;
}

export class SimulationParametersDto extends BaseSimulationParametersDto implements ISimulationParametersDto {
    date?: Date;
    startDate?: string;
    stopDate?: string;

    constructor(data?: ISimulationParametersDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.startDate = _data["startDate"];
            this.stopDate = _data["stopDate"];
        }
    }

    static fromJS(data: any): SimulationParametersDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationParametersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["startDate"] = this.startDate;
        data["stopDate"] = this.stopDate;
        super.toJSON(data);
        return data;
    }

    clone(): SimulationParametersDto {
        const json = this.toJSON();
        let result = new SimulationParametersDto();
        result.init(json);
        return result;
    }
}

export interface ISimulationParametersDto extends IBaseSimulationParametersDto {
    date?: Date;
    startDate?: string;
    stopDate?: string;
}

export class CyclicSimulationParametersDto extends BaseSimulationParametersDto implements ICyclicSimulationParametersDto {
    cycle?: string;
    period?: string;

    constructor(data?: ICyclicSimulationParametersDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cycle = _data["cycle"];
            this.period = _data["period"];
        }
    }

    static fromJS(data: any): CyclicSimulationParametersDto {
        data = typeof data === 'object' ? data : {};
        let result = new CyclicSimulationParametersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cycle"] = this.cycle;
        data["period"] = this.period;
        super.toJSON(data);
        return data;
    }

    clone(): CyclicSimulationParametersDto {
        const json = this.toJSON();
        let result = new CyclicSimulationParametersDto();
        result.init(json);
        return result;
    }
}

export interface ICyclicSimulationParametersDto extends IBaseSimulationParametersDto {
    cycle?: string;
    period?: string;
}

export class SnapshotDto implements ISnapshotDto {
    id?: string;
    instanceId?: string;
    name?: string | undefined;
    creationDate?: Date;
    groupId?: string;

    constructor(data?: ISnapshotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.instanceId = _data["instanceId"];
            this.name = _data["name"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): SnapshotDto {
        data = typeof data === 'object' ? data : {};
        let result = new SnapshotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["instanceId"] = this.instanceId;
        data["name"] = this.name;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["groupId"] = this.groupId;
        return data;
    }

    clone(): SnapshotDto {
        const json = this.toJSON();
        let result = new SnapshotDto();
        result.init(json);
        return result;
    }
}

export interface ISnapshotDto {
    id?: string;
    instanceId?: string;
    name?: string | undefined;
    creationDate?: Date;
    groupId?: string;
}

export class LayerResponseDto implements ILayerResponseDto {
    snapshotId?: string;
    scenarioId?: string;
    layerId?: string;
    layerName?: string | undefined;
    geometryType?: string | undefined;

    constructor(data?: ILayerResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.snapshotId = _data["snapshotId"];
            this.scenarioId = _data["scenarioId"];
            this.layerId = _data["layerId"];
            this.layerName = _data["layerName"];
            this.geometryType = _data["geometryType"];
        }
    }

    static fromJS(data: any): LayerResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new LayerResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["snapshotId"] = this.snapshotId;
        data["scenarioId"] = this.scenarioId;
        data["layerId"] = this.layerId;
        data["layerName"] = this.layerName;
        data["geometryType"] = this.geometryType;
        return data;
    }

    clone(): LayerResponseDto {
        const json = this.toJSON();
        let result = new LayerResponseDto();
        result.init(json);
        return result;
    }
}

export interface ILayerResponseDto {
    snapshotId?: string;
    scenarioId?: string;
    layerId?: string;
    layerName?: string | undefined;
    geometryType?: string | undefined;
}

export class ScenarioAttributeResultDto implements IScenarioAttributeResultDto {
    scenarioId?: string;
    startDate?: Date;
    endDate?: Date;
    networkElements?: NetworkElementAttributeResultDto[] | undefined;

    constructor(data?: IScenarioAttributeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["networkElements"])) {
                this.networkElements = [] as any;
                for (let item of _data["networkElements"])
                    this.networkElements!.push(NetworkElementAttributeResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScenarioAttributeResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioAttributeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.networkElements)) {
            data["networkElements"] = [];
            for (let item of this.networkElements)
                data["networkElements"].push(item.toJSON());
        }
        return data;
    }

    clone(): ScenarioAttributeResultDto {
        const json = this.toJSON();
        let result = new ScenarioAttributeResultDto();
        result.init(json);
        return result;
    }
}

export interface IScenarioAttributeResultDto {
    scenarioId?: string;
    startDate?: Date;
    endDate?: Date;
    networkElements?: NetworkElementAttributeResultDto[] | undefined;
}

export class NetworkElementAttributeResultDto implements INetworkElementAttributeResultDto {
    networkElementId?: string | undefined;
    networkElementName?: string | undefined;
    networkElementTypeId?: string | undefined;
    attributes?: AttributeResultDto[] | undefined;

    constructor(data?: INetworkElementAttributeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.networkElementId = _data["networkElementId"];
            this.networkElementName = _data["networkElementName"];
            this.networkElementTypeId = _data["networkElementTypeId"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(AttributeResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NetworkElementAttributeResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NetworkElementAttributeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["networkElementId"] = this.networkElementId;
        data["networkElementName"] = this.networkElementName;
        data["networkElementTypeId"] = this.networkElementTypeId;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        return data;
    }

    clone(): NetworkElementAttributeResultDto {
        const json = this.toJSON();
        let result = new NetworkElementAttributeResultDto();
        result.init(json);
        return result;
    }
}

export interface INetworkElementAttributeResultDto {
    networkElementId?: string | undefined;
    networkElementName?: string | undefined;
    networkElementTypeId?: string | undefined;
    attributes?: AttributeResultDto[] | undefined;
}

export class AttributeResultDto implements IAttributeResultDto {
    name?: string | undefined;
    values?: { [key: string]: any; } | undefined;

    constructor(data?: IAttributeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): AttributeResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = (<any>this.values)[key];
            }
        }
        return data;
    }

    clone(): AttributeResultDto {
        const json = this.toJSON();
        let result = new AttributeResultDto();
        result.init(json);
        return result;
    }
}

export interface IAttributeResultDto {
    name?: string | undefined;
    values?: { [key: string]: any; } | undefined;
}

export class ChartResultResponseDto implements IChartResultResponseDto {
    scenarioId?: string;
    networkElementId?: string;
    attributeId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    attributeResults?: AttributeValueResponse[] | undefined;

    constructor(data?: IChartResultResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.networkElementId = _data["networkElementId"];
            this.attributeId = _data["attributeId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["attributeResults"])) {
                this.attributeResults = [] as any;
                for (let item of _data["attributeResults"])
                    this.attributeResults!.push(AttributeValueResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChartResultResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartResultResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["networkElementId"] = this.networkElementId;
        data["attributeId"] = this.attributeId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.attributeResults)) {
            data["attributeResults"] = [];
            for (let item of this.attributeResults)
                data["attributeResults"].push(item.toJSON());
        }
        return data;
    }

    clone(): ChartResultResponseDto {
        const json = this.toJSON();
        let result = new ChartResultResponseDto();
        result.init(json);
        return result;
    }
}

export interface IChartResultResponseDto {
    scenarioId?: string;
    networkElementId?: string;
    attributeId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    attributeResults?: AttributeValueResponse[] | undefined;
}

export class AttributeValueResponse implements IAttributeValueResponse {
    value?: string | undefined;
    resultDateTime?: Date;

    constructor(data?: IAttributeValueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.resultDateTime = _data["resultDateTime"] ? new Date(_data["resultDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AttributeValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["resultDateTime"] = this.resultDateTime ? this.resultDateTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): AttributeValueResponse {
        const json = this.toJSON();
        let result = new AttributeValueResponse();
        result.init(json);
        return result;
    }
}

export interface IAttributeValueResponse {
    value?: string | undefined;
    resultDateTime?: Date;
}

export class ChartResultDto implements IChartResultDto {
    scenarioId?: string;
    networkElementId?: string;
    attributeId?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IChartResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.networkElementId = _data["networkElementId"];
            this.attributeId = _data["attributeId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChartResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["networkElementId"] = this.networkElementId;
        data["attributeId"] = this.attributeId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): ChartResultDto {
        const json = this.toJSON();
        let result = new ChartResultDto();
        result.init(json);
        return result;
    }
}

export interface IChartResultDto {
    scenarioId?: string;
    networkElementId?: string;
    attributeId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class ResultObjectRequestCmdResponse implements IResultObjectRequestCmdResponse {
    status?: PublishResultsStatus;

    constructor(data?: IResultObjectRequestCmdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ResultObjectRequestCmdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResultObjectRequestCmdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }

    clone(): ResultObjectRequestCmdResponse {
        const json = this.toJSON();
        let result = new ResultObjectRequestCmdResponse();
        result.init(json);
        return result;
    }
}

export interface IResultObjectRequestCmdResponse {
    status?: PublishResultsStatus;
}

export enum PublishResultsStatus {
    Initial = 0,
    Receiving = 1,
    Publishing = 2,
    Published = 3,
}

export class ResultObjectRequestDto implements IResultObjectRequestDto {
    steps?: { [key: string]: Date; } | undefined;
    objects?: { [key: string]: ResultObjectDto; } | undefined;

    constructor(data?: IResultObjectRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["steps"]) {
                this.steps = {} as any;
                for (let key in _data["steps"]) {
                    if (_data["steps"].hasOwnProperty(key))
                        (<any>this.steps)![key] = _data["steps"][key] ? new Date(_data["steps"][key].toString()) : <any>undefined;
                }
            }
            if (_data["objects"]) {
                this.objects = {} as any;
                for (let key in _data["objects"]) {
                    if (_data["objects"].hasOwnProperty(key))
                        (<any>this.objects)![key] = _data["objects"][key] ? ResultObjectDto.fromJS(_data["objects"][key]) : new ResultObjectDto();
                }
            }
        }
    }

    static fromJS(data: any): ResultObjectRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultObjectRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.steps) {
            data["steps"] = {};
            for (let key in this.steps) {
                if (this.steps.hasOwnProperty(key))
                    (<any>data["steps"])[key] = this.steps[key] ? this.steps[key].toISOString() : <any>undefined;
            }
        }
        if (this.objects) {
            data["objects"] = {};
            for (let key in this.objects) {
                if (this.objects.hasOwnProperty(key))
                    (<any>data["objects"])[key] = this.objects[key] ? this.objects[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }

    clone(): ResultObjectRequestDto {
        const json = this.toJSON();
        let result = new ResultObjectRequestDto();
        result.init(json);
        return result;
    }
}

export interface IResultObjectRequestDto {
    steps?: { [key: string]: Date; } | undefined;
    objects?: { [key: string]: ResultObjectDto; } | undefined;
}

export class ResultObjectDto implements IResultObjectDto {
    results?: { [key: string]: TimeSerieDataDto; } | undefined;
    attributes?: { [key: string]: any; } | undefined;
    workOrders?: AddWorkOrderDto[] | undefined;

    constructor(data?: IResultObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["results"]) {
                this.results = {} as any;
                for (let key in _data["results"]) {
                    if (_data["results"].hasOwnProperty(key))
                        (<any>this.results)![key] = _data["results"][key] ? TimeSerieDataDto.fromJS(_data["results"][key]) : new TimeSerieDataDto();
                }
            }
            if (_data["attributes"]) {
                this.attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>this.attributes)![key] = _data["attributes"][key];
                }
            }
            if (Array.isArray(_data["workOrders"])) {
                this.workOrders = [] as any;
                for (let item of _data["workOrders"])
                    this.workOrders!.push(AddWorkOrderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.results) {
            data["results"] = {};
            for (let key in this.results) {
                if (this.results.hasOwnProperty(key))
                    (<any>data["results"])[key] = this.results[key] ? this.results[key].toJSON() : <any>undefined;
            }
        }
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        if (Array.isArray(this.workOrders)) {
            data["workOrders"] = [];
            for (let item of this.workOrders)
                data["workOrders"].push(item.toJSON());
        }
        return data;
    }

    clone(): ResultObjectDto {
        const json = this.toJSON();
        let result = new ResultObjectDto();
        result.init(json);
        return result;
    }
}

export interface IResultObjectDto {
    results?: { [key: string]: TimeSerieDataDto; } | undefined;
    attributes?: { [key: string]: any; } | undefined;
    workOrders?: AddWorkOrderDto[] | undefined;
}

export class TimeSerieDataDto implements ITimeSerieDataDto {

    [key: string]: any;

    constructor(data?: ITimeSerieDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): TimeSerieDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSerieDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }

    clone(): TimeSerieDataDto {
        const json = this.toJSON();
        let result = new TimeSerieDataDto();
        result.init(json);
        return result;
    }
}

export interface ITimeSerieDataDto {

    [key: string]: any;
}

export class AddWorkOrderDto implements IAddWorkOrderDto {
    timeStamp?: Date;
    action?: number;

    constructor(data?: IAddWorkOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): AddWorkOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddWorkOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["action"] = this.action;
        return data;
    }

    clone(): AddWorkOrderDto {
        const json = this.toJSON();
        let result = new AddWorkOrderDto();
        result.init(json);
        return result;
    }
}

export interface IAddWorkOrderDto {
    timeStamp?: Date;
    action?: number;
}

export class SimulationSettingsResponseDto implements ISimulationSettingsResponseDto {
    snapshotId?: string;
    scenarioId?: string;
    executionId?: string;

    constructor(data?: ISimulationSettingsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.snapshotId = _data["snapshotId"];
            this.scenarioId = _data["scenarioId"];
            this.executionId = _data["executionId"];
        }
    }

    static fromJS(data: any): SimulationSettingsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationSettingsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["snapshotId"] = this.snapshotId;
        data["scenarioId"] = this.scenarioId;
        data["executionId"] = this.executionId;
        return data;
    }

    clone(): SimulationSettingsResponseDto {
        const json = this.toJSON();
        let result = new SimulationSettingsResponseDto();
        result.init(json);
        return result;
    }
}

export interface ISimulationSettingsResponseDto {
    snapshotId?: string;
    scenarioId?: string;
    executionId?: string;
}

export class SimulationSettingsDto implements ISimulationSettingsDto {
    scenarioName?: string | undefined;
    isCyclic?: boolean;
    snapshotId?: string | undefined;
    snapshotName?: string | undefined;
    groupName?: string | undefined;
    isActive?: boolean;

    constructor(data?: ISimulationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioName = _data["scenarioName"];
            this.isCyclic = _data["isCyclic"];
            this.snapshotId = _data["snapshotId"];
            this.snapshotName = _data["snapshotName"];
            this.groupName = _data["groupName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SimulationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioName"] = this.scenarioName;
        data["isCyclic"] = this.isCyclic;
        data["snapshotId"] = this.snapshotId;
        data["snapshotName"] = this.snapshotName;
        data["groupName"] = this.groupName;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): SimulationSettingsDto {
        const json = this.toJSON();
        let result = new SimulationSettingsDto();
        result.init(json);
        return result;
    }
}

export interface ISimulationSettingsDto {
    scenarioName?: string | undefined;
    isCyclic?: boolean;
    snapshotId?: string | undefined;
    snapshotName?: string | undefined;
    groupName?: string | undefined;
    isActive?: boolean;
}

export class ScenarioSettingsResponseDto implements IScenarioSettingsResponseDto {
    status?: string | undefined;

    constructor(data?: IScenarioSettingsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ScenarioSettingsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioSettingsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }

    clone(): ScenarioSettingsResponseDto {
        const json = this.toJSON();
        let result = new ScenarioSettingsResponseDto();
        result.init(json);
        return result;
    }
}

export interface IScenarioSettingsResponseDto {
    status?: string | undefined;
}

export class ScenarioSettingsDto implements IScenarioSettingsDto {
    executionId?: string;
    fromDate?: Date;
    toDate?: Date;
    types?: NetworkElementTypeDto[] | undefined;

    constructor(data?: IScenarioSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.executionId = _data["executionId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(NetworkElementTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScenarioSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["executionId"] = this.executionId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJSON());
        }
        return data;
    }

    clone(): ScenarioSettingsDto {
        const json = this.toJSON();
        let result = new ScenarioSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IScenarioSettingsDto {
    executionId?: string;
    fromDate?: Date;
    toDate?: Date;
    types?: NetworkElementTypeDto[] | undefined;
}

export class NetworkElementTypeDto implements INetworkElementTypeDto {
    objectType?: string | undefined;
    originalObjectType?: string | undefined;
    hasLength?: boolean;
    definitions?: ConfigurationParameterDataDto[] | undefined;
    tagDefinitions?: { [key: string]: ConfigurationParameterDataDto; } | undefined;

    constructor(data?: INetworkElementTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectType = _data["objectType"];
            this.originalObjectType = _data["originalObjectType"];
            this.hasLength = _data["hasLength"];
            if (Array.isArray(_data["definitions"])) {
                this.definitions = [] as any;
                for (let item of _data["definitions"])
                    this.definitions!.push(ConfigurationParameterDataDto.fromJS(item));
            }
            if (_data["tagDefinitions"]) {
                this.tagDefinitions = {} as any;
                for (let key in _data["tagDefinitions"]) {
                    if (_data["tagDefinitions"].hasOwnProperty(key))
                        (<any>this.tagDefinitions)![key] = _data["tagDefinitions"][key] ? ConfigurationParameterDataDto.fromJS(_data["tagDefinitions"][key]) : new ConfigurationParameterDataDto();
                }
            }
        }
    }

    static fromJS(data: any): NetworkElementTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new NetworkElementTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectType"] = this.objectType;
        data["originalObjectType"] = this.originalObjectType;
        data["hasLength"] = this.hasLength;
        if (Array.isArray(this.definitions)) {
            data["definitions"] = [];
            for (let item of this.definitions)
                data["definitions"].push(item.toJSON());
        }
        if (this.tagDefinitions) {
            data["tagDefinitions"] = {};
            for (let key in this.tagDefinitions) {
                if (this.tagDefinitions.hasOwnProperty(key))
                    (<any>data["tagDefinitions"])[key] = this.tagDefinitions[key] ? this.tagDefinitions[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }

    clone(): NetworkElementTypeDto {
        const json = this.toJSON();
        let result = new NetworkElementTypeDto();
        result.init(json);
        return result;
    }
}

export interface INetworkElementTypeDto {
    objectType?: string | undefined;
    originalObjectType?: string | undefined;
    hasLength?: boolean;
    definitions?: ConfigurationParameterDataDto[] | undefined;
    tagDefinitions?: { [key: string]: ConfigurationParameterDataDto; } | undefined;
}

export class ConfigurationParameterDataDto implements IConfigurationParameterDataDto {
    name?: string | undefined;
    alias?: string | undefined;
    group?: string | undefined;
    dataSource?: string | undefined;
    type?: string | undefined;
    physType?: PhysTypeDto | undefined;
    isWeb?: boolean;

    constructor(data?: IConfigurationParameterDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.alias = _data["alias"];
            this.group = _data["group"];
            this.dataSource = _data["dataSource"];
            this.type = _data["type"];
            this.physType = _data["physType"] ? PhysTypeDto.fromJS(_data["physType"]) : <any>undefined;
            this.isWeb = _data["isWeb"];
        }
    }

    static fromJS(data: any): ConfigurationParameterDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationParameterDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["alias"] = this.alias;
        data["group"] = this.group;
        data["dataSource"] = this.dataSource;
        data["type"] = this.type;
        data["physType"] = this.physType ? this.physType.toJSON() : <any>undefined;
        data["isWeb"] = this.isWeb;
        return data;
    }

    clone(): ConfigurationParameterDataDto {
        const json = this.toJSON();
        let result = new ConfigurationParameterDataDto();
        result.init(json);
        return result;
    }
}

export interface IConfigurationParameterDataDto {
    name?: string | undefined;
    alias?: string | undefined;
    group?: string | undefined;
    dataSource?: string | undefined;
    type?: string | undefined;
    physType?: PhysTypeDto | undefined;
    isWeb?: boolean;
}

export class PhysTypeDto implements IPhysTypeDto {
    name?: string | undefined;
    alias?: string | undefined;
    units?: string | undefined;
    format?: string | undefined;

    constructor(data?: IPhysTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.alias = _data["alias"];
            this.units = _data["units"];
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): PhysTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhysTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["alias"] = this.alias;
        data["units"] = this.units;
        data["format"] = this.format;
        return data;
    }

    clone(): PhysTypeDto {
        const json = this.toJSON();
        let result = new PhysTypeDto();
        result.init(json);
        return result;
    }
}

export interface IPhysTypeDto {
    name?: string | undefined;
    alias?: string | undefined;
    units?: string | undefined;
    format?: string | undefined;
}

export class PublishScenarioExecutionCmdResponse implements IPublishScenarioExecutionCmdResponse {
    status?: PublishResultsStatus;

    constructor(data?: IPublishScenarioExecutionCmdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PublishScenarioExecutionCmdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PublishScenarioExecutionCmdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }

    clone(): PublishScenarioExecutionCmdResponse {
        const json = this.toJSON();
        let result = new PublishScenarioExecutionCmdResponse();
        result.init(json);
        return result;
    }
}

export interface IPublishScenarioExecutionCmdResponse {
    status?: PublishResultsStatus;
}

export class PublishScenarioResultsDto implements IPublishScenarioResultsDto {
    instanceId?: string;
    executionId?: string;
    lastSnapshotId?: string | undefined;
    isCleanSnapshot?: boolean;
    cleanedConnections?: CleanedWorkspaceConnectionDto[] | undefined;

    constructor(data?: IPublishScenarioResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instanceId = _data["instanceId"];
            this.executionId = _data["executionId"];
            this.lastSnapshotId = _data["lastSnapshotId"];
            this.isCleanSnapshot = _data["isCleanSnapshot"];
            if (Array.isArray(_data["cleanedConnections"])) {
                this.cleanedConnections = [] as any;
                for (let item of _data["cleanedConnections"])
                    this.cleanedConnections!.push(CleanedWorkspaceConnectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PublishScenarioResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublishScenarioResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceId"] = this.instanceId;
        data["executionId"] = this.executionId;
        data["lastSnapshotId"] = this.lastSnapshotId;
        data["isCleanSnapshot"] = this.isCleanSnapshot;
        if (Array.isArray(this.cleanedConnections)) {
            data["cleanedConnections"] = [];
            for (let item of this.cleanedConnections)
                data["cleanedConnections"].push(item.toJSON());
        }
        return data;
    }

    clone(): PublishScenarioResultsDto {
        const json = this.toJSON();
        let result = new PublishScenarioResultsDto();
        result.init(json);
        return result;
    }
}

export interface IPublishScenarioResultsDto {
    instanceId?: string;
    executionId?: string;
    lastSnapshotId?: string | undefined;
    isCleanSnapshot?: boolean;
    cleanedConnections?: CleanedWorkspaceConnectionDto[] | undefined;
}

export class CleanedWorkspaceConnectionDto implements ICleanedWorkspaceConnectionDto {
    workspaceId?: string;
    snapshotId?: string;
    scenarioName?: string | undefined;

    constructor(data?: ICleanedWorkspaceConnectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            this.snapshotId = _data["snapshotId"];
            this.scenarioName = _data["scenarioName"];
        }
    }

    static fromJS(data: any): CleanedWorkspaceConnectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CleanedWorkspaceConnectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        data["snapshotId"] = this.snapshotId;
        data["scenarioName"] = this.scenarioName;
        return data;
    }

    clone(): CleanedWorkspaceConnectionDto {
        const json = this.toJSON();
        let result = new CleanedWorkspaceConnectionDto();
        result.init(json);
        return result;
    }
}

export interface ICleanedWorkspaceConnectionDto {
    workspaceId?: string;
    snapshotId?: string;
    scenarioName?: string | undefined;
}

export class ScenarioResponseDto implements IScenarioResponseDto {
    snapshotId?: string;
    scenarioId?: string;
    isActive?: boolean;
    name?: string | undefined;
    status?: RegistrationStatus;

    constructor(data?: IScenarioResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.snapshotId = _data["snapshotId"];
            this.scenarioId = _data["scenarioId"];
            this.isActive = _data["isActive"];
            this.name = _data["name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ScenarioResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["snapshotId"] = this.snapshotId;
        data["scenarioId"] = this.scenarioId;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["status"] = this.status;
        return data;
    }

    clone(): ScenarioResponseDto {
        const json = this.toJSON();
        let result = new ScenarioResponseDto();
        result.init(json);
        return result;
    }
}

export interface IScenarioResponseDto {
    snapshotId?: string;
    scenarioId?: string;
    isActive?: boolean;
    name?: string | undefined;
    status?: RegistrationStatus;
}

export enum RegistrationStatus {
    Offline = 0,
    Online = 1,
    Simulating = 2,
    SimulatingCycling = 3,
}

export class UpdateScenarioStatusDto implements IUpdateScenarioStatusDto {
    status?: RegistrationStatus;

    constructor(data?: IUpdateScenarioStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateScenarioStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScenarioStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }

    clone(): UpdateScenarioStatusDto {
        const json = this.toJSON();
        let result = new UpdateScenarioStatusDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateScenarioStatusDto {
    status?: RegistrationStatus;
}

export class CleanSnapshotResponseDto implements ICleanSnapshotResponseDto {
    success?: boolean;
    cleanedConnections?: CleanedWorkspaceConnectionDto[] | undefined;

    constructor(data?: ICleanSnapshotResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["cleanedConnections"])) {
                this.cleanedConnections = [] as any;
                for (let item of _data["cleanedConnections"])
                    this.cleanedConnections!.push(CleanedWorkspaceConnectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CleanSnapshotResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CleanSnapshotResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.cleanedConnections)) {
            data["cleanedConnections"] = [];
            for (let item of this.cleanedConnections)
                data["cleanedConnections"].push(item.toJSON());
        }
        return data;
    }

    clone(): CleanSnapshotResponseDto {
        const json = this.toJSON();
        let result = new CleanSnapshotResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICleanSnapshotResponseDto {
    success?: boolean;
    cleanedConnections?: CleanedWorkspaceConnectionDto[] | undefined;
}

export class FrontendSettingsDto implements IFrontendSettingsDto {
    id?: string | undefined;
    log?: boolean;
    application?: FrontendSettingsAppDto | undefined;
    oAuthConfig?: FrontendSettingsOAuthConfigDto | undefined;
    geoServer?: FrontendSettingsGeoServerDto | undefined;
    map?: FrontendSettingsMapDto | undefined;

    constructor(data?: IFrontendSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.log = _data["log"];
            this.application = _data["application"] ? FrontendSettingsAppDto.fromJS(_data["application"]) : <any>undefined;
            this.oAuthConfig = _data["oAuthConfig"] ? FrontendSettingsOAuthConfigDto.fromJS(_data["oAuthConfig"]) : <any>undefined;
            this.geoServer = _data["geoServer"] ? FrontendSettingsGeoServerDto.fromJS(_data["geoServer"]) : <any>undefined;
            this.map = _data["map"] ? FrontendSettingsMapDto.fromJS(_data["map"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FrontendSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["log"] = this.log;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["oAuthConfig"] = this.oAuthConfig ? this.oAuthConfig.toJSON() : <any>undefined;
        data["geoServer"] = this.geoServer ? this.geoServer.toJSON() : <any>undefined;
        data["map"] = this.map ? this.map.toJSON() : <any>undefined;
        return data;
    }

    clone(): FrontendSettingsDto {
        const json = this.toJSON();
        let result = new FrontendSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IFrontendSettingsDto {
    id?: string | undefined;
    log?: boolean;
    application?: FrontendSettingsAppDto | undefined;
    oAuthConfig?: FrontendSettingsOAuthConfigDto | undefined;
    geoServer?: FrontendSettingsGeoServerDto | undefined;
    map?: FrontendSettingsMapDto | undefined;
}

export class FrontendSettingsAppDto implements IFrontendSettingsAppDto {
    name?: string | undefined;
    logoUrl?: string | undefined;

    constructor(data?: IFrontendSettingsAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.logoUrl = _data["logoUrl"];
        }
    }

    static fromJS(data: any): FrontendSettingsAppDto {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendSettingsAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["logoUrl"] = this.logoUrl;
        return data;
    }

    clone(): FrontendSettingsAppDto {
        const json = this.toJSON();
        let result = new FrontendSettingsAppDto();
        result.init(json);
        return result;
    }
}

export interface IFrontendSettingsAppDto {
    name?: string | undefined;
    logoUrl?: string | undefined;
}

export class FrontendSettingsOAuthConfigDto implements IFrontendSettingsOAuthConfigDto {
    issuer?: string | undefined;
    clientId?: string | undefined;
    dummyClientSecret?: string | undefined;
    scope?: string | undefined;
    showDebugInformation?: string | undefined;
    oidc?: boolean;
    requireHttps?: boolean;
    responseType?: string | undefined;
    redirectUri?: string | undefined;

    constructor(data?: IFrontendSettingsOAuthConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuer = _data["issuer"];
            this.clientId = _data["clientId"];
            this.dummyClientSecret = _data["dummyClientSecret"];
            this.scope = _data["scope"];
            this.showDebugInformation = _data["showDebugInformation"];
            this.oidc = _data["oidc"];
            this.requireHttps = _data["requireHttps"];
            this.responseType = _data["responseType"];
            this.redirectUri = _data["redirectUri"];
        }
    }

    static fromJS(data: any): FrontendSettingsOAuthConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendSettingsOAuthConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuer"] = this.issuer;
        data["clientId"] = this.clientId;
        data["dummyClientSecret"] = this.dummyClientSecret;
        data["scope"] = this.scope;
        data["showDebugInformation"] = this.showDebugInformation;
        data["oidc"] = this.oidc;
        data["requireHttps"] = this.requireHttps;
        data["responseType"] = this.responseType;
        data["redirectUri"] = this.redirectUri;
        return data;
    }

    clone(): FrontendSettingsOAuthConfigDto {
        const json = this.toJSON();
        let result = new FrontendSettingsOAuthConfigDto();
        result.init(json);
        return result;
    }
}

export interface IFrontendSettingsOAuthConfigDto {
    issuer?: string | undefined;
    clientId?: string | undefined;
    dummyClientSecret?: string | undefined;
    scope?: string | undefined;
    showDebugInformation?: string | undefined;
    oidc?: boolean;
    requireHttps?: boolean;
    responseType?: string | undefined;
    redirectUri?: string | undefined;
}

export class FrontendSettingsGeoServerDto implements IFrontendSettingsGeoServerDto {
    url?: string | undefined;

    constructor(data?: IFrontendSettingsGeoServerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): FrontendSettingsGeoServerDto {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendSettingsGeoServerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }

    clone(): FrontendSettingsGeoServerDto {
        const json = this.toJSON();
        let result = new FrontendSettingsGeoServerDto();
        result.init(json);
        return result;
    }
}

export interface IFrontendSettingsGeoServerDto {
    url?: string | undefined;
}

export class FrontendSettingsMapDto implements IFrontendSettingsMapDto {
    timeBarVelocity?: number;

    constructor(data?: IFrontendSettingsMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeBarVelocity = _data["timeBarVelocity"];
        }
    }

    static fromJS(data: any): FrontendSettingsMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendSettingsMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeBarVelocity"] = this.timeBarVelocity;
        return data;
    }

    clone(): FrontendSettingsMapDto {
        const json = this.toJSON();
        let result = new FrontendSettingsMapDto();
        result.init(json);
        return result;
    }
}

export interface IFrontendSettingsMapDto {
    timeBarVelocity?: number;
}

export class GetGroupModelsCrudByGroupIdCmdResponse implements IGetGroupModelsCrudByGroupIdCmdResponse {
    groupModels?: GroupModelResponse[] | undefined;

    constructor(data?: IGetGroupModelsCrudByGroupIdCmdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groupModels"])) {
                this.groupModels = [] as any;
                for (let item of _data["groupModels"])
                    this.groupModels!.push(GroupModelResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGroupModelsCrudByGroupIdCmdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupModelsCrudByGroupIdCmdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groupModels)) {
            data["groupModels"] = [];
            for (let item of this.groupModels)
                data["groupModels"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetGroupModelsCrudByGroupIdCmdResponse {
        const json = this.toJSON();
        let result = new GetGroupModelsCrudByGroupIdCmdResponse();
        result.init(json);
        return result;
    }
}

export interface IGetGroupModelsCrudByGroupIdCmdResponse {
    groupModels?: GroupModelResponse[] | undefined;
}

export class GroupModelResponse implements IGroupModelResponse {
    groupId?: number;
    instanceId?: string;
    write?: boolean;
    read?: boolean;

    constructor(data?: IGroupModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.instanceId = _data["instanceId"];
            this.write = _data["write"];
            this.read = _data["read"];
        }
    }

    static fromJS(data: any): GroupModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GroupModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["instanceId"] = this.instanceId;
        data["write"] = this.write;
        data["read"] = this.read;
        return data;
    }

    clone(): GroupModelResponse {
        const json = this.toJSON();
        let result = new GroupModelResponse();
        result.init(json);
        return result;
    }
}

export interface IGroupModelResponse {
    groupId?: number;
    instanceId?: string;
    write?: boolean;
    read?: boolean;
}

export class SaveGroupModelsCrudCmdResponse implements ISaveGroupModelsCrudCmdResponse {
    success?: string[] | undefined;
    errors?: string[] | undefined;
    successModelGroupsCrud?: string[] | undefined;
    errorModelGroupsCrud?: string[] | undefined;

    constructor(data?: ISaveGroupModelsCrudCmdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["success"])) {
                this.success = [] as any;
                for (let item of _data["success"])
                    this.success!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["successModelGroupsCrud"])) {
                this.successModelGroupsCrud = [] as any;
                for (let item of _data["successModelGroupsCrud"])
                    this.successModelGroupsCrud!.push(item);
            }
            if (Array.isArray(_data["errorModelGroupsCrud"])) {
                this.errorModelGroupsCrud = [] as any;
                for (let item of _data["errorModelGroupsCrud"])
                    this.errorModelGroupsCrud!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveGroupModelsCrudCmdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveGroupModelsCrudCmdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.success)) {
            data["success"] = [];
            for (let item of this.success)
                data["success"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.successModelGroupsCrud)) {
            data["successModelGroupsCrud"] = [];
            for (let item of this.successModelGroupsCrud)
                data["successModelGroupsCrud"].push(item);
        }
        if (Array.isArray(this.errorModelGroupsCrud)) {
            data["errorModelGroupsCrud"] = [];
            for (let item of this.errorModelGroupsCrud)
                data["errorModelGroupsCrud"].push(item);
        }
        return data;
    }

    clone(): SaveGroupModelsCrudCmdResponse {
        const json = this.toJSON();
        let result = new SaveGroupModelsCrudCmdResponse();
        result.init(json);
        return result;
    }
}

export interface ISaveGroupModelsCrudCmdResponse {
    success?: string[] | undefined;
    errors?: string[] | undefined;
    successModelGroupsCrud?: string[] | undefined;
    errorModelGroupsCrud?: string[] | undefined;
}

export class SaveGroupModelsCrudDto implements ISaveGroupModelsCrudDto {
    groupId?: number;
    instanceId?: string;
    write?: boolean | undefined;
    read?: boolean | undefined;

    constructor(data?: ISaveGroupModelsCrudDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.instanceId = _data["instanceId"];
            this.write = _data["write"];
            this.read = _data["read"];
        }
    }

    static fromJS(data: any): SaveGroupModelsCrudDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveGroupModelsCrudDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["instanceId"] = this.instanceId;
        data["write"] = this.write;
        data["read"] = this.read;
        return data;
    }

    clone(): SaveGroupModelsCrudDto {
        const json = this.toJSON();
        let result = new SaveGroupModelsCrudDto();
        result.init(json);
        return result;
    }
}

export interface ISaveGroupModelsCrudDto {
    groupId?: number;
    instanceId?: string;
    write?: boolean | undefined;
    read?: boolean | undefined;
}

export class GetReportsResponseDto implements IGetReportsResponseDto {
    reports?: { [key: string]: string[]; } | undefined;

    constructor(data?: IGetReportsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["reports"]) {
                this.reports = {} as any;
                for (let key in _data["reports"]) {
                    if (_data["reports"].hasOwnProperty(key))
                        (<any>this.reports)![key] = _data["reports"][key] !== undefined ? _data["reports"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): GetReportsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.reports) {
            data["reports"] = {};
            for (let key in this.reports) {
                if (this.reports.hasOwnProperty(key))
                    (<any>data["reports"])[key] = (<any>this.reports)[key];
            }
        }
        return data;
    }

    clone(): GetReportsResponseDto {
        const json = this.toJSON();
        let result = new GetReportsResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetReportsResponseDto {
    reports?: { [key: string]: string[]; } | undefined;
}

export class GetReportResponseDto implements IGetReportResponseDto {
    success?: boolean;

    constructor(data?: IGetReportResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): GetReportResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }

    clone(): GetReportResponseDto {
        const json = this.toJSON();
        let result = new GetReportResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetReportResponseDto {
    success?: boolean;
}

export enum ReportFormat {
    Html = 0,
    Pdf = 1,
    Excel = 2,
}

export class InstanceResponseDto implements IInstanceResponseDto {
    instanceId?: string;
    name?: string | undefined;
    url?: string | undefined;
    modelId?: string | undefined;
    status?: RegistrationStatus;
    realTimeId?: string | undefined;
    snapshots?: SnapshotResponseDto[] | undefined;

    constructor(data?: IInstanceResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instanceId = _data["instanceId"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.modelId = _data["modelId"];
            this.status = _data["status"];
            this.realTimeId = _data["realTimeId"];
            if (Array.isArray(_data["snapshots"])) {
                this.snapshots = [] as any;
                for (let item of _data["snapshots"])
                    this.snapshots!.push(SnapshotResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstanceResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstanceResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceId"] = this.instanceId;
        data["name"] = this.name;
        data["url"] = this.url;
        data["modelId"] = this.modelId;
        data["status"] = this.status;
        data["realTimeId"] = this.realTimeId;
        if (Array.isArray(this.snapshots)) {
            data["snapshots"] = [];
            for (let item of this.snapshots)
                data["snapshots"].push(item.toJSON());
        }
        return data;
    }

    clone(): InstanceResponseDto {
        const json = this.toJSON();
        let result = new InstanceResponseDto();
        result.init(json);
        return result;
    }
}

export interface IInstanceResponseDto {
    instanceId?: string;
    name?: string | undefined;
    url?: string | undefined;
    modelId?: string | undefined;
    status?: RegistrationStatus;
    realTimeId?: string | undefined;
    snapshots?: SnapshotResponseDto[] | undefined;
}

export class SnapshotResponseDto implements ISnapshotResponseDto {
    instanceId?: string;
    snapshotId?: string;
    name?: string | undefined;
    isDefault?: boolean;
    startDate?: Date;
    endDate?: Date | undefined;
    creationDate?: Date | undefined;
    scenarios?: ScenarioResponseDto[] | undefined;

    constructor(data?: ISnapshotResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instanceId = _data["instanceId"];
            this.snapshotId = _data["snapshotId"];
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["scenarios"])) {
                this.scenarios = [] as any;
                for (let item of _data["scenarios"])
                    this.scenarios!.push(ScenarioResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SnapshotResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SnapshotResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceId"] = this.instanceId;
        data["snapshotId"] = this.snapshotId;
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.scenarios)) {
            data["scenarios"] = [];
            for (let item of this.scenarios)
                data["scenarios"].push(item.toJSON());
        }
        return data;
    }

    clone(): SnapshotResponseDto {
        const json = this.toJSON();
        let result = new SnapshotResponseDto();
        result.init(json);
        return result;
    }
}

export interface ISnapshotResponseDto {
    instanceId?: string;
    snapshotId?: string;
    name?: string | undefined;
    isDefault?: boolean;
    startDate?: Date;
    endDate?: Date | undefined;
    creationDate?: Date | undefined;
    scenarios?: ScenarioResponseDto[] | undefined;
}

export class RegisterInstanceDto implements IRegisterInstanceDto {
    name?: string | undefined;
    url?: string | undefined;
    modelId?: string | undefined;
    realTimeId?: string | undefined;

    constructor(data?: IRegisterInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.modelId = _data["modelId"];
            this.realTimeId = _data["realTimeId"];
        }
    }

    static fromJS(data: any): RegisterInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["modelId"] = this.modelId;
        data["realTimeId"] = this.realTimeId;
        return data;
    }

    clone(): RegisterInstanceDto {
        const json = this.toJSON();
        let result = new RegisterInstanceDto();
        result.init(json);
        return result;
    }
}

export interface IRegisterInstanceDto {
    name?: string | undefined;
    url?: string | undefined;
    modelId?: string | undefined;
    realTimeId?: string | undefined;
}

export class UpdateInstanceDto implements IUpdateInstanceDto {
    instanceId?: string;
    status?: RegistrationStatus;

    constructor(data?: IUpdateInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instanceId = _data["instanceId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instanceId"] = this.instanceId;
        data["status"] = this.status;
        return data;
    }

    clone(): UpdateInstanceDto {
        const json = this.toJSON();
        let result = new UpdateInstanceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateInstanceDto {
    instanceId?: string;
    status?: RegistrationStatus;
}

export class GetScenarioProfilesDto implements IGetScenarioProfilesDto {
    scenarioProfiles?: { [key: string]: ScenarioProfileDto[]; } | undefined;

    constructor(data?: IGetScenarioProfilesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["scenarioProfiles"]) {
                this.scenarioProfiles = {} as any;
                for (let key in _data["scenarioProfiles"]) {
                    if (_data["scenarioProfiles"].hasOwnProperty(key))
                        (<any>this.scenarioProfiles)![key] = _data["scenarioProfiles"][key] ? _data["scenarioProfiles"][key].map((i: any) => ScenarioProfileDto.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): GetScenarioProfilesDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetScenarioProfilesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.scenarioProfiles) {
            data["scenarioProfiles"] = {};
            for (let key in this.scenarioProfiles) {
                if (this.scenarioProfiles.hasOwnProperty(key))
                    (<any>data["scenarioProfiles"])[key] = (<any>this.scenarioProfiles)[key];
            }
        }
        return data;
    }

    clone(): GetScenarioProfilesDto {
        const json = this.toJSON();
        let result = new GetScenarioProfilesDto();
        result.init(json);
        return result;
    }
}

export interface IGetScenarioProfilesDto {
    scenarioProfiles?: { [key: string]: ScenarioProfileDto[]; } | undefined;
}

export class ScenarioProfileDto implements IScenarioProfileDto {
    id?: string;
    name?: string | undefined;

    constructor(data?: IScenarioProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ScenarioProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): ScenarioProfileDto {
        const json = this.toJSON();
        let result = new ScenarioProfileDto();
        result.init(json);
        return result;
    }
}

export interface IScenarioProfileDto {
    id?: string;
    name?: string | undefined;
}

export class GetProfileSeriesDto implements IGetProfileSeriesDto {
    lengend?: string | undefined;
    chainageUnits?: string | undefined;
    chainagePhysType?: string | undefined;
    profileSerieValues?: ProfileSerieDto[] | undefined;

    constructor(data?: IGetProfileSeriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lengend = _data["lengend"];
            this.chainageUnits = _data["chainageUnits"];
            this.chainagePhysType = _data["chainagePhysType"];
            if (Array.isArray(_data["profileSerieValues"])) {
                this.profileSerieValues = [] as any;
                for (let item of _data["profileSerieValues"])
                    this.profileSerieValues!.push(ProfileSerieDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProfileSeriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfileSeriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lengend"] = this.lengend;
        data["chainageUnits"] = this.chainageUnits;
        data["chainagePhysType"] = this.chainagePhysType;
        if (Array.isArray(this.profileSerieValues)) {
            data["profileSerieValues"] = [];
            for (let item of this.profileSerieValues)
                data["profileSerieValues"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetProfileSeriesDto {
        const json = this.toJSON();
        let result = new GetProfileSeriesDto();
        result.init(json);
        return result;
    }
}

export interface IGetProfileSeriesDto {
    lengend?: string | undefined;
    chainageUnits?: string | undefined;
    chainagePhysType?: string | undefined;
    profileSerieValues?: ProfileSerieDto[] | undefined;
}

export class ProfileSerieDto implements IProfileSerieDto {
    attribute?: string | undefined;
    values?: ProfileValueDto[] | undefined;

    constructor(data?: IProfileSerieDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attribute = _data["attribute"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ProfileValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfileSerieDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileSerieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProfileSerieDto {
        const json = this.toJSON();
        let result = new ProfileSerieDto();
        result.init(json);
        return result;
    }
}

export interface IProfileSerieDto {
    attribute?: string | undefined;
    values?: ProfileValueDto[] | undefined;
}

export class ProfileValueDto implements IProfileValueDto {
    value?: any | undefined;
    pathValue?: number | undefined;
    elementName?: string | undefined;

    constructor(data?: IProfileValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.pathValue = _data["pathValue"];
            this.elementName = _data["elementName"];
        }
    }

    static fromJS(data: any): ProfileValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["pathValue"] = this.pathValue;
        data["elementName"] = this.elementName;
        return data;
    }

    clone(): ProfileValueDto {
        const json = this.toJSON();
        let result = new ProfileValueDto();
        result.init(json);
        return result;
    }
}

export interface IProfileValueDto {
    value?: any | undefined;
    pathValue?: number | undefined;
    elementName?: string | undefined;
}

export class WorkspaceMapSettingsDto implements IWorkspaceMapSettingsDto {
    id?: string | undefined;
    workspaceId?: string;
    visibleScenarioIds?: string[] | undefined;
    layerItems?: LayerItemDto[] | undefined;
    thematicLayerItems?: LayerItemDto[] | undefined;

    constructor(data?: IWorkspaceMapSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workspaceId = _data["workspaceId"];
            if (Array.isArray(_data["visibleScenarioIds"])) {
                this.visibleScenarioIds = [] as any;
                for (let item of _data["visibleScenarioIds"])
                    this.visibleScenarioIds!.push(item);
            }
            if (Array.isArray(_data["layerItems"])) {
                this.layerItems = [] as any;
                for (let item of _data["layerItems"])
                    this.layerItems!.push(LayerItemDto.fromJS(item));
            }
            if (Array.isArray(_data["thematicLayerItems"])) {
                this.thematicLayerItems = [] as any;
                for (let item of _data["thematicLayerItems"])
                    this.thematicLayerItems!.push(LayerItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkspaceMapSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceMapSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workspaceId"] = this.workspaceId;
        if (Array.isArray(this.visibleScenarioIds)) {
            data["visibleScenarioIds"] = [];
            for (let item of this.visibleScenarioIds)
                data["visibleScenarioIds"].push(item);
        }
        if (Array.isArray(this.layerItems)) {
            data["layerItems"] = [];
            for (let item of this.layerItems)
                data["layerItems"].push(item.toJSON());
        }
        if (Array.isArray(this.thematicLayerItems)) {
            data["thematicLayerItems"] = [];
            for (let item of this.thematicLayerItems)
                data["thematicLayerItems"].push(item.toJSON());
        }
        return data;
    }

    clone(): WorkspaceMapSettingsDto {
        const json = this.toJSON();
        let result = new WorkspaceMapSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IWorkspaceMapSettingsDto {
    id?: string | undefined;
    workspaceId?: string;
    visibleScenarioIds?: string[] | undefined;
    layerItems?: LayerItemDto[] | undefined;
    thematicLayerItems?: LayerItemDto[] | undefined;
}

export class LayerItemDto implements ILayerItemDto {
    key?: string | undefined;
    settings?: LayerItemSettingsDto | undefined;

    constructor(data?: ILayerItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.settings = _data["settings"] ? LayerItemSettingsDto.fromJS(_data["settings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LayerItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LayerItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        return data;
    }

    clone(): LayerItemDto {
        const json = this.toJSON();
        let result = new LayerItemDto();
        result.init(json);
        return result;
    }
}

export interface ILayerItemDto {
    key?: string | undefined;
    settings?: LayerItemSettingsDto | undefined;
}

export class LayerItemSettingsDto implements ILayerItemSettingsDto {
    isVisible?: boolean;
    styleId?: string;
    order?: number;

    constructor(data?: ILayerItemSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isVisible = _data["isVisible"];
            this.styleId = _data["styleId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): LayerItemSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LayerItemSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isVisible"] = this.isVisible;
        data["styleId"] = this.styleId;
        data["order"] = this.order;
        return data;
    }

    clone(): LayerItemSettingsDto {
        const json = this.toJSON();
        let result = new LayerItemSettingsDto();
        result.init(json);
        return result;
    }
}

export interface ILayerItemSettingsDto {
    isVisible?: boolean;
    styleId?: string;
    order?: number;
}

export class MultiTenantDto implements IMultiTenantDto {
    id?: string;
    name?: string | undefined;
    connectionString?: string | undefined;
    identityConnectionString?: string | undefined;
    mapServerUrl?: string | undefined;
    mapServerUser?: string | undefined;
    mapServerPassword?: string | undefined;

    constructor(data?: IMultiTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.identityConnectionString = _data["identityConnectionString"];
            this.mapServerUrl = _data["mapServerUrl"];
            this.mapServerUser = _data["mapServerUser"];
            this.mapServerPassword = _data["mapServerPassword"];
        }
    }

    static fromJS(data: any): MultiTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["identityConnectionString"] = this.identityConnectionString;
        data["mapServerUrl"] = this.mapServerUrl;
        data["mapServerUser"] = this.mapServerUser;
        data["mapServerPassword"] = this.mapServerPassword;
        return data;
    }

    clone(): MultiTenantDto {
        const json = this.toJSON();
        let result = new MultiTenantDto();
        result.init(json);
        return result;
    }
}

export interface IMultiTenantDto {
    id?: string;
    name?: string | undefined;
    connectionString?: string | undefined;
    identityConnectionString?: string | undefined;
    mapServerUrl?: string | undefined;
    mapServerUser?: string | undefined;
    mapServerPassword?: string | undefined;
}

export class MapStyleResponseDto implements IMapStyleResponseDto {
    id?: string;
    styleName?: string | undefined;
    layerType?: LayerType;
    objectType?: string | undefined;
    isThematic?: boolean;
    styleDefinition?: any | undefined;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: IMapStyleResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.styleName = _data["styleName"];
            this.layerType = _data["layerType"];
            this.objectType = _data["objectType"];
            this.isThematic = _data["isThematic"];
            this.styleDefinition = _data["styleDefinition"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MapStyleResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapStyleResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["styleName"] = this.styleName;
        data["layerType"] = this.layerType;
        data["objectType"] = this.objectType;
        data["isThematic"] = this.isThematic;
        data["styleDefinition"] = this.styleDefinition;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): MapStyleResponseDto {
        const json = this.toJSON();
        let result = new MapStyleResponseDto();
        result.init(json);
        return result;
    }
}

export interface IMapStyleResponseDto {
    id?: string;
    styleName?: string | undefined;
    layerType?: LayerType;
    objectType?: string | undefined;
    isThematic?: boolean;
    styleDefinition?: any | undefined;
    createdAt?: Date;
    updatedAt?: Date;
}

export class LayerThematicStylesDto implements ILayerThematicStylesDto {
    id?: string | undefined;
    workspaceId?: string;
    layerType?: LayerType;
    objectType?: string | undefined;
    styleName?: string | undefined;
    fieldName?: string | undefined;
    styleDefinition?: MapThematicStylesDto | undefined;

    constructor(data?: ILayerThematicStylesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workspaceId = _data["workspaceId"];
            this.layerType = _data["layerType"];
            this.objectType = _data["objectType"];
            this.styleName = _data["styleName"];
            this.fieldName = _data["fieldName"];
            this.styleDefinition = _data["styleDefinition"] ? MapThematicStylesDto.fromJS(_data["styleDefinition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LayerThematicStylesDto {
        data = typeof data === 'object' ? data : {};
        let result = new LayerThematicStylesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workspaceId"] = this.workspaceId;
        data["layerType"] = this.layerType;
        data["objectType"] = this.objectType;
        data["styleName"] = this.styleName;
        data["fieldName"] = this.fieldName;
        data["styleDefinition"] = this.styleDefinition ? this.styleDefinition.toJSON() : <any>undefined;
        return data;
    }

    clone(): LayerThematicStylesDto {
        const json = this.toJSON();
        let result = new LayerThematicStylesDto();
        result.init(json);
        return result;
    }
}

export interface ILayerThematicStylesDto {
    id?: string | undefined;
    workspaceId?: string;
    layerType?: LayerType;
    objectType?: string | undefined;
    styleName?: string | undefined;
    fieldName?: string | undefined;
    styleDefinition?: MapThematicStylesDto | undefined;
}

export class MapThematicStylesDto implements IMapThematicStylesDto {
    className?: string[] | undefined;
    thematicType?: ThematicType;
    fieldName?: string | undefined;
    rangeDefinition?: MapThematicRangeItemDto[] | undefined;

    constructor(data?: IMapThematicStylesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["className"])) {
                this.className = [] as any;
                for (let item of _data["className"])
                    this.className!.push(item);
            }
            this.thematicType = _data["thematicType"];
            this.fieldName = _data["fieldName"];
            if (Array.isArray(_data["rangeDefinition"])) {
                this.rangeDefinition = [] as any;
                for (let item of _data["rangeDefinition"])
                    this.rangeDefinition!.push(MapThematicRangeItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MapThematicStylesDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapThematicStylesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.className)) {
            data["className"] = [];
            for (let item of this.className)
                data["className"].push(item);
        }
        data["thematicType"] = this.thematicType;
        data["fieldName"] = this.fieldName;
        if (Array.isArray(this.rangeDefinition)) {
            data["rangeDefinition"] = [];
            for (let item of this.rangeDefinition)
                data["rangeDefinition"].push(item.toJSON());
        }
        return data;
    }

    clone(): MapThematicStylesDto {
        const json = this.toJSON();
        let result = new MapThematicStylesDto();
        result.init(json);
        return result;
    }
}

export interface IMapThematicStylesDto {
    className?: string[] | undefined;
    thematicType?: ThematicType;
    fieldName?: string | undefined;
    rangeDefinition?: MapThematicRangeItemDto[] | undefined;
}

export enum ThematicType {
    Graduated = "Graduated",
    Category = "Category",
}

export class MapThematicRangeItemDto implements IMapThematicRangeItemDto {
    value?: number;
    styleDefinition?: MapCssStyleDto | undefined;

    constructor(data?: IMapThematicRangeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.styleDefinition = _data["styleDefinition"] ? MapCssStyleDto.fromJS(_data["styleDefinition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MapThematicRangeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapThematicRangeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["styleDefinition"] = this.styleDefinition ? this.styleDefinition.toJSON() : <any>undefined;
        return data;
    }

    clone(): MapThematicRangeItemDto {
        const json = this.toJSON();
        let result = new MapThematicRangeItemDto();
        result.init(json);
        return result;
    }
}

export interface IMapThematicRangeItemDto {
    value?: number;
    styleDefinition?: MapCssStyleDto | undefined;
}

export class WorkspaceDashboardsSettingDto implements IWorkspaceDashboardsSettingDto {
    workspaceDashboardsId?: string | undefined;
    workspaceId?: string;
    definition?: string | undefined;
    userCode?: string | undefined;
    lastUpdate?: Date | undefined;
    tenantId?: string | undefined;

    constructor(data?: IWorkspaceDashboardsSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceDashboardsId = _data["workspaceDashboardsId"];
            this.workspaceId = _data["workspaceId"];
            this.definition = _data["definition"];
            this.userCode = _data["userCode"];
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): WorkspaceDashboardsSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceDashboardsSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceDashboardsId"] = this.workspaceDashboardsId;
        data["workspaceId"] = this.workspaceId;
        data["definition"] = this.definition;
        data["userCode"] = this.userCode;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): WorkspaceDashboardsSettingDto {
        const json = this.toJSON();
        let result = new WorkspaceDashboardsSettingDto();
        result.init(json);
        return result;
    }
}

export interface IWorkspaceDashboardsSettingDto {
    workspaceDashboardsId?: string | undefined;
    workspaceId?: string;
    definition?: string | undefined;
    userCode?: string | undefined;
    lastUpdate?: Date | undefined;
    tenantId?: string | undefined;
}

export class DashboardDefinitionDto implements IDashboardDefinitionDto {
    dashboardDefinitionId?: string | undefined;
    title?: string | undefined;
    definition?: string | undefined;
    userCode?: string | undefined;
    lastUpdate?: Date | undefined;
    tenantId?: string | undefined;

    constructor(data?: IDashboardDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardDefinitionId = _data["dashboardDefinitionId"];
            this.title = _data["title"];
            this.definition = _data["definition"];
            this.userCode = _data["userCode"];
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): DashboardDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardDefinitionId"] = this.dashboardDefinitionId;
        data["title"] = this.title;
        data["definition"] = this.definition;
        data["userCode"] = this.userCode;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): DashboardDefinitionDto {
        const json = this.toJSON();
        let result = new DashboardDefinitionDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardDefinitionDto {
    dashboardDefinitionId?: string | undefined;
    title?: string | undefined;
    definition?: string | undefined;
    userCode?: string | undefined;
    lastUpdate?: Date | undefined;
    tenantId?: string | undefined;
}

export class CtWorkspaceDto implements ICtWorkspaceDto {
    workspaceId?: string;
    workspaceName?: string | undefined;
    workspaceDescription?: string | undefined;
    lastUpdate?: Date;
    isPublic?: boolean | undefined;
    ownerCode?: string | undefined;
    workspaceConnectSettings?: WorkspaceConnectSettingDto[] | undefined;

    constructor(data?: ICtWorkspaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceId = _data["workspaceId"];
            this.workspaceName = _data["workspaceName"];
            this.workspaceDescription = _data["workspaceDescription"];
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : <any>undefined;
            this.isPublic = _data["isPublic"];
            this.ownerCode = _data["ownerCode"];
            if (Array.isArray(_data["workspaceConnectSettings"])) {
                this.workspaceConnectSettings = [] as any;
                for (let item of _data["workspaceConnectSettings"])
                    this.workspaceConnectSettings!.push(WorkspaceConnectSettingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CtWorkspaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CtWorkspaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId;
        data["workspaceName"] = this.workspaceName;
        data["workspaceDescription"] = this.workspaceDescription;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        data["isPublic"] = this.isPublic;
        data["ownerCode"] = this.ownerCode;
        if (Array.isArray(this.workspaceConnectSettings)) {
            data["workspaceConnectSettings"] = [];
            for (let item of this.workspaceConnectSettings)
                data["workspaceConnectSettings"].push(item.toJSON());
        }
        return data;
    }

    clone(): CtWorkspaceDto {
        const json = this.toJSON();
        let result = new CtWorkspaceDto();
        result.init(json);
        return result;
    }
}

export interface ICtWorkspaceDto {
    workspaceId?: string;
    workspaceName?: string | undefined;
    workspaceDescription?: string | undefined;
    lastUpdate?: Date;
    isPublic?: boolean | undefined;
    ownerCode?: string | undefined;
    workspaceConnectSettings?: WorkspaceConnectSettingDto[] | undefined;
}

export class WorkspaceConnectSettingDto implements IWorkspaceConnectSettingDto {
    workspaceConnectSettingId?: string;
    workspaceId?: string;
    instanceId?: string;
    instanceName?: string | undefined;
    snapshotId?: string;
    snapshotName?: string | undefined;
    scenarioId?: string;
    scenarioName?: string | undefined;
    lastDateWasChecked?: Date;

    constructor(data?: IWorkspaceConnectSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workspaceConnectSettingId = _data["workspaceConnectSettingId"];
            this.workspaceId = _data["workspaceId"];
            this.instanceId = _data["instanceId"];
            this.instanceName = _data["instanceName"];
            this.snapshotId = _data["snapshotId"];
            this.snapshotName = _data["snapshotName"];
            this.scenarioId = _data["scenarioId"];
            this.scenarioName = _data["scenarioName"];
            this.lastDateWasChecked = _data["lastDateWasChecked"] ? new Date(_data["lastDateWasChecked"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkspaceConnectSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkspaceConnectSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceConnectSettingId"] = this.workspaceConnectSettingId;
        data["workspaceId"] = this.workspaceId;
        data["instanceId"] = this.instanceId;
        data["instanceName"] = this.instanceName;
        data["snapshotId"] = this.snapshotId;
        data["snapshotName"] = this.snapshotName;
        data["scenarioId"] = this.scenarioId;
        data["scenarioName"] = this.scenarioName;
        data["lastDateWasChecked"] = this.lastDateWasChecked ? this.lastDateWasChecked.toISOString() : <any>undefined;
        return data;
    }

    clone(): WorkspaceConnectSettingDto {
        const json = this.toJSON();
        let result = new WorkspaceConnectSettingDto();
        result.init(json);
        return result;
    }
}

export interface IWorkspaceConnectSettingDto {
    workspaceConnectSettingId?: string;
    workspaceId?: string;
    instanceId?: string;
    instanceName?: string | undefined;
    snapshotId?: string;
    snapshotName?: string | undefined;
    scenarioId?: string;
    scenarioName?: string | undefined;
    lastDateWasChecked?: Date;
}

export class AttributeDto implements IAttributeDto {
    name?: string | undefined;
    value?: string | undefined;
    resultDateTime?: Date;

    constructor(data?: IAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.resultDateTime = _data["resultDateTime"] ? new Date(_data["resultDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["resultDateTime"] = this.resultDateTime ? this.resultDateTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): AttributeDto {
        const json = this.toJSON();
        let result = new AttributeDto();
        result.init(json);
        return result;
    }
}

export interface IAttributeDto {
    name?: string | undefined;
    value?: string | undefined;
    resultDateTime?: Date;
}

export class ElementTypeCategoriesDto implements IElementTypeCategoriesDto {
    type?: string | undefined;
    geometryType?: string | undefined;
    categories?: AttributeMetadataDto[] | undefined;
    layerStyle?: LayerStylesDto | undefined;
    layerIcon?: LayerIconDto | undefined;

    constructor(data?: IElementTypeCategoriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.geometryType = _data["geometryType"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(AttributeMetadataDto.fromJS(item));
            }
            this.layerStyle = _data["layerStyle"] ? LayerStylesDto.fromJS(_data["layerStyle"]) : <any>undefined;
            this.layerIcon = _data["layerIcon"] ? LayerIconDto.fromJS(_data["layerIcon"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ElementTypeCategoriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementTypeCategoriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["geometryType"] = this.geometryType;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["layerStyle"] = this.layerStyle ? this.layerStyle.toJSON() : <any>undefined;
        data["layerIcon"] = this.layerIcon ? this.layerIcon.toJSON() : <any>undefined;
        return data;
    }

    clone(): ElementTypeCategoriesDto {
        const json = this.toJSON();
        let result = new ElementTypeCategoriesDto();
        result.init(json);
        return result;
    }
}

export interface IElementTypeCategoriesDto {
    type?: string | undefined;
    geometryType?: string | undefined;
    categories?: AttributeMetadataDto[] | undefined;
    layerStyle?: LayerStylesDto | undefined;
    layerIcon?: LayerIconDto | undefined;
}

export class AttributeMetadataDto implements IAttributeMetadataDto {
    name?: string | undefined;
    attributes?: AttributeInfoDto[] | undefined;

    constructor(data?: IAttributeMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(AttributeInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttributeMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        return data;
    }

    clone(): AttributeMetadataDto {
        const json = this.toJSON();
        let result = new AttributeMetadataDto();
        result.init(json);
        return result;
    }
}

export interface IAttributeMetadataDto {
    name?: string | undefined;
    attributes?: AttributeInfoDto[] | undefined;
}

export class AttributeInfoDto implements IAttributeInfoDto {
    name?: string | undefined;
    alias?: string | undefined;
    units?: string | undefined;
    physType?: string | undefined;
    format?: string | undefined;
    description?: string | undefined;
    attributeTypeKey?: string | undefined;
    isWeb?: boolean;

    constructor(data?: IAttributeInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.alias = _data["alias"];
            this.units = _data["units"];
            this.physType = _data["physType"];
            this.format = _data["format"];
            this.description = _data["description"];
            this.attributeTypeKey = _data["attributeTypeKey"];
            this.isWeb = _data["isWeb"];
        }
    }

    static fromJS(data: any): AttributeInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["alias"] = this.alias;
        data["units"] = this.units;
        data["physType"] = this.physType;
        data["format"] = this.format;
        data["description"] = this.description;
        data["attributeTypeKey"] = this.attributeTypeKey;
        data["isWeb"] = this.isWeb;
        return data;
    }

    clone(): AttributeInfoDto {
        const json = this.toJSON();
        let result = new AttributeInfoDto();
        result.init(json);
        return result;
    }
}

export interface IAttributeInfoDto {
    name?: string | undefined;
    alias?: string | undefined;
    units?: string | undefined;
    physType?: string | undefined;
    format?: string | undefined;
    description?: string | undefined;
    attributeTypeKey?: string | undefined;
    isWeb?: boolean;
}

export class LayerIconDto implements ILayerIconDto {
    layerType?: string | undefined;
    iconSvg?: string | undefined;

    constructor(data?: ILayerIconDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layerType = _data["layerType"];
            this.iconSvg = _data["iconSvg"];
        }
    }

    static fromJS(data: any): LayerIconDto {
        data = typeof data === 'object' ? data : {};
        let result = new LayerIconDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layerType"] = this.layerType;
        data["iconSvg"] = this.iconSvg;
        return data;
    }

    clone(): LayerIconDto {
        const json = this.toJSON();
        let result = new LayerIconDto();
        result.init(json);
        return result;
    }
}

export interface ILayerIconDto {
    layerType?: string | undefined;
    iconSvg?: string | undefined;
}

export class DateRangeDto implements IDateRangeDto {
    startDate?: Date;
    endDate?: Date | undefined;
    steps?: Date[] | undefined;

    constructor(data?: IDateRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(new Date(item));
            }
        }
    }

    static fromJS(data: any): DateRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toISOString());
        }
        return data;
    }

    clone(): DateRangeDto {
        const json = this.toJSON();
        let result = new DateRangeDto();
        result.init(json);
        return result;
    }
}

export interface IDateRangeDto {
    startDate?: Date;
    endDate?: Date | undefined;
    steps?: Date[] | undefined;
}

export class ExtensibleObject implements IExtensibleObject {
    extraProperties?: ExtraPropertyDictionary;

    constructor(data?: IExtensibleObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extraProperties = _data["extraProperties"] ? ExtraPropertyDictionary.fromJS(_data["extraProperties"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtensibleObject {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensibleObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extraProperties"] = this.extraProperties ? this.extraProperties.toJSON() : <any>undefined;
        return data;
    }

    clone(): ExtensibleObject {
        const json = this.toJSON();
        let result = new ExtensibleObject();
        result.init(json);
        return result;
    }
}

export interface IExtensibleObject {
    extraProperties?: ExtraPropertyDictionary;
}

export abstract class ExtensibleEntityDtoOfGuid extends ExtensibleObject implements IExtensibleEntityDtoOfGuid {
    /** Id of the entity. */
    id?: string;

    constructor(data?: IExtensibleEntityDtoOfGuid) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExtensibleEntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ExtensibleEntityDtoOfGuid' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }

    clone(): ExtensibleEntityDtoOfGuid {
        throw new Error("The abstract class 'ExtensibleEntityDtoOfGuid' cannot be instantiated.");
    }
}

export interface IExtensibleEntityDtoOfGuid extends IExtensibleObject {
    /** Id of the entity. */
    id?: string;
}

/** This class can be inherited by DTO classes to implement ICreationAuditedObject interface. It also implements the IHasExtraProperties interface. */
export abstract class ExtensibleCreationAuditedEntityDtoOfGuid extends ExtensibleEntityDtoOfGuid implements IExtensibleCreationAuditedEntityDtoOfGuid {
    /** Creation time. */
    creationTime?: Date;
    /** Id of the creator. */
    creatorId?: string | undefined;

    constructor(data?: IExtensibleCreationAuditedEntityDtoOfGuid) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorId = _data["creatorId"];
        }
    }

    static fromJS(data: any): ExtensibleCreationAuditedEntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ExtensibleCreationAuditedEntityDtoOfGuid' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        super.toJSON(data);
        return data;
    }

    clone(): ExtensibleCreationAuditedEntityDtoOfGuid {
        throw new Error("The abstract class 'ExtensibleCreationAuditedEntityDtoOfGuid' cannot be instantiated.");
    }
}

/** This class can be inherited by DTO classes to implement ICreationAuditedObject interface. It also implements the IHasExtraProperties interface. */
export interface IExtensibleCreationAuditedEntityDtoOfGuid extends IExtensibleEntityDtoOfGuid {
    /** Creation time. */
    creationTime?: Date;
    /** Id of the creator. */
    creatorId?: string | undefined;
}

/** This class can be inherited by DTO classes to implement IAuditedObject interface. It also implements the IHasExtraProperties interface. */
export abstract class ExtensibleAuditedEntityDtoOfGuid extends ExtensibleCreationAuditedEntityDtoOfGuid implements IExtensibleAuditedEntityDtoOfGuid {
    /** The last modified time for this entity. */
    lastModificationTime?: Date | undefined;
    /** Last modifier user for this entity. */
    lastModifierId?: string | undefined;

    constructor(data?: IExtensibleAuditedEntityDtoOfGuid) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = _data["lastModifierId"];
        }
    }

    static fromJS(data: any): ExtensibleAuditedEntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ExtensibleAuditedEntityDtoOfGuid' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        super.toJSON(data);
        return data;
    }

    clone(): ExtensibleAuditedEntityDtoOfGuid {
        throw new Error("The abstract class 'ExtensibleAuditedEntityDtoOfGuid' cannot be instantiated.");
    }
}

/** This class can be inherited by DTO classes to implement IAuditedObject interface. It also implements the IHasExtraProperties interface. */
export interface IExtensibleAuditedEntityDtoOfGuid extends IExtensibleCreationAuditedEntityDtoOfGuid {
    /** The last modified time for this entity. */
    lastModificationTime?: Date | undefined;
    /** Last modifier user for this entity. */
    lastModifierId?: string | undefined;
}

/** This class can be inherited by DTO classes to implement IFullAuditedObject interface. It also implements the IHasExtraProperties interface. */
export abstract class ExtensibleFullAuditedEntityDtoOfGuid extends ExtensibleAuditedEntityDtoOfGuid implements IExtensibleFullAuditedEntityDtoOfGuid {
    /** Used to mark an Entity as 'Deleted'. */
    isDeleted?: boolean;
    /** Id of the deleter user. */
    deleterId?: string | undefined;
    /** Deletion time. */
    deletionTime?: Date | undefined;

    constructor(data?: IExtensibleFullAuditedEntityDtoOfGuid) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isDeleted = _data["isDeleted"];
            this.deleterId = _data["deleterId"];
            this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtensibleFullAuditedEntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ExtensibleFullAuditedEntityDtoOfGuid' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): ExtensibleFullAuditedEntityDtoOfGuid {
        throw new Error("The abstract class 'ExtensibleFullAuditedEntityDtoOfGuid' cannot be instantiated.");
    }
}

/** This class can be inherited by DTO classes to implement IFullAuditedObject interface. It also implements the IHasExtraProperties interface. */
export interface IExtensibleFullAuditedEntityDtoOfGuid extends IExtensibleAuditedEntityDtoOfGuid {
    /** Used to mark an Entity as 'Deleted'. */
    isDeleted?: boolean;
    /** Id of the deleter user. */
    deleterId?: string | undefined;
    /** Deletion time. */
    deletionTime?: Date | undefined;
}

export class IdentityUserDto extends ExtensibleFullAuditedEntityDtoOfGuid implements IIdentityUserDto {
    tenantId?: string | undefined;
    userName?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    isActive?: boolean;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    lockoutEnd?: Date | undefined;
    concurrencyStamp?: string | undefined;
    entityVersion?: number;
    lastPasswordChangeTime?: Date | undefined;

    constructor(data?: IIdentityUserDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.isActive = _data["isActive"];
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.entityVersion = _data["entityVersion"];
            this.lastPasswordChangeTime = _data["lastPasswordChangeTime"] ? new Date(_data["lastPasswordChangeTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IdentityUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["isActive"] = this.isActive;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["entityVersion"] = this.entityVersion;
        data["lastPasswordChangeTime"] = this.lastPasswordChangeTime ? this.lastPasswordChangeTime.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): IdentityUserDto {
        const json = this.toJSON();
        let result = new IdentityUserDto();
        result.init(json);
        return result;
    }
}

export interface IIdentityUserDto extends IExtensibleFullAuditedEntityDtoOfGuid {
    tenantId?: string | undefined;
    userName?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    isActive?: boolean;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    lockoutEnd?: Date | undefined;
    concurrencyStamp?: string | undefined;
    entityVersion?: number;
    lastPasswordChangeTime?: Date | undefined;
}

export class ExtraPropertyDictionary implements IExtraPropertyDictionary {

    [key: string]: any;

    constructor(data?: IExtraPropertyDictionary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): ExtraPropertyDictionary {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraPropertyDictionary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }

    clone(): ExtraPropertyDictionary {
        const json = this.toJSON();
        let result = new ExtraPropertyDictionary();
        result.init(json);
        return result;
    }
}

export interface IExtraPropertyDictionary {

    [key: string]: any;
}

export class RemoteServiceErrorResponse implements IRemoteServiceErrorResponse {
    error?: RemoteServiceErrorInfo;

    constructor(data?: IRemoteServiceErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] ? RemoteServiceErrorInfo.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RemoteServiceErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteServiceErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }

    clone(): RemoteServiceErrorResponse {
        const json = this.toJSON();
        let result = new RemoteServiceErrorResponse();
        result.init(json);
        return result;
    }
}

export interface IRemoteServiceErrorResponse {
    error?: RemoteServiceErrorInfo;
}

/** Used to store information about an error. */
export class RemoteServiceErrorInfo implements IRemoteServiceErrorInfo {
    /** Error code. */
    code?: string | undefined;
    /** Error message. */
    message?: string | undefined;
    /** Error details. */
    details?: string | undefined;
    /** Error data. */
    data?: any[] | undefined;
    /** Validation errors if exists. */
    validationErrors?: RemoteServiceValidationErrorInfo[] | undefined;

    constructor(data?: IRemoteServiceErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.details = _data["details"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(RemoteServiceValidationErrorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RemoteServiceErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteServiceErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): RemoteServiceErrorInfo {
        const json = this.toJSON();
        let result = new RemoteServiceErrorInfo();
        result.init(json);
        return result;
    }
}

/** Used to store information about an error. */
export interface IRemoteServiceErrorInfo {
    /** Error code. */
    code?: string | undefined;
    /** Error message. */
    message?: string | undefined;
    /** Error details. */
    details?: string | undefined;
    /** Error data. */
    data?: any[] | undefined;
    /** Validation errors if exists. */
    validationErrors?: RemoteServiceValidationErrorInfo[] | undefined;
}

/** Used to store information about a validation error. */
export class RemoteServiceValidationErrorInfo implements IRemoteServiceValidationErrorInfo {
    /** Validation error message. */
    message?: string;
    /** Relate invalid members (fields/properties). */
    members?: string[];

    constructor(data?: IRemoteServiceValidationErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(item);
            }
        }
    }

    static fromJS(data: any): RemoteServiceValidationErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteServiceValidationErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data;
    }

    clone(): RemoteServiceValidationErrorInfo {
        const json = this.toJSON();
        let result = new RemoteServiceValidationErrorInfo();
        result.init(json);
        return result;
    }
}

/** Used to store information about a validation error. */
export interface IRemoteServiceValidationErrorInfo {
    /** Validation error message. */
    message?: string;
    /** Relate invalid members (fields/properties). */
    members?: string[];
}

export class RegisterDto extends ExtensibleObject implements IRegisterDto {
    userName!: string;
    emailAddress!: string;
    password!: string;
    appName!: string;

    constructor(data?: IRegisterDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.appName = _data["appName"];
        }
    }

    static fromJS(data: any): RegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["appName"] = this.appName;
        super.toJSON(data);
        return data;
    }

    clone(): RegisterDto {
        const json = this.toJSON();
        let result = new RegisterDto();
        result.init(json);
        return result;
    }
}

export interface IRegisterDto extends IExtensibleObject {
    userName: string;
    emailAddress: string;
    password: string;
    appName: string;
}

export class SendPasswordResetCodeDto implements ISendPasswordResetCodeDto {
    email!: string;
    appName!: string;
    returnUrl?: string | undefined;
    returnUrlHash?: string | undefined;

    constructor(data?: ISendPasswordResetCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.appName = _data["appName"];
            this.returnUrl = _data["returnUrl"];
            this.returnUrlHash = _data["returnUrlHash"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["appName"] = this.appName;
        data["returnUrl"] = this.returnUrl;
        data["returnUrlHash"] = this.returnUrlHash;
        return data;
    }

    clone(): SendPasswordResetCodeDto {
        const json = this.toJSON();
        let result = new SendPasswordResetCodeDto();
        result.init(json);
        return result;
    }
}

export interface ISendPasswordResetCodeDto {
    email: string;
    appName: string;
    returnUrl?: string | undefined;
    returnUrlHash?: string | undefined;
}

export class VerifyPasswordResetTokenInput implements IVerifyPasswordResetTokenInput {
    userId?: string;
    resetToken!: string;

    constructor(data?: IVerifyPasswordResetTokenInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetToken = _data["resetToken"];
        }
    }

    static fromJS(data: any): VerifyPasswordResetTokenInput {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyPasswordResetTokenInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetToken"] = this.resetToken;
        return data;
    }

    clone(): VerifyPasswordResetTokenInput {
        const json = this.toJSON();
        let result = new VerifyPasswordResetTokenInput();
        result.init(json);
        return result;
    }
}

export interface IVerifyPasswordResetTokenInput {
    userId?: string;
    resetToken: string;
}

export class ResetPasswordDto implements IResetPasswordDto {
    userId?: string;
    resetToken!: string;
    password!: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetToken = _data["resetToken"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetToken"] = this.resetToken;
        data["password"] = this.password;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    userId?: string;
    resetToken: string;
    password: string;
}

export class AbpLoginResult implements IAbpLoginResult {
    result?: LoginResultType;
    description?: string | undefined;

    constructor(data?: IAbpLoginResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AbpLoginResult {
        data = typeof data === 'object' ? data : {};
        let result = new AbpLoginResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["description"] = this.description;
        return data;
    }

    clone(): AbpLoginResult {
        const json = this.toJSON();
        let result = new AbpLoginResult();
        result.init(json);
        return result;
    }
}

export interface IAbpLoginResult {
    result?: LoginResultType;
    description?: string | undefined;
}

export enum LoginResultType {
    Success = 1,
    InvalidUserNameOrPassword = 2,
    NotAllowed = 3,
    LockedOut = 4,
    RequiresTwoFactor = 5,
}

export class UserLoginInfo implements IUserLoginInfo {
    userNameOrEmailAddress!: string;
    password!: string;
    rememberMe?: boolean;

    constructor(data?: IUserLoginInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberMe = _data["rememberMe"];
        }
    }

    static fromJS(data: any): UserLoginInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberMe"] = this.rememberMe;
        return data;
    }

    clone(): UserLoginInfo {
        const json = this.toJSON();
        let result = new UserLoginInfo();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfo {
    userNameOrEmailAddress: string;
    password: string;
    rememberMe?: boolean;
}

export class ProfileDto extends ExtensibleObject implements IProfileDto {
    userName?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    phoneNumber?: string | undefined;
    isExternal?: boolean;
    hasPassword?: boolean;
    concurrencyStamp?: string | undefined;

    constructor(data?: IProfileDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.isExternal = _data["isExternal"];
            this.hasPassword = _data["hasPassword"];
            this.concurrencyStamp = _data["concurrencyStamp"];
        }
    }

    static fromJS(data: any): ProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["isExternal"] = this.isExternal;
        data["hasPassword"] = this.hasPassword;
        data["concurrencyStamp"] = this.concurrencyStamp;
        super.toJSON(data);
        return data;
    }

    clone(): ProfileDto {
        const json = this.toJSON();
        let result = new ProfileDto();
        result.init(json);
        return result;
    }
}

export interface IProfileDto extends IExtensibleObject {
    userName?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    phoneNumber?: string | undefined;
    isExternal?: boolean;
    hasPassword?: boolean;
    concurrencyStamp?: string | undefined;
}

export class UpdateProfileDto extends ExtensibleObject implements IUpdateProfileDto {
    userName?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    phoneNumber?: string | undefined;
    concurrencyStamp?: string | undefined;

    constructor(data?: IUpdateProfileDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.concurrencyStamp = _data["concurrencyStamp"];
        }
    }

    static fromJS(data: any): UpdateProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["concurrencyStamp"] = this.concurrencyStamp;
        super.toJSON(data);
        return data;
    }

    clone(): UpdateProfileDto {
        const json = this.toJSON();
        let result = new UpdateProfileDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateProfileDto extends IExtensibleObject {
    userName?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    phoneNumber?: string | undefined;
    concurrencyStamp?: string | undefined;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword?: string | undefined;
    newPassword!: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordInput {
        const json = this.toJSON();
        let result = new ChangePasswordInput();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordInput {
    currentPassword?: string | undefined;
    newPassword: string;
}

export class FindTenantResultDto implements IFindTenantResultDto {
    success?: boolean;
    tenantId?: string | undefined;
    name?: string | undefined;
    normalizedName?: string | undefined;
    isActive?: boolean;

    constructor(data?: IFindTenantResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): FindTenantResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FindTenantResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): FindTenantResultDto {
        const json = this.toJSON();
        let result = new FindTenantResultDto();
        result.init(json);
        return result;
    }
}

export interface IFindTenantResultDto {
    success?: boolean;
    tenantId?: string | undefined;
    name?: string | undefined;
    normalizedName?: string | undefined;
    isActive?: boolean;
}

export class ListResultDtoOfIdentityRoleDto implements IListResultDtoOfIdentityRoleDto {
    /** List of items. */
    items?: IdentityRoleDto[];

    constructor(data?: IListResultDtoOfIdentityRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IdentityRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfIdentityRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfIdentityRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfIdentityRoleDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfIdentityRoleDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfIdentityRoleDto {
    /** List of items. */
    items?: IdentityRoleDto[];
}

export class IdentityRoleDto extends ExtensibleEntityDtoOfGuid implements IIdentityRoleDto {
    name?: string | undefined;
    isDefault?: boolean;
    isStatic?: boolean;
    isPublic?: boolean;
    concurrencyStamp?: string | undefined;

    constructor(data?: IIdentityRoleDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
            this.isStatic = _data["isStatic"];
            this.isPublic = _data["isPublic"];
            this.concurrencyStamp = _data["concurrencyStamp"];
        }
    }

    static fromJS(data: any): IdentityRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["isStatic"] = this.isStatic;
        data["isPublic"] = this.isPublic;
        data["concurrencyStamp"] = this.concurrencyStamp;
        super.toJSON(data);
        return data;
    }

    clone(): IdentityRoleDto {
        const json = this.toJSON();
        let result = new IdentityRoleDto();
        result.init(json);
        return result;
    }
}

export interface IIdentityRoleDto extends IExtensibleEntityDtoOfGuid {
    name?: string | undefined;
    isDefault?: boolean;
    isStatic?: boolean;
    isPublic?: boolean;
    concurrencyStamp?: string | undefined;
}

/** Implements IPagedResult`1. */
export class PagedResultDtoOfIdentityRoleDto extends ListResultDtoOfIdentityRoleDto implements IPagedResultDtoOfIdentityRoleDto {
    /** Total count of Items. */
    totalCount?: number;

    constructor(data?: IPagedResultDtoOfIdentityRoleDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfIdentityRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfIdentityRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultDtoOfIdentityRoleDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfIdentityRoleDto();
        result.init(json);
        return result;
    }
}

/** Implements IPagedResult`1. */
export interface IPagedResultDtoOfIdentityRoleDto extends IListResultDtoOfIdentityRoleDto {
    /** Total count of Items. */
    totalCount?: number;
}

export class IdentityRoleCreateOrUpdateDtoBase extends ExtensibleObject implements IIdentityRoleCreateOrUpdateDtoBase {
    name!: string;
    isDefault?: boolean;
    isPublic?: boolean;

    constructor(data?: IIdentityRoleCreateOrUpdateDtoBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): IdentityRoleCreateOrUpdateDtoBase {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityRoleCreateOrUpdateDtoBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["isPublic"] = this.isPublic;
        super.toJSON(data);
        return data;
    }

    clone(): IdentityRoleCreateOrUpdateDtoBase {
        const json = this.toJSON();
        let result = new IdentityRoleCreateOrUpdateDtoBase();
        result.init(json);
        return result;
    }
}

export interface IIdentityRoleCreateOrUpdateDtoBase extends IExtensibleObject {
    name: string;
    isDefault?: boolean;
    isPublic?: boolean;
}

export class IdentityRoleCreateDto extends IdentityRoleCreateOrUpdateDtoBase implements IIdentityRoleCreateDto {

    constructor(data?: IIdentityRoleCreateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): IdentityRoleCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityRoleCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): IdentityRoleCreateDto {
        const json = this.toJSON();
        let result = new IdentityRoleCreateDto();
        result.init(json);
        return result;
    }
}

export interface IIdentityRoleCreateDto extends IIdentityRoleCreateOrUpdateDtoBase {
}

export class IdentityRoleUpdateDto extends IdentityRoleCreateOrUpdateDtoBase implements IIdentityRoleUpdateDto {
    concurrencyStamp?: string | undefined;

    constructor(data?: IIdentityRoleUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.concurrencyStamp = _data["concurrencyStamp"];
        }
    }

    static fromJS(data: any): IdentityRoleUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityRoleUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["concurrencyStamp"] = this.concurrencyStamp;
        super.toJSON(data);
        return data;
    }

    clone(): IdentityRoleUpdateDto {
        const json = this.toJSON();
        let result = new IdentityRoleUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IIdentityRoleUpdateDto extends IIdentityRoleCreateOrUpdateDtoBase {
    concurrencyStamp?: string | undefined;
}

export class ListResultDtoOfIdentityUserDto implements IListResultDtoOfIdentityUserDto {
    /** List of items. */
    items?: IdentityUserDto[];

    constructor(data?: IListResultDtoOfIdentityUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IdentityUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfIdentityUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfIdentityUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfIdentityUserDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfIdentityUserDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfIdentityUserDto {
    /** List of items. */
    items?: IdentityUserDto[];
}

/** Implements IPagedResult`1. */
export class PagedResultDtoOfIdentityUserDto extends ListResultDtoOfIdentityUserDto implements IPagedResultDtoOfIdentityUserDto {
    /** Total count of Items. */
    totalCount?: number;

    constructor(data?: IPagedResultDtoOfIdentityUserDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfIdentityUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfIdentityUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultDtoOfIdentityUserDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfIdentityUserDto();
        result.init(json);
        return result;
    }
}

/** Implements IPagedResult`1. */
export interface IPagedResultDtoOfIdentityUserDto extends IListResultDtoOfIdentityUserDto {
    /** Total count of Items. */
    totalCount?: number;
}

export abstract class IdentityUserCreateOrUpdateDtoBase extends ExtensibleObject implements IIdentityUserCreateOrUpdateDtoBase {
    userName!: string;
    name?: string | undefined;
    surname?: string | undefined;
    email!: string;
    phoneNumber?: string | undefined;
    isActive?: boolean;
    lockoutEnabled?: boolean;
    roleNames?: string[] | undefined;

    constructor(data?: IIdentityUserCreateOrUpdateDtoBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            this.lockoutEnabled = _data["lockoutEnabled"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
        }
    }

    static fromJS(data: any): IdentityUserCreateOrUpdateDtoBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IdentityUserCreateOrUpdateDtoBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        data["lockoutEnabled"] = this.lockoutEnabled;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): IdentityUserCreateOrUpdateDtoBase {
        throw new Error("The abstract class 'IdentityUserCreateOrUpdateDtoBase' cannot be instantiated.");
    }
}

export interface IIdentityUserCreateOrUpdateDtoBase extends IExtensibleObject {
    userName: string;
    name?: string | undefined;
    surname?: string | undefined;
    email: string;
    phoneNumber?: string | undefined;
    isActive?: boolean;
    lockoutEnabled?: boolean;
    roleNames?: string[] | undefined;
}

export class IdentityUserCreateDto extends IdentityUserCreateOrUpdateDtoBase implements IIdentityUserCreateDto {
    password!: string;

    constructor(data?: IIdentityUserCreateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): IdentityUserCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        super.toJSON(data);
        return data;
    }

    clone(): IdentityUserCreateDto {
        const json = this.toJSON();
        let result = new IdentityUserCreateDto();
        result.init(json);
        return result;
    }
}

export interface IIdentityUserCreateDto extends IIdentityUserCreateOrUpdateDtoBase {
    password: string;
}

export class IdentityUserUpdateDto extends IdentityUserCreateOrUpdateDtoBase implements IIdentityUserUpdateDto {
    password?: string | undefined;
    concurrencyStamp?: string | undefined;

    constructor(data?: IIdentityUserUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.password = _data["password"];
            this.concurrencyStamp = _data["concurrencyStamp"];
        }
    }

    static fromJS(data: any): IdentityUserUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["concurrencyStamp"] = this.concurrencyStamp;
        super.toJSON(data);
        return data;
    }

    clone(): IdentityUserUpdateDto {
        const json = this.toJSON();
        let result = new IdentityUserUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IIdentityUserUpdateDto extends IIdentityUserCreateOrUpdateDtoBase {
    password?: string | undefined;
    concurrencyStamp?: string | undefined;
}

export class IdentityUserUpdateRolesDto implements IIdentityUserUpdateRolesDto {
    roleNames!: string[];

    constructor(data?: IIdentityUserUpdateRolesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
        }
    }

    static fromJS(data: any): IdentityUserUpdateRolesDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserUpdateRolesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data;
    }

    clone(): IdentityUserUpdateRolesDto {
        const json = this.toJSON();
        let result = new IdentityUserUpdateRolesDto();
        result.init(json);
        return result;
    }
}

export interface IIdentityUserUpdateRolesDto {
    roleNames: string[];
}

export class UserData implements IUserData {
    id?: string;
    tenantId?: string | undefined;
    userName?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    isActive?: boolean;
    email?: string | undefined;
    emailConfirmed?: boolean;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    extraProperties?: ExtraPropertyDictionary | undefined;

    constructor(data?: IUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.isActive = _data["isActive"];
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.extraProperties = _data["extraProperties"] ? ExtraPropertyDictionary.fromJS(_data["extraProperties"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserData {
        data = typeof data === 'object' ? data : {};
        let result = new UserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["isActive"] = this.isActive;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["extraProperties"] = this.extraProperties ? this.extraProperties.toJSON() : <any>undefined;
        return data;
    }

    clone(): UserData {
        const json = this.toJSON();
        let result = new UserData();
        result.init(json);
        return result;
    }
}

export interface IUserData {
    id?: string;
    tenantId?: string | undefined;
    userName?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    isActive?: boolean;
    email?: string | undefined;
    emailConfirmed?: boolean;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    extraProperties?: ExtraPropertyDictionary | undefined;
}

export class ListResultDtoOfUserData implements IListResultDtoOfUserData {
    /** List of items. */
    items?: UserData[];

    constructor(data?: IListResultDtoOfUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserData {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfUserData {
        const json = this.toJSON();
        let result = new ListResultDtoOfUserData();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfUserData {
    /** List of items. */
    items?: UserData[];
}

export class TenantDto extends ExtensibleEntityDtoOfGuid implements ITenantDto {
    name?: string | undefined;
    concurrencyStamp?: string | undefined;

    constructor(data?: ITenantDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.concurrencyStamp = _data["concurrencyStamp"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["concurrencyStamp"] = this.concurrencyStamp;
        super.toJSON(data);
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto extends IExtensibleEntityDtoOfGuid {
    name?: string | undefined;
    concurrencyStamp?: string | undefined;
}

export class ListResultDtoOfTenantDto implements IListResultDtoOfTenantDto {
    /** List of items. */
    items?: TenantDto[];

    constructor(data?: IListResultDtoOfTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): ListResultDtoOfTenantDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfTenantDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfTenantDto {
    /** List of items. */
    items?: TenantDto[];
}

/** Implements IPagedResult`1. */
export class PagedResultDtoOfTenantDto extends ListResultDtoOfTenantDto implements IPagedResultDtoOfTenantDto {
    /** Total count of Items. */
    totalCount?: number;

    constructor(data?: IPagedResultDtoOfTenantDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        super.toJSON(data);
        return data;
    }

    clone(): PagedResultDtoOfTenantDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTenantDto();
        result.init(json);
        return result;
    }
}

/** Implements IPagedResult`1. */
export interface IPagedResultDtoOfTenantDto extends IListResultDtoOfTenantDto {
    /** Total count of Items. */
    totalCount?: number;
}

export abstract class TenantCreateOrUpdateDtoBase extends ExtensibleObject implements ITenantCreateOrUpdateDtoBase {
    name!: string;

    constructor(data?: ITenantCreateOrUpdateDtoBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantCreateOrUpdateDtoBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TenantCreateOrUpdateDtoBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }

    clone(): TenantCreateOrUpdateDtoBase {
        throw new Error("The abstract class 'TenantCreateOrUpdateDtoBase' cannot be instantiated.");
    }
}

export interface ITenantCreateOrUpdateDtoBase extends IExtensibleObject {
    name: string;
}

export class TenantCreateDto extends TenantCreateOrUpdateDtoBase implements ITenantCreateDto {
    adminEmailAddress!: string;
    adminPassword!: string;

    constructor(data?: ITenantCreateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
        }
    }

    static fromJS(data: any): TenantCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        super.toJSON(data);
        return data;
    }

    clone(): TenantCreateDto {
        const json = this.toJSON();
        let result = new TenantCreateDto();
        result.init(json);
        return result;
    }
}

export interface ITenantCreateDto extends ITenantCreateOrUpdateDtoBase {
    adminEmailAddress: string;
    adminPassword: string;
}

export class TenantUpdateDto extends TenantCreateOrUpdateDtoBase implements ITenantUpdateDto {
    concurrencyStamp?: string | undefined;

    constructor(data?: ITenantUpdateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.concurrencyStamp = _data["concurrencyStamp"];
        }
    }

    static fromJS(data: any): TenantUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["concurrencyStamp"] = this.concurrencyStamp;
        super.toJSON(data);
        return data;
    }

    clone(): TenantUpdateDto {
        const json = this.toJSON();
        let result = new TenantUpdateDto();
        result.init(json);
        return result;
    }
}

export interface ITenantUpdateDto extends ITenantCreateOrUpdateDtoBase {
    concurrencyStamp?: string | undefined;
}

export class GetFeatureListResultDto implements IGetFeatureListResultDto {
    groups?: FeatureGroupDto[] | undefined;

    constructor(data?: IGetFeatureListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(FeatureGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFeatureListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeatureListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetFeatureListResultDto {
        const json = this.toJSON();
        let result = new GetFeatureListResultDto();
        result.init(json);
        return result;
    }
}

export interface IGetFeatureListResultDto {
    groups?: FeatureGroupDto[] | undefined;
}

export class FeatureGroupDto implements IFeatureGroupDto {
    name?: string | undefined;
    displayName?: string | undefined;
    features?: FeatureDto[] | undefined;

    constructor(data?: IFeatureGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeatureGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }

    clone(): FeatureGroupDto {
        const json = this.toJSON();
        let result = new FeatureGroupDto();
        result.init(json);
        return result;
    }
}

export interface IFeatureGroupDto {
    name?: string | undefined;
    displayName?: string | undefined;
    features?: FeatureDto[] | undefined;
}

export class FeatureDto implements IFeatureDto {
    name?: string | undefined;
    displayName?: string | undefined;
    value?: string | undefined;
    provider?: FeatureProviderDto | undefined;
    description?: string | undefined;
    valueType?: IStringValueType | undefined;
    depth?: number;
    parentName?: string | undefined;

    constructor(data?: IFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.value = _data["value"];
            this.provider = _data["provider"] ? FeatureProviderDto.fromJS(_data["provider"]) : <any>undefined;
            this.description = _data["description"];
            this.valueType = _data["valueType"] ? IStringValueType.fromJS(_data["valueType"]) : <any>undefined;
            this.depth = _data["depth"];
            this.parentName = _data["parentName"];
        }
    }

    static fromJS(data: any): FeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["value"] = this.value;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["valueType"] = this.valueType ? this.valueType.toJSON() : <any>undefined;
        data["depth"] = this.depth;
        data["parentName"] = this.parentName;
        return data;
    }

    clone(): FeatureDto {
        const json = this.toJSON();
        let result = new FeatureDto();
        result.init(json);
        return result;
    }
}

export interface IFeatureDto {
    name?: string | undefined;
    displayName?: string | undefined;
    value?: string | undefined;
    provider?: FeatureProviderDto | undefined;
    description?: string | undefined;
    valueType?: IStringValueType | undefined;
    depth?: number;
    parentName?: string | undefined;
}

export class FeatureProviderDto implements IFeatureProviderDto {
    name?: string | undefined;
    key?: string | undefined;

    constructor(data?: IFeatureProviderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): FeatureProviderDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureProviderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["key"] = this.key;
        return data;
    }

    clone(): FeatureProviderDto {
        const json = this.toJSON();
        let result = new FeatureProviderDto();
        result.init(json);
        return result;
    }
}

export interface IFeatureProviderDto {
    name?: string | undefined;
    key?: string | undefined;
}

export abstract class IStringValueType implements IIStringValueType {
    name?: string;
    properties?: { [key: string]: any; };
    validator?: IValueValidator;

    constructor(data?: IIStringValueType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IStringValueType {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IStringValueType' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data;
    }

    clone(): IStringValueType {
        throw new Error("The abstract class 'IStringValueType' cannot be instantiated.");
    }
}

export interface IIStringValueType {
    name?: string;
    properties?: { [key: string]: any; };
    validator?: IValueValidator;
}

export abstract class IValueValidator implements IIValueValidator {
    name?: string;
    properties?: { [key: string]: any; };

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IValueValidator' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        return data;
    }

    clone(): IValueValidator {
        throw new Error("The abstract class 'IValueValidator' cannot be instantiated.");
    }
}

export interface IIValueValidator {
    name?: string;
    properties?: { [key: string]: any; };
}

export class UpdateFeaturesDto implements IUpdateFeaturesDto {
    features?: UpdateFeatureDto[] | undefined;

    constructor(data?: IUpdateFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(UpdateFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateFeaturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateFeaturesDto {
        const json = this.toJSON();
        let result = new UpdateFeaturesDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFeaturesDto {
    features?: UpdateFeatureDto[] | undefined;
}

export class UpdateFeatureDto implements IUpdateFeatureDto {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IUpdateFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): UpdateFeatureDto {
        const json = this.toJSON();
        let result = new UpdateFeatureDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFeatureDto {
    name?: string | undefined;
    value?: string | undefined;
}

export class ApplicationConfigurationDto implements IApplicationConfigurationDto {
    localization?: ApplicationLocalizationConfigurationDto;
    auth?: ApplicationAuthConfigurationDto;
    setting?: ApplicationSettingConfigurationDto;
    currentUser?: CurrentUserDto;
    features?: ApplicationFeatureConfigurationDto;
    globalFeatures?: ApplicationGlobalFeatureConfigurationDto;
    multiTenancy?: MultiTenancyInfoDto;
    currentTenant?: CurrentTenantDto;
    timing?: TimingDto;
    clock?: ClockDto;
    objectExtensions?: ObjectExtensionsDto;
    extraProperties?: ExtraPropertyDictionary;

    constructor(data?: IApplicationConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localization = _data["localization"] ? ApplicationLocalizationConfigurationDto.fromJS(_data["localization"]) : <any>undefined;
            this.auth = _data["auth"] ? ApplicationAuthConfigurationDto.fromJS(_data["auth"]) : <any>undefined;
            this.setting = _data["setting"] ? ApplicationSettingConfigurationDto.fromJS(_data["setting"]) : <any>undefined;
            this.currentUser = _data["currentUser"] ? CurrentUserDto.fromJS(_data["currentUser"]) : <any>undefined;
            this.features = _data["features"] ? ApplicationFeatureConfigurationDto.fromJS(_data["features"]) : <any>undefined;
            this.globalFeatures = _data["globalFeatures"] ? ApplicationGlobalFeatureConfigurationDto.fromJS(_data["globalFeatures"]) : <any>undefined;
            this.multiTenancy = _data["multiTenancy"] ? MultiTenancyInfoDto.fromJS(_data["multiTenancy"]) : <any>undefined;
            this.currentTenant = _data["currentTenant"] ? CurrentTenantDto.fromJS(_data["currentTenant"]) : <any>undefined;
            this.timing = _data["timing"] ? TimingDto.fromJS(_data["timing"]) : <any>undefined;
            this.clock = _data["clock"] ? ClockDto.fromJS(_data["clock"]) : <any>undefined;
            this.objectExtensions = _data["objectExtensions"] ? ObjectExtensionsDto.fromJS(_data["objectExtensions"]) : <any>undefined;
            this.extraProperties = _data["extraProperties"] ? ExtraPropertyDictionary.fromJS(_data["extraProperties"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localization"] = this.localization ? this.localization.toJSON() : <any>undefined;
        data["auth"] = this.auth ? this.auth.toJSON() : <any>undefined;
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        data["currentUser"] = this.currentUser ? this.currentUser.toJSON() : <any>undefined;
        data["features"] = this.features ? this.features.toJSON() : <any>undefined;
        data["globalFeatures"] = this.globalFeatures ? this.globalFeatures.toJSON() : <any>undefined;
        data["multiTenancy"] = this.multiTenancy ? this.multiTenancy.toJSON() : <any>undefined;
        data["currentTenant"] = this.currentTenant ? this.currentTenant.toJSON() : <any>undefined;
        data["timing"] = this.timing ? this.timing.toJSON() : <any>undefined;
        data["clock"] = this.clock ? this.clock.toJSON() : <any>undefined;
        data["objectExtensions"] = this.objectExtensions ? this.objectExtensions.toJSON() : <any>undefined;
        data["extraProperties"] = this.extraProperties ? this.extraProperties.toJSON() : <any>undefined;
        return data;
    }

    clone(): ApplicationConfigurationDto {
        const json = this.toJSON();
        let result = new ApplicationConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationConfigurationDto {
    localization?: ApplicationLocalizationConfigurationDto;
    auth?: ApplicationAuthConfigurationDto;
    setting?: ApplicationSettingConfigurationDto;
    currentUser?: CurrentUserDto;
    features?: ApplicationFeatureConfigurationDto;
    globalFeatures?: ApplicationGlobalFeatureConfigurationDto;
    multiTenancy?: MultiTenancyInfoDto;
    currentTenant?: CurrentTenantDto;
    timing?: TimingDto;
    clock?: ClockDto;
    objectExtensions?: ObjectExtensionsDto;
    extraProperties?: ExtraPropertyDictionary;
}

export class ApplicationLocalizationConfigurationDto implements IApplicationLocalizationConfigurationDto {
    /** This is not filled if IncludeLocalizationResources is false. */
    values?: { [key: string]: { [key: string]: string; }; };
    /** This property will never be filled by the application configuration endpoint
(by AbpApplicationConfigurationAppService). However, it is here to be filled
using the application localization endpoint (AbpApplicationLocalizationAppService).
This is an ugly design, but it is the best solution for backward-compability and
simple implementation.

It's client's responsibility to fill this property
using the application localization endpoint. */
    resources?: { [key: string]: ApplicationLocalizationResourceDto; };
    languages?: LanguageInfo[];
    currentCulture?: CurrentCultureDto;
    defaultResourceName?: string | undefined;
    languagesMap?: { [key: string]: NameValue[]; };
    languageFilesMap?: { [key: string]: NameValue[]; };

    constructor(data?: IApplicationLocalizationConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key] !== undefined ? _data["values"][key] : {};
                }
            }
            if (_data["resources"]) {
                this.resources = {} as any;
                for (let key in _data["resources"]) {
                    if (_data["resources"].hasOwnProperty(key))
                        (<any>this.resources)![key] = _data["resources"][key] ? ApplicationLocalizationResourceDto.fromJS(_data["resources"][key]) : new ApplicationLocalizationResourceDto();
                }
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LanguageInfo.fromJS(item));
            }
            this.currentCulture = _data["currentCulture"] ? CurrentCultureDto.fromJS(_data["currentCulture"]) : <any>undefined;
            this.defaultResourceName = _data["defaultResourceName"];
            if (_data["languagesMap"]) {
                this.languagesMap = {} as any;
                for (let key in _data["languagesMap"]) {
                    if (_data["languagesMap"].hasOwnProperty(key))
                        (<any>this.languagesMap)![key] = _data["languagesMap"][key] ? _data["languagesMap"][key].map((i: any) => NameValue.fromJS(i)) : [];
                }
            }
            if (_data["languageFilesMap"]) {
                this.languageFilesMap = {} as any;
                for (let key in _data["languageFilesMap"]) {
                    if (_data["languageFilesMap"].hasOwnProperty(key))
                        (<any>this.languageFilesMap)![key] = _data["languageFilesMap"][key] ? _data["languageFilesMap"][key].map((i: any) => NameValue.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationLocalizationConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLocalizationConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = (<any>this.values)[key];
            }
        }
        if (this.resources) {
            data["resources"] = {};
            for (let key in this.resources) {
                if (this.resources.hasOwnProperty(key))
                    (<any>data["resources"])[key] = this.resources[key] ? this.resources[key].toJSON() : <any>undefined;
            }
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        data["currentCulture"] = this.currentCulture ? this.currentCulture.toJSON() : <any>undefined;
        data["defaultResourceName"] = this.defaultResourceName;
        if (this.languagesMap) {
            data["languagesMap"] = {};
            for (let key in this.languagesMap) {
                if (this.languagesMap.hasOwnProperty(key))
                    (<any>data["languagesMap"])[key] = (<any>this.languagesMap)[key];
            }
        }
        if (this.languageFilesMap) {
            data["languageFilesMap"] = {};
            for (let key in this.languageFilesMap) {
                if (this.languageFilesMap.hasOwnProperty(key))
                    (<any>data["languageFilesMap"])[key] = (<any>this.languageFilesMap)[key];
            }
        }
        return data;
    }

    clone(): ApplicationLocalizationConfigurationDto {
        const json = this.toJSON();
        let result = new ApplicationLocalizationConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationLocalizationConfigurationDto {
    /** This is not filled if IncludeLocalizationResources is false. */
    values?: { [key: string]: { [key: string]: string; }; };
    /** This property will never be filled by the application configuration endpoint
(by AbpApplicationConfigurationAppService). However, it is here to be filled
using the application localization endpoint (AbpApplicationLocalizationAppService).
This is an ugly design, but it is the best solution for backward-compability and
simple implementation.

It's client's responsibility to fill this property
using the application localization endpoint. */
    resources?: { [key: string]: ApplicationLocalizationResourceDto; };
    languages?: LanguageInfo[];
    currentCulture?: CurrentCultureDto;
    defaultResourceName?: string | undefined;
    languagesMap?: { [key: string]: NameValue[]; };
    languageFilesMap?: { [key: string]: NameValue[]; };
}

export class ApplicationLocalizationResourceDto implements IApplicationLocalizationResourceDto {
    texts?: { [key: string]: string; };
    baseResources?: string[];

    constructor(data?: IApplicationLocalizationResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["texts"]) {
                this.texts = {} as any;
                for (let key in _data["texts"]) {
                    if (_data["texts"].hasOwnProperty(key))
                        (<any>this.texts)![key] = _data["texts"][key];
                }
            }
            if (Array.isArray(_data["baseResources"])) {
                this.baseResources = [] as any;
                for (let item of _data["baseResources"])
                    this.baseResources!.push(item);
            }
        }
    }

    static fromJS(data: any): ApplicationLocalizationResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLocalizationResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.texts) {
            data["texts"] = {};
            for (let key in this.texts) {
                if (this.texts.hasOwnProperty(key))
                    (<any>data["texts"])[key] = (<any>this.texts)[key];
            }
        }
        if (Array.isArray(this.baseResources)) {
            data["baseResources"] = [];
            for (let item of this.baseResources)
                data["baseResources"].push(item);
        }
        return data;
    }

    clone(): ApplicationLocalizationResourceDto {
        const json = this.toJSON();
        let result = new ApplicationLocalizationResourceDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationLocalizationResourceDto {
    texts?: { [key: string]: string; };
    baseResources?: string[];
}

export class LanguageInfo implements ILanguageInfo {
    cultureName?: string;
    uiCultureName?: string;
    displayName?: string;
    twoLetterISOLanguageName?: string;

    constructor(data?: ILanguageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureName = _data["cultureName"];
            this.uiCultureName = _data["uiCultureName"];
            this.displayName = _data["displayName"];
            this.twoLetterISOLanguageName = _data["twoLetterISOLanguageName"];
        }
    }

    static fromJS(data: any): LanguageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureName"] = this.cultureName;
        data["uiCultureName"] = this.uiCultureName;
        data["displayName"] = this.displayName;
        data["twoLetterISOLanguageName"] = this.twoLetterISOLanguageName;
        return data;
    }

    clone(): LanguageInfo {
        const json = this.toJSON();
        let result = new LanguageInfo();
        result.init(json);
        return result;
    }
}

export interface ILanguageInfo {
    cultureName?: string;
    uiCultureName?: string;
    displayName?: string;
    twoLetterISOLanguageName?: string;
}

export class CurrentCultureDto implements ICurrentCultureDto {
    displayName?: string;
    englishName?: string;
    threeLetterIsoLanguageName?: string;
    twoLetterIsoLanguageName?: string;
    isRightToLeft?: boolean;
    cultureName?: string;
    name?: string;
    nativeName?: string;
    dateTimeFormat?: DateTimeFormatDto;

    constructor(data?: ICurrentCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.englishName = _data["englishName"];
            this.threeLetterIsoLanguageName = _data["threeLetterIsoLanguageName"];
            this.twoLetterIsoLanguageName = _data["twoLetterIsoLanguageName"];
            this.isRightToLeft = _data["isRightToLeft"];
            this.cultureName = _data["cultureName"];
            this.name = _data["name"];
            this.nativeName = _data["nativeName"];
            this.dateTimeFormat = _data["dateTimeFormat"] ? DateTimeFormatDto.fromJS(_data["dateTimeFormat"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CurrentCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["englishName"] = this.englishName;
        data["threeLetterIsoLanguageName"] = this.threeLetterIsoLanguageName;
        data["twoLetterIsoLanguageName"] = this.twoLetterIsoLanguageName;
        data["isRightToLeft"] = this.isRightToLeft;
        data["cultureName"] = this.cultureName;
        data["name"] = this.name;
        data["nativeName"] = this.nativeName;
        data["dateTimeFormat"] = this.dateTimeFormat ? this.dateTimeFormat.toJSON() : <any>undefined;
        return data;
    }

    clone(): CurrentCultureDto {
        const json = this.toJSON();
        let result = new CurrentCultureDto();
        result.init(json);
        return result;
    }
}

export interface ICurrentCultureDto {
    displayName?: string;
    englishName?: string;
    threeLetterIsoLanguageName?: string;
    twoLetterIsoLanguageName?: string;
    isRightToLeft?: boolean;
    cultureName?: string;
    name?: string;
    nativeName?: string;
    dateTimeFormat?: DateTimeFormatDto;
}

export class DateTimeFormatDto implements IDateTimeFormatDto {
    calendarAlgorithmType?: string;
    dateTimeFormatLong?: string;
    shortDatePattern?: string;
    fullDateTimePattern?: string;
    dateSeparator?: string;
    shortTimePattern?: string;
    longTimePattern?: string;

    constructor(data?: IDateTimeFormatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calendarAlgorithmType = _data["calendarAlgorithmType"];
            this.dateTimeFormatLong = _data["dateTimeFormatLong"];
            this.shortDatePattern = _data["shortDatePattern"];
            this.fullDateTimePattern = _data["fullDateTimePattern"];
            this.dateSeparator = _data["dateSeparator"];
            this.shortTimePattern = _data["shortTimePattern"];
            this.longTimePattern = _data["longTimePattern"];
        }
    }

    static fromJS(data: any): DateTimeFormatDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeFormatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarAlgorithmType"] = this.calendarAlgorithmType;
        data["dateTimeFormatLong"] = this.dateTimeFormatLong;
        data["shortDatePattern"] = this.shortDatePattern;
        data["fullDateTimePattern"] = this.fullDateTimePattern;
        data["dateSeparator"] = this.dateSeparator;
        data["shortTimePattern"] = this.shortTimePattern;
        data["longTimePattern"] = this.longTimePattern;
        return data;
    }

    clone(): DateTimeFormatDto {
        const json = this.toJSON();
        let result = new DateTimeFormatDto();
        result.init(json);
        return result;
    }
}

export interface IDateTimeFormatDto {
    calendarAlgorithmType?: string;
    dateTimeFormatLong?: string;
    shortDatePattern?: string;
    fullDateTimePattern?: string;
    dateSeparator?: string;
    shortTimePattern?: string;
    longTimePattern?: string;
}

/** Can be used to store Name/Value (or Key/Value) pairs. */
export class NameValueOfString implements INameValueOfString {
    /** Name. */
    name?: string;
    /** Value. */
    value?: string | undefined;

    constructor(data?: INameValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueOfString {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): NameValueOfString {
        const json = this.toJSON();
        let result = new NameValueOfString();
        result.init(json);
        return result;
    }
}

/** Can be used to store Name/Value (or Key/Value) pairs. */
export interface INameValueOfString {
    /** Name. */
    name?: string;
    /** Value. */
    value?: string | undefined;
}

/** Can be used to store Name/Value (or Key/Value) pairs. */
export class NameValue extends NameValueOfString implements INameValue {

    constructor(data?: INameValue) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): NameValue {
        const json = this.toJSON();
        let result = new NameValue();
        result.init(json);
        return result;
    }
}

/** Can be used to store Name/Value (or Key/Value) pairs. */
export interface INameValue extends INameValueOfString {
}

export class ApplicationAuthConfigurationDto implements IApplicationAuthConfigurationDto {
    grantedPolicies?: { [key: string]: boolean; };

    constructor(data?: IApplicationAuthConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["grantedPolicies"]) {
                this.grantedPolicies = {} as any;
                for (let key in _data["grantedPolicies"]) {
                    if (_data["grantedPolicies"].hasOwnProperty(key))
                        (<any>this.grantedPolicies)![key] = _data["grantedPolicies"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationAuthConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationAuthConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.grantedPolicies) {
            data["grantedPolicies"] = {};
            for (let key in this.grantedPolicies) {
                if (this.grantedPolicies.hasOwnProperty(key))
                    (<any>data["grantedPolicies"])[key] = (<any>this.grantedPolicies)[key];
            }
        }
        return data;
    }

    clone(): ApplicationAuthConfigurationDto {
        const json = this.toJSON();
        let result = new ApplicationAuthConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationAuthConfigurationDto {
    grantedPolicies?: { [key: string]: boolean; };
}

export class ApplicationSettingConfigurationDto implements IApplicationSettingConfigurationDto {
    values?: { [key: string]: string; };

    constructor(data?: IApplicationSettingConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationSettingConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationSettingConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = (<any>this.values)[key];
            }
        }
        return data;
    }

    clone(): ApplicationSettingConfigurationDto {
        const json = this.toJSON();
        let result = new ApplicationSettingConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationSettingConfigurationDto {
    values?: { [key: string]: string; };
}

export class CurrentUserDto implements ICurrentUserDto {
    isAuthenticated?: boolean;
    id?: string | undefined;
    tenantId?: string | undefined;
    impersonatorUserId?: string | undefined;
    impersonatorTenantId?: string | undefined;
    impersonatorUserName?: string | undefined;
    impersonatorTenantName?: string | undefined;
    userName?: string | undefined;
    name?: string | undefined;
    surName?: string | undefined;
    email?: string | undefined;
    emailVerified?: boolean;
    phoneNumber?: string | undefined;
    phoneNumberVerified?: boolean;
    roles?: string[];
    sessionId?: string | undefined;

    constructor(data?: ICurrentUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthenticated = _data["isAuthenticated"];
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.impersonatorUserName = _data["impersonatorUserName"];
            this.impersonatorTenantName = _data["impersonatorTenantName"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surName = _data["surName"];
            this.email = _data["email"];
            this.emailVerified = _data["emailVerified"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberVerified = _data["phoneNumberVerified"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): CurrentUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthenticated"] = this.isAuthenticated;
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserName"] = this.impersonatorUserName;
        data["impersonatorTenantName"] = this.impersonatorTenantName;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surName"] = this.surName;
        data["email"] = this.email;
        data["emailVerified"] = this.emailVerified;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberVerified"] = this.phoneNumberVerified;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["sessionId"] = this.sessionId;
        return data;
    }

    clone(): CurrentUserDto {
        const json = this.toJSON();
        let result = new CurrentUserDto();
        result.init(json);
        return result;
    }
}

export interface ICurrentUserDto {
    isAuthenticated?: boolean;
    id?: string | undefined;
    tenantId?: string | undefined;
    impersonatorUserId?: string | undefined;
    impersonatorTenantId?: string | undefined;
    impersonatorUserName?: string | undefined;
    impersonatorTenantName?: string | undefined;
    userName?: string | undefined;
    name?: string | undefined;
    surName?: string | undefined;
    email?: string | undefined;
    emailVerified?: boolean;
    phoneNumber?: string | undefined;
    phoneNumberVerified?: boolean;
    roles?: string[];
    sessionId?: string | undefined;
}

export class ApplicationFeatureConfigurationDto implements IApplicationFeatureConfigurationDto {
    values?: { [key: string]: string; };

    constructor(data?: IApplicationFeatureConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationFeatureConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationFeatureConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = (<any>this.values)[key];
            }
        }
        return data;
    }

    clone(): ApplicationFeatureConfigurationDto {
        const json = this.toJSON();
        let result = new ApplicationFeatureConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationFeatureConfigurationDto {
    values?: { [key: string]: string; };
}

export class ApplicationGlobalFeatureConfigurationDto implements IApplicationGlobalFeatureConfigurationDto {
    enabledFeatures?: string[];

    constructor(data?: IApplicationGlobalFeatureConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["enabledFeatures"])) {
                this.enabledFeatures = [] as any;
                for (let item of _data["enabledFeatures"])
                    this.enabledFeatures!.push(item);
            }
        }
    }

    static fromJS(data: any): ApplicationGlobalFeatureConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationGlobalFeatureConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.enabledFeatures)) {
            data["enabledFeatures"] = [];
            for (let item of this.enabledFeatures)
                data["enabledFeatures"].push(item);
        }
        return data;
    }

    clone(): ApplicationGlobalFeatureConfigurationDto {
        const json = this.toJSON();
        let result = new ApplicationGlobalFeatureConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationGlobalFeatureConfigurationDto {
    enabledFeatures?: string[];
}

export class MultiTenancyInfoDto implements IMultiTenancyInfoDto {
    isEnabled?: boolean;

    constructor(data?: IMultiTenancyInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): MultiTenancyInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiTenancyInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        return data;
    }

    clone(): MultiTenancyInfoDto {
        const json = this.toJSON();
        let result = new MultiTenancyInfoDto();
        result.init(json);
        return result;
    }
}

export interface IMultiTenancyInfoDto {
    isEnabled?: boolean;
}

export class CurrentTenantDto implements ICurrentTenantDto {
    id?: string | undefined;
    name?: string | undefined;
    isAvailable?: boolean;

    constructor(data?: ICurrentTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): CurrentTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isAvailable"] = this.isAvailable;
        return data;
    }

    clone(): CurrentTenantDto {
        const json = this.toJSON();
        let result = new CurrentTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICurrentTenantDto {
    id?: string | undefined;
    name?: string | undefined;
    isAvailable?: boolean;
}

export class TimingDto implements ITimingDto {
    timeZone?: TimeZone;

    constructor(data?: ITimingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZone = _data["timeZone"] ? TimeZone.fromJS(_data["timeZone"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimingDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : <any>undefined;
        return data;
    }

    clone(): TimingDto {
        const json = this.toJSON();
        let result = new TimingDto();
        result.init(json);
        return result;
    }
}

export interface ITimingDto {
    timeZone?: TimeZone;
}

export class TimeZone implements ITimeZone {
    iana?: IanaTimeZone;
    windows?: WindowsTimeZone;

    constructor(data?: ITimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iana = _data["iana"] ? IanaTimeZone.fromJS(_data["iana"]) : <any>undefined;
            this.windows = _data["windows"] ? WindowsTimeZone.fromJS(_data["windows"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iana"] = this.iana ? this.iana.toJSON() : <any>undefined;
        data["windows"] = this.windows ? this.windows.toJSON() : <any>undefined;
        return data;
    }

    clone(): TimeZone {
        const json = this.toJSON();
        let result = new TimeZone();
        result.init(json);
        return result;
    }
}

export interface ITimeZone {
    iana?: IanaTimeZone;
    windows?: WindowsTimeZone;
}

export class IanaTimeZone implements IIanaTimeZone {
    timeZoneName?: string | undefined;

    constructor(data?: IIanaTimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneName = _data["timeZoneName"];
        }
    }

    static fromJS(data: any): IanaTimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new IanaTimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneName"] = this.timeZoneName;
        return data;
    }

    clone(): IanaTimeZone {
        const json = this.toJSON();
        let result = new IanaTimeZone();
        result.init(json);
        return result;
    }
}

export interface IIanaTimeZone {
    timeZoneName?: string | undefined;
}

export class WindowsTimeZone implements IWindowsTimeZone {
    timeZoneId?: string | undefined;

    constructor(data?: IWindowsTimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneId = _data["timeZoneId"];
        }
    }

    static fromJS(data: any): WindowsTimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new WindowsTimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneId"] = this.timeZoneId;
        return data;
    }

    clone(): WindowsTimeZone {
        const json = this.toJSON();
        let result = new WindowsTimeZone();
        result.init(json);
        return result;
    }
}

export interface IWindowsTimeZone {
    timeZoneId?: string | undefined;
}

export class ClockDto implements IClockDto {
    kind?: string;

    constructor(data?: IClockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
        }
    }

    static fromJS(data: any): ClockDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        return data;
    }

    clone(): ClockDto {
        const json = this.toJSON();
        let result = new ClockDto();
        result.init(json);
        return result;
    }
}

export interface IClockDto {
    kind?: string;
}

export class ObjectExtensionsDto implements IObjectExtensionsDto {
    modules?: { [key: string]: ModuleExtensionDto; };
    enums?: { [key: string]: ExtensionEnumDto; };

    constructor(data?: IObjectExtensionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["modules"]) {
                this.modules = {} as any;
                for (let key in _data["modules"]) {
                    if (_data["modules"].hasOwnProperty(key))
                        (<any>this.modules)![key] = _data["modules"][key] ? ModuleExtensionDto.fromJS(_data["modules"][key]) : new ModuleExtensionDto();
                }
            }
            if (_data["enums"]) {
                this.enums = {} as any;
                for (let key in _data["enums"]) {
                    if (_data["enums"].hasOwnProperty(key))
                        (<any>this.enums)![key] = _data["enums"][key] ? ExtensionEnumDto.fromJS(_data["enums"][key]) : new ExtensionEnumDto();
                }
            }
        }
    }

    static fromJS(data: any): ObjectExtensionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectExtensionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.modules) {
            data["modules"] = {};
            for (let key in this.modules) {
                if (this.modules.hasOwnProperty(key))
                    (<any>data["modules"])[key] = this.modules[key] ? this.modules[key].toJSON() : <any>undefined;
            }
        }
        if (this.enums) {
            data["enums"] = {};
            for (let key in this.enums) {
                if (this.enums.hasOwnProperty(key))
                    (<any>data["enums"])[key] = this.enums[key] ? this.enums[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }

    clone(): ObjectExtensionsDto {
        const json = this.toJSON();
        let result = new ObjectExtensionsDto();
        result.init(json);
        return result;
    }
}

export interface IObjectExtensionsDto {
    modules?: { [key: string]: ModuleExtensionDto; };
    enums?: { [key: string]: ExtensionEnumDto; };
}

export class ModuleExtensionDto implements IModuleExtensionDto {
    entities?: { [key: string]: EntityExtensionDto; };
    configuration?: { [key: string]: any; };

    constructor(data?: IModuleExtensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["entities"]) {
                this.entities = {} as any;
                for (let key in _data["entities"]) {
                    if (_data["entities"].hasOwnProperty(key))
                        (<any>this.entities)![key] = _data["entities"][key] ? EntityExtensionDto.fromJS(_data["entities"][key]) : new EntityExtensionDto();
                }
            }
            if (_data["configuration"]) {
                this.configuration = {} as any;
                for (let key in _data["configuration"]) {
                    if (_data["configuration"].hasOwnProperty(key))
                        (<any>this.configuration)![key] = _data["configuration"][key];
                }
            }
        }
    }

    static fromJS(data: any): ModuleExtensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleExtensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.entities) {
            data["entities"] = {};
            for (let key in this.entities) {
                if (this.entities.hasOwnProperty(key))
                    (<any>data["entities"])[key] = this.entities[key] ? this.entities[key].toJSON() : <any>undefined;
            }
        }
        if (this.configuration) {
            data["configuration"] = {};
            for (let key in this.configuration) {
                if (this.configuration.hasOwnProperty(key))
                    (<any>data["configuration"])[key] = (<any>this.configuration)[key];
            }
        }
        return data;
    }

    clone(): ModuleExtensionDto {
        const json = this.toJSON();
        let result = new ModuleExtensionDto();
        result.init(json);
        return result;
    }
}

export interface IModuleExtensionDto {
    entities?: { [key: string]: EntityExtensionDto; };
    configuration?: { [key: string]: any; };
}

export class EntityExtensionDto implements IEntityExtensionDto {
    properties?: { [key: string]: ExtensionPropertyDto; };
    configuration?: { [key: string]: any; };

    constructor(data?: IEntityExtensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] ? ExtensionPropertyDto.fromJS(_data["properties"][key]) : new ExtensionPropertyDto();
                }
            }
            if (_data["configuration"]) {
                this.configuration = {} as any;
                for (let key in _data["configuration"]) {
                    if (_data["configuration"].hasOwnProperty(key))
                        (<any>this.configuration)![key] = _data["configuration"][key];
                }
            }
        }
    }

    static fromJS(data: any): EntityExtensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityExtensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] ? this.properties[key].toJSON() : <any>undefined;
            }
        }
        if (this.configuration) {
            data["configuration"] = {};
            for (let key in this.configuration) {
                if (this.configuration.hasOwnProperty(key))
                    (<any>data["configuration"])[key] = (<any>this.configuration)[key];
            }
        }
        return data;
    }

    clone(): EntityExtensionDto {
        const json = this.toJSON();
        let result = new EntityExtensionDto();
        result.init(json);
        return result;
    }
}

export interface IEntityExtensionDto {
    properties?: { [key: string]: ExtensionPropertyDto; };
    configuration?: { [key: string]: any; };
}

export class ExtensionPropertyDto implements IExtensionPropertyDto {
    type?: string;
    typeSimple?: string;
    displayName?: LocalizableStringDto | undefined;
    api?: ExtensionPropertyApiDto;
    ui?: ExtensionPropertyUiDto;
    attributes?: ExtensionPropertyAttributeDto[];
    configuration?: { [key: string]: any; };
    defaultValue?: any | undefined;

    constructor(data?: IExtensionPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.typeSimple = _data["typeSimple"];
            this.displayName = _data["displayName"] ? LocalizableStringDto.fromJS(_data["displayName"]) : <any>undefined;
            this.api = _data["api"] ? ExtensionPropertyApiDto.fromJS(_data["api"]) : <any>undefined;
            this.ui = _data["ui"] ? ExtensionPropertyUiDto.fromJS(_data["ui"]) : <any>undefined;
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(ExtensionPropertyAttributeDto.fromJS(item));
            }
            if (_data["configuration"]) {
                this.configuration = {} as any;
                for (let key in _data["configuration"]) {
                    if (_data["configuration"].hasOwnProperty(key))
                        (<any>this.configuration)![key] = _data["configuration"][key];
                }
            }
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): ExtensionPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["typeSimple"] = this.typeSimple;
        data["displayName"] = this.displayName ? this.displayName.toJSON() : <any>undefined;
        data["api"] = this.api ? this.api.toJSON() : <any>undefined;
        data["ui"] = this.ui ? this.ui.toJSON() : <any>undefined;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        if (this.configuration) {
            data["configuration"] = {};
            for (let key in this.configuration) {
                if (this.configuration.hasOwnProperty(key))
                    (<any>data["configuration"])[key] = (<any>this.configuration)[key];
            }
        }
        data["defaultValue"] = this.defaultValue;
        return data;
    }

    clone(): ExtensionPropertyDto {
        const json = this.toJSON();
        let result = new ExtensionPropertyDto();
        result.init(json);
        return result;
    }
}

export interface IExtensionPropertyDto {
    type?: string;
    typeSimple?: string;
    displayName?: LocalizableStringDto | undefined;
    api?: ExtensionPropertyApiDto;
    ui?: ExtensionPropertyUiDto;
    attributes?: ExtensionPropertyAttributeDto[];
    configuration?: { [key: string]: any; };
    defaultValue?: any | undefined;
}

export class LocalizableStringDto implements ILocalizableStringDto {
    name?: string;
    resource?: string | undefined;

    constructor(data?: ILocalizableStringDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.resource = _data["resource"];
        }
    }

    static fromJS(data: any): LocalizableStringDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableStringDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["resource"] = this.resource;
        return data;
    }

    clone(): LocalizableStringDto {
        const json = this.toJSON();
        let result = new LocalizableStringDto();
        result.init(json);
        return result;
    }
}

export interface ILocalizableStringDto {
    name?: string;
    resource?: string | undefined;
}

export class ExtensionPropertyApiDto implements IExtensionPropertyApiDto {
    onGet?: ExtensionPropertyApiGetDto;
    onCreate?: ExtensionPropertyApiCreateDto;
    onUpdate?: ExtensionPropertyApiUpdateDto;

    constructor(data?: IExtensionPropertyApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onGet = _data["onGet"] ? ExtensionPropertyApiGetDto.fromJS(_data["onGet"]) : <any>undefined;
            this.onCreate = _data["onCreate"] ? ExtensionPropertyApiCreateDto.fromJS(_data["onCreate"]) : <any>undefined;
            this.onUpdate = _data["onUpdate"] ? ExtensionPropertyApiUpdateDto.fromJS(_data["onUpdate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtensionPropertyApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onGet"] = this.onGet ? this.onGet.toJSON() : <any>undefined;
        data["onCreate"] = this.onCreate ? this.onCreate.toJSON() : <any>undefined;
        data["onUpdate"] = this.onUpdate ? this.onUpdate.toJSON() : <any>undefined;
        return data;
    }

    clone(): ExtensionPropertyApiDto {
        const json = this.toJSON();
        let result = new ExtensionPropertyApiDto();
        result.init(json);
        return result;
    }
}

export interface IExtensionPropertyApiDto {
    onGet?: ExtensionPropertyApiGetDto;
    onCreate?: ExtensionPropertyApiCreateDto;
    onUpdate?: ExtensionPropertyApiUpdateDto;
}

export class ExtensionPropertyApiGetDto implements IExtensionPropertyApiGetDto {
    /** Default: true. */
    isAvailable?: boolean;

    constructor(data?: IExtensionPropertyApiGetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): ExtensionPropertyApiGetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyApiGetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        return data;
    }

    clone(): ExtensionPropertyApiGetDto {
        const json = this.toJSON();
        let result = new ExtensionPropertyApiGetDto();
        result.init(json);
        return result;
    }
}

export interface IExtensionPropertyApiGetDto {
    /** Default: true. */
    isAvailable?: boolean;
}

export class ExtensionPropertyApiCreateDto implements IExtensionPropertyApiCreateDto {
    /** Default: true. */
    isAvailable?: boolean;

    constructor(data?: IExtensionPropertyApiCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): ExtensionPropertyApiCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyApiCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        return data;
    }

    clone(): ExtensionPropertyApiCreateDto {
        const json = this.toJSON();
        let result = new ExtensionPropertyApiCreateDto();
        result.init(json);
        return result;
    }
}

export interface IExtensionPropertyApiCreateDto {
    /** Default: true. */
    isAvailable?: boolean;
}

export class ExtensionPropertyApiUpdateDto implements IExtensionPropertyApiUpdateDto {
    /** Default: true. */
    isAvailable?: boolean;

    constructor(data?: IExtensionPropertyApiUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): ExtensionPropertyApiUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyApiUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        return data;
    }

    clone(): ExtensionPropertyApiUpdateDto {
        const json = this.toJSON();
        let result = new ExtensionPropertyApiUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IExtensionPropertyApiUpdateDto {
    /** Default: true. */
    isAvailable?: boolean;
}

export class ExtensionPropertyUiDto implements IExtensionPropertyUiDto {
    onTable?: ExtensionPropertyUiTableDto;
    onCreateForm?: ExtensionPropertyUiFormDto;
    onEditForm?: ExtensionPropertyUiFormDto;
    lookup?: ExtensionPropertyUiLookupDto;

    constructor(data?: IExtensionPropertyUiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onTable = _data["onTable"] ? ExtensionPropertyUiTableDto.fromJS(_data["onTable"]) : <any>undefined;
            this.onCreateForm = _data["onCreateForm"] ? ExtensionPropertyUiFormDto.fromJS(_data["onCreateForm"]) : <any>undefined;
            this.onEditForm = _data["onEditForm"] ? ExtensionPropertyUiFormDto.fromJS(_data["onEditForm"]) : <any>undefined;
            this.lookup = _data["lookup"] ? ExtensionPropertyUiLookupDto.fromJS(_data["lookup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtensionPropertyUiDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyUiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onTable"] = this.onTable ? this.onTable.toJSON() : <any>undefined;
        data["onCreateForm"] = this.onCreateForm ? this.onCreateForm.toJSON() : <any>undefined;
        data["onEditForm"] = this.onEditForm ? this.onEditForm.toJSON() : <any>undefined;
        data["lookup"] = this.lookup ? this.lookup.toJSON() : <any>undefined;
        return data;
    }

    clone(): ExtensionPropertyUiDto {
        const json = this.toJSON();
        let result = new ExtensionPropertyUiDto();
        result.init(json);
        return result;
    }
}

export interface IExtensionPropertyUiDto {
    onTable?: ExtensionPropertyUiTableDto;
    onCreateForm?: ExtensionPropertyUiFormDto;
    onEditForm?: ExtensionPropertyUiFormDto;
    lookup?: ExtensionPropertyUiLookupDto;
}

export class ExtensionPropertyUiTableDto implements IExtensionPropertyUiTableDto {
    isVisible?: boolean;

    constructor(data?: IExtensionPropertyUiTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): ExtensionPropertyUiTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyUiTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isVisible"] = this.isVisible;
        return data;
    }

    clone(): ExtensionPropertyUiTableDto {
        const json = this.toJSON();
        let result = new ExtensionPropertyUiTableDto();
        result.init(json);
        return result;
    }
}

export interface IExtensionPropertyUiTableDto {
    isVisible?: boolean;
}

export class ExtensionPropertyUiFormDto implements IExtensionPropertyUiFormDto {
    isVisible?: boolean;

    constructor(data?: IExtensionPropertyUiFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): ExtensionPropertyUiFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyUiFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isVisible"] = this.isVisible;
        return data;
    }

    clone(): ExtensionPropertyUiFormDto {
        const json = this.toJSON();
        let result = new ExtensionPropertyUiFormDto();
        result.init(json);
        return result;
    }
}

export interface IExtensionPropertyUiFormDto {
    isVisible?: boolean;
}

export class ExtensionPropertyUiLookupDto implements IExtensionPropertyUiLookupDto {
    url?: string;
    resultListPropertyName?: string;
    displayPropertyName?: string;
    valuePropertyName?: string;
    filterParamName?: string;

    constructor(data?: IExtensionPropertyUiLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.resultListPropertyName = _data["resultListPropertyName"];
            this.displayPropertyName = _data["displayPropertyName"];
            this.valuePropertyName = _data["valuePropertyName"];
            this.filterParamName = _data["filterParamName"];
        }
    }

    static fromJS(data: any): ExtensionPropertyUiLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyUiLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["resultListPropertyName"] = this.resultListPropertyName;
        data["displayPropertyName"] = this.displayPropertyName;
        data["valuePropertyName"] = this.valuePropertyName;
        data["filterParamName"] = this.filterParamName;
        return data;
    }

    clone(): ExtensionPropertyUiLookupDto {
        const json = this.toJSON();
        let result = new ExtensionPropertyUiLookupDto();
        result.init(json);
        return result;
    }
}

export interface IExtensionPropertyUiLookupDto {
    url?: string;
    resultListPropertyName?: string;
    displayPropertyName?: string;
    valuePropertyName?: string;
    filterParamName?: string;
}

export class ExtensionPropertyAttributeDto implements IExtensionPropertyAttributeDto {
    typeSimple?: string;
    config?: { [key: string]: any; };

    constructor(data?: IExtensionPropertyAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeSimple = _data["typeSimple"];
            if (_data["config"]) {
                this.config = {} as any;
                for (let key in _data["config"]) {
                    if (_data["config"].hasOwnProperty(key))
                        (<any>this.config)![key] = _data["config"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExtensionPropertyAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeSimple"] = this.typeSimple;
        if (this.config) {
            data["config"] = {};
            for (let key in this.config) {
                if (this.config.hasOwnProperty(key))
                    (<any>data["config"])[key] = (<any>this.config)[key];
            }
        }
        return data;
    }

    clone(): ExtensionPropertyAttributeDto {
        const json = this.toJSON();
        let result = new ExtensionPropertyAttributeDto();
        result.init(json);
        return result;
    }
}

export interface IExtensionPropertyAttributeDto {
    typeSimple?: string;
    config?: { [key: string]: any; };
}

export class ExtensionEnumDto implements IExtensionEnumDto {
    fields?: ExtensionEnumFieldDto[];
    localizationResource?: string | undefined;

    constructor(data?: IExtensionEnumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(ExtensionEnumFieldDto.fromJS(item));
            }
            this.localizationResource = _data["localizationResource"];
        }
    }

    static fromJS(data: any): ExtensionEnumDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionEnumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["localizationResource"] = this.localizationResource;
        return data;
    }

    clone(): ExtensionEnumDto {
        const json = this.toJSON();
        let result = new ExtensionEnumDto();
        result.init(json);
        return result;
    }
}

export interface IExtensionEnumDto {
    fields?: ExtensionEnumFieldDto[];
    localizationResource?: string | undefined;
}

export class ExtensionEnumFieldDto implements IExtensionEnumFieldDto {
    name?: string | undefined;
    value?: any | undefined;

    constructor(data?: IExtensionEnumFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ExtensionEnumFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionEnumFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): ExtensionEnumFieldDto {
        const json = this.toJSON();
        let result = new ExtensionEnumFieldDto();
        result.init(json);
        return result;
    }
}

export interface IExtensionEnumFieldDto {
    name?: string | undefined;
    value?: any | undefined;
}

export class ApplicationLocalizationDto implements IApplicationLocalizationDto {
    resources?: { [key: string]: ApplicationLocalizationResourceDto; };
    currentCulture?: CurrentCultureDto;

    constructor(data?: IApplicationLocalizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["resources"]) {
                this.resources = {} as any;
                for (let key in _data["resources"]) {
                    if (_data["resources"].hasOwnProperty(key))
                        (<any>this.resources)![key] = _data["resources"][key] ? ApplicationLocalizationResourceDto.fromJS(_data["resources"][key]) : new ApplicationLocalizationResourceDto();
                }
            }
            this.currentCulture = _data["currentCulture"] ? CurrentCultureDto.fromJS(_data["currentCulture"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationLocalizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLocalizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.resources) {
            data["resources"] = {};
            for (let key in this.resources) {
                if (this.resources.hasOwnProperty(key))
                    (<any>data["resources"])[key] = this.resources[key] ? this.resources[key].toJSON() : <any>undefined;
            }
        }
        data["currentCulture"] = this.currentCulture ? this.currentCulture.toJSON() : <any>undefined;
        return data;
    }

    clone(): ApplicationLocalizationDto {
        const json = this.toJSON();
        let result = new ApplicationLocalizationDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationLocalizationDto {
    resources?: { [key: string]: ApplicationLocalizationResourceDto; };
    currentCulture?: CurrentCultureDto;
}

export class ApplicationApiDescriptionModel implements IApplicationApiDescriptionModel {
    modules?: { [key: string]: ModuleApiDescriptionModel; };
    types?: { [key: string]: TypeApiDescriptionModel; };

    constructor(data?: IApplicationApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["modules"]) {
                this.modules = {} as any;
                for (let key in _data["modules"]) {
                    if (_data["modules"].hasOwnProperty(key))
                        (<any>this.modules)![key] = _data["modules"][key] ? ModuleApiDescriptionModel.fromJS(_data["modules"][key]) : new ModuleApiDescriptionModel();
                }
            }
            if (_data["types"]) {
                this.types = {} as any;
                for (let key in _data["types"]) {
                    if (_data["types"].hasOwnProperty(key))
                        (<any>this.types)![key] = _data["types"][key] ? TypeApiDescriptionModel.fromJS(_data["types"][key]) : new TypeApiDescriptionModel();
                }
            }
        }
    }

    static fromJS(data: any): ApplicationApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.modules) {
            data["modules"] = {};
            for (let key in this.modules) {
                if (this.modules.hasOwnProperty(key))
                    (<any>data["modules"])[key] = this.modules[key] ? this.modules[key].toJSON() : <any>undefined;
            }
        }
        if (this.types) {
            data["types"] = {};
            for (let key in this.types) {
                if (this.types.hasOwnProperty(key))
                    (<any>data["types"])[key] = this.types[key] ? this.types[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }

    clone(): ApplicationApiDescriptionModel {
        const json = this.toJSON();
        let result = new ApplicationApiDescriptionModel();
        result.init(json);
        return result;
    }
}

export interface IApplicationApiDescriptionModel {
    modules?: { [key: string]: ModuleApiDescriptionModel; };
    types?: { [key: string]: TypeApiDescriptionModel; };
}

export class ModuleApiDescriptionModel implements IModuleApiDescriptionModel {
    rootPath?: string;
    remoteServiceName?: string;
    controllers?: { [key: string]: ControllerApiDescriptionModel; };

    constructor(data?: IModuleApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rootPath = _data["rootPath"];
            this.remoteServiceName = _data["remoteServiceName"];
            if (_data["controllers"]) {
                this.controllers = {} as any;
                for (let key in _data["controllers"]) {
                    if (_data["controllers"].hasOwnProperty(key))
                        (<any>this.controllers)![key] = _data["controllers"][key] ? ControllerApiDescriptionModel.fromJS(_data["controllers"][key]) : new ControllerApiDescriptionModel();
                }
            }
        }
    }

    static fromJS(data: any): ModuleApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rootPath"] = this.rootPath;
        data["remoteServiceName"] = this.remoteServiceName;
        if (this.controllers) {
            data["controllers"] = {};
            for (let key in this.controllers) {
                if (this.controllers.hasOwnProperty(key))
                    (<any>data["controllers"])[key] = this.controllers[key] ? this.controllers[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }

    clone(): ModuleApiDescriptionModel {
        const json = this.toJSON();
        let result = new ModuleApiDescriptionModel();
        result.init(json);
        return result;
    }
}

export interface IModuleApiDescriptionModel {
    rootPath?: string;
    remoteServiceName?: string;
    controllers?: { [key: string]: ControllerApiDescriptionModel; };
}

export class ControllerApiDescriptionModel implements IControllerApiDescriptionModel {
    controllerName?: string;
    controllerGroupName?: string | undefined;
    isRemoteService?: boolean;
    isIntegrationService?: boolean;
    apiVersion?: string | undefined;
    type?: string;
    interfaces?: ControllerInterfaceApiDescriptionModel[];
    actions?: { [key: string]: ActionApiDescriptionModel; };

    constructor(data?: IControllerApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controllerName = _data["controllerName"];
            this.controllerGroupName = _data["controllerGroupName"];
            this.isRemoteService = _data["isRemoteService"];
            this.isIntegrationService = _data["isIntegrationService"];
            this.apiVersion = _data["apiVersion"];
            this.type = _data["type"];
            if (Array.isArray(_data["interfaces"])) {
                this.interfaces = [] as any;
                for (let item of _data["interfaces"])
                    this.interfaces!.push(ControllerInterfaceApiDescriptionModel.fromJS(item));
            }
            if (_data["actions"]) {
                this.actions = {} as any;
                for (let key in _data["actions"]) {
                    if (_data["actions"].hasOwnProperty(key))
                        (<any>this.actions)![key] = _data["actions"][key] ? ActionApiDescriptionModel.fromJS(_data["actions"][key]) : new ActionApiDescriptionModel();
                }
            }
        }
    }

    static fromJS(data: any): ControllerApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ControllerApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controllerName"] = this.controllerName;
        data["controllerGroupName"] = this.controllerGroupName;
        data["isRemoteService"] = this.isRemoteService;
        data["isIntegrationService"] = this.isIntegrationService;
        data["apiVersion"] = this.apiVersion;
        data["type"] = this.type;
        if (Array.isArray(this.interfaces)) {
            data["interfaces"] = [];
            for (let item of this.interfaces)
                data["interfaces"].push(item.toJSON());
        }
        if (this.actions) {
            data["actions"] = {};
            for (let key in this.actions) {
                if (this.actions.hasOwnProperty(key))
                    (<any>data["actions"])[key] = this.actions[key] ? this.actions[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }

    clone(): ControllerApiDescriptionModel {
        const json = this.toJSON();
        let result = new ControllerApiDescriptionModel();
        result.init(json);
        return result;
    }
}

export interface IControllerApiDescriptionModel {
    controllerName?: string;
    controllerGroupName?: string | undefined;
    isRemoteService?: boolean;
    isIntegrationService?: boolean;
    apiVersion?: string | undefined;
    type?: string;
    interfaces?: ControllerInterfaceApiDescriptionModel[];
    actions?: { [key: string]: ActionApiDescriptionModel; };
}

export class ControllerInterfaceApiDescriptionModel implements IControllerInterfaceApiDescriptionModel {
    type?: string;
    name?: string;
    methods?: InterfaceMethodApiDescriptionModel[];

    constructor(data?: IControllerInterfaceApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            if (Array.isArray(_data["methods"])) {
                this.methods = [] as any;
                for (let item of _data["methods"])
                    this.methods!.push(InterfaceMethodApiDescriptionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ControllerInterfaceApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ControllerInterfaceApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        if (Array.isArray(this.methods)) {
            data["methods"] = [];
            for (let item of this.methods)
                data["methods"].push(item.toJSON());
        }
        return data;
    }

    clone(): ControllerInterfaceApiDescriptionModel {
        const json = this.toJSON();
        let result = new ControllerInterfaceApiDescriptionModel();
        result.init(json);
        return result;
    }
}

export interface IControllerInterfaceApiDescriptionModel {
    type?: string;
    name?: string;
    methods?: InterfaceMethodApiDescriptionModel[];
}

export class InterfaceMethodApiDescriptionModel implements IInterfaceMethodApiDescriptionModel {
    name?: string;
    parametersOnMethod?: MethodParameterApiDescriptionModel[];
    returnValue?: ReturnValueApiDescriptionModel;

    constructor(data?: IInterfaceMethodApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["parametersOnMethod"])) {
                this.parametersOnMethod = [] as any;
                for (let item of _data["parametersOnMethod"])
                    this.parametersOnMethod!.push(MethodParameterApiDescriptionModel.fromJS(item));
            }
            this.returnValue = _data["returnValue"] ? ReturnValueApiDescriptionModel.fromJS(_data["returnValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InterfaceMethodApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new InterfaceMethodApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.parametersOnMethod)) {
            data["parametersOnMethod"] = [];
            for (let item of this.parametersOnMethod)
                data["parametersOnMethod"].push(item.toJSON());
        }
        data["returnValue"] = this.returnValue ? this.returnValue.toJSON() : <any>undefined;
        return data;
    }

    clone(): InterfaceMethodApiDescriptionModel {
        const json = this.toJSON();
        let result = new InterfaceMethodApiDescriptionModel();
        result.init(json);
        return result;
    }
}

export interface IInterfaceMethodApiDescriptionModel {
    name?: string;
    parametersOnMethod?: MethodParameterApiDescriptionModel[];
    returnValue?: ReturnValueApiDescriptionModel;
}

export class MethodParameterApiDescriptionModel implements IMethodParameterApiDescriptionModel {
    name?: string;
    typeAsString?: string;
    type?: string;
    typeSimple?: string;
    isOptional?: boolean;
    defaultValue?: any | undefined;

    constructor(data?: IMethodParameterApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.typeAsString = _data["typeAsString"];
            this.type = _data["type"];
            this.typeSimple = _data["typeSimple"];
            this.isOptional = _data["isOptional"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): MethodParameterApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new MethodParameterApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["typeAsString"] = this.typeAsString;
        data["type"] = this.type;
        data["typeSimple"] = this.typeSimple;
        data["isOptional"] = this.isOptional;
        data["defaultValue"] = this.defaultValue;
        return data;
    }

    clone(): MethodParameterApiDescriptionModel {
        const json = this.toJSON();
        let result = new MethodParameterApiDescriptionModel();
        result.init(json);
        return result;
    }
}

export interface IMethodParameterApiDescriptionModel {
    name?: string;
    typeAsString?: string;
    type?: string;
    typeSimple?: string;
    isOptional?: boolean;
    defaultValue?: any | undefined;
}

export class ReturnValueApiDescriptionModel implements IReturnValueApiDescriptionModel {
    type?: string;
    typeSimple?: string;

    constructor(data?: IReturnValueApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.typeSimple = _data["typeSimple"];
        }
    }

    static fromJS(data: any): ReturnValueApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnValueApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["typeSimple"] = this.typeSimple;
        return data;
    }

    clone(): ReturnValueApiDescriptionModel {
        const json = this.toJSON();
        let result = new ReturnValueApiDescriptionModel();
        result.init(json);
        return result;
    }
}

export interface IReturnValueApiDescriptionModel {
    type?: string;
    typeSimple?: string;
}

export class ActionApiDescriptionModel implements IActionApiDescriptionModel {
    uniqueName?: string;
    name?: string;
    httpMethod?: string | undefined;
    url?: string;
    supportedVersions?: string[] | undefined;
    parametersOnMethod?: MethodParameterApiDescriptionModel[];
    parameters?: ParameterApiDescriptionModel[];
    returnValue?: ReturnValueApiDescriptionModel;
    allowAnonymous?: boolean | undefined;
    implementFrom?: string | undefined;

    constructor(data?: IActionApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueName = _data["uniqueName"];
            this.name = _data["name"];
            this.httpMethod = _data["httpMethod"];
            this.url = _data["url"];
            if (Array.isArray(_data["supportedVersions"])) {
                this.supportedVersions = [] as any;
                for (let item of _data["supportedVersions"])
                    this.supportedVersions!.push(item);
            }
            if (Array.isArray(_data["parametersOnMethod"])) {
                this.parametersOnMethod = [] as any;
                for (let item of _data["parametersOnMethod"])
                    this.parametersOnMethod!.push(MethodParameterApiDescriptionModel.fromJS(item));
            }
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ParameterApiDescriptionModel.fromJS(item));
            }
            this.returnValue = _data["returnValue"] ? ReturnValueApiDescriptionModel.fromJS(_data["returnValue"]) : <any>undefined;
            this.allowAnonymous = _data["allowAnonymous"];
            this.implementFrom = _data["implementFrom"];
        }
    }

    static fromJS(data: any): ActionApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActionApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueName"] = this.uniqueName;
        data["name"] = this.name;
        data["httpMethod"] = this.httpMethod;
        data["url"] = this.url;
        if (Array.isArray(this.supportedVersions)) {
            data["supportedVersions"] = [];
            for (let item of this.supportedVersions)
                data["supportedVersions"].push(item);
        }
        if (Array.isArray(this.parametersOnMethod)) {
            data["parametersOnMethod"] = [];
            for (let item of this.parametersOnMethod)
                data["parametersOnMethod"].push(item.toJSON());
        }
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["returnValue"] = this.returnValue ? this.returnValue.toJSON() : <any>undefined;
        data["allowAnonymous"] = this.allowAnonymous;
        data["implementFrom"] = this.implementFrom;
        return data;
    }

    clone(): ActionApiDescriptionModel {
        const json = this.toJSON();
        let result = new ActionApiDescriptionModel();
        result.init(json);
        return result;
    }
}

export interface IActionApiDescriptionModel {
    uniqueName?: string;
    name?: string;
    httpMethod?: string | undefined;
    url?: string;
    supportedVersions?: string[] | undefined;
    parametersOnMethod?: MethodParameterApiDescriptionModel[];
    parameters?: ParameterApiDescriptionModel[];
    returnValue?: ReturnValueApiDescriptionModel;
    allowAnonymous?: boolean | undefined;
    implementFrom?: string | undefined;
}

export class ParameterApiDescriptionModel implements IParameterApiDescriptionModel {
    nameOnMethod?: string;
    name?: string;
    jsonName?: string | undefined;
    type?: string | undefined;
    typeSimple?: string | undefined;
    isOptional?: boolean;
    defaultValue?: any | undefined;
    constraintTypes?: string[] | undefined;
    bindingSourceId?: string | undefined;
    descriptorName?: string | undefined;

    constructor(data?: IParameterApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameOnMethod = _data["nameOnMethod"];
            this.name = _data["name"];
            this.jsonName = _data["jsonName"];
            this.type = _data["type"];
            this.typeSimple = _data["typeSimple"];
            this.isOptional = _data["isOptional"];
            this.defaultValue = _data["defaultValue"];
            if (Array.isArray(_data["constraintTypes"])) {
                this.constraintTypes = [] as any;
                for (let item of _data["constraintTypes"])
                    this.constraintTypes!.push(item);
            }
            this.bindingSourceId = _data["bindingSourceId"];
            this.descriptorName = _data["descriptorName"];
        }
    }

    static fromJS(data: any): ParameterApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameOnMethod"] = this.nameOnMethod;
        data["name"] = this.name;
        data["jsonName"] = this.jsonName;
        data["type"] = this.type;
        data["typeSimple"] = this.typeSimple;
        data["isOptional"] = this.isOptional;
        data["defaultValue"] = this.defaultValue;
        if (Array.isArray(this.constraintTypes)) {
            data["constraintTypes"] = [];
            for (let item of this.constraintTypes)
                data["constraintTypes"].push(item);
        }
        data["bindingSourceId"] = this.bindingSourceId;
        data["descriptorName"] = this.descriptorName;
        return data;
    }

    clone(): ParameterApiDescriptionModel {
        const json = this.toJSON();
        let result = new ParameterApiDescriptionModel();
        result.init(json);
        return result;
    }
}

export interface IParameterApiDescriptionModel {
    nameOnMethod?: string;
    name?: string;
    jsonName?: string | undefined;
    type?: string | undefined;
    typeSimple?: string | undefined;
    isOptional?: boolean;
    defaultValue?: any | undefined;
    constraintTypes?: string[] | undefined;
    bindingSourceId?: string | undefined;
    descriptorName?: string | undefined;
}

export class TypeApiDescriptionModel implements ITypeApiDescriptionModel {
    baseType?: string | undefined;
    isEnum?: boolean;
    enumNames?: string[] | undefined;
    enumValues?: any[] | undefined;
    genericArguments?: string[] | undefined;
    properties?: PropertyApiDescriptionModel[] | undefined;

    constructor(data?: ITypeApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseType = _data["baseType"];
            this.isEnum = _data["isEnum"];
            if (Array.isArray(_data["enumNames"])) {
                this.enumNames = [] as any;
                for (let item of _data["enumNames"])
                    this.enumNames!.push(item);
            }
            if (Array.isArray(_data["enumValues"])) {
                this.enumValues = [] as any;
                for (let item of _data["enumValues"])
                    this.enumValues!.push(item);
            }
            if (Array.isArray(_data["genericArguments"])) {
                this.genericArguments = [] as any;
                for (let item of _data["genericArguments"])
                    this.genericArguments!.push(item);
            }
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(PropertyApiDescriptionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TypeApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypeApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseType"] = this.baseType;
        data["isEnum"] = this.isEnum;
        if (Array.isArray(this.enumNames)) {
            data["enumNames"] = [];
            for (let item of this.enumNames)
                data["enumNames"].push(item);
        }
        if (Array.isArray(this.enumValues)) {
            data["enumValues"] = [];
            for (let item of this.enumValues)
                data["enumValues"].push(item);
        }
        if (Array.isArray(this.genericArguments)) {
            data["genericArguments"] = [];
            for (let item of this.genericArguments)
                data["genericArguments"].push(item);
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data;
    }

    clone(): TypeApiDescriptionModel {
        const json = this.toJSON();
        let result = new TypeApiDescriptionModel();
        result.init(json);
        return result;
    }
}

export interface ITypeApiDescriptionModel {
    baseType?: string | undefined;
    isEnum?: boolean;
    enumNames?: string[] | undefined;
    enumValues?: any[] | undefined;
    genericArguments?: string[] | undefined;
    properties?: PropertyApiDescriptionModel[] | undefined;
}

export class PropertyApiDescriptionModel implements IPropertyApiDescriptionModel {
    name?: string;
    jsonName?: string | undefined;
    type?: string;
    typeSimple?: string;
    isRequired?: boolean;
    minLength?: number | undefined;
    maxLength?: number | undefined;
    minimum?: string | undefined;
    maximum?: string | undefined;
    regex?: string | undefined;

    constructor(data?: IPropertyApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.jsonName = _data["jsonName"];
            this.type = _data["type"];
            this.typeSimple = _data["typeSimple"];
            this.isRequired = _data["isRequired"];
            this.minLength = _data["minLength"];
            this.maxLength = _data["maxLength"];
            this.minimum = _data["minimum"];
            this.maximum = _data["maximum"];
            this.regex = _data["regex"];
        }
    }

    static fromJS(data: any): PropertyApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["jsonName"] = this.jsonName;
        data["type"] = this.type;
        data["typeSimple"] = this.typeSimple;
        data["isRequired"] = this.isRequired;
        data["minLength"] = this.minLength;
        data["maxLength"] = this.maxLength;
        data["minimum"] = this.minimum;
        data["maximum"] = this.maximum;
        data["regex"] = this.regex;
        return data;
    }

    clone(): PropertyApiDescriptionModel {
        const json = this.toJSON();
        let result = new PropertyApiDescriptionModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyApiDescriptionModel {
    name?: string;
    jsonName?: string | undefined;
    type?: string;
    typeSimple?: string;
    isRequired?: boolean;
    minLength?: number | undefined;
    maxLength?: number | undefined;
    minimum?: string | undefined;
    maximum?: string | undefined;
    regex?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
	
		// If blob is an already parsed JSON object or array, ignore
		if ((typeof blob === 'object' && blob !== null) || Array.isArray(blob)) {
			observer.next(JSON.stringify(blob));
            observer.complete();
		} else if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}